(function(f, define) {
    "use strict";
    define("kendo.junkyard.ns", [], f);
})(function() {
    "use strict";
    kendo.ui.junkyard = {};
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.constants", [ "kendo.junkyard.ns" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend;
        var Settings = {
            DefaultPage: 1,
            PaseSize: 50,
            UnlimPaseSize: 99999999
        };
        var UiEvents = {
            DocumentClick: "DocumentClick",
            CreateView: "CreateView",
            DestroyView: "DestroyView"
        };
        var BroadcastEvents = {
            SelectContext: "SelectContext"
        };
        var HttpCodes = {
            Unauthorized: 401
        };
        var CommandState = {
            Created: 1,
            Running: 2,
            Done: 3,
            Failed: 4
        };
        var Commands = {
            ShowItems: "ShowItems",
            ShowDrives: "ShowDrives",
            Startup: "Startup",
            ChangeView: "ChangeView",
            OpenDrive: "OpenDrive",
            OpenFolder: "OpenFolder",
            OpenFile: "OpenFile",
            OpenPreview: "OpenPreview",
            AddDriveDialog: "AddDriveDialog",
            SaveDrive: "SaveDrive",
            ShowDetails: "ShowDetails",
            CloseDetails: "CloseDetails",
            AddFolderDialog: "AddFolderDialog",
            CreateFolder: "CreateFolder",
            CreateFile: "CreateFile",
            ActionFile: "ActionFile",
            ShareDriveDialog: "ShareDriveDialog",
            Upload: "Upload",
            ReloadUI: "ReloadUI",
            RenameDialog: "RenameDialog",
            RenameDrive: "RenameDrive",
            RenameItem: "RenameItem",
            MoveDialog: "MoveDialog",
            RestoreDialog: "RestoreDialog",
            CopyDialog: "CopyDialog",
            MoveItem: "MoveItem",
            RestoreItem: "RestoreItem",
            CopyItem: "CopyItem",
            DownloadItem: "DownloadItem",
            PreviewDialog: "PreviewDialog",
            OpenFileDialog: "OpenFileDialog",
            DeleteItem: "DeleteItem",
            DeleteItemWithConfirm: "DeleteItemWithConfirm",
            OpenObject: "OpenObject",
            DeleteDrive: "DeleteDrive",
            ChangeSizeDialog: "ChangeSizeDialog",
            ChangeDriveSize: "ChangeDriveSize",
            ShowDeletedItems: "ShowDeletedItems",
            ShareLinkDialog: "ShareLinkDialog",
            CropEditorDialog: "CropEditorDialog",
            ClearTrash: "ClearTrash",
            RevokeAllUrls: "RevokeAllUrls",
            DeleteDriveById: "DeleteDriveById"
        };
        var progressWaitData = {};
        progressWaitData[Commands.SaveDrive] = true;
        progressWaitData[Commands.CreateFolder] = true;
        progressWaitData[Commands.RenameDrive] = true;
        progressWaitData[Commands.RenameItem] = true;
        progressWaitData[Commands.MoveItem] = true;
        progressWaitData[Commands.RestoreItem] = true;
        progressWaitData[Commands.CopyItem] = true;
        progressWaitData[Commands.DownloadItem] = true;
        progressWaitData[Commands.DeleteItem] = true;
        progressWaitData[Commands.DeleteDrive] = true;
        progressWaitData[Commands.ChangeDriveSize] = true;
        var suppressDisplayErrorData = {};
        suppressDisplayErrorData[Commands.ReloadUI] = true;
        suppressDisplayErrorData[Commands.OpenFolder] = true;
        suppressDisplayErrorData[Commands.OpenDrive] = true;
        suppressDisplayErrorData[Commands.ShowItems] = true;
        suppressDisplayErrorData[Commands.ShowDrives] = true;
        suppressDisplayErrorData[Commands.ShowDeletedItems] = true;
        suppressDisplayErrorData[Commands.OpenObject] = true;
        var ViewType = {
            Card: 1,
            Grid: 2
        };
        var ItemType = {
            Folder: "Directory",
            File: "File"
        };
        var MenuItemType = {
            Menu: 1,
            Drive: 2,
            Item: 3
        };
        var MenuTreeIcons = {
            MyDrive: "fa-server",
            Shared: "fa-users",
            Drive: "fa-hdd-o",
            Folder: "fa-folder",
            Trash: "fa-trash-o"
        };
        var FileTypeIcons = {
            default: [ "" ],
            docs: [ "doc", "docx", "rtf", "pages" ],
            tables: [ "xls", "xlsx" ],
            image: [ "png", "jpg", "jpeg", "gif", "tiff", "psd", "sketch", "webp" ],
            slides: [ "ppt", "pps", "pptx", "ppsx", "sldx", "sldm", "key" ],
            pdf: [ "pdf" ],
            archive: [ "zip", "rar", "7z", "gz", "tar" ],
            vector: [ "ai", "cdr", "svg", "eps" ],
            audio: [ "mp3", "aac", "ogg", "wav", "flac", "ape", "wv" ],
            video: [ "avi", "asf", "mov", "flv", "mp4", "webm", "vob", "wmv", "mpeg", "mkv", "mpg" ],
            json: [ "json", "geojson" ],
            code: [ "js", "html", "less", "css", "htm", "scss" ],
            text: [ "txt", "md", "mdown", "markdown" ]
        };
        var ImageTypes = {
            JPG: "image/jpeg",
            GIF: "image/gif",
            PNG: "image/png",
            WEBP: "image/webp",
            SVG: "image/svg+xml"
        };
        var ImageSize = {
            XS: "xs",
            S: "s",
            M: "m",
            L: "l"
        };
        var ImageTypeExt = {};
        ImageTypeExt[ImageTypes.JPG] = "jpg";
        ImageTypeExt[ImageTypes.GIF] = "gif";
        ImageTypeExt[ImageTypes.PNG] = "png";
        ImageTypeExt[ImageTypes.WEBP] = "webp";
        ImageTypeExt[ImageTypes.SVG] = "svg";
        var AspectRatioTypes = {
            Ratio16x9: "16:9",
            Ratio4x3: "4:3",
            Ratio1x1: "1:1",
            Ratio2x3: "2:3",
            RatioFree: "free"
        };
        var LinkTypes = {
            ByPath: "byPath",
            ById: "byId",
            ByVersion: "byVersion"
        };
        var MenuIds = {
            My: "my",
            Shared: "shared",
            Trash: "trash"
        };
        var Permissions = {
            Undefined: "Undefined",
            Read: "Read",
            Write: "Write",
            Admin: "Admin"
        };
        var DriveSortOrder = {
            Owned: "Owned",
            Title: "Title",
            Owner: "Owner"
        };
        var ItemSortOrder = {
            Name: "Name",
            Size: "Size",
            Extension: "Extension",
            ModifyDate: "ModifyDate"
        };
        var FileHandlerActionTypes = {
            Open: "open",
            Preview: "preview",
            SmallPreview: "smallPreview",
            Custom: "custom"
        };
        var FileHandlerContentTypes = {
            Image: "image",
            Video: "video",
            Iframe: "iframe"
        };
        var rootMenuData = [ {
            Id: MenuIds.My,
            Title: "Мои диски",
            Icon: MenuTreeIcons.MyDrive,
            HasChildren: true
        }, {
            Id: MenuIds.Shared,
            Title: "Общие",
            Icon: MenuTreeIcons.Shared,
            HasChildren: true
        } ];
        var trashMenuModelData = {
            Id: MenuIds.Trash,
            title: "Сетевая корзина",
            icon: MenuTreeIcons.Trash,
            menuType: MenuItemType.Menu,
            hasChildren: false
        };
        var permissionData = [ {
            id: Permissions.Read,
            title: "Чтение"
        }, {
            id: Permissions.Write,
            title: "Запись"
        }, {
            id: Permissions.Admin,
            title: "Администратор"
        } ];
        var driveSortData = [ {
            id: DriveSortOrder.Title,
            title: "По названию"
        } ];
        var itemSortData = [ {
            id: ItemSortOrder.Name,
            title: "По названию"
        }, {
            id: ItemSortOrder.Extension,
            title: "По типу"
        }, {
            id: ItemSortOrder.Size,
            title: "По размеру файла"
        }, {
            id: ItemSortOrder.ModifyDate,
            title: "По дате изменения"
        } ];
        var createBtnData = [ {
            id: "addDrive",
            title: "Новый диск",
            icon: "fa-hdd-o",
            modIcon: null
        }, {
            id: "addEncryptedDrive",
            title: "Защищенный диск",
            icon: "fa-hdd-o",
            modIcon: "fa-lock"
        } ];
        var contextMenuData = [ {
            title: "Новый диск",
            command: "menuItemAddDrive",
            icon: "fa-hdd-o",
            separator: false,
            enabled: true,
            visible: true
        }, {
            title: "Новая папка",
            command: "menuItemAddFolder",
            icon: "fa-folder-open-o",
            separator: false,
            enabled: true,
            visible: true
        }, {
            title: "Загрузить файлы",
            command: "menuItemUploadFiles",
            icon: "fa-cloud-upload",
            separator: false,
            enabled: true,
            visible: true
        }, {
            title: "Пользовательская команда",
            command: "menuItemCustom",
            icon: "fa-edit",
            separator: true,
            enabled: true,
            visible: false
        }, {
            title: "Общий доступ",
            command: "menuItemShare",
            icon: "fa-user-plus",
            separator: false,
            enabled: true,
            visible: true
        }, {
            title: "Включить доступ по ссылке",
            command: "menuItemShareLink",
            icon: "fa-link",
            separator: false,
            enabled: true,
            visible: true
        }, {
            title: "Отозвать ссылки",
            command: "menuItemRevokeAllUrls",
            icon: "fa-unlink",
            separator: false,
            enabled: true,
            visible: true
        }, {
            title: "Переместить в ...",
            command: "menuItemMove",
            icon: "fa-folder-open-o",
            separator: false,
            enabled: true,
            visible: true
        }, {
            title: "Переименовать",
            command: "menuItemRename",
            icon: "fa-edit",
            separator: true,
            enabled: true,
            visible: true
        }, {
            title: "Изменить размер",
            command: "menuItemChangeSize",
            icon: "fa-database",
            separator: true,
            enabled: true,
            visible: true
        }, {
            title: "Показать свойства",
            command: "menuItemOpenDetails",
            icon: "fa-info-circle",
            separator: false,
            enabled: true,
            visible: true
        }, {
            title: "Создать копию",
            command: "menuItemCopy",
            icon: "fa-files-o",
            separator: false,
            enabled: true,
            visible: true
        }, {
            title: "Скачать",
            command: "menuItemDownload",
            icon: "fa-download",
            separator: true,
            enabled: true,
            visible: true
        }, {
            title: "Удалить",
            command: "menuItemDelete",
            icon: "fa-trash-o",
            separator: false,
            enabled: true,
            visible: true
        }, {
            title: "Восстановить",
            command: "menuItemRestore",
            icon: "fa-history",
            separator: false,
            enabled: true,
            visible: false
        }, {
            title: "Очистить корзину",
            command: "menuItemClearTrash",
            icon: "fa-trash-o",
            separator: false,
            enabled: true,
            visible: false
        } ];
        extend(jyNS, {
            UiEvents: UiEvents,
            BroadcastEvents: BroadcastEvents,
            HttpCodes: HttpCodes,
            CommandState: CommandState,
            Commands: Commands,
            MenuItemType: MenuItemType,
            MenuIds: MenuIds,
            rootMenuData: rootMenuData,
            trashMenuModelData: trashMenuModelData,
            ViewType: ViewType,
            ItemType: ItemType,
            MenuTreeIcons: MenuTreeIcons,
            Settings: Settings,
            Permissions: Permissions,
            permissionData: permissionData,
            driveSortData: driveSortData,
            itemSortData: itemSortData,
            DriveSortOrder: DriveSortOrder,
            ItemSortOrder: ItemSortOrder,
            contextMenuData: contextMenuData,
            createBtnData: createBtnData,
            progressWaitData: progressWaitData,
            suppressDisplayErrorData: suppressDisplayErrorData,
            FileTypeIcons: FileTypeIcons,
            FileHandlerActionTypes: FileHandlerActionTypes,
            FileHandlerContentTypes: FileHandlerContentTypes,
            ImageTypes: ImageTypes,
            ImageTypeExt: ImageTypeExt,
            AspectRatioTypes: AspectRatioTypes,
            LinkTypes: LinkTypes,
            ImageSize: ImageSize
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.utils", [ "kendo.junkyard.ns", "kendo.junkyard.constants" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, arraySlice = Array.prototype.slice, HttpCodes = jyNS.HttpCodes, ObservableObject = kendo.data.ObservableObject;
        function isObject(obj) {
            return obj !== null && obj !== undefined && Object.prototype.toString.call(obj) === "[object Object]";
        }
        function compareObjects(o1, o2, left) {
            var p1, p2;
            for (p1 in o1) {
                if (o1.hasOwnProperty(p1)) {
                    if (o1[p1] !== o2[p1]) {
                        return false;
                    }
                }
            }
            if (!left) {
                for (p2 in o2) {
                    if (o2.hasOwnProperty(p2)) {
                        if (o1[p2] !== o2[p2]) {
                            return false;
                        }
                    }
                }
            }
            return true;
        }
        function notNullFilter(obj) {
            return obj !== null && obj !== undefined;
        }
        function filterByField(name, value) {
            return function(item) {
                return item[name] === value;
            };
        }
        function onlyUnique(value, index, self) {
            return self.indexOf(value) === index;
        }
        function findByRef(array, ref) {
            var result = array.filter(function(item) {
                return item === ref;
            });
            return result.length > 0 ? result[0] : null;
        }
        function selectField(name) {
            return function(item) {
                return item[name];
            };
        }
        function arrayCount(array, filter) {
            return array.filter(filter).length;
        }
        function arrayFlatten(arr) {
            return arr.reduce(function(flat, toFlatten) {
                return flat.concat(Array.isArray(toFlatten) ? arrayFlatten(toFlatten) : toFlatten);
            }, []);
        }
        function arrayIntersect(a, b) {
            var t;
            if (b.length > a.length) {
                t = b;
                b = a;
                a = t;
            }
            return a.filter(function(e) {
                if (b.indexOf(e) !== -1) {
                    return true;
                }
            });
        }
        function arrayFirst(array) {
            return array.length > 0 ? array[0] : null;
        }
        function arrayLast(array) {
            return array.length > 0 ? array[array.length - 1] : null;
        }
        function arrayFindIndex(array, predicate) {
            for (var i = 0; i < array.length; i++) {
                if (predicate(array[i], i, array)) {
                    return i;
                }
            }
            return -1;
        }
        function toArray(obj) {
            if (Array.isArray(obj)) {
                return obj;
            } else if (obj instanceof kendo.data.ObservableArray) {
                return obj.map(function(item) {
                    return item;
                });
            } else {
                throw new Error("Cannot convert obj to array.");
            }
        }
        function toUrlQuery(data, firstSymbol) {
            var query = "";
            if (isObject(data)) {
                var queryParts = Object.keys(data).map(function(key) {
                    var val = data[key];
                    return val === undefined ? null : key + "=" + encodeURIComponent(val);
                }).filter(notNullFilter);
                query = queryParts.join("&");
            }
            query = firstSymbol ? "?" + query : query;
            return query;
        }
        function fileExtension(fileName, dot) {
            var matches = fileName.match(/\.([^\.]+)$/);
            return matches ? matches[dot ? 0 : 1] : "";
        }
        function fileNameParts(fileName) {
            var parts = (fileName || "").split(".");
            var extension = parts.length > 1 ? parts.pop() : "";
            var name = parts.join(".");
            return {
                name: name,
                extension: extension
            };
        }
        function humanFileSize(bytes, si) {
            var thresh = si ? 1e3 : 1024;
            if (Math.abs(bytes) < thresh) {
                return bytes + " Б";
            }
            var units = si ? [ "КБ", "МБ", "ГБ", "ТБ", "PB", "EB", "ZB", "YB" ] : [ "КБ", "МБ", "ГБ", "ТБ", "PiB", "EiB", "ZiB", "YiB" ];
            var u = -1;
            do {
                bytes /= thresh;
                ++u;
            } while (Math.abs(bytes) >= thresh && u < units.length - 1);
            return bytes.toFixed(1) + " " + units[u];
        }
        function _formatDate(date, format, def) {
            def = def == null ? "" : def;
            if (date instanceof Date) {
                return kendo.toString(date, format);
            } else if (typeof date === "string") {
                return kendo.toString(kendo.parseDate(date), format);
            } else {
                return def;
            }
        }
        function formatDate(date, def) {
            var format = "dd MMM yyyy";
            return _formatDate(date, format, def);
        }
        function formatDateTime(date, def) {
            var format = "dd MMM yyyy HH:mm";
            return _formatDate(date, format, def);
        }
        function formatSize(size, def) {
            def = def == null ? "" : def;
            if (size != null) {
                return humanFileSize(size);
            } else {
                return def;
            }
        }
        function confirm(text, title, messages, width) {
            var confirmOpt = {
                content: text
            };
            if (title !== undefined) {
                confirmOpt.title = title;
            }
            if (messages !== undefined) {
                confirmOpt.messages = messages;
            }
            if (width !== undefined) {
                confirmOpt.width = width;
            }
            var confirmDialog = $("<div />").kendoConfirm(confirmOpt).data("kendoConfirm").open();
            return confirmDialog.result;
        }
        function bindingTargetSource(element) {
            return element && element.kendoBindingTarget && element.kendoBindingTarget.source instanceof ObservableObject ? element.kendoBindingTarget.source : null;
        }
        function traceError(msg) {
            if (console && console.error) {
                console.error(msg);
            } else if (console && console.log) {
                console.log(msg);
            }
        }
        function async(fn) {
            var args = arguments;
            setTimeout(function() {
                fn.apply(null, args);
            }, 0);
        }
        function makeReqError(jqXHR, textStatus, errorThrown) {
            var error = new Error("Request failed.");
            error.textStatus = textStatus;
            error.errorThrown = errorThrown;
            error.jqXHR = jqXHR;
            error.toString = function() {
                var string = Error.prototype.toString.call(this);
                string += " " + this.jqXHR.status;
                string += " " + this.jqXHR.statusText;
                string += " " + this.textStatus;
                string += " " + this.errorThrown;
                return string;
            };
            return error;
        }
        function request(method, url, data, accessToken, withCredentials, ret) {
            var defer = $.Deferred();
            if (method !== "GET" && data !== null && data !== undefined) {
                data = JSON.stringify(data);
            }
            var options = {
                type: method,
                url: url,
                data: data,
                dataType: "json",
                cache: true,
                contentType: "application/json; charset=utf-8",
                xhrFields: {},
                beforeSend: function(xhr) {
                    if (accessToken) {
                        xhr.setRequestHeader("Authorization", "Bearer " + accessToken);
                    }
                },
                error: function(jqXHR, textStatus, errorThrown) {
                    defer.reject(makeReqError(jqXHR, textStatus, errorThrown));
                },
                success: function(response, textStatus, jqXHR) {
                    defer.resolve({
                        response: response,
                        textStatus: textStatus,
                        jqXHR: jqXHR
                    });
                }
            };
            if (typeof kendo.ui.junkyard.globalWithCredentials === "boolean") {
                options.xhrFields.withCredentials = kendo.ui.junkyard.globalWithCredentials;
            } else if (typeof withCredentials === "boolean") {
                options.xhrFields.withCredentials = false;
            }
            var xhr = $.ajax(options);
            if (ret) {
                ret.xhr = xhr;
            }
            return defer.promise();
        }
        function post(url, data, accessToken, withCredentials, ret) {
            return request("POST", url, data, accessToken, withCredentials, ret);
        }
        function put(url, data, accessToken, withCredentials, ret) {
            return request("PUT", url, data, accessToken, withCredentials, ret);
        }
        function get(url, data, accessToken, withCredentials, ret) {
            return request("GET", url, data, accessToken, withCredentials, ret);
        }
        function del(url, data, accessToken, withCredentials, ret) {
            return request("DELETE", url, data, accessToken, withCredentials, ret);
        }
        function makeUnauthorizedHandler(auth, defer, requestFunc, requestArgs) {
            return function(error) {
                if (auth.enabled() && error.jqXHR && error.jqXHR.status === HttpCodes.Unauthorized) {
                    auth.refreshToken().done(function(token) {
                        try {
                            requestArgs[2] = token;
                            requestFunc.apply(null, requestArgs).done(defer.resolve).fail(defer.reject);
                        } catch (e) {
                            traceError(e.toString());
                            defer.reject(e);
                        }
                        return token;
                    }).fail(function(e) {
                        defer.reject(e);
                        return e;
                    });
                } else {
                    defer.reject(error);
                }
            };
        }
        function resourceRequest(auth, requestFunc, url, data, accessToken, withCredentials, ret) {
            var requestArgs = arraySlice.call(arguments, 2);
            if (!accessToken) {
                return requestFunc.apply(null, requestArgs);
            }
            var defer = $.Deferred();
            requestFunc.apply(null, requestArgs).done(defer.resolve).fail(makeUnauthorizedHandler(auth, defer, requestFunc, [ url, data, null, withCredentials, ret ]));
            return defer;
        }
        function resourceGet(auth, url, data, withCredentials, ret) {
            var accessToken = auth && auth.enabled() && auth.token ? auth.token : null;
            return resourceRequest(auth, get, url, data, accessToken, withCredentials, ret);
        }
        function resourcePost(auth, url, data, withCredentials, ret) {
            var accessToken = auth && auth.enabled() && auth.token ? auth.token : null;
            return resourceRequest(auth, post, url, data, accessToken, withCredentials, ret);
        }
        function resourceDelete(auth, url, data, withCredentials, ret) {
            var accessToken = auth && auth.enabled() && auth.token ? auth.token : null;
            return resourceRequest(auth, del, url, data, accessToken, withCredentials, ret);
        }
        function resourcePut(auth, url, data, withCredentials, ret) {
            var accessToken = auth && auth.enabled() && auth.token ? auth.token : null;
            return resourceRequest(auth, put, url, data, accessToken, withCredentials, ret);
        }
        request.get = get;
        request.post = post;
        request.put = put;
        request.del = del;
        extend(jyNS, {
            traceError: traceError,
            bindingTargetSource: bindingTargetSource,
            request: request,
            resource: {
                get: resourceGet,
                post: resourcePost,
                put: resourcePut,
                del: resourceDelete
            },
            utils: {
                isObject: isObject,
                compareObjects: compareObjects,
                notNullFilter: notNullFilter,
                filterByField: filterByField,
                findByRef: findByRef,
                onlyUnique: onlyUnique,
                selectField: selectField,
                arrayCount: arrayCount,
                arrayFlatten: arrayFlatten,
                arrayIntersect: arrayIntersect,
                first: arrayFirst,
                last: arrayLast,
                arrayFindIndex: arrayFindIndex,
                toArray: toArray,
                toUrlQuery: toUrlQuery,
                makeReqError: makeReqError,
                formatDate: formatDate,
                formatDateTime: formatDateTime,
                formatSize: formatSize,
                humanFileSize: humanFileSize,
                fileExtension: fileExtension,
                fileNameParts: fileNameParts,
                confirm: confirm,
                async: async
            }
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
"use strict";

(function(f, define) {
    "use strict";
    define("kendo.junkyard.templates", [ "kendo.junkyard.ns" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, extend = $.extend, junkyardNS = kendo.ui.junkyard;
        var templates = '<script type="text/x-kendo-template" id="jyt-access-item">\n    <div class="jy-access__list-item">\n        <span class="jy-user-info"\n            data-bind="lazyText: accessItemTitle"\n            data-default-text="Неизвестный"\n            data-progress-text="Загрузка..."></span>\n        <span class="jy-user-actions">\n            <span class="jy-permission-title" data-bind="text: permissionTitle"></span>\n            <span class="jy-permission-editor-wrapper"\n                data-role="junkyardfragment"\n                data-bind="model: createPermissionEditor"\n                data-template-id="jyt-permission-editor"></span>\n\n            <span data-bind="click: onRemoveAccess" class="jy-permission-remove">×</span>\n        </span>\n    </div>\n<\/script>\n<script type="text/x-kendo-template" id="jyt-access">\n    <div class="jy-access">\n        <section class="jy-access__list-wrap">\n            <h4 class="jy-access__list-title">Уровни доступа</h4>\n\n            <div class="jy-access__loading" data-bind="visible: accessListLoading">Загружается...</div>\n\n            <div class="jy-access__list"\n                 data-template="jyt-access-item"\n                 data-bind="source: accessList"\n                 data-auto-bind="false"></div>\n        </section>\n\n        <section class="jy-access__add">\n            <h4 class="jy-access__add-title">Пользователь или группа</h4>\n\n            <div class="jy-access__add-input-group">\n                <input data-role="autocomplete"\n                    data-placeholder="Введите имя пользователя или группы"\n                    data-text-field="title"\n                    data-filter="contains"\n                    data-template="jyt-user-or-group-item"\n                    data-bind="value: selectedUserOrGroup,\n                               source: userAndGroups,\n                               events: { change: onSelectUserOrGroup }"/>\n\n                <div class="jy-permission-title" data-bind="text: addPermissionEditor.value"></div>\n\n                <div class="jy-permission-editor-wrapper"\n                    data-role="junkyardfragment"\n                    data-bind="model: addPermissionEditor"\n                    data-template-id="jyt-permission-editor"></div>\n            </div>\n\n            <div class="jy-access__add-actions" data-bind="visible: addActionsVisible">\n                <button data-bind="click: onCancelAdd" class="jy-access__add-action">Отмена</button>\n                <button data-bind="click: onAddAccess" class="jy-access__add-action">Добавить</button>\n            </div>\n        </section>\n    </div>\n<\/script>\n\n<script type="text/x-kendo-template" id="jyt-change-size-dialog">\n    <div id="jy-window-${uid}"\n        class="jy-window"\n        data-role="window"\n        data-title="Изменить размер"\n        data-width="500"\n        data-height="190"\n        data-modal="true"\n        data-actions="[\'Close\']"\n        data-scrollable="true"\n        data-resizable="false"\n        data-visible="false">\n\n        <div class="jy-window__content">\n            <div class="jy-input-group">\n                <label class="jy-input-group__label">Введите новый размер, ГБ</label>\n                <input style="width: 100%;" id="jy-numeric-${uid}" type="text" data-role="numerictextbox" data-format="\\#.00 ГБ"\n                    data-bind="value: size"/>\n            </div>\n        </div>\n\n        <div class="jy-window__button-group">\n            <button class="jy-window__button" data-bind="click: onOk, enabled: isValid">Сохранить</button>\n            <button class="jy-window__button" data-bind="click: onCancel">Отмена</button>\n        </div>\n    </div>\n<\/script>\n<script type="text/x-kendo-template" id="jyt-circle-progress">\n    <div class="jy-circle-progress">\n        <svg\n            class="jy-circle-progress__circle"\n            viewBox="0 0 100 100"\n            data-bind="visible: visible">\n            <path\n                class="jy-circle-progress__circle__track"\n                d="M 50,50 m 0,-48 a 48,48 0 1 1 0,96 a 48,48 0 1 1 0,-96"\n                stroke="\\#eee"\n                stroke-width="1"\n                fill-opacity="0"></path>\n            <path\n                class="jy-circle-progress__circle__value"\n                d="M 50,50 m 0,-48 a 48,48 0 1 1 0,96 a 48,48 0 1 1 0,-96"\n                stroke="\\#000"\n                stroke-width="4"\n                fill-opacity="0"\n                stroke-dasharray="301.635, 301.635"\n                stroke-dashoffset="301.635"\n                data-bind="attr: {stroke-dashoffset: dashOffset, stroke-dasharray: dashArray}"></path>\n        </svg>\n\n        <div class="jy-circle-progress__text"\n            data-bind="text: percent, visible: textVisible"\n            data-format="\\#\\\\%"></div>\n    </div>\n<\/script>\n<script type="text/x-kendo-template" id="jyt-cloud-file-chooser-dialog">\n    <div id="jy-window-${uid}"\n        class="jy-window"\n        data-role="window"\n        data-title="Выбор файла"\n        data-width="${windowOpt.width}"\n        data-height="${windowOpt.height}"\n        data-min-width="400"\n        data-min-height="270"\n        data-modal="true"\n        data-actions="[\'Maximize\', \'Close\']"\n        data-scrollable="true"\n        data-resizable="true"\n        data-visible="false">\n\n        <div class="jy-window__content jy-window__content--no-padding">\n            <div id="jy-junkyard-${uid}"\n                data-role="junkyard"\n                data-server-api="${widgetOpt.serverApi}"\n                data-auth-api="${widgetOpt.authApi}"\n                data-file-handler-api="${widgetOpt.fileHandlerApi}"\n                data-debug-mode="${widgetOpt.debugMode}"\n                data-enable-routes="false"\n                data-persist-selection="true"\n                data-selection-item="file"\n                data-bind="events: {select: onSelect}"></div>\n        </div>\n\n        <div class="jy-window__button-group">\n            <button class="jy-window__button" data-bind="click: onOk, enabled: isValid">\n                <span data-bind="invisible: selectedItemsCount">Выбрать</span>\n                <span data-bind="visible: selectedItemsCount">Выбрать (<span data-bind="text: selectedItemsCount"></span>)</span>\n            </button>\n            <button class="jy-window__button" data-bind="click: onCancel">Отмена</button>\n        </div>\n    </div>\n<\/script>\n<script type="text/x-kendo-template" id="jyt-command-debug-item">\n    <li data-bind="css: {jy-command-done: isDone, jy-command-failed: isFailed}">\n        <div>${type}</div>\n        <div>\n            Статус:\n            <span data-bind="visible: isCreated">создана</span>\n            <span data-bind="visible: isDone">выполнена</span>\n            <span data-bind="visible: isFailed">ошибка</span>\n            <span data-bind="visible: isRunning">выполняется...</span>\n        </div>\n        <div>\n            Активна:\n            <span data-bind="visible: canExec">да</span>\n            <span data-bind="invisible: canExec">нет</span>\n        </div>\n        <div>\n            Параметры:\n            <pre>#if (args.noSerializeArgs) { #отключено# } else { ##=JSON.stringify(args, null, 2)## } #</pre>\n        </div>\n        <div data-bind="visible: isFailed">\n            Сообщение:\n            <div data-bind="text: lastErrorMessage"></div>\n        </div>\n        <div class="jy-command-date">#=kendo.toString(createdAt, \'t\')#</div>\n    </li>\n<\/script>\n<script type="text/x-kendo-template" id="jyt-context-menu-item">\n    <li data-command="${command}" data-bind="css: {jy-context-menu__separator--after: separator, k-state-disabled: disabled}, visible: visible">\n        <i class="fa fa-fw" data-bind="cssClass: icon"></i> <span data-bind="text: title"></span>\n    </li>\n<\/script>\n<script type="text/x-kendo-template" id="jyt-copy-item-dialog">\n    <div id="jy-window-${uid}"\n        class="jy-window"\n        data-role="window"\n        data-title="Скопировать в"\n        data-width="300"\n        data-height="500"\n        data-modal="true"\n        data-actions="[\'Close\']"\n        data-scrollable="true"\n        data-resizable="false"\n        data-visible="false">\n\n        <div class="jy-window__content jy-window__content--move-dialog">\n            <div class="jy-folder-chooser-wrap"\n                 data-role="junkyardfragment"\n                 data-bind="model: folderChooser, events: {createView: onCreateFolderChooser}"\n                 data-template-id="jyt-folder-chooser"></div>\n        </div>\n\n        <div class="jy-window__button-group">\n            <button class="jy-window__button" data-bind="click: onOk, enabled: isValid">Скопировать</button>\n            <button class="jy-window__button" data-bind="click: onCancel">Отмена</button>\n        </div>\n    </div>\n<\/script>\n<script type="text/x-kendo-template" id="jyt-create-btn">\n    <div class="jy-create-btn">\n        <div data-bind="click: onToggle, css: { jy-create-btn__disabled: authProgress }">Добавить</div>\n\n        <ul class="jy-selector"\n             data-bind="source: items, css: {jy-selector--opened: opened}"\n             data-template="jyt-create-item"></ul>\n    </div>\n<\/script>\n\n<script type="text/x-kendo-template" id="jyt-create-item">\n    <li class="jy-selector__item jy-selector__item--icon" data-bind="click: onSelect">\n        <i class="fa fa-fw ${icon}">#if (modIcon) {#<i class="fa ${modIcon} jy-mod-icon"></i>#}#</i>${title}\n    </li>\n<\/script>\n<script type="text/x-kendo-template" id="jyt-crop-editor-dialog">\n  <div id="jy-window-${uid}"\n      class="jy-window"\n      data-role="window"\n      data-title="Редактировать изображение"\n      data-width="850"\n      data-height="590"\n      data-min-width="460"\n      data-min-height="200"\n      data-modal="true"\n      data-actions="[\'Maximize\', \'Close\']"\n      data-scrollable="false"\n      data-resizable="true"\n      data-visible="false">\n\n      <div class="jy-window__content jy-window__content--no-padding">\n          <div id="jy-crop-editor-${uid}"\n              data-role="junkyardcropeditor"\n              data-aspect-ratio="${cropAspectRatio}"\n              data-fixed-aspect-ratio="${cropFixedAspectRatio}"\n              data-bind="imageUrl: sourceImageUrl, events: {cropChange: onCropChange, init: onCropEditorInit}"></div>\n      </div>\n\n      <div class="jy-window__button-group jy-crop-editor-dialog__button-group">\n          <button class="ba-c-btn ba-c-btn--small" data-bind="click: onCancel">Отмена</button>\n          <button class="ba-c-btn ba-c-btn--small ba-c-btn--primary" data-bind="click: onOk, enabled: isValid">Сохранить</button>\n      </div>\n  </div>\n<\/script>\n\n<script type="text/x-kendo-template" id="jyt-crop-editor-widget">\n    <div class="jy-crop-editor" data-bind="css: {\n        jy-crop-editor--init: isInit,\n        jy-crop-editor--loading: isLoading,\n        jy-crop-editor--no-image: isNoImage,\n        jy-crop-editor--no-support: isNoSupport,\n        jy-crop-editor--ready: isReady}">\n\n        <div class="jy-crop-editor__progress">\n            <div class="jy-crop-editor__progress__wrap">\n                <i class="fa fa-spinner fa-spin" />\n            </div>\n        </div>\n\n        <div class="jy-crop-editor__no-image">\n            <i class="fa fa-exclamation-triangle" /> Нет изображения\n        </div>\n\n        <div class="jy-crop-editor__no-support">\n            <i class="fa fa-exclamation-circle" />\n            <br/>Редактирование изображения<br/>не поддерживается\n        </div>\n\n        <div class="jy-crop-editor__surface">\n            <img class="jy-crop-editor__image" id="jy-crop-editor-image-${uid}" alt=""\n                data-bind="image: sourceUrl, events: {load: onSourceLoaded, error: onSourceError}"/>\n        </div>\n\n        <div class="jy-crop-editor__toolbar">\n            <div class="jy-crop-editor__toolbar__actions"\n                data-bind="source: actions"\n                data-template="jyt-crop-editor-widget-toolbar-action"></div>\n        </div>\n\n        <div class="jy-crop-editor__zoom-info" data-bind="visible: zoomVisible">\n            <span data-bind="text: zoom"></span>%\n        </div>\n\n        <div class="jy-crop-editor__info">\n            <div class="jy-crop-editor__preview">\n                <div id="jy-crop-editor-preview-${uid}"\n                    class="jy-crop-editor__preview__content"\n                    data-bind="css: {cropper-bg: outputBackgroundTransparent}, style: {background-color: outputBackgroundColor}"></div>\n            </div>\n\n            <div class="jy-crop-editor__info-box jy-crop-editor__size">\n                <div class="jy-crop-editor__info__header">Размер изображения</div>\n                <div class="jy-crop-editor__size__value">Ширина: <span data-bind="text: croppedWidth"></span><span class="editor__size__value__unit">px</span></div>\n                <div class="jy-crop-editor__size__value">Высота: <span data-bind="text: croppedHeight"></span><span class="editor__size__value__unit">px</span></div>\n            </div>\n\n            <div class="jy-crop-editor__info-box jy-crop-editor__aspect-ratio">\n                <div class="jy-crop-editor__info__header">Форма рамки</div>\n                <div class="jy-crop-editor__save__formats"\n                    data-bind="source: aspectRatioList"\n                    data-template="jyt-crop-editor-widget-aspect-ratio"/>\n            </div>\n\n            <div class="jy-crop-editor__info-box jy-crop-editor__save" data-bind="visible: outputInfoVisible">\n                <div class="jy-crop-editor__info__header">Сохранить как</div>\n\n                <div class="jy-crop-editor__save__formats"\n                    data-bind="source: outputFormats"\n                    data-template="jyt-crop-editor-widget-output-format"/>\n\n                <div class="jy-crop-editor__save__bg-tranparent" data-bind="visible: outputBackgroundTransparentVisible">\n                    <label class="jy-crop-editor__save__bg-tranparent__label" for="jy-checkbox-${uid}">Прозрачный фон</label>\n                    <input class="jy-crop-editor__save__bg-tranparent__checkbox"\n                        type="checkbox"\n                        id="jy-checkbox-${uid}"\n                        data-bind="checked: outputBackgroundTransparent, events: {change: onOutputBackgroundTransparentChange}"/>\n                </div>\n\n                <div class="jy-crop-editor__save__bg-color">\n                    <span class="jy-crop-editor__save__bg-color__label">Цвет фона:</span>\n                    <input class="jy-crop-editor__save__bg-color__picker" data-role="colorpicker"\n                        data-buttons="false"\n                        data-bind="\n                            enabled: outputBackgroundColorPickerEnabled,\n                            value: outputBackgroundColorValue,\n                            events: { select: onOutputBackgroundColorSelect }"/>\n                </div>\n\n                <div class="jy-crop-editor__save__filename" data-bind="visible: outputFileName">\n                    <span>Имя файла:</span>\n                    <span data-bind="text: outputFileName"></span>\n                </div>\n            </div>\n        </div>\n    </div>\n<\/script>\n\n<script type="text/x-kendo-template" id="jyt-crop-editor-widget-output-format">\n    <div class="jy-crop-editor__save__format"\n        data-bind="css: {jy-crop-editor__save__format--active: isOutputFormatActive}, click: onOutputFormatClick">${label}</div>\n<\/script>\n\n<script type="text/x-kendo-template" id="jyt-crop-editor-widget-aspect-ratio">\n    <div class="jy-crop-editor__save__format"\n        data-bind="css: {jy-crop-editor__save__format--active: isAspectRatioActive}, click: onAspectRatioClick">\n        # if (data.icon) { #\n            <i class="fa fa-${data.icon}"></i>\n        # } else { #\n            ${label}\n        # } #\n    </div>\n<\/script>\n\n<script type="text/x-kendo-template" id="jyt-crop-editor-widget-toolbar-action">\n    <div class="jy-crop-editor__toolbar__action"\n        title="${title}"\n        data-bind="css: {\n            jy-crop-editor__toolbar__action--active: active,\n            jy-crop-editor__toolbar__action--disabled: disabled\n        }, click: click">\n        <i class="fa fa-${icon}"></i>\n    </div>\n<\/script>\n<script type="text/x-kendo-template" id="jyt-details">\n\t<div class="jy-details" data-bind="css: {jy-details--opened: opened}">\n\t\t<div class="jy-details__close" data-bind="click: close">×</div>\n\n\t\t<div class="jy-details__progress" data-bind="visible: loading">\n\t\t\t<svg class="jy-loading-hexes"\n\t\t\t\tdata-role="junkyardsvgprogress"\n\t\t\t\txmlns="http://www.w3.org/2000/svg"\n\t\t\t\tviewBox="0 0 100 100"\n\t\t\t\twidth="100"\n\t\t\t\theight="100"\n\t\t\t\tfill-rule="evenodd"\n\t\t\t\tclip-rule="evenodd"></svg>\n\t\t</div>\n\n\t\t<div class="jy-details__content">\n\t\t\t<div class="jy-details__header">\n\t\t\t\t<svg class="jy-icon-file jy-icon-file-folder" data-bind="visible: details.isFolder">\n\t\t\t\t\t<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="\\#jy-icon-file-folder"></use>\n\t\t\t\t</svg>\n\t\t\t\t<svg class="jy-icon-file" data-bind="visible: details.isFile, cssClass: fileTypeIconClass, html: fileTypeSvgIconRef"></svg>\n\t\t\t\t<i class="fa fa-hdd-o" data-bind="visible: details.isDrive"><i data-bind="visible: details.isEncrypted" class="fa fa-lock jy-mod-icon"></i></i>\n\t\t\t\t<span data-bind="text: details.title"></span>\n\t\t\t</div>\n\n\t\t\t<div data-bind="invisible: loading">\n\t\t\t\t<div class="jy-details-tabs" data-bind="visible: details.tabsEnabled">\n\t\t\t\t\t<div class="jy-details-tab-link" data-bind="click: openPropertyTab, css: { jy-details-tab-link--current: details.propertyTab }">Свойства</div>\n\t\t\t\t\t<div class="jy-details-tab-link" data-bind="click: openHistoryTab, css: { jy-details-tab-link--current: details.historyTab }">История</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div data-bind="visible: details.propertyTab">\n\t\t\t\t\t<div class="jy-details__preview" data-bind="visible: details.isFile">\n\t\t\t\t\t\t<svg class="jy-icon-file" data-bind="visible: details.isFileTypeIcon, cssClass: fileTypeIconClass, html: fileTypeSvgIconRef"></svg>\n\t\t\t\t\t\t<div class="jy-details__preview-loading" data-bind="visible: details.isPreviewLoading">\n\t\t\t\t\t\t\t<svg class="jy-loading-hexes"\n\t\t\t\t\t\t\t\tdata-role="junkyardsvgprogress"\n\t\t\t\t\t\t\t\txmlns="http://www.w3.org/2000/svg"\n\t\t\t\t\t\t\t\tviewBox="0 0 100 100"\n\t\t\t\t\t\t\t\twidth="100"\n\t\t\t\t\t\t\t\theight="100"\n\t\t\t\t\t\t\t\tfill-rule="evenodd"\n\t\t\t\t\t\t\t\tclip-rule="evenodd"></svg>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<img alt="" data-bind="css: { jy-visualy-hidden: details.isPreviewLoading }, visible: details.previewUrl, imageAjax: details.previewUrl, events: { load: onPreviewLoad }"/>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="jy-details__drive-space jy-drive-space" data-bind="visible: details.isDrive">\n\t\t\t\t\t\t<div class="jy-drive-space__remain-total">\n\t\t\t\t\t\t\t<span data-bind="invisible: details.space.isUnlimited">\n\t\t\t\t\t\t\t\tСвободно\n\t\t\t\t\t\t\t\t<span data-bind="text: details.space.freeTitle"></span>\n\t\t\t\t\t\t\t\tиз\n\t\t\t\t\t\t\t\t<span data-bind="text: details.space.quotaTitle"></span>\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t<span data-bind="visible: details.space.isUnlimited">Неограниченно</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="jy-drive-space__progress-bar">\n\t\t\t\t\t\t\t<div class="jy-drive-space__used"\n\t\t\t\t\t\t\t\tdata-bind="style: { width: details.space.usedPercent }, css: { jy-drive-space__ends: details.space.ends }"></div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="jy-drive-space__used-info">\n\t\t\t\t\t\t\tЗанято <span data-bind="text: details.space.usedTitle"></span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="jy-details__access" data-bind="visible: details.access.enabled">\n\t\t\t\t\t\t<span data-bind="visible: details.access.isPrivate"><i class="fa fa-user-secret"></i>&nbsp;Без общего доступа</span>\n\n\t\t\t\t\t\t<div class="jy-details-access-list"\n\t\t\t\t\t\t\tdata-template="jyt-details-access-item"\n\t\t\t\t\t\t\tdata-bind="source: details.access.items, invisible: details.access.isPrivate"></div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="jy-details__props">\n\t\t\t\t\t\t<div class="jy-details__prop">\n\t\t\t\t\t\t\t<span class="jy-details__prop-label">Тип</span>\n\t\t\t\t\t\t\t<span class="jy-details__prop-value" data-bind="visible: details.isDrive">Диск</span>\n\t\t\t\t\t\t\t<span class="jy-details__prop-value" data-bind="visible: details.isFile">Файл</span>\n\t\t\t\t\t\t\t<span class="jy-details__prop-value" data-bind="visible: details.isFolder">Папка</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="jy-details__prop" data-bind="visible: details.isItem">\n\t\t\t\t\t\t\t<span class="jy-details__prop-label">Размер</span>\n\t\t\t\t\t\t\t<span class="jy-details__prop-value">\n\t\t\t\t\t\t\t\t<span data-bind="visible: details.size, text: details.sizeText"></span>\n\t\t\t\t\t\t\t\t<span data-bind="invisible: details.size">&mdash;</span>\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="jy-details__prop">\n\t\t\t\t\t\t\t<span class="jy-details__prop-label">Расположение</span>\n\t\t\t\t\t\t\t<span class="jy-details__prop-value" data-bind="lazyText: locationTitle" data-default-text="-"></span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="jy-details__prop" data-bind="visible: details.owner">\n\t\t\t\t\t\t\t<span class="jy-details__prop-label">Владелец</span>\n\t\t\t\t\t\t\t<span class="jy-details__prop-value" data-bind="lazyText: ownerTitle" data-default-text="Неизвестный">я</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="jy-details__prop" data-bind="visible: details.isDrive">\n\t\t\t\t\t\t\t<span class="jy-details__prop-label">Шифрование</span>\n\t\t\t\t\t\t\t<span class="jy-details__prop-value">\n\t\t\t\t\t\t\t\t<span data-bind="visible: details.isEncrypted">Да</span>\n\t\t\t\t\t\t\t\t<span data-bind="invisible: details.isEncrypted">Нет</span>\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="jy-details__prop" data-bind="visible: details.isDrive">\n\t\t\t\t\t\t\t<span class="jy-details__prop-label">История</span>\n\t\t\t\t\t\t\t<span class="jy-details__prop-value">\n\t\t\t\t\t\t\t\t<span data-bind="visible: details.isHistory">Да</span>\n\t\t\t\t\t\t\t\t<span data-bind="invisible: details.isHistory">Нет</span>\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="jy-details__prop" data-bind="visible: details.isDrive">\n\t\t\t\t\t\t\t<span class="jy-details__prop-label">Сетевая корзина</span>\n\t\t\t\t\t\t\t<span class="jy-details__prop-value">\n\t\t\t\t\t\t\t\t<span data-bind="visible: details.isTrashBin">Да</span>\n\t\t\t\t\t\t\t\t<span data-bind="invisible: details.isTrashBin">Нет</span>\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="jy-details__prop" data-bind="visible: details.label">\n\t\t\t\t\t\t\t<span class="jy-details__prop-label">Метка</span>\n\t\t\t\t\t\t\t<span class="jy-details__prop-value">\n\t\t\t\t\t\t\t\t<input class="jy-details__prop-input"\n\t\t\t\t\t\t\t\t\ttype="text"\n\t\t\t\t\t\t\t\t\tdata-bind="click: onInputAllSelect, value: details.label" readonly />\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="jy-details__prop" data-bind="visible: details.createDate">\n\t\t\t\t\t\t\t<span class="jy-details__prop-label">Дата создания</span>\n\t\t\t\t\t\t\t<span class="jy-details__prop-value" data-bind="text: details.createDate"></span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="jy-details__prop" data-bind="visible: details.modifyDate">\n\t\t\t\t\t\t\t<span class="jy-details__prop-label">Дата изменения</span>\n\t\t\t\t\t\t\t<span class="jy-details__prop-value" data-bind="text: details.modifyDate"></span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="jy-details__prop" data-bind="visible: details.createBy">\n\t\t\t\t\t\t\t<span class="jy-details__prop-label">Создан</span>\n\t\t\t\t\t\t\t<span class="jy-details__prop-value" data-bind="lazyText: details.createBy"></span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class="jy-details__prop" data-bind="visible: details.modifyBy">\n\t\t\t\t\t\t\t<span class="jy-details__prop-label">Изменен</span>\n\t\t\t\t\t\t\t<span class="jy-details__prop-value" data-bind="lazyText: details.modifyBy"></span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div data-bind="visible: details.isDrive" class="jy-details__copy-url">\n\t\t\t\t\t\t<label for="jy-webdav-link-input-${uid}" class="jy-details__copy-url-label">Ссылка на WebDav:</label>\n\t\t\t\t\t\t<div class="jy-details__copy-url-group">\n\t\t\t\t\t\t\t<input id="jy-webdav-link-input-${uid}"\n\t\t\t\t\t\t\t\tclass="jy-details__copy-url-input"\n\t\t\t\t\t\t\t\ttype="text"\n\t\t\t\t\t\t\t\tdata-bind="click: onInputAllSelect, value: details.webdavUrl" readonly />\n\t\t\t\t\t\t\t<button class="jy-details__copy-url-copy-button"\n\t\t\t\t\t\t\t\ttype="button"\n\t\t\t\t\t\t\t\tdata-ref="jy-webdav-link-input-${uid}"\n\t\t\t\t\t\t\t\tdata-bind="click: onCopyToClipboard">\n\t\t\t\t\t\t\t\t\t<i class="fa fa-clipboard" aria-hidden="true"></i>\n\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div style="display: none;">\n\t\t\t\t\t\t<button class="jy-details__encrypt" type="button" data-bind="invisible: details.isEncrypted">\n\t\t\t\t\t\t\t<i class="fa fa-lock" aria-hidden="true"></i>&nbsp;Зашифровать\n\t\t\t\t\t\t</button>\n\t\t\t\t\t</div>\n\n                    <div class="jy-details__tags" data-bind="invisible: details.isDrive">\n                        <div class="jy-details__tags__label">Теги</div>\n                        <div data-role="junkyardtags" data-bind="value: details.tags, events: {change: onItemTagsChanged}"></div>\n                    </div>\n\n                    <div class="jy-details__description" data-bind="invisible: details.isDrive">\n                        <div class="jy-details__description__label">Описание</div>\n                        <textarea class="jy-details__description__textarea"\n                            data-bind="value: details.description, events: {keyup: itemDescriptionChangedHandler}"\n                            data-value-update="keyup"></textarea>\n                        <div data-bind="visible: details.descriptionSaving" class="jy-details__description__saving">Сохранение…</div>\n                    </div>\n\t\t\t\t</div>\n\n\t\t\t\t<div data-bind="visible: details.historyTab">\n\t\t\t\t\t<div class="jy-details__progress" data-bind="visible: details.historyLoading">\n\t\t\t\t\t\t<svg class="jy-loading-hexes"\n\t\t\t\t\t\t\tdata-role="junkyardsvgprogress"\n\t\t\t\t\t\t\txmlns="http://www.w3.org/2000/svg"\n\t\t\t\t\t\t\tviewBox="0 0 100 100"\n\t\t\t\t\t\t\twidth="100"\n\t\t\t\t\t\t\theight="100"\n\t\t\t\t\t\t\tfill-rule="evenodd"\n\t\t\t\t\t\t\tclip-rule="evenodd"></svg>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<div class="jy-details-history" data-auto-bind="false"\n\t\t\t\t\t\t data-template="jyt-details-history-item"\n\t\t\t\t\t\t data-bind="source: details.historyDataSource"></div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n<\/script>\n\n<script type="text/x-kendo-template" id="jyt-details-access-item">\n\t<div class="jy-details-access-list__item">\n\t\t<i class="fa fa-user-circle"></i>\n\t\t<span class="jy-details-access-list__user-name"\n\t\t\tdata-bind="lazyText: accessTitle"\n\t\t\tdata-default-text="Неизвестный"\n\t\t\tdata-progress-text="Загрузка..."></span>\n\t\t<span class="jy-details-access-list__permission" data-bind="text: permissionTitle"></span>\n\t</div>\n<\/script>\n\n<script type="text/x-kendo-template" id="jyt-details-history-item">\n\t<div class="jy-details-history__item">\n\t\t<div class="jy-details-history__version" data-bind="visible: isCurrent">Текущая версия</div>\n\t\t<div>\n\t\t\t<span class="jy-details-history__modify-date" data-bind="text: historyModifyDate"></span>\n\t\t\t<span class="jy-details-history__modify-by" data-bind="lazyText: historyModifyBy"></span>\n\t\t</div>\n\t\t<div class="jy-details-history__file-wrap">\n\t\t\t<div class="jy-details-history__file">\n\t\t\t\t<svg class="jy-icon-file" data-bind="cssClass: fileTypeIconClass, html: fileTypeSvgIconRef"></svg>\n\t\t\t\t<span class="jy-details-history__filename" data-bind="text: title"></span>\n\t\t\t</div>\n\t\t\t<span class="jy-details-history__file-restore" data-bind="visible: version, click: onRestoreVersion">восстановить</span>\n\t\t\t<span data-bind="click: onOpenPreviewVersion" class="jy-details-history__file-preview"><span>Просмотр</span><i class="fa fa-eye"></i></span>\n\t\t</div>\n\t</div>\n<\/script>\n\n<script type="text/x-kendo-template" id="jyt-drive-item">\n    <div class="jy-cards-section__item" data-bind="events: {click: onDriveClick, dblclick: onDoubleClick}">\n        <div class="jy-cards-section__item-inner jy-card-item jy-card-item--drive jy-cards-section__ctx" data-bind="css: { jy-card-item--encrypted-drive: isEncrypted }">\n            <div class="jy-card-item__about">\n                <i class="fa fa-hdd-o jy-card-item__icon">#if (isEncrypted) {#<i class="fa fa-lock jy-mod-icon"></i>#}#</i>\n                <span class="jy-card-item__name">${title}</span>\n            </div>\n        </div>\n    </div>\n<\/script>\n\n<script type="text/x-kendo-template" id="jyt-file-item">\n    <div class="jy-cards-section__item" data-bind="events: {dblclick: onFileDoubleClick}">\n        <div class="jy-cards-section__item-inner jy-card-item jy-card-item--file jy-cards-section__ctx jy-card-item--file-${kendo.ui.junkyard.fileTypeIcon(extension)}" data-bind="css: { jy-card-item--thumb-loaded: previewLoaded }">\n            <figure class="jy-card-item__thumb">\n                <div class="jy-card-item__thumb-image-wrap">\n                    <img class="jy-card-item__thumb-image" alt=""\n                    data-bind="visible: previewUrl, imageAjax: previewUrl, css: { jy-card-item__thumb-image--vertical: previewVertical }, events: { load: onPreviewLoad }"/>\n                </div>\n\n                <div class="jy-card-item__thumb-icon" data-bind="css: { jy-card-item__thumb-icon--hidden: previewLoaded }">\n                    <svg class="jy-icon-file jy-icon-file-${kendo.ui.junkyard.fileTypeIcon(extension)}">\n                        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="\\#jy-icon-file-${kendo.ui.junkyard.fileTypeIcon(extension)}"></use>\n                    </svg>\n                </div>\n            </figure>\n            <div class="jy-card-item__about">\n                <svg class="jy-icon-file jy-icon-file-${kendo.ui.junkyard.fileTypeIcon(extension)}">\n                    <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="\\#jy-icon-file-${kendo.ui.junkyard.fileTypeIcon(extension)}"></use>\n                </svg>\n\n                #if (HasActiveLinks) {#\n                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 1024 1024" style="margin-right: 8px;">\n                        <title></title>\n                        <g id="icomoon-ignore"></g>\n                        <path style="height: 100%; width: 100%" d="M810.56 314.88l-112 193.984c-17.696 30.592-56.8 41.088-87.424 23.392l-27.68-16 32-55.392c15.296 8.8 34.88 3.584 43.68-11.712l80-138.56c8.832-15.328 3.584-34.88-11.68-43.712l-110.88-64c-15.328-8.832-34.88-3.584-43.68 11.712l-80 138.56c-8.864 15.328-3.616 34.88 11.68 43.712l-32 55.392-27.68-16c-30.624-17.664-41.12-56.8-23.424-87.392l112-193.984c17.696-30.624 56.8-41.088 87.424-23.424l166.24 96c30.624 17.664 41.12 56.8 23.424 87.424zM432 650.56c-15.328-8.832-20.576-28.416-11.712-43.712l128-221.696c8.832-15.328 28.416-20.576 43.712-11.712s20.576 28.416 11.68 43.712l-128 221.696c-8.8 15.296-28.352 20.512-43.68 11.712zM408.576 563.168v0c-15.328-8.832-34.88-3.584-43.712 11.68l-80 138.56c-8.832 15.328-3.584 34.88 11.712 43.712l110.88 64c15.296 8.832 34.88 3.584 43.68-11.712l80-138.56c8.832-15.296 3.584-34.88-11.68-43.712v0l32-55.392 27.68 16c30.624 17.664 41.12 56.768 23.424 87.392l-112 193.984c-17.696 30.624-56.8 41.088-87.424 23.424l-166.272-96c-30.624-17.696-41.12-56.8-23.424-87.424l112-193.984c17.696-30.624 56.832-41.12 87.456-23.424l27.68 16-32 55.456z"></path>\n                    </svg>\n                #}#\n\n                <span class="jy-card-item__name">${title}</span>\n            </div>\n        </div>\n    </div>\n<\/script>\n\n<script type="text/x-kendo-template" id="jyt-folder-chooser">\n    <div class="jy-folder-chooser">\n        <div id="jy-tree-view-${uid}"\n             data-role="junkyardtreeview"\n             data-text-field="title"\n             data-bind="source: dataSource, events: {change: onSelect}"\n             data-auto-bind="false"\n             data-template="jyt-menu-item"\n             class="jy-treeview"></div>\n    </div>\n<\/script>\n<script type="text/x-kendo-template" id="jyt-folder-item">\n    <div class="jy-cards-section__item jy-cards-section__item--tighter jy-cards-section__item--folder" data-bind="events: {click: onFolderClick, dblclick: onFolderDoubleClick}">\n        <div class="jy-cards-section__item-inner jy-card-item jy-card-item--folder jy-cards-section__ctx">\n            <div class="jy-card-item__about">\n                <svg class="jy-icon jy-icon-folder">\n                    <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="\\#jy-icon-folder"></use>\n                </svg>\n                <div class="jy-card-item__name">${title}</div>\n            </div>\n        </div>\n    </div>\n<\/script>\n\n<script type="text/x-kendo-template" id="jyt-grid-drive-item">\n    <tr data-uid="${uid}" class="jy-cards-section__ctx jy-grid-item" data-bind="events: {dblclick: onDoubleClick}">\n        <td>\n            <i class="fa fa-hdd-o"></i>\n            <span class="jy-grid-item__name">${title}</span>\n        </td>\n    </tr>\n<\/script>\n\n<script type="text/x-kendo-template" id="jyt-grid-item">\n    <tr data-uid="${uid}" class="jy-cards-section__ctx jy-grid-item #if (type === \'Directory\') {# jy-grid-item--folder #}#" data-bind="events: {dblclick: onDoubleClick}">\n        <td>\n            # if (type === "File") { #\n                <div class="jy-icon-wrap">\n                    <svg class="jy-icon-file jy-icon-file-${kendo.ui.junkyard.fileTypeIcon(extension)}">\n                        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="\\#jy-icon-file-${kendo.ui.junkyard.fileTypeIcon(extension)}"></use>\n                    </svg>\n                </div>\n            # } else { #\n                <div class="jy-icon-wrap">\n                    <svg class="jy-icon-file jy-icon-file-folder">\n                        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="\\#jy-icon-file-folder"></use>\n                    </svg>\n                </div>\n            # } #\n\n            <span class="jy-grid-item__name">${title}</span>\n        </td>\n        <td>\n            <span data-bind="lazyText: lazyCreateBy"\n                data-default-text="Неизвестный"></span>\n        </td>\n        <td>#= kendo.ui.junkyard.utils.formatDateTime(modifyDate, \'\') #</td>\n        <td>#= kendo.ui.junkyard.utils.formatSize(size, \'&mdash;\') #</td>\n    </tr>\n<\/script>\n<script type="text/x-kendo-template" id="jyt-icons">\n    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="display:none">\n        <symbol id="jy-loading-hexes" viewBox="0 0 100 100" width="100" height="100">\n            <path class="jy-loading-hexes__outer" d="M48,7.854C49.238,7.14 50.763,7.14 52,7.854C58.502,11.608 78.998,23.441 85.501,27.195C86.738,27.909 87.5,29.23 87.5,30.659L87.5,69.342C87.5,70.771 86.738,72.091 85.501,72.806C78.999,76.56 58.503,88.393 52,92.148C50.763,92.862 49.238,92.862 48,92.148C41.498,88.393 21.003,76.56 14.5,72.806C13.263,72.092 12.501,70.771 12.501,69.342L12.501,30.659C12.501,29.23 13.263,27.91 14.5,27.195L48,7.854L48,7.854Z"/>\n            <path class="jy-loading-hexes__middle" d="M48.5,19.112C49.428,18.576 50.572,18.576 51.5,19.112L76,33.257C76.928,33.793 77.5,34.784 77.5,35.855L77.5,64.146C77.5,65.218 76.928,66.208 76,66.744C71.207,69.512 56.293,78.122 51.5,80.889C50.572,81.425 49.428,81.425 48.5,80.889C43.706,78.122 28.793,69.512 24,66.744C23.071,66.208 22.5,65.218 22.5,64.146L22.5,35.855C22.5,34.784 23.071,33.793 24,33.257C28.793,30.49 43.706,21.879 48.5,19.112L48.5,19.112Z"/>\n            <path class="jy-loading-hexes__core" d="M49,30.947C49.619,30.59 50.381,30.59 51,30.947C54.013,32.687 62.986,37.867 66,39.607C66.619,39.964 67,40.624 67,41.339L67,58.659C67,59.373 66.619,60.034 66,60.391C62.987,62.131 54.014,67.311 51,69.051C50.381,69.408 49.619,69.408 49,69.051C45.987,67.311 37.014,62.131 34,60.391C33.381,60.034 33,59.374 33,58.659L33,41.339C33,40.624 33.381,39.964 34,39.607C37.014,37.867 45.987,32.687 49,30.947L49,30.947Z"/>\n        </symbol>\n        <symbol id="jy-icon-arrow" viewBox="0 0 24 24">\n            <path d="M14 21l9-9-9-9M23 12h-22" stroke-linecap="round" fill="none"/>\n        </symbol>\n        <symbol id="jy-icon-folder" viewBox="0 0 100 100">\n            <path d="M9.55 24.159c0-2.761 2.239-5 5-5h24.766c.731 0 1.436.267 1.984.75l6.719 5.925h37.431c2.761 0 5 2.239 5 5v45.008c0 2.761-2.239 5-5 5h-70.9c-2.761 0-5-2.239-5-5v-51.683z" stroke-width=".5"/>\n            <path d="M85.95 33.052c0-2.818-1.87-5.103-4.178-5.103h-59.247c-2.307 0-4.178 2.285-4.178 5.103v39.802c0 2.818 1.871 5.103 4.178 5.103h59.247c2.308 0 4.178-2.285 4.178-5.103v-39.802z" stroke-width=".5" transform="matrix(1.197 0 0 .98 -12.406 4.455)"/>\n        </symbol>\n        <symbol id="jy-icon-file-folder" viewBox="0 0 2048 1792">\n            <path d="M962.884 128h3.191c2.269.1 4.537.2 6.8.4 6.433.5 12.827 1.5 19.112 3 8.403 2 16.613 4.8 24.473 8.3 7.98 3.7 15.59 8.2 22.68 13.3 5.81 4.3 11.27 9 16.29 14.2 1.8 1.8 3.54 3.7 5.23 5.6.79 1 1.58 1.9 2.35 2.8l170.59 208.3c196.96 0 393.93-.3 590.9 0l1.49.1c1.82 0 3.63 0 5.45.1 3.78.2 7.55.5 11.31.9 10.38 1.3 20.64 3.5 30.58 6.7 9.59 3.2 18.89 7.2 27.73 12 8.74 4.8 17.03 10.5 24.72 16.8 11.44 9.4 21.55 20.4 29.96 32.6 8.41 12.3 15.11 25.6 19.85 39.7 3.61 10.6 6.08 21.7 7.37 32.9.45 3.9.75 7.8.91 11.8.08 2 .12 4 .13 5.9.5 320.4.51 640.8 0 961.1-.01 2.2-.06 4.5-.16 6.7-.19 4.2-.54 8.5-1.06 12.7-1.37 11-3.88 21.8-7.5 32.3-3.86 11.2-8.97 21.9-15.2 32-6.5 10.5-14.22 20.2-22.94 28.9-8.73 8.7-18.46 16.5-28.94 23-10.05 6.2-20.78 11.3-31.95 15.2-10.49 3.6-21.36 6.1-32.37 7.5-4.21.5-8.44.8-12.67 1-2.23.1-4.46.2-6.69.2-533.68.8-1067.36.8-1601.038 0-2.231 0-4.462-.1-6.692-.2-4.234-.2-8.461-.5-12.667-1-11.012-1.4-21.879-3.9-32.368-7.5-11.173-3.9-21.909-9-31.954-15.2-10.486-6.5-20.214-14.3-28.938-23s-16.44-18.4-22.942-28.9c-6.229-10.1-11.339-20.8-15.197-32-3.622-10.5-6.137-21.3-7.501-32.3-.522-4.2-.876-8.5-1.063-12.7-.099-2.2-.149-4.5-.159-6.7-.642-405.7-.63-811.3 0-1217 .008-1.8.042-3.7.11-5.5.141-3.8.416-7.5.825-11.3 1.146-10.6 3.348-21 6.56-31.1 3.001-9.5 6.885-18.6 11.584-27.4 4.642-8.6 10.08-16.8 16.223-24.5 9.392-11.7 20.429-22 32.692-30.6 12.393-8.7 26.024-15.7 40.361-20.6 10.661-3.6 21.705-6.1 32.892-7.4 4.086-.5 8.191-.8 12.302-1 1.983-.1 3.968-.1 5.953-.1 246.46-.4 492.921-.4 739.381 0zm376.786 383.9h-1147.9c-.187 330.7.23 661.3.23 992l.003.5c.023 1.7.157 3.3.419 4.9.354 2.2.941 4.3 1.751 6.4 2.052 5.2 5.514 9.8 9.87 13.3 1.283 1 2.644 2 4.067 2.8 1.064.6 2.165 1.2 3.294 1.6.651.3 1.311.6 1.981.8 1.114.4 2.247.7 3.397 1 2.262.5 4.589.8 6.909.8 533.352 2 1066.709 0 1600.069 0h.61c1.06 0 2.12-.1 3.17-.2l1.2-.1 2.48-.5c1.93-.4 3.83-1.1 5.65-1.9 1.87-.8 3.65-1.8 5.33-3 .8-.5 1.58-1.1 2.33-1.8.91-.7 1.79-1.5 2.61-2.4 1.46-1.5 2.78-3.2 3.92-5 1.3-2 2.37-4.2 3.17-6.5.74-2.1 1.25-4.3 1.52-6.5.16-1.3.24-2.7.25-4 .53-320 0-640 0-960.1v-.5c-.02-1.1-.09-2.3-.23-3.4-.21-1.7-.55-3.4-1.02-5-.73-2.6-1.8-5-3.15-7.3-.38-.7-.79-1.4-1.23-2l-.59-.8c-.25-.4-.51-.7-.77-1-.34-.4-.68-.8-1.03-1.2-.5-.6-1.01-1.1-1.54-1.7-1.05-1-2.18-2-3.36-2.8-2.1-1.6-4.39-2.9-6.8-3.9-2.46-1-5.05-1.7-7.69-2.1-.99-.2-1.98-.3-2.97-.3l-1.87-.1h-484.08zm-270.52-128c-34.46-42.9-69.04-85.7-105.223-127.2-.27-.3-.62-.6-1.013-.7h-.409c-246.166-6.4-492.496 0-738.744 0h-1.381c-.854.1-1.708.1-2.557.3-2.337.3-4.638.8-6.851 1.6-2.787 1.1-5.427 2.5-7.826 4.2-1.931 1.4-3.708 3.1-5.275 4.9-.659.7-1.279 1.5-1.868 2.3-.7 1-1.335 2-1.92 3-1.205 2.2-2.157 4.5-2.836 6.8-.477 1.7-.823 3.4-1.025 5.1-.143 1.2-.216 2.5-.222 3.7-.049 32-.091 64-.126 96h877.276z"/>\n            <path fill-opacity=".5" d="M191.91 521.52h1664.922v1025.103h-1664.922z"/>\n            <path fill-opacity=".25" d="M191.841 261.835h877.28v130.658h-877.28z"/>\n        </symbol>\n        <symbol id="jy-icon-file-default" viewBox="0 0 2048 1792" fill-rule="evenodd" clip-rule="evenodd">\n            <path d="M1417.03 128c3.42.1 6.84.2 10.24.5 6.75.6 13.45 1.8 20 3.6 6.27 1.6 12.41 3.8 18.33 6.5 5.93 2.7 11.63 5.9 17.03 9.5 4.13 2.8 8.08 5.8 11.83 9.1 1.94 1.7 3.81 3.4 5.64 5.2 150.06 149.6 299.89 299.5 449.49 449.5 1.81 1.9 3.56 3.7 5.25 5.7 3.27 3.7 6.3 7.7 9.07 11.8 3.63 5.4 6.81 11.1 9.5 17 2.69 6 4.89 12.1 6.57 18.4 1.75 6.5 2.94 13.2 3.54 20 .31 3.4.46 6.8.48 10.2.42 269.9.43 539.7 0 809.6-.01 2.2-.06 4.4-.16 6.7-.19 4.2-.54 8.4-1.06 12.6-1.37 11-3.88 21.9-7.5 32.4-3.86 11.2-8.97 21.9-15.2 31.9-6.5 10.5-14.22 20.3-22.94 29-8.73 8.7-18.46 16.4-28.94 22.9-10.05 6.2-20.78 11.4-31.95 15.2-10.49 3.6-21.36 6.2-32.37 7.5-4.21.5-8.44.9-12.67 1.1-2.23.1-4.46.1-6.69.1-533.68.9-1067.36.9-1601.038 0-2.231 0-4.462 0-6.692-.1-4.234-.2-8.461-.6-12.667-1.1-11.012-1.3-21.879-3.9-32.368-7.5-11.173-3.8-21.909-9-31.954-15.2-10.486-6.5-20.214-14.2-28.938-22.9s-16.44-18.5-22.942-29c-6.229-10-11.339-20.7-15.197-31.9-3.622-10.5-6.137-21.4-7.501-32.4-.522-4.2-.876-8.4-1.063-12.6-.099-2.3-.149-4.5-.159-6.7-.642-405.7-.63-811.4 0-1217.1.009-1.9.049-3.9.129-5.9.166-4.1.49-8.2.972-12.3 1.32-11.2 3.826-22.2 7.462-32.9 4.89-14.3 11.824-28 20.534-40.4 8.619-12.2 18.967-23.3 30.649-32.7 7.64-6.1 15.846-11.5 24.48-16.2 8.74-4.7 17.916-8.6 27.374-11.6 10.12-3.2 20.559-5.4 31.115-6.5 3.765-.4 7.544-.7 11.329-.8l5.458-.2c397.843-.6 795.687-.6 1193.527 0zm-79.34 128h-1113.59c-1.224 0-2.444.1-3.66.2-2.496.3-4.958.9-7.32 1.7-2.85 1.1-5.552 2.5-8 4.3-2.633 1.9-4.968 4.3-6.9 6.9-2.086 2.8-3.697 6-4.751 9.4-.616 1.9-1.043 3.9-1.271 6-.125 1.1-.189 2.2-.197 3.3-1.886 405.4-.001 810.8-.001 1216.1l.003.6c.022 1.5.14 3.1.372 4.6.325 2.1.869 4.2 1.628 6.2.663 1.8 1.486 3.5 2.452 5.1 3.726 6.2 9.565 11.1 16.363 13.7 1.987.7 4.051 1.2 6.148 1.6 1.629.2 3.276.3 4.924.3 533.334.9 1066.67 0 1600 0h.56c1.6 0 3.2-.1 4.78-.4 2.06-.3 4.09-.8 6.05-1.6 8.42-3.1 15.36-10 18.61-18.4.89-2.3 1.49-4.7 1.82-7.1.14-1.1.22-2.1.27-3.1.01-.5.02-1 .02-1.5v-729.5c-101.66 0-203.33.1-305-.1-2.97 0-5.94 0-8.9-.2-5.66-.2-11.3-.7-16.92-1.4-14.75-1.8-29.31-5.2-43.36-10-9.87-3.4-19.48-7.6-28.74-12.4-9.35-4.9-18.34-10.4-26.88-16.6-9.52-6.9-18.47-14.6-26.73-22.9-7.06-7.2-13.62-14.8-19.61-22.9-7.06-9.5-13.33-19.6-18.72-30.1-4.96-9.7-9.18-19.7-12.61-30.1-4.47-13.5-7.59-27.4-9.29-41.5-.68-5.6-1.13-11.3-1.37-16.9-.12-3-.17-5.9-.18-8.9v-304.4zm-792.348 1152.4h-87.246v-112.5c-91.429-13.9-144.614-73.6-144.614-148.5 0-74.8 53.185-134.5 144.614-148.4v-112.6h87.246v112.6c91.429 13.9 144.613 73.6 144.613 148.4 0 74.9-53.184 134.6-144.613 148.5v112.5zm501.968-116h-89.641v-27.2c-19.72 22-49.001 35.4-89.039 35.4-78.282 0-142.82-66.7-142.82-153.2 0-86.4 64.538-153.1 142.82-153.1 40.038 0 69.319 13.4 89.039 35.4v-27.3h89.641v290zm672.27 0h-89.64v-206.4h-64.54v86.4c0 87.6-45.41 129.9-132.66 120v-81.2c28.09 8.2 43.03-8.7 43.03-44.6v-164.2h243.81v290zm-540.81 0h-65.73v-290h87.25v145l127.88-145h65.73v290h-87.25v-145l-127.88 145zm-292.212-74.2c-41.233 0-71.112-27.3-71.112-70.8s29.879-70.7 71.112-70.7c41.232 0 71.111 27.2 71.111 70.7s-29.879 70.8-71.111 70.8zm-484.635-70.8c0-31.9 19.123-55.6 56.173-65.5v131.1c-37.05-9.9-56.173-33.7-56.173-65.6zm143.419 65.6v-131.1c37.049 9.9 56.172 33.6 56.172 65.5s-19.123 55.7-56.172 65.6zm797.768-244.8h-179.28v-75.4h179.28v75.4zm208.63-321.9h251.23l-337.4-337.4c-.13 84-.28 168 .12 252 .01 1.2.04 2.4.1 3.6.12 2.6.35 5.1.7 7.7.82 5.9 2.26 11.8 4.31 17.5 2.37 6.5 5.53 12.7 9.4 18.5 3.66 5.4 7.94 10.4 12.73 14.9 4.6 4.3 9.68 8.2 15.11 11.4 4.7 2.7 9.67 5.1 14.82 6.9 5.84 2.1 11.91 3.5 18.07 4.3 2.27.3 4.55.5 6.84.6h3.97z"/>\n        </symbol>\n        <symbol id="jy-icon-file-text" viewBox="0 0 2048 1792">\n                <path d="M1417.03 128.001c3.42.015 6.84.169 10.24.475 6.75.607 13.45 1.796 20 3.548 6.27 1.68 12.41 3.879 18.33 6.566 5.93 2.69 11.63 5.87 17.03 9.497 4.13 2.772 8.08 5.804 11.83 9.074 1.94 1.687 3.81 3.439 5.64 5.245 150.06 149.6 299.89 299.433 449.49 449.498 1.81 1.823 3.56 3.699 5.25 5.633 3.27 3.748 6.3 7.702 9.07 11.832 3.63 5.403 6.81 11.105 9.5 17.031 2.69 5.917 4.89 12.056 6.57 18.334 1.75 6.546 2.94 13.242 3.54 19.992.31 3.405.46 6.822.48 10.24.42 269.85.43 539.704 0 809.554-.01 2.23-.06 4.46-.16 6.69-.19 4.23-.54 8.46-1.06 12.67-1.37 11.01-3.88 21.88-7.5 32.37-3.86 11.17-8.97 21.9-15.2 31.95-6.5 10.48-14.22 20.21-22.94 28.94-8.73 8.72-18.46 16.44-28.94 22.94-10.05 6.23-20.78 11.34-31.95 15.2-10.49 3.62-21.36 6.13-32.37 7.5-4.21.52-8.44.87-12.67 1.06-2.23.1-4.46.15-6.69.16-533.68.84-1067.36.84-1601.038 0-2.231-.01-4.462-.06-6.692-.16-4.234-.19-8.461-.54-12.667-1.06-11.012-1.37-21.879-3.88-32.368-7.5-11.173-3.86-21.909-8.97-31.954-15.2-10.486-6.5-20.214-14.22-28.938-22.94-8.724-8.73-16.44-18.46-22.942-28.94-6.229-10.05-11.339-20.78-15.197-31.95-3.622-10.49-6.137-21.36-7.501-32.37-.522-4.21-.876-8.44-1.063-12.67-.099-2.23-.149-4.46-.159-6.69-.642-405.67-.63-811.346 0-1217.017.009-1.985.049-3.97.129-5.953.166-4.111.49-8.216.972-12.303 1.32-11.186 3.826-22.23 7.462-32.891 4.89-14.337 11.824-27.968 20.534-40.361 8.619-12.263 18.967-23.3 30.649-32.692 7.64-6.143 15.846-11.581 24.48-16.223 8.74-4.699 17.916-8.583 27.374-11.584 10.12-3.212 20.559-5.414 31.115-6.56 3.765-.409 7.544-.684 11.329-.825 1.819-.068 3.638-.102 5.458-.11 397.843-.617 795.687-.618 1193.527 0zm-79.34 127.999h-1113.59c-1.224.002-2.444.062-3.66.198-2.496.279-4.958.854-7.32 1.708-2.85 1.031-5.552 2.468-8 4.256-2.633 1.924-4.968 4.253-6.9 6.88-2.086 2.836-3.697 6.016-4.751 9.375-.616 1.961-1.043 3.981-1.271 6.024-.125 1.116-.189 2.237-.197 3.36-1.886 405.361-.001 810.729-.001 1216.099l.003.55c.022 1.53.14 3.06.372 4.58.325 2.13.869 4.22 1.628 6.24.663 1.76 1.486 3.45 2.452 5.07 3.726 6.21 9.565 11.15 16.363 13.69 1.987.74 4.051 1.27 6.148 1.59 1.629.25 3.276.37 4.924.38 533.334.88 1066.67 0 1600 0h.56c1.6-.03 3.2-.15 4.78-.4 2.06-.33 4.09-.87 6.05-1.61 8.42-3.17 15.36-10.05 18.61-18.44.89-2.29 1.49-4.68 1.82-7.12.14-1.03.22-2.07.27-3.11.01-.48.02-.95.02-1.43v-729.575c-101.66.039-203.33.138-305-.015-2.97-.014-5.94-.08-8.9-.211-5.66-.251-11.3-.724-16.92-1.42-14.75-1.828-29.31-5.2-43.36-10.052-9.87-3.407-19.48-7.542-28.74-12.357-9.35-4.861-18.34-10.416-26.88-16.601-9.52-6.899-18.47-14.583-26.73-22.945-7.06-7.145-13.62-14.785-19.61-22.847-7.06-9.493-13.33-19.57-18.72-30.097-4.96-9.688-9.18-19.757-12.61-30.089-4.47-13.494-7.59-27.437-9.29-41.551-.68-5.619-1.13-11.264-1.37-16.918-.12-2.95-.17-5.902-.18-8.855v-304.357zm-1017.69 992.39h1408v160h-1408v-160zm0-288.142h1408v160.002h-1408v-160.002zm0-288.142h889.7v160h-889.7v-160zm1231.74-25.805h251.23l-337.4-337.402c-.13 83.99-.28 167.98.12 251.969.01 1.214.04 2.427.1 3.639.12 2.553.35 5.101.7 7.634.82 5.96 2.26 11.831 4.31 17.486 2.37 6.519 5.53 12.742 9.4 18.5 3.66 5.45 7.94 10.481 12.73 14.968 4.6 4.312 9.68 8.119 15.11 11.33 4.7 2.781 9.67 5.111 14.82 6.942 5.84 2.078 11.91 3.511 18.07 4.273 2.27.282 4.55.473 6.84.574 1.32.059 2.64.085 3.97.087zm-1231.74-262.338h889.7v160h-889.7v-160z"/>\n        </symbol>\n        <symbol id="jy-icon-file-docs" viewBox="0 0 2048 1792" fill-rule="evenodd" clip-rule="evenodd">\n            <path d="M1417.03 128.001c3.42.015 6.84.169 10.24.475 6.75.607 13.45 1.796 20 3.548 6.27 1.68 12.41 3.879 18.33 6.566 5.93 2.69 11.63 5.87 17.03 9.497 4.13 2.772 8.08 5.804 11.83 9.074 1.94 1.687 3.81 3.439 5.64 5.245 150.06 149.6 299.89 299.433 449.49 449.498 1.81 1.823 3.56 3.699 5.25 5.633 3.27 3.748 6.3 7.702 9.07 11.832 3.63 5.403 6.81 11.105 9.5 17.031 2.69 5.917 4.89 12.056 6.57 18.334 1.75 6.546 2.94 13.242 3.54 19.992.31 3.405.46 6.822.48 10.24.42 269.85.43 539.704 0 809.554-.01 2.23-.06 4.46-.16 6.69-.19 4.23-.54 8.46-1.06 12.67-1.37 11.01-3.88 21.88-7.5 32.37-3.86 11.17-8.97 21.9-15.2 31.95-6.5 10.48-14.22 20.21-22.94 28.94-8.73 8.72-18.46 16.44-28.94 22.94-10.05 6.23-20.78 11.34-31.95 15.2-10.49 3.62-21.36 6.13-32.37 7.5-4.21.52-8.44.87-12.67 1.06-2.23.1-4.46.15-6.69.16-533.68.84-1067.36.84-1601.038 0-2.231-.01-4.462-.06-6.692-.16-4.234-.19-8.461-.54-12.667-1.06-11.012-1.37-21.879-3.88-32.368-7.5-11.173-3.86-21.909-8.97-31.954-15.2-10.486-6.5-20.214-14.22-28.938-22.94-8.724-8.73-16.44-18.46-22.942-28.94-6.229-10.05-11.339-20.78-15.197-31.95-3.622-10.49-6.137-21.36-7.501-32.37-.522-4.21-.876-8.44-1.063-12.67-.099-2.23-.149-4.46-.159-6.69-.642-405.67-.63-811.346 0-1217.017.009-1.985.049-3.97.129-5.953.166-4.111.49-8.216.972-12.303 1.32-11.186 3.826-22.23 7.462-32.891 4.89-14.337 11.824-27.968 20.534-40.361 8.619-12.263 18.967-23.3 30.649-32.692 7.64-6.143 15.846-11.581 24.48-16.223 8.74-4.699 17.916-8.583 27.374-11.584 10.12-3.212 20.559-5.414 31.115-6.56 3.765-.409 7.544-.684 11.329-.825 1.819-.068 3.638-.102 5.458-.11 397.843-.617 795.687-.618 1193.527 0zm-79.34 127.999h-1113.59c-1.224.002-2.444.062-3.66.198-2.496.279-4.958.854-7.32 1.708-2.85 1.031-5.552 2.468-8 4.256-2.633 1.924-4.968 4.253-6.9 6.88-2.086 2.836-3.697 6.016-4.751 9.375-.616 1.961-1.043 3.981-1.271 6.024-.125 1.116-.189 2.237-.197 3.36-1.886 405.361-.001 810.729-.001 1216.099l.003.55c.022 1.53.14 3.06.372 4.58.325 2.13.869 4.22 1.628 6.24.663 1.76 1.486 3.45 2.452 5.07 3.726 6.21 9.565 11.15 16.363 13.69 1.987.74 4.051 1.27 6.148 1.59 1.629.25 3.276.37 4.924.38 533.334.88 1066.67 0 1600 0h.56c1.6-.03 3.2-.15 4.78-.4 2.06-.33 4.09-.87 6.05-1.61 8.42-3.17 15.36-10.05 18.61-18.44.89-2.29 1.49-4.68 1.82-7.12.14-1.03.22-2.07.27-3.11.01-.48.02-.95.02-1.43v-729.575c-101.66.039-203.33.138-305-.015-2.97-.014-5.94-.08-8.9-.211-5.66-.251-11.3-.724-16.92-1.42-14.75-1.828-29.31-5.2-43.36-10.052-9.87-3.407-19.48-7.542-28.74-12.357-9.35-4.861-18.34-10.416-26.88-16.601-9.52-6.899-18.47-14.583-26.73-22.945-7.06-7.145-13.62-14.785-19.61-22.847-7.06-9.493-13.33-19.57-18.72-30.097-4.96-9.688-9.18-19.757-12.61-30.089-4.47-13.494-7.59-27.437-9.29-41.551-.68-5.619-1.13-11.264-1.37-16.918-.12-2.95-.17-5.902-.18-8.855v-304.357zm-1017.69 1024.39h1408v128h-1408v-128zm0-250.08h1408v128h-1408v-128zm211.398-287.921l98.75-358.426h95.093l98.75 358.426 88.509-358.426h122.89l-141.177 512.037h-133.129l-83.389-302.102-83.389 302.102h-133.13l-141.176-512.037h122.889l88.509 358.426zm1020.342-96.088h251.23l-337.4-337.402c-.13 83.99-.28 167.98.12 251.969.01 1.214.04 2.427.1 3.639.12 2.553.35 5.101.7 7.634.82 5.96 2.26 11.831 4.31 17.486 2.37 6.519 5.53 12.742 9.4 18.5 3.66 5.45 7.94 10.481 12.73 14.968 4.6 4.312 9.68 8.119 15.11 11.33 4.7 2.781 9.67 5.111 14.82 6.942 5.84 2.078 11.91 3.511 18.07 4.273 2.27.282 4.55.473 6.84.574 1.32.059 2.64.085 3.97.087z"/>\n        </symbol>\n        <symbol id="jy-icon-file-tables" viewBox="0 0 2048 1792" fill-rule="evenodd" clip-rule="evenodd">\n            <path d="M1417.03 128c3.42.01 6.84.17 10.24.47 6.75.61 13.45 1.8 20 3.55 6.27 1.68 12.41 3.88 18.33 6.57 5.93 2.69 11.63 5.87 17.03 9.49 4.13 2.77 8.08 5.81 11.83 9.08 1.94 1.68 3.81 3.43 5.64 5.24 150.06 149.6 299.89 299.43 449.49 449.5 1.81 1.82 3.56 3.7 5.25 5.63 3.27 3.75 6.3 7.71 9.07 11.83 3.63 5.41 6.81 11.11 9.5 17.04 2.69 5.91 4.89 12.05 6.57 18.33 1.75 6.55 2.94 13.24 3.54 19.99.31 3.41.46 6.82.48 10.24.42 269.85.43 539.7 0 809.55-.01 2.23-.06 4.47-.16 6.7-.19 4.23-.54 8.46-1.06 12.66-1.37 11.01-3.88 21.88-7.5 32.37-3.86 11.17-8.97 21.91-15.2 31.96-6.5 10.48-14.22 20.21-22.94 28.93-8.73 8.73-18.46 16.44-28.94 22.94-10.05 6.23-20.78 11.34-31.95 15.2-10.49 3.62-21.36 6.14-32.37 7.5-4.21.52-8.44.88-12.67 1.07-2.23.1-4.46.14-6.69.15-533.68.85-1067.36.85-1601.038 0-2.231-.01-4.462-.05-6.692-.15-4.234-.19-8.461-.55-12.667-1.07-11.012-1.36-21.879-3.88-32.368-7.5-11.173-3.86-21.909-8.97-31.954-15.2-10.486-6.5-20.214-14.21-28.938-22.94-8.724-8.72-16.44-18.45-22.942-28.93-6.229-10.05-11.339-20.79-15.197-31.96-3.622-10.49-6.137-21.36-7.501-32.37-.522-4.2-.876-8.43-1.063-12.66-.099-2.23-.149-4.47-.159-6.7-.642-405.67-.63-811.34 0-1217.01.009-1.99.049-3.97.129-5.95.166-4.12.49-8.22.972-12.31 1.32-11.18 3.826-22.23 7.462-32.89 4.89-14.34 11.824-27.97 20.534-40.36 8.619-12.26 18.967-23.3 30.649-32.69 7.64-6.15 15.846-11.58 24.48-16.23 8.74-4.69 17.916-8.58 27.374-11.58 10.12-3.21 20.559-5.41 31.115-6.56 3.765-.41 7.544-.68 11.329-.82 1.819-.07 3.638-.1 5.458-.11 397.843-.62 795.687-.62 1193.527 0zm-79.34 127.99h-1113.59c-1.224.01-2.444.07-3.66.2-2.496.28-4.958.86-7.32 1.71-2.85 1.03-5.552 2.47-8 4.26-2.633 1.92-4.968 4.25-6.9 6.88-2.086 2.83-3.697 6.01-4.751 9.37-.616 1.96-1.043 3.98-1.271 6.03-.125 1.11-.189 2.23-.197 3.36-1.886 405.36-.001 810.73-.001 1216.09l.003.55c.022 1.54.14 3.07.372 4.59.325 2.12.869 4.22 1.628 6.23.663 1.76 1.486 3.46 2.452 5.07 3.726 6.22 9.565 11.16 16.363 13.69 1.987.75 4.051 1.28 6.148 1.6 1.629.25 3.276.37 4.924.37 533.334.89 1066.67.01 1600 0h.56c1.6-.02 3.2-.15 4.78-.4 2.06-.33 4.09-.86 6.05-1.6 8.42-3.17 15.36-10.05 18.61-18.44.89-2.29 1.49-4.69 1.82-7.12.14-1.03.22-2.08.27-3.12.01-.47.02-.95.02-1.42v-729.58c-101.66.04-203.33.14-305-.01-2.97-.02-5.94-.08-8.9-.22-5.66-.25-11.3-.72-16.92-1.41-14.75-1.83-29.31-5.2-43.36-10.06-9.87-3.4-19.48-7.54-28.74-12.35-9.35-4.87-18.34-10.42-26.88-16.61-9.52-6.89-18.47-14.58-26.73-22.94-7.06-7.14-13.62-14.79-19.61-22.85-7.06-9.49-13.33-19.57-18.72-30.1-4.96-9.68-9.18-19.75-12.61-30.08-4.47-13.5-7.59-27.44-9.29-41.55-.68-5.62-1.13-11.27-1.37-16.92-.12-2.95-.17-5.91-.18-8.86v-304.36zm-127.99 1152.4h-889.7v-1024.4299999999998h889.7v1024.43zm333.8-375.1l78.66-134.75h132.56l-144.94 248.37 152.22 261.48h-132.56l-85.94-147.13-85.95 147.13h-132.56l152.23-261.48-144.94-248.37h132.56l78.66 134.75zm-1095.5 44.54v202.56h226.85v-202.56h-226.85zm316.85 0v202.56h316.85v-202.56h-316.85zm-316.85-296.12v206.12h226.85v-206.12h-226.85zm316.85 0v206.12h316.85v-206.12h-316.85zm-316.85-269.75v179.75h226.85v-179.75h-226.85zm316.85 0v179.75h316.85v-179.75h-316.85zm786.89 134.34h251.23l-337.4-337.41c-.13 83.99-.28 167.99.12 251.97.01 1.22.04 2.43.1 3.64.12 2.56.35 5.1.7 7.64.82 5.96 2.26 11.83 4.31 17.48 2.37 6.52 5.53 12.74 9.4 18.5 3.66 5.45 7.94 10.48 12.73 14.97 4.6 4.31 9.68 8.12 15.11 11.33 4.7 2.78 9.67 5.11 14.82 6.94 5.84 2.08 11.91 3.51 18.07 4.28 2.27.28 4.55.47 6.84.57 1.32.06 2.64.08 3.97.09z"/>\n        </symbol>\n        <symbol id="jy-icon-file-image" viewBox="0 0 2048 1792" fill-rule="evenodd" clip-rule="evenodd">\n            <path d="M1417.03 128c3.42.02 6.84.17 10.24.48 6.75.6 13.45 1.79 20 3.54 6.27 1.68 12.41 3.88 18.33 6.57 5.93 2.69 11.63 5.87 17.03 9.5 4.13 2.77 8.08 5.8 11.83 9.07 1.94 1.69 3.81 3.44 5.64 5.25 150.06 149.6 299.89 299.43 449.49 449.49 1.81 1.83 3.56 3.7 5.25 5.64 3.27 3.75 6.3 7.7 9.07 11.83 3.63 5.4 6.81 11.11 9.5 17.03 2.69 5.92 4.89 12.06 6.57 18.34 1.75 6.54 2.94 13.24 3.54 19.99.31 3.4.46 6.82.48 10.24.42 269.85.43 539.7 0 809.55-.01 2.23-.06 4.46-.16 6.69-.19 4.24-.54 8.46-1.06 12.67-1.37 11.01-3.88 21.88-7.5 32.36-3.86 11.18-8.97 21.91-15.2 31.96-6.5 10.49-14.22 20.21-22.94 28.94-8.73 8.72-18.46 16.44-28.94 22.94-10.05 6.23-20.78 11.34-31.95 15.2-10.49 3.62-21.36 6.13-32.37 7.5-4.21.52-8.44.87-12.67 1.06-2.23.1-4.46.15-6.69.16-533.68.84-1067.36.84-1601.038 0-2.231-.01-4.462-.06-6.692-.16-4.234-.19-8.461-.54-12.667-1.06-11.012-1.37-21.879-3.88-32.368-7.5-11.173-3.86-21.909-8.97-31.954-15.2-10.486-6.5-20.214-14.22-28.938-22.94-8.724-8.73-16.44-18.45-22.942-28.94-6.229-10.05-11.339-20.78-15.197-31.96-3.622-10.48-6.137-21.35-7.501-32.36-.522-4.21-.876-8.43-1.063-12.67-.099-2.23-.149-4.46-.159-6.69-.642-405.67-.63-811.35 0-1217.02.009-1.98.049-3.97.129-5.95.166-4.11.49-8.22.972-12.3 1.32-11.19 3.826-22.23 7.462-32.89 4.89-14.34 11.824-27.97 20.534-40.37 8.619-12.26 18.967-23.29 30.649-32.69 7.64-6.14 15.846-11.58 24.48-16.22 8.74-4.7 17.916-8.58 27.374-11.58 10.12-3.22 20.559-5.42 31.115-6.56 3.765-.41 7.544-.69 11.329-.83 1.819-.07 3.638-.1 5.458-.11 397.843-.62 795.687-.62 1193.527 0zm-79.34 128h-1113.59c-1.224 0-2.444.06-3.66.2-2.496.28-4.958.85-7.32 1.71-2.85 1.03-5.552 2.46-8 4.25-2.633 1.93-4.968 4.25-6.9 6.88-2.086 2.84-3.697 6.02-4.751 9.38-.616 1.96-1.043 3.98-1.271 6.02-.125 1.12-.189 2.24-.197 3.36-1.886 405.36-.001 810.73-.001 1216.1l.003.55c.022 1.53.14 3.06.372 4.58.325 2.13.869 4.22 1.628 6.24.663 1.76 1.486 3.45 2.452 5.07 3.726 6.21 9.565 11.15 16.363 13.69 1.987.74 4.051 1.27 6.148 1.59 1.629.25 3.276.37 4.924.38 533.334.88 1066.67 0 1600 0h.56c1.6-.02 3.2-.15 4.78-.4 2.06-.33 4.09-.87 6.05-1.61 8.42-3.17 15.36-10.05 18.61-18.44.89-2.29 1.49-4.68 1.82-7.12.14-1.03.22-2.07.27-3.11.01-.48.02-.95.02-1.42v-729.58c-101.66.03-203.33.13-305-.02-2.97-.01-5.94-.08-8.9-.21-5.66-.25-11.3-.72-16.92-1.42-14.75-1.83-29.31-5.2-43.36-10.05-9.87-3.41-19.48-7.54-28.74-12.36-9.35-4.86-18.34-10.42-26.88-16.6-9.52-6.9-18.47-14.58-26.73-22.95-7.06-7.14-13.62-14.78-19.61-22.84-7.06-9.5-13.33-19.57-18.72-30.1-4.96-9.69-9.18-19.76-12.61-30.09-4.47-13.49-7.59-27.44-9.29-41.55-.68-5.62-1.13-11.26-1.37-16.92-.12-2.95-.17-5.9-.18-8.85v-304.36zm-118.44 384.75c2.41 9.97 5.27 19.83 8.57 29.54 5.16 15.21 11.4 30.05 18.66 44.39 8.65 17.08 18.73 33.44 30.12 48.83 10.57 14.31 22.27 27.79 34.94 40.29 12.31 12.14 25.54 23.35 39.54 33.5 14.28 10.35 29.35 19.59 45.04 27.61 16.17 8.26 33 15.24 50.28 20.82 21.59 6.98 43.87 11.8 66.41 14.37 8.15.93 16.33 1.56 24.52 1.9 3.79.16 7.59.25 11.38.29l1.83.01c38.61.06 77.23.08 115.84.08l61.62 61.62v444.01h-4.13l-125.02.03-125.02.06c-266.64.13-533.276.33-799.915.28-99.962-.01-199.925-.07-299.887-.18l-54.028-.06v-188.14l320-320 160 160 419.25-419.25zm-515.25-60.75c0 53.33-18.667 98.67-56 136s-82.667 56-136 56-98.667-18.67-136-56-56-82.67-56-136 18.667-98.67 56-136 82.667-56 136-56 98.667 18.67 136 56 56 82.67 56 136zm847.74 66.3h251.23l-337.4-337.4c-.13 83.99-.28 167.98.12 251.97.01 1.21.04 2.42.1 3.64.12 2.55.35 5.1.7 7.63.82 5.96 2.26 11.83 4.31 17.49 2.37 6.52 5.53 12.74 9.4 18.5 3.66 5.45 7.94 10.48 12.73 14.97 4.6 4.31 9.68 8.11 15.11 11.32 4.7 2.79 9.67 5.12 14.82 6.95 5.84 2.08 11.91 3.51 18.07 4.27 2.27.28 4.55.47 6.84.57 1.32.06 2.64.09 3.97.09z"/>\n        </symbol>\n        <symbol id="jy-icon-file-slides" viewBox="0 0 2048 1792" fill-rule="evenodd" clip-rule="evenodd">\n            <path d="M1417.03 128c3.42 0 6.84.1 10.24.5 6.75.6 13.45 1.7 20 3.5 6.27 1.7 12.41 3.9 18.33 6.6 5.93 2.7 11.63 5.8 17.03 9.5 4.13 2.7 8.08 5.8 11.83 9 1.94 1.7 3.81 3.5 5.64 5.3 150.06 149.6 299.89 299.4 449.49 449.5 1.81 1.8 3.56 3.7 5.25 5.6 3.27 3.8 6.3 7.7 9.07 11.8 3.63 5.4 6.81 11.2 9.5 17.1 2.69 5.9 4.89 12 6.57 18.3 1.75 6.6 2.94 13.3 3.54 20 .31 3.4.46 6.8.48 10.2.42 269.9.43 539.7 0 809.6-.01 2.2-.06 4.5-.16 6.7-.19 4.2-.54 8.4-1.06 12.7-1.37 11-3.88 21.8-7.5 32.3-3.86 11.2-8.97 21.9-15.2 32-6.5 10.5-14.22 20.2-22.94 28.9-8.73 8.7-18.46 16.5-28.94 23-10.05 6.2-20.78 11.3-31.95 15.2-10.49 3.6-21.36 6.1-32.37 7.5-4.21.5-8.44.8-12.67 1-2.23.1-4.46.2-6.69.2-533.68.8-1067.36.8-1601.038 0-2.231 0-4.462-.1-6.692-.2-4.234-.2-8.461-.5-12.667-1-11.012-1.4-21.879-3.9-32.368-7.5-11.173-3.9-21.909-9-31.954-15.2-10.486-6.5-20.214-14.3-28.938-23s-16.44-18.4-22.942-28.9c-6.229-10.1-11.339-20.8-15.197-32-3.622-10.5-6.137-21.3-7.501-32.3-.522-4.3-.876-8.5-1.063-12.7-.099-2.2-.149-4.5-.159-6.7-.642-405.7-.63-811.3 0-1217 .009-2 .049-4 .129-6 .166-4.1.49-8.2.972-12.3 1.32-11.2 3.826-22.2 7.462-32.9 4.89-14.3 11.824-27.9 20.534-40.3 8.619-12.3 18.967-23.3 30.649-32.7 7.64-6.2 15.846-11.6 24.48-16.2 8.74-4.7 17.916-8.6 27.374-11.6 10.12-3.2 20.559-5.4 31.115-6.6 3.765-.4 7.544-.7 11.329-.8 1.819-.1 3.638-.1 5.458-.1 397.843-.6 795.687-.6 1193.527 0zm-79.34 128h-1113.59c-1.224 0-2.444 0-3.66.2-2.496.3-4.958.8-7.32 1.7-2.85 1-5.552 2.5-8 4.2-2.633 2-4.968 4.3-6.9 6.9-2.086 2.9-3.697 6-4.751 9.4-.616 2-1.043 4-1.271 6-.125 1.1-.189 2.3-.197 3.4-1.886 405.3-.001 810.7-.001 1216.1l.003.5c.022 1.6.14 3.1.372 4.6.325 2.1.869 4.2 1.628 6.2.663 1.8 1.486 3.5 2.452 5.1 3.726 6.2 9.565 11.2 16.363 13.7 1.987.7 4.051 1.3 6.148 1.6 1.629.3 3.276.4 4.924.4 533.334.9 1066.67 0 1600 0h.56c1.6 0 3.2-.2 4.78-.4 2.06-.4 4.09-.9 6.05-1.6 8.42-3.2 15.36-10.1 18.61-18.5.89-2.3 1.49-4.7 1.82-7.1.14-1 .22-2.1.27-3.1.01-.5.02-1 .02-1.4v-729.6c-101.66 0-203.33.1-305 0-2.97 0-5.94-.1-8.9-.2-5.66-.3-11.3-.8-16.92-1.5-14.75-1.8-29.31-5.2-43.36-10-9.87-3.4-19.48-7.5-28.74-12.4-9.35-4.8-18.34-10.4-26.88-16.6-9.52-6.9-18.47-14.5-26.73-22.9-7.06-7.2-13.62-14.8-19.61-22.9-7.06-9.4-13.33-19.5-18.72-30.1-4.96-9.6-9.18-19.7-12.61-30-4.47-13.5-7.59-27.5-9.29-41.6-.68-5.6-1.13-11.3-1.37-16.9-.12-3-.17-5.9-.18-8.9v-304.3zm-889.69 890h-128v-634h704v256h249.7v640.4h-768v-262.4h-57.7zm697.7-250h-121.7v250h-390.3v134.4h512v-384.4zm-249.7-256h-448v378h448v-378zm655.74 6.3h251.23l-337.4-337.4c-.13 84-.28 168 .12 251.9.01 1.3.04 2.5.1 3.7.12 2.5.35 5.1.7 7.6.82 6 2.26 11.8 4.31 17.5 2.37 6.5 5.53 12.7 9.4 18.5 3.66 5.5 7.94 10.5 12.73 15 4.6 4.3 9.68 8.1 15.11 11.3 4.7 2.8 9.67 5.1 14.82 6.9 5.84 2.1 11.91 3.6 18.07 4.3 2.27.3 4.55.5 6.84.6l3.97.1z"/>\n        </symbol>\n        <symbol id="jy-icon-file-pdf" viewBox="0 0 2048 1792" fill-rule="evenodd" clip-rule="evenodd">\n            <path d="M1417.03 128c3.42.02 6.84.17 10.24.48 6.75.6 13.45 1.79 20 3.54 6.27 1.68 12.41 3.88 18.33 6.57 5.93 2.69 11.63 5.87 17.03 9.5 4.13 2.77 8.08 5.8 11.83 9.07 1.94 1.69 3.81 3.44 5.64 5.25 150.06 149.6 299.89 299.43 449.49 449.49 1.81 1.83 3.56 3.7 5.25 5.64 3.27 3.74 6.3 7.7 9.07 11.83 3.63 5.4 6.81 11.1 9.5 17.03 2.69 5.92 4.89 12.06 6.57 18.33 1.75 6.55 2.94 13.25 3.54 19.99.31 3.41.46 6.83.48 10.25.42 269.85.43 539.7 0 809.55-.01 2.23-.06 4.46-.16 6.69-.19 4.23-.54 8.46-1.06 12.67-1.37 11.01-3.88 21.88-7.5 32.36-3.86 11.18-8.97 21.91-15.2 31.96-6.5 10.48-14.22 20.21-22.94 28.94-8.73 8.72-18.46 16.44-28.94 22.94-10.05 6.23-20.78 11.34-31.95 15.2-10.49 3.62-21.36 6.13-32.37 7.5-4.21.52-8.44.87-12.67 1.06-2.23.1-4.46.15-6.69.16-533.68.84-1067.36.84-1601.038 0-2.231-.01-4.462-.06-6.692-.16-4.234-.19-8.461-.54-12.667-1.06-11.012-1.37-21.879-3.88-32.368-7.5-11.173-3.86-21.909-8.97-31.954-15.2-10.486-6.5-20.214-14.22-28.938-22.94-8.724-8.73-16.44-18.46-22.942-28.94-6.229-10.05-11.339-20.78-15.197-31.96-3.622-10.48-6.137-21.35-7.501-32.36-.522-4.21-.876-8.44-1.063-12.67-.099-2.23-.149-4.46-.159-6.69-.642-405.67-.63-811.35 0-1217.02.009-1.98.049-3.97.129-5.95.166-4.11.49-8.22.972-12.3 1.32-11.19 3.826-22.23 7.462-32.9 4.89-14.33 11.824-27.96 20.534-40.35 8.619-12.27 18.967-23.31 30.649-32.7 7.64-6.14 15.846-11.58 24.48-16.22 8.74-4.7 17.916-8.58 27.374-11.58 10.12-3.22 20.559-5.42 31.115-6.57 3.765-.4 7.544-.68 11.329-.82 1.819-.07 3.638-.1 5.458-.11 397.843-.62 795.687-.62 1193.527 0zm-79.34 128h-1113.59c-1.224 0-2.444.06-3.66.2-2.496.28-4.958.85-7.32 1.71-2.85 1.03-5.552 2.46-8 4.25-2.633 1.93-4.968 4.25-6.9 6.88-2.086 2.84-3.697 6.02-4.751 9.38-.616 1.96-1.043 3.98-1.271 6.02-.125 1.12-.189 2.24-.197 3.36-1.886 405.36-.001 810.73-.001 1216.1l.003.55c.022 1.53.14 3.06.372 4.58.325 2.13.869 4.22 1.628 6.24.663 1.75 1.486 3.45 2.452 5.07 3.726 6.21 9.565 11.15 16.363 13.69 1.987.74 4.051 1.27 6.148 1.59 1.629.25 3.276.37 4.924.38 533.334.88 1066.67 0 1600 0h.56c1.6-.03 3.2-.15 4.78-.41 2.06-.33 4.09-.86 6.05-1.6 8.42-3.17 15.36-10.05 18.61-18.44.89-2.29 1.49-4.68 1.82-7.12.14-1.03.22-2.07.27-3.12.01-.47.02-.94.02-1.42v-729.58c-101.66.04-203.33.14-305-.01-2.97-.01-5.94-.08-8.9-.21-5.66-.25-11.3-.73-16.92-1.42-14.75-1.83-29.31-5.2-43.36-10.05-9.87-3.41-19.48-7.54-28.74-12.36-9.35-4.86-18.34-10.42-26.88-16.6-9.52-6.9-18.47-14.58-26.73-22.95-7.06-7.14-13.62-14.78-19.61-22.84-7.06-9.5-13.33-19.57-18.72-30.1-4.96-9.69-9.18-19.76-12.61-30.09-4.47-13.49-7.59-27.44-9.29-41.55-.68-5.62-1.13-11.26-1.37-16.92-.12-2.95-.17-5.9-.18-8.85v-304.36zm-315.69 687c22 17.33 50 36 84 56 39.33-4.67 78.33-7 117-7 98 0 157 16.33 177 49 10.67 14.67 11.33 32 2 52 0 .67-.33 1.33-1 2l-2 2v1c-4 25.33-27.67 38-71 38-32 0-70.33-6.67-115-20s-88-31-130-53c-147.333 16-278 43.67-392 83-102 174.67-182.667 262-242 262-10 0-19.333-2.33-28-7l-24-12c-.667-.67-2.667-2.33-6-5-6.667-6.67-8.667-18.67-6-36 6-26.67 24.667-57.17 56-91.5s75.333-66.5 132-96.5c9.333-6 17-4 23 6 1.333 1.33 2 2.67 2 4 34.667-56.67 70.333-122.33 107-197 45.333-90.67 80-178 104-262-16-54.67-26.167-107.83-30.5-159.5-4.333-51.67-2.167-94.17 6.5-127.5 7.333-26.67 21.333-40 42-40h22c15.333 0 27 5 35 15 12 14 15 36.67 9 68-1.333 4-2.667 6.67-4 8 .667 2 1 4.67 1 8v30c-1.333 82-6 146-14 192 36.667 109.33 85.333 188.67 146 238zm-576 411c34.667-16 80.333-68.67 137-158-34 26.67-63.167 54.67-87.5 84s-40.833 54-49.5 74zm274-259c90-36 184.667-63 284-81-1.33-.67-5.667-3.83-13-9.5s-12.667-10.17-16-13.5c-50.667-44.67-93-103.33-127-176-18 57.33-45.667 123-83 197-20 37.33-35 65-45 83zm646-16c-16-16-62.67-24-140-24 50.67 18.67 92 28 124 28 9.33 0 15.33-.33 18-1 0-.67-.67-1.67-2-3zm185.74-432.7h251.23l-337.4-337.4c-.13 83.99-.28 167.98.12 251.97.01 1.21.04 2.42.1 3.64.12 2.55.35 5.1.7 7.63.82 5.96 2.26 11.83 4.31 17.49 2.37 6.52 5.53 12.74 9.4 18.5 3.66 5.45 7.94 10.48 12.73 14.96 4.6 4.32 9.68 8.12 15.11 11.33 4.7 2.79 9.67 5.12 14.82 6.95 5.84 2.08 11.91 3.51 18.07 4.27 2.27.28 4.55.47 6.84.57 1.32.06 2.64.09 3.97.09zm-707.74-212.3c-10 28-10.667 72-2 132 .667-4.67 3-19.33 7-44 0-2 2.333-16.33 7-43 .667-2.67 2-5.33 4-8-.667-.67-1-1.33-1-2-.667-1.33-1-2.33-1-3-.667-14.67-5-26.67-13-36 0 .67-.333 1.33-1 2v2z"/>\n        </symbol>\n        <symbol id="jy-icon-file-archive" viewBox="0 0 2048 1792" fill-rule="evenodd" clip-rule="evenodd">\n            <path d="M1417.11 129.7c3.42 0 6.84.2 10.24.5 6.75.6 13.45 1.8 20 3.5 6.27 1.7 12.41 3.9 18.33 6.6 5.93 2.7 11.63 5.9 17.03 9.5 4.13 2.8 8.09 5.8 11.83 9.1 1.94 1.7 3.81 3.4 5.64 5.2 150.06 149.6 299.89 299.5 449.49 449.5 1.81 1.8 3.56 3.7 5.25 5.7 3.27 3.7 6.3 7.7 9.07 11.8 3.63 5.4 6.81 11.1 9.5 17 2.69 5.9 4.89 12.1 6.57 18.3 1.75 6.6 2.94 13.3 3.54 20 .31 3.4.46 6.9.48 10.3.42 269.8.43 539.7 0 809.5-.01 2.3-.06 4.5-.16 6.7-.19 4.3-.54 8.5-1.06 12.7-1.37 11-3.88 21.9-7.5 32.4-3.86 11.1-8.97 21.9-15.2 31.9-6.5 10.5-14.22 20.2-22.94 29-8.73 8.7-18.45 16.4-28.94 22.9-10.05 6.2-20.78 11.3-31.95 15.2-10.49 3.6-21.36 6.1-32.37 7.5-4.21.5-8.44.9-12.67 1.1-2.23.1-4.46.1-6.69.1-533.68.9-1067.36.9-1601.038 0-2.232 0-4.463 0-6.692-.1-4.235-.2-8.461-.6-12.668-1.1-11.012-1.4-21.878-3.9-32.367-7.5-11.173-3.9-21.909-9-31.954-15.2-10.486-6.5-20.214-14.2-28.938-22.9-8.724-8.8-16.441-18.5-22.942-29-6.229-10-11.339-20.8-15.197-31.9-3.622-10.5-6.137-21.4-7.502-32.4-.521-4.2-.875-8.4-1.063-12.7-.099-2.2-.148-4.4-.158-6.7-.643-405.6-.63-811.3 0-1217 .009-2 .049-4 .129-5.9.165-4.1.49-8.3.972-12.3 1.32-11.2 3.826-22.3 7.462-32.9 4.889-14.4 11.823-28 20.534-40.4 8.619-12.3 18.967-23.3 30.648-32.7 7.641-6.1 15.846-11.6 24.481-16.2 8.739-4.7 17.916-8.6 27.374-11.6 10.12-3.2 20.559-5.4 31.114-6.5 3.765-.5 7.545-.7 11.33-.9l5.458-.1c397.843-.6 795.687-.6 1193.527 0zm-79.34 128h-569.776v126.3h-128v-126.3h-415.814c-1.224 0-2.445.1-3.66.2-2.496.3-4.958.9-7.32 1.7-2.851 1.1-5.553 2.5-8 4.3-2.633 1.9-4.968 4.2-6.9 6.9-2.086 2.8-3.697 6-4.752 9.3-.616 2-1.042 4-1.27 6.1-.125 1.1-.189 2.2-.197 3.3-1.886 405.4-.001 810.7-.001 1216.1l.003.6c.022 1.5.14 3 .372 4.5.325 2.2.869 4.3 1.628 6.3.662 1.7 1.486 3.4 2.452 5 3.725 6.3 9.565 11.2 16.362 13.7 1.988.8 4.052 1.3 6.149 1.6 1.629.3 3.276.4 4.924.4 533.334.9 1066.67 0 1600 0h.56c1.6 0 3.2-.1 4.78-.4 2.06-.3 4.09-.9 6.05-1.6 8.42-3.2 15.36-10 18.61-18.4.89-2.3 1.5-4.7 1.82-7.2.14-1 .23-2 .27-3.1.01-.4.02-.9.02-1.4v-729.6c-101.67.1-203.33.2-305 0-2.97 0-5.94-.1-8.91-.2-5.65-.2-11.29-.7-16.9-1.4-14.76-1.8-29.32-5.2-43.37-10.1-9.87-3.4-19.48-7.5-28.74-12.3-9.35-4.9-18.35-10.4-26.88-16.6-9.52-6.9-18.47-14.6-26.73-23-7.06-7.1-13.62-14.8-19.61-22.8-7.06-9.5-13.33-19.6-18.72-30.1-4.96-9.7-9.18-19.8-12.61-30.1-4.47-13.5-7.59-27.4-9.29-41.6-.68-5.6-1.13-11.2-1.37-16.9-.12-2.9-.17-5.9-.18-8.8v-304.4zm-698.776 638.3h385.006v512h-513.006v-512h128zm86.506 128h-86.506v256h257.006v-256h-85.5v128h-85v-128zm42.5-128h-128v-128h128v128zm128-128h-128v-128h128v128zm655.82-120h251.23l-337.4-337.4c-.13 84-.28 168 .12 252 .01 1.2.04 2.4.1 3.6.12 2.6.36 5.1.7 7.7.82 5.9 2.26 11.8 4.31 17.4 2.37 6.6 5.53 12.8 9.4 18.5 3.65 5.5 7.94 10.5 12.73 15 4.6 4.3 9.68 8.1 15.11 11.3 4.7 2.8 9.67 5.2 14.82 7 5.84 2.1 11.91 3.5 18.07 4.3 2.27.2 4.55.4 6.84.5 1.32.1 2.64.1 3.97.1zm-655.826-136h-127.994v128h-128v-128h127.994v-128h128v128z"/>\n        </symbol>\n        <symbol id="jy-icon-file-vector" viewBox="0 0 2048 1792" fill-rule="evenodd" clip-rule="evenodd">\n            <path d="M1417.03 128c3.42 0 6.84.2 10.24.5 6.75.6 13.45 1.8 20 3.5 6.27 1.7 12.41 3.9 18.33 6.6 5.93 2.7 11.63 5.9 17.03 9.5 4.13 2.8 8.08 5.8 11.83 9.1 1.94 1.7 3.81 3.4 5.64 5.2 150.06 149.6 299.89 299.5 449.49 449.5 1.81 1.8 3.56 3.7 5.25 5.7 3.27 3.7 6.3 7.7 9.07 11.8 3.63 5.4 6.81 11.1 9.5 17 2.69 5.9 4.89 12.1 6.57 18.4 1.75 6.5 2.94 13.2 3.54 19.9.31 3.5.46 6.9.48 10.3.42 269.8.43 539.7 0 809.5-.01 2.3-.06 4.5-.16 6.7-.19 4.3-.54 8.5-1.06 12.7-1.37 11-3.88 21.9-7.5 32.4-3.86 11.1-8.97 21.9-15.2 31.9-6.5 10.5-14.22 20.2-22.94 29-8.73 8.7-18.46 16.4-28.94 22.9-10.05 6.2-20.78 11.3-31.95 15.2-10.49 3.6-21.36 6.1-32.37 7.5-4.21.5-8.44.9-12.67 1.1-2.23.1-4.46.1-6.69.1-533.68.9-1067.36.9-1601.038 0-2.231 0-4.462 0-6.692-.1-4.234-.2-8.461-.6-12.667-1.1-11.012-1.4-21.879-3.9-32.368-7.5-11.173-3.9-21.909-9-31.954-15.2-10.486-6.5-20.214-14.2-28.938-22.9-8.724-8.8-16.44-18.5-22.942-29-6.229-10-11.339-20.8-15.197-31.9-3.622-10.5-6.137-21.4-7.501-32.4-.522-4.2-.876-8.4-1.063-12.7-.099-2.2-.149-4.4-.159-6.7-.642-405.6-.63-811.3 0-1217 .009-2 .049-3.9.129-5.9.166-4.1.49-8.2.972-12.3 1.32-11.2 3.826-22.3 7.462-32.9 4.89-14.4 11.824-28 20.534-40.4 8.619-12.2 18.967-23.3 30.649-32.7 7.64-6.1 15.846-11.6 24.48-16.2 8.74-4.7 17.916-8.6 27.374-11.6 10.12-3.2 20.559-5.4 31.115-6.5 3.765-.5 7.544-.7 11.329-.9l5.458-.1c397.843-.6 795.687-.6 1193.527 0zm-79.34 128h-1113.59c-1.224 0-2.444.1-3.66.2-2.496.3-4.958.9-7.32 1.7-2.85 1.1-5.552 2.5-8 4.3-2.633 1.9-4.968 4.2-6.9 6.9-2.086 2.8-3.697 6-4.751 9.3-.616 2-1.043 4-1.271 6.1-.125 1.1-.189 2.2-.197 3.3-1.886 405.4-.001 810.8-.001 1216.1l.003.6c.022 1.5.14 3 .372 4.6.325 2.1.869 4.2 1.628 6.2.663 1.7 1.486 3.4 2.452 5.1 3.726 6.2 9.565 11.1 16.363 13.6 1.987.8 4.051 1.3 6.148 1.6 1.629.3 3.276.4 4.924.4 533.334.9 1066.67 0 1600 0h.56c1.6 0 3.2-.1 4.78-.4 2.06-.3 4.09-.9 6.05-1.6 8.42-3.2 15.36-10 18.61-18.4.89-2.3 1.49-4.7 1.82-7.1.14-1.1.22-2.1.27-3.2.01-.4.02-.9.02-1.4v-729.6c-101.66.1-203.33.2-305 0-2.97 0-5.94-.1-8.9-.2-5.66-.2-11.3-.7-16.92-1.4-14.75-1.8-29.31-5.2-43.36-10.1-9.87-3.4-19.48-7.5-28.74-12.3-9.35-4.9-18.34-10.4-26.88-16.6-9.52-6.9-18.47-14.6-26.73-23-7.06-7.1-13.62-14.8-19.61-22.8-7.06-9.5-13.33-19.6-18.72-30.1-4.96-9.7-9.18-19.8-12.61-30.1-4.47-13.5-7.59-27.4-9.29-41.6-.68-5.6-1.13-11.2-1.37-16.9-.12-2.9-.17-5.9-.18-8.8v-304.4zm-213.41 278.6h-150.654v-20l-3.623.7c-2.572.6-5.138 1.1-7.698 1.7-2.746.6-5.483 1.3-8.214 2-1.922.5-3.84.9-5.754 1.5-2.7.7-5.394 1.4-8.077 2.2-2.504.7-5.001 1.5-7.491 2.3-1.514.5-3.025.9-4.533 1.4-4.154 1.4-8.282 2.8-12.387 4.3-4.268 1.6-8.507 3.2-12.716 4.9-5.473 2.2-10.895 4.6-16.259 7-9.624 4.5-19.071 9.3-28.298 14.5-2.554 1.4-5.095 2.9-7.616 4.4-2.367 1.4-4.721 2.8-7.059 4.3-1.991 1.2-3.968 2.5-5.936 3.7-2.126 1.4-4.237 2.8-6.335 4.2-3.394 2.3-6.751 4.7-10.07 7.1-1.734 1.2-3.458 2.5-5.17 3.8-3.754 2.8-7.458 5.7-11.112 8.6-3.481 2.8-6.912 5.7-10.293 8.6-11.342 9.8-22.125 20.2-32.272 31.3-2.106 2.3-4.187 4.6-6.237 6.9-9.121 10.4-17.695 21.3-25.666 32.6-7.43 10.6-14.333 21.5-20.682 32.7-2.89 5.1-5.665 10.3-8.316 15.5-6.852 13.6-12.93 27.5-18.145 41.7-2.305 6.3-4.451 12.7-6.428 19.1h55.345v241h-51.475l.154.5c1.232 3.6 2.513 7.1 3.848 10.6 3.701 9.8 7.797 19.4 12.278 28.9 3.622 7.6 7.494 15.1 11.602 22.5 2.38 4.2 4.846 8.5 7.386 12.7 2.229 3.6 4.523 7.3 6.874 10.8 6.083 9.3 12.568 18.4 19.423 27.1 7.203 9.2 14.818 18.1 22.815 26.6 2.665 2.8 5.37 5.6 8.118 8.4 1.936 1.9 3.893 3.9 5.867 5.8 1.951 1.8 3.925 3.7 5.916 5.5 3.431 3.2 6.916 6.3 10.459 9.3 2.669 2.3 5.368 4.6 8.096 6.8 8.621 7 17.549 13.7 26.735 19.9 1.774 1.2 3.562 2.4 5.356 3.6 2.601 1.7 5.222 3.4 7.865 5 2.321 1.5 4.655 2.9 7.007 4.3 2.19 1.3 4.39 2.6 6.605 3.8 3.248 1.9 6.521 3.7 9.82 5.4 2.433 1.3 4.881 2.6 7.341 3.8 2.099 1 4.211 2.1 6.33 3.1 6.212 3 12.506 5.8 18.867 8.4 5.278 2.2 10.606 4.3 15.978 6.3 4.291 1.5 8.608 3 12.952 4.4 3.044 1 6.1 2 9.166 2.9 4.209 1.3 8.443 2.4 12.693 3.5 4.451 1.2 8.925 2.3 13.416 3.3 3.175.7 6.358 1.4 9.55 2v-20h150.654v150.6h-150.654v-33.1c-4.471-.7-8.932-1.5-13.383-2.3-6.437-1.2-12.849-2.6-19.233-4-4.899-1.1-9.782-2.3-14.644-3.6-5.31-1.4-10.6-2.8-15.86-4.4-3.797-1.1-7.58-2.3-11.349-3.5-7.305-2.4-14.553-5-21.736-7.7-4.851-1.8-9.672-3.7-14.459-5.7-2.267-1-4.528-1.9-6.78-2.9-4.048-1.8-8.072-3.6-12.071-5.5-3.568-1.6-7.113-3.3-10.638-5.1-8.535-4.2-16.947-8.7-25.217-13.5-16.89-9.6-33.198-20.3-48.805-32-6.607-4.9-13.087-10-19.438-15.3-6.168-5.1-12.207-10.3-18.114-15.7-3.049-2.8-6.064-5.6-9.039-8.5-2.43-2.3-4.839-4.7-7.222-7.1-3.423-3.4-6.792-6.9-10.111-10.5-9.962-10.6-19.449-21.6-28.421-33.1-8.542-10.9-16.622-22.1-24.202-33.7-2.933-4.5-5.797-9-8.58-13.6-3.166-5.2-6.239-10.5-9.206-15.8-.353-.7-.705-1.3-1.055-1.9v146.4c15.366 9.9 25.553 27.2 25.553 46.8 0 30.7-24.893 55.5-55.553 55.5-30.66 0-55.553-24.8-55.553-55.5 0-19.6 10.187-36.9 25.553-46.8v-253.7h-72.521v-241h72.521v-265.2c-15.366-9.9-25.553-27.2-25.553-46.8 0-30.6 24.893-55.5 55.553-55.5 30.66 0 55.553 24.9 55.553 55.5 0 19.6-10.187 36.9-25.553 46.8v146.1c8.589-15.5 18.03-30.6 28.273-45.2 21.926-31.1 47.51-59.6 76.058-84.8 8.55-7.6 17.363-14.8 26.422-21.7 3.469-2.7 6.972-5.3 10.511-7.8 1.585-1.2 3.175-2.3 4.774-3.4 4.36-3.1 8.768-6.1 13.224-9 2.236-1.5 4.486-2.9 6.746-4.4 4.953-3.1 9.966-6.2 15.032-9.1 10.139-5.9 20.49-11.5 31.032-16.6 3.739-1.9 7.502-3.7 11.287-5.4 1.33-.6 2.664-1.2 4-1.8 2.938-1.3 5.892-2.6 8.858-3.9 2.948-1.2 5.907-2.4 8.879-3.6 2.053-.8 4.111-1.6 6.175-2.4 6.936-2.7 13.934-5.2 20.987-7.5 2.599-.9 5.203-1.7 7.816-2.6 3.33-1 6.669-2 10.021-3 2.375-.7 4.756-1.3 7.141-2 6.534-1.8 13.107-3.4 19.711-4.9 3.912-.9 7.835-1.7 11.768-2.5l5.982-1.2c4.942-.9 9.898-1.8 14.866-2.6v-33.1h150.654v150.6zm-453.696 309h-117.042v117h117.042v-117zm881.156-197.3h251.23l-337.4-337.4c-.13 84-.28 168 .12 252 .01 1.2.04 2.4.1 3.6.12 2.6.35 5.1.7 7.7.82 5.9 2.26 11.8 4.31 17.4 2.37 6.6 5.53 12.8 9.4 18.5 3.66 5.5 7.94 10.5 12.73 15 4.6 4.3 9.68 8.1 15.11 11.3 4.7 2.8 9.67 5.2 14.82 7 5.84 2.1 11.91 3.5 18.07 4.3 2.27.2 4.55.4 6.84.5 1.32.1 2.64.1 3.97.1z"/>\n        </symbol>\n        <symbol id="jy-icon-file-audio" viewBox="0 0 2048 1792" fill-rule="evenodd" clip-rule="evenodd">\n            <path d="M1417.03 128c3.42.01 6.84.17 10.24.47 6.75.61 13.45 1.8 20 3.55 6.27 1.68 12.41 3.88 18.33 6.57 5.93 2.69 11.63 5.87 17.03 9.49 4.13 2.77 8.08 5.81 11.83 9.08 1.94 1.68 3.81 3.44 5.64 5.24 150.06 149.6 299.89 299.44 449.49 449.5 1.81 1.82 3.56 3.7 5.25 5.63 3.27 3.75 6.3 7.71 9.07 11.83 3.63 5.41 6.81 11.11 9.5 17.04 2.69 5.91 4.89 12.05 6.57 18.33 1.75 6.55 2.94 13.24 3.54 19.99.31 3.41.46 6.82.48 10.24.42 269.85.43 539.7 0 809.6-.01 2.2-.06 4.4-.16 6.6-.19 4.3-.54 8.5-1.06 12.7-1.37 11-3.88 21.9-7.5 32.4-3.86 11.2-8.97 21.9-15.2 31.9-6.5 10.5-14.22 20.2-22.94 29-8.73 8.7-18.46 16.4-28.94 22.9-10.05 6.2-20.78 11.4-31.95 15.2-10.49 3.6-21.36 6.1-32.37 7.5-4.21.5-8.44.9-12.67 1.1-2.23.1-4.46.1-6.69.1-533.68.9-1067.36.9-1601.038 0-2.231 0-4.462 0-6.692-.1-4.234-.2-8.461-.6-12.667-1.1-11.012-1.4-21.879-3.9-32.368-7.5-11.173-3.8-21.909-9-31.954-15.2-10.486-6.5-20.214-14.2-28.938-22.9-8.724-8.8-16.44-18.5-22.942-29-6.229-10-11.339-20.7-15.197-31.9-3.622-10.5-6.137-21.4-7.501-32.4-.522-4.2-.876-8.4-1.063-12.7-.099-2.2-.149-4.4-.159-6.6-.642-405.72-.63-811.39 0-1217.06.009-1.99.049-3.97.129-5.95.166-4.12.49-8.22.972-12.31 1.32-11.18 3.826-22.23 7.462-32.89 4.89-14.34 11.824-27.97 20.534-40.36 8.619-12.26 18.967-23.3 30.649-32.69 7.64-6.14 15.846-11.58 24.48-16.22 8.74-4.7 17.916-8.59 27.374-11.59 10.12-3.21 20.559-5.41 31.115-6.56 3.765-.41 7.544-.68 11.329-.82 1.819-.07 3.638-.11 5.458-.11 397.843-.62 795.687-.62 1193.527 0zm438.97 949.83h-484.59l-5.92-.39c-5.16-1.03-6.55-1.05-11.44-3.09-5.48-2.29-10.49-5.68-14.67-9.91-1.39-1.41-2.59-3-3.88-4.49l-65.85-87.22-67.77 217.53-2.39 6c-1.08 1.9-2.03 3.9-3.25 5.7-2.44 3.6-5.39 6.9-8.76 9.6-1.68 1.4-3.47 2.7-5.34 3.8-3.74 2.3-7.78 4-12.01 5.1-2.11.5-4.26.9-6.43 1.1-4.34.5-8.73.3-13.02-.5-4.29-.8-8.44-2.2-12.33-4.2-3.88-2-7.45-4.5-10.6-7.6-1.57-1.5-3.04-3.1-4.37-4.8-2.68-3.5-4.84-7.3-6.42-11.4-.79-2-1.28-4.1-1.91-6.2l-104.41-457.04-80.348 674.84-1.283 6.6c-.748 2.1-1.341 4.3-2.243 6.3-.902 2.1-1.959 4-3.154 5.9-2.396 3.8-5.342 7.2-8.741 10.1-3.399 2.9-7.214 5.3-11.317 7.1-4.103 1.8-8.449 2.9-12.895 3.4-2.217.3-4.459.4-6.688.3-2.23-.1-4.459-.3-6.652-.8-4.398-.8-8.648-2.3-12.611-4.3-3.962-2.1-7.593-4.8-10.771-7.9-1.585-1.6-3.057-3.3-4.391-5.1-2.677-3.6-4.803-7.5-6.31-11.7-.751-2.1-1.186-4.3-1.779-6.5l-117.759-597.51-98.376 463.51-1.804 6.2c-.895 2-1.649 4.1-2.684 6-1.035 1.9-2.21 3.7-3.508 5.4-2.603 3.5-5.695 6.6-9.18 9.2-3.486 2.6-7.328 4.6-11.407 6.1-2.034.8-4.127 1.4-6.247 1.8-2.12.5-4.278.7-6.44.9-4.334.2-8.684-.1-12.915-1.1-4.23-1-8.296-2.6-12.071-4.7-3.776-2.2-7.221-4.8-10.228-8-1.499-1.5-2.89-3.2-4.149-5-2.524-3.5-4.524-7.4-5.937-11.5-.705-2.1-1.11-4.2-1.665-6.3l-67.725-358.06-79.756 145.74-3.234 5.07c-3.439 4.07-4.13 5.3-8.34 8.63-3.153 2.49-6.625 4.55-10.325 6.12-3.699 1.57-7.593 2.63-11.575 3.17-1.987.27-4.001.27-6.002.4h-158.571c.216 139.93.441 279.83.441 419.73l.003.6c.022 1.5.14 3.1.372 4.6.325 2.1.869 4.2 1.628 6.2.663 1.8 1.486 3.5 2.452 5.1 3.726 6.2 9.565 11.1 16.363 13.7 1.987.7 4.051 1.2 6.148 1.6 1.629.2 3.276.3 4.924.3 533.334.9 1066.67 0 1600 0h.56c1.6 0 3.2-.1 4.78-.4 2.06-.3 4.09-.8 6.05-1.6 8.42-3.1 15.36-10 18.61-18.4.89-2.3 1.49-4.7 1.82-7.1.14-1.1.22-2.1.27-3.1.01-.5.02-1 .02-1.5v-426.03zm-518.31-821.83h-1113.59c-1.224 0-2.444.06-3.66.19-2.496.28-4.958.86-7.32 1.71-2.85 1.03-5.552 2.47-8 4.26-2.633 1.92-4.968 4.25-6.9 6.88-2.086 2.83-3.697 6.01-4.751 9.37-.616 1.96-1.043 3.98-1.271 6.03-.125 1.11-.189 2.23-.197 3.36-1.095 235.44-.919 470.88-.578 706.33h132.036l127.288-232.59 3.518-5.46c1.422-1.63 2.73-3.36 4.266-4.89 3.08-3.05 6.585-5.65 10.408-7.7 3.822-2.05 7.92-3.54 12.168-4.42 4.249-.88 8.601-1.14 12.924-.77 4.322.37 8.569 1.36 12.608 2.94 2.014.79 3.977 1.73 5.856 2.8 3.77 2.15 7.209 4.83 10.211 7.96 3.002 3.13 5.536 6.68 7.522 10.54.991 1.92 1.844 3.92 2.548 5.96.703 2.05 1.108 4.19 1.663 6.28l49.404 261.22 97.469-459.24 1.798-6.22c.891-1.97 1.642-4.01 2.673-5.91 2.066-3.8 4.67-7.29 7.733-10.35 1.527-1.53 3.169-2.95 4.899-4.24 3.471-2.59 7.297-4.67 11.36-6.16 2.027-.75 4.113-1.35 6.225-1.8 4.237-.9 8.58-1.18 12.897-.84 4.317.35 8.562 1.31 12.603 2.87 2.015.77 3.98 1.7 5.863 2.75 3.776 2.13 7.226 4.78 10.244 7.89 3.017 3.1 5.571 6.63 7.581 10.46 1.003 1.91 1.869 3.9 2.587 5.94.717 2.04 1.138 4.17 1.707 6.25l105.147 533.54 77.345-649.69 1.264-6.5c.735-2.08 1.319-4.22 2.205-6.24 1.777-4.06 4.143-7.83 7.02-11.19 1.435-1.68 2.998-3.25 4.664-4.7 1.665-1.45 3.442-2.78 5.302-3.97 3.731-2.38 7.792-4.2 12.054-5.4 2.125-.6 4.3-1.04 6.489-1.32 4.391-.56 8.841-.47 13.208.27 4.36.74 8.59 2.12 12.56 4.1 3.96 1.97 7.61 4.52 10.82 7.56 1.61 1.52 3.1 3.16 4.47 4.89 2.74 3.48 4.94 7.34 6.55 11.47.8 2.05 1.3 4.22 1.95 6.33l125.08 547.54 44.19-141.8 2.4-6.12c2.9-5.04 3.39-6.53 7.35-10.86 2.96-3.24 6.38-6.03 10.16-8.28 1.88-1.12 3.85-2.11 5.87-2.95 4.06-1.67 8.35-2.75 12.72-3.18 5.84-.58 7.32-.08 13.1.61 2.11.58 4.22 1.16 6.34 1.73 5.33 2.34 6.86 2.66 11.59 6.12 4.74 3.47 5.5 4.82 9.34 9.2l105.15 139.27h462.18v-213.52c-101.66.04-203.33.14-305-.01-2.97-.02-5.94-.08-8.9-.21-5.66-.26-11.3-.73-16.92-1.42-14.75-1.83-29.31-5.2-43.36-10.06-9.87-3.4-19.48-7.54-28.74-12.35-9.35-4.86-18.34-10.42-26.88-16.6-9.52-6.91-18.47-14.59-26.73-22.95-7.06-7.14-13.62-14.79-19.61-22.85-7.06-9.49-13.33-19.57-18.72-30.09-4.96-9.69-9.18-19.76-12.61-30.09-4.47-13.5-7.59-27.44-9.29-41.55-.68-5.62-1.13-11.27-1.37-16.92-.12-2.95-.17-5.9-.18-8.86v-304.35zm214.05 390.3h251.23l-337.4-337.4c-.13 83.99-.28 167.98.12 251.96.01 1.22.04 2.43.1 3.64.12 2.56.35 5.1.7 7.64.82 5.96 2.26 11.83 4.31 17.48 2.37 6.52 5.53 12.74 9.4 18.5 3.66 5.45 7.94 10.48 12.73 14.97 4.6 4.31 9.68 8.12 15.11 11.33 4.7 2.78 9.67 5.11 14.82 6.94 5.84 2.08 11.91 3.51 18.07 4.28 2.27.28 4.55.47 6.84.57 1.32.06 2.64.09 3.97.09z" />\n        </symbol>\n        <symbol id="jy-icon-file-video" viewBox="0 0 2048 1792" fill-rule="evenodd" clip-rule="evenodd">\n            <path d="M1417.03 128c3.42 0 6.84.2 10.24.5 6.75.6 13.45 1.8 20 3.5 6.27 1.7 12.41 3.9 18.33 6.6 5.93 2.7 11.63 5.9 17.03 9.5 4.13 2.8 8.08 5.8 11.83 9.1 1.94 1.7 3.81 3.4 5.64 5.2 150.06 149.6 299.89 299.5 449.49 449.5 1.81 1.8 3.56 3.7 5.25 5.6 3.27 3.8 6.3 7.8 9.07 11.9 3.63 5.4 6.81 11.1 9.5 17 2.69 5.9 4.89 12.1 6.57 18.3 1.75 6.6 2.94 13.3 3.54 20 .31 3.4.46 6.9.48 10.3.42 269.8.43 539.7 0 809.5-.01 2.3-.06 4.5-.16 6.7-.19 4.3-.54 8.5-1.06 12.7-1.37 11-3.88 21.9-7.5 32.4-3.86 11.1-8.97 21.9-15.2 31.9-6.5 10.5-14.22 20.2-22.94 28.9-8.73 8.8-18.46 16.5-28.94 23-10.05 6.2-20.78 11.3-31.95 15.2-10.49 3.6-21.36 6.1-32.37 7.5-4.21.5-8.44.9-12.67 1.1-2.23.1-4.46.1-6.69.1-533.68.9-1067.36.9-1601.038 0-2.231 0-4.462 0-6.692-.1-4.234-.2-8.461-.6-12.667-1.1-11.012-1.4-21.879-3.9-32.368-7.5-11.173-3.9-21.909-9-31.954-15.2-10.486-6.5-20.214-14.2-28.938-23-8.724-8.7-16.44-18.4-22.942-28.9-6.229-10-11.339-20.8-15.197-31.9-3.622-10.5-6.137-21.4-7.501-32.4-.522-4.2-.876-8.4-1.063-12.7-.099-2.2-.149-4.4-.159-6.7-.642-405.6-.63-811.3 0-1217 .009-2 .049-4 .129-5.9.166-4.2.49-8.3.972-12.3 1.32-11.2 3.826-22.3 7.462-32.9 4.89-14.4 11.824-28 20.534-40.4 8.619-12.3 18.967-23.3 30.649-32.7 7.64-6.1 15.846-11.6 24.48-16.2 8.74-4.7 17.916-8.6 27.374-11.6 10.12-3.2 20.559-5.4 31.115-6.6 3.765-.4 7.544-.6 11.329-.8l5.458-.1c397.843-.6 795.687-.6 1193.527 0zm-79.34 128h-1113.59c-1.224 0-2.444.1-3.66.2-2.496.3-4.958.9-7.32 1.7-2.85 1-5.552 2.5-8 4.3-2.633 1.9-4.968 4.2-6.9 6.9-2.086 2.8-3.697 6-4.751 9.3-.616 2-1.043 4-1.271 6.1-.125 1.1-.189 2.2-.197 3.3-1.886 405.4-.001 810.7-.001 1216.1l.003.6c.022 1.5.14 3 .372 4.5.325 2.2.869 4.3 1.628 6.3.663 1.7 1.486 3.4 2.452 5 3.726 6.3 9.565 11.2 16.363 13.7 1.987.8 4.051 1.3 6.148 1.6 1.629.3 3.276.4 4.924.4 533.334.9 1066.67 0 1600 0h.56c1.6 0 3.2-.1 4.78-.4 2.06-.3 4.09-.9 6.05-1.6 8.42-3.2 15.36-10 18.61-18.4.89-2.3 1.49-4.7 1.82-7.2.14-1 .22-2 .27-3.1.01-.4.02-.9.02-1.4v-729.6c-101.66.1-203.33.2-305 0-2.97 0-5.94-.1-8.9-.2-5.66-.3-11.3-.7-16.92-1.4-14.75-1.8-29.31-5.2-43.36-10.1-9.87-3.4-19.48-7.5-28.74-12.3-9.35-4.9-18.34-10.4-26.88-16.6-9.52-6.9-18.47-14.6-26.73-23-7.06-7.1-13.62-14.8-19.61-22.8-7.06-9.5-13.33-19.6-18.72-30.1-4.96-9.7-9.18-19.8-12.61-30.1-4.47-13.5-7.59-27.4-9.29-41.6-.68-5.6-1.13-11.2-1.37-16.9-.12-2.9-.17-5.9-.18-8.8v-304.4zm-447.683 195.2c245.523 0 444.853 199.3 444.853 444.8s-199.33 444.9-444.853 444.9c-245.519 0-444.85-199.4-444.85-444.9 0-245.5 199.331-444.8 444.85-444.8zm260.453 444.8l-409.78-240.9v481.9l409.78-241zm401.28-249.7h251.23l-337.4-337.4c-.13 84-.28 168 .12 252 .01 1.2.04 2.4.1 3.6.12 2.6.35 5.1.7 7.7.82 5.9 2.26 11.8 4.31 17.4 2.37 6.6 5.53 12.8 9.4 18.5 3.66 5.5 7.94 10.5 12.73 15 4.6 4.3 9.68 8.1 15.11 11.3 4.7 2.8 9.67 5.1 14.82 7 5.84 2.1 11.91 3.5 18.07 4.3 2.27.2 4.55.4 6.84.5 1.32.1 2.64.1 3.97.1z"/>\n        </symbol>\n        <symbol id="jy-icon-file-json" viewBox="0 0 2048 1792" fill-rule="evenodd" clip-rule="evenodd">\n            <path d="M1417.03 128c3.42 0 6.84.2 10.24.5 6.75.6 13.45 1.8 20 3.5 6.27 1.7 12.41 3.9 18.33 6.6 5.93 2.7 11.63 5.9 17.03 9.5 4.13 2.8 8.08 5.8 11.83 9.1 1.94 1.7 3.81 3.4 5.64 5.2 150.06 149.6 299.89 299.5 449.49 449.5 1.81 1.8 3.56 3.7 5.25 5.6 3.27 3.8 6.3 7.7 9.07 11.9 3.63 5.4 6.81 11.1 9.5 17 2.69 5.9 4.89 12.1 6.57 18.3 1.75 6.6 2.94 13.3 3.54 20 .31 3.4.46 6.9.48 10.3.42 269.8.43 539.7 0 809.5-.01 2.3-.06 4.5-.16 6.7-.19 4.3-.54 8.5-1.06 12.7-1.37 11-3.88 21.9-7.5 32.4-3.86 11.1-8.97 21.9-15.2 31.9-6.5 10.5-14.22 20.2-22.94 28.9-8.73 8.8-18.46 16.5-28.94 23-10.05 6.2-20.78 11.3-31.95 15.2-10.49 3.6-21.36 6.1-32.37 7.5-4.21.5-8.44.9-12.67 1.1-2.23.1-4.46.1-6.69.1-533.68.9-1067.36.9-1601.038 0-2.231 0-4.462 0-6.692-.1-4.234-.2-8.461-.6-12.667-1.1-11.012-1.4-21.879-3.9-32.368-7.5-11.173-3.9-21.909-9-31.954-15.2-10.486-6.5-20.214-14.2-28.938-23-8.724-8.7-16.44-18.4-22.942-28.9-6.229-10-11.339-20.8-15.197-31.9-3.622-10.5-6.137-21.4-7.501-32.4-.522-4.2-.876-8.4-1.063-12.7-.099-2.2-.149-4.4-.159-6.7-.642-405.6-.63-811.3 0-1217 .009-2 .049-4 .129-5.9.166-4.1.49-8.3.972-12.3 1.32-11.2 3.826-22.3 7.462-32.9 4.89-14.4 11.824-28 20.534-40.4 8.619-12.3 18.967-23.3 30.649-32.7 7.64-6.1 15.846-11.6 24.48-16.2 8.74-4.7 17.916-8.6 27.374-11.6 10.12-3.2 20.559-5.4 31.115-6.6 3.765-.4 7.544-.6 11.329-.8l5.458-.1c397.843-.6 795.687-.6 1193.527 0zm-79.34 128h-1113.59c-1.224 0-2.444.1-3.66.2-2.496.3-4.958.9-7.32 1.7-2.85 1-5.552 2.5-8 4.3-2.633 1.9-4.968 4.2-6.9 6.9-2.086 2.8-3.697 6-4.751 9.3-.616 2-1.043 4-1.271 6.1-.125 1.1-.189 2.2-.197 3.3-1.886 405.4-.001 810.7-.001 1216.1l.003.6c.022 1.5.14 3 .372 4.5.325 2.2.869 4.3 1.628 6.3.663 1.7 1.486 3.4 2.452 5 3.726 6.3 9.565 11.2 16.363 13.7 1.987.8 4.051 1.3 6.148 1.6 1.629.3 3.276.4 4.924.4 533.334.9 1066.67 0 1600 0h.56c1.6 0 3.2-.1 4.78-.4 2.06-.3 4.09-.9 6.05-1.6 8.42-3.2 15.36-10 18.61-18.4.89-2.3 1.49-4.7 1.82-7.2.14-1 .22-2 .27-3.1.01-.4.02-.9.02-1.4v-729.6c-101.66.1-203.33.2-305 0-2.97 0-5.94-.1-8.9-.2-5.66-.3-11.3-.7-16.92-1.4-14.75-1.8-29.31-5.2-43.36-10.1-9.87-3.4-19.48-7.5-28.74-12.3-9.35-4.9-18.34-10.4-26.88-16.6-9.52-6.9-18.47-14.6-26.73-23-7.06-7.1-13.62-14.8-19.61-22.8-7.06-9.5-13.33-19.6-18.72-30.1-4.96-9.7-9.18-19.8-12.61-30.1-4.47-13.5-7.59-27.4-9.29-41.6-.68-5.6-1.13-11.2-1.37-16.9-.12-2.9-.17-5.9-.18-8.8v-304.4zm-747.345 688.3v300c0 93.6-44.509 133.8-142.182 128.4v-86.4c34.001 1.8 49.455-10.2 49.455-42v-300h92.727zm152.691 87.6c0-10.8 9.891-16.8 25.964-16.8 20.4 0 32.764 10.8 41.418 26.4l79.127-41.4c-25.963-42.6-70.472-64.2-120.545-64.2-64.291 0-121.164 33-121.164 98.4 0 103.8 152.073 86.4 152.073 119.4 0 12-11.127 18.6-33.382 18.6-27.2 0-44.509-12.6-52.545-35.4l-80.364 44.4c24.109 48.6 71.091 71.4 132.909 71.4 66.764 0 128.582-29.4 128.582-98.4 0-111-152.073-88.2-152.073-122.4zm343.714 220.8c90.87 0 163.81-69 163.81-158.4s-72.94-158.4-163.81-158.4c-90.877 0-163.823 69-163.823 158.4s72.946 158.4 163.823 158.4zm309.09-308.4v28.2c16.69-22.2 47.6-36.6 88.4-36.6 62.43 0 115.6 43.2 115.6 124.2v184.2h-92.73v-171c0-37.2-24.11-54.6-53.78-54.6-34 0-57.49 19.2-57.49 61.8v163.8h-92.73v-300h92.73zm-309.09 220.8c-40.19 0-71.1-28.2-71.1-70.8 0-42.6 30.91-70.8 71.1-70.8 40.18 0 71.09 28.2 71.09 70.8 0 42.6-30.91 70.8-71.09 70.8zm-542.768-247.2c30.291 0 55.636-24.6 55.636-54s-25.345-54-55.636-54c-30.291 0-55.637 24.6-55.637 54s25.346 54 55.637 54zm1007.758-271.6h251.23l-337.4-337.4c-.13 84-.28 168 .12 252 .01 1.2.04 2.4.1 3.6.12 2.6.35 5.1.7 7.7.82 5.9 2.26 11.8 4.31 17.4 2.37 6.6 5.53 12.8 9.4 18.5 3.66 5.5 7.94 10.5 12.73 15 4.6 4.3 9.68 8.1 15.11 11.3 4.7 2.8 9.67 5.1 14.82 7 5.84 2.1 11.91 3.5 18.07 4.3 2.27.2 4.55.4 6.84.5 1.32.1 2.64.1 3.97.1z"/>\n        </symbol>\n        <symbol id="jy-icon-file-code" viewBox="0 0 2048 1792" fill-rule="evenodd" clip-rule="evenodd">\n            <path d="M1417.03 128c3.42 0 6.84.2 10.24.5 6.75.6 13.45 1.8 20 3.5 6.27 1.7 12.41 3.9 18.33 6.6 5.93 2.7 11.63 5.9 17.03 9.5 4.13 2.8 8.08 5.8 11.83 9.1 1.94 1.7 3.81 3.4 5.64 5.2 150.06 149.6 299.89 299.5 449.49 449.5 1.81 1.9 3.56 3.7 5.25 5.7 3.27 3.7 6.3 7.7 9.07 11.8 3.63 5.4 6.81 11.1 9.5 17 2.69 5.9 4.89 12.1 6.57 18.4 1.75 6.5 2.94 13.2 3.54 19.9.31 3.5.46 6.9.48 10.3.42 269.8.43 539.7 0 809.5-.01 2.3-.06 4.5-.16 6.7-.19 4.3-.54 8.5-1.06 12.7-1.37 11-3.88 21.9-7.5 32.4-3.86 11.1-8.97 21.9-15.2 31.9-6.5 10.5-14.22 20.2-22.94 29-8.73 8.7-18.46 16.4-28.94 22.9-10.05 6.2-20.78 11.3-31.95 15.2-10.49 3.6-21.36 6.1-32.37 7.5-4.21.5-8.44.9-12.67 1.1-2.23.1-4.46.1-6.69.1-533.68.9-1067.36.9-1601.038 0-2.231 0-4.462 0-6.692-.1-4.234-.2-8.461-.6-12.667-1.1-11.012-1.4-21.879-3.9-32.368-7.5-11.173-3.9-21.909-9-31.954-15.2-10.486-6.5-20.214-14.2-28.938-22.9-8.724-8.8-16.44-18.5-22.942-29-6.229-10-11.339-20.8-15.197-31.9-3.622-10.5-6.137-21.4-7.501-32.4-.522-4.2-.876-8.4-1.063-12.7-.099-2.2-.149-4.4-.159-6.7-.642-405.6-.63-811.3 0-1217 .009-2 .049-3.9.129-5.9.166-4.1.49-8.2.972-12.3 1.32-11.2 3.826-22.3 7.462-32.9 4.89-14.4 11.824-28 20.534-40.4 8.619-12.2 18.967-23.3 30.649-32.7 7.64-6.1 15.846-11.6 24.48-16.2 8.74-4.7 17.916-8.6 27.374-11.6 10.12-3.2 20.559-5.4 31.115-6.5 3.765-.4 7.544-.7 11.329-.9l5.458-.1c397.843-.6 795.687-.6 1193.527 0zm-79.34 128h-1113.59c-1.224 0-2.444.1-3.66.2-2.496.3-4.958.9-7.32 1.7-2.85 1.1-5.552 2.5-8 4.3-2.633 1.9-4.968 4.2-6.9 6.9-2.086 2.8-3.697 6-4.751 9.3-.616 2-1.043 4-1.271 6.1-.125 1.1-.189 2.2-.197 3.3-1.886 405.4-.001 810.8-.001 1216.1l.003.6c.022 1.5.14 3 .372 4.6.325 2.1.869 4.2 1.628 6.2.663 1.8 1.486 3.4 2.452 5.1 3.726 6.2 9.565 11.1 16.363 13.7 1.987.7 4.051 1.2 6.148 1.5 1.629.3 3.276.4 4.924.4 533.334.9 1066.67 0 1600 0h.56c1.6 0 3.2-.1 4.78-.4 2.06-.3 4.09-.8 6.05-1.6 8.42-3.2 15.36-10 18.61-18.4.89-2.3 1.49-4.7 1.82-7.1.14-1.1.22-2.1.27-3.2.01-.4.02-.9.02-1.4v-729.6c-101.66.1-203.33.2-305 0-2.97 0-5.94-.1-8.9-.2-5.66-.2-11.3-.7-16.92-1.4-14.75-1.8-29.31-5.2-43.36-10.1-9.87-3.4-19.48-7.5-28.74-12.3-9.35-4.9-18.34-10.4-26.88-16.6-9.52-6.9-18.47-14.6-26.73-23-7.06-7.1-13.62-14.7-19.61-22.8-7.06-9.5-13.33-19.6-18.72-30.1-4.96-9.7-9.18-19.8-12.61-30.1-4.47-13.5-7.59-27.4-9.29-41.5-.68-5.7-1.13-11.3-1.37-17-.12-2.9-.17-5.9-.18-8.8v-304.4zm-644.188 1127.9l214.248-880.7 124.37 30.3-214.246 880.7-124.372-30.3zm-380.613-425.2l259.196-345.5 102.393 76.8-201.579 268.7 201.579 268.7-102.393 76.8-259.196-345.5zm1099.851 0l-259.2-345.5-102.39 76.8 201.58 268.7-201.58 268.7 102.39 76.8 259.2-345.5zm139-312.4h251.23l-337.4-337.4c-.13 84-.28 168 .12 252 .01 1.2.04 2.4.1 3.6.12 2.6.35 5.1.7 7.7.82 5.9 2.26 11.8 4.31 17.5 2.37 6.5 5.53 12.7 9.4 18.5 3.66 5.4 7.94 10.4 12.73 14.9 4.6 4.3 9.68 8.1 15.11 11.3 4.7 2.8 9.67 5.2 14.82 7 5.84 2.1 11.91 3.5 18.07 4.3 2.27.2 4.55.4 6.84.5 1.32.1 2.64.1 3.97.1z"/>\n        </symbol>\n        <symbol id="jy-icon-cloud" viewBox="0 0 24 24" fill-rule="evenodd" clip-rule="evenodd">\n            <g>\n                <path fill="none" d="M-.013.015h23.998v23.998h-23.998z"/>\n                <path d="M10.453 4.291c.502.015.998.085 1.481.227 1.026.3 1.955.898 2.658 1.703.272.311.504.65.706 1.011l.003.005.197-.1.187-.078c.399-.146.819-.215 1.244-.193.331.017.659.088.968.21.833.329 1.496 1.025 1.784 1.873.099.291.153.598.161.905.01.399-.06.791-.199 1.164v.001l.185.078.164.077c.429.22.822.498 1.161.841.511.515.889 1.156 1.091 1.852.165.571.21 1.174.135 1.763-.054.428-.172.846-.35 1.239-.202.447-.48.858-.818 1.213-.362.38-.792.693-1.265.921-.387.187-.801.315-1.226.38-.183.028-.366.042-.551.049-3.681.046-7.362.001-11.044.001-.211-.003-.422-.013-.632-.04-.49-.063-.971-.199-1.421-.403-.549-.248-1.051-.597-1.477-1.023-.398-.397-.728-.861-.972-1.367-.214-.444-.362-.92-.437-1.407-.098-.643-.07-1.306.083-1.939.202-.827.619-1.597 1.199-2.22.357-.384.773-.704 1.228-.962l.006-.004v-.28l.014-.289c.06-.721.248-1.426.57-2.075.192-.386.428-.749.702-1.081.725-.879 1.714-1.528 2.81-1.839.409-.116.83-.182 1.255-.206l.4-.007zm-.17 1c-.62.011-1.232.137-1.8.386-.36.157-.699.36-1.007.603-.263.206-.504.441-.717.699-.542.657-.896 1.46-1.014 2.304-.044.313-.052.627-.033.943l.03.444-.436.21-.184.1c-.361.213-.689.475-.969.787-.424.471-.733 1.041-.894 1.654-.139.527-.167 1.082-.084 1.621.054.357.158.706.307 1.035.186.41.442.788.753 1.114.332.349.728.638 1.162.847.354.171.734.289 1.123.349.168.026.336.038.505.045 3.706.047 7.413.047 11.119 0l.425-.038c.326-.05.645-.148.943-.292.389-.187.74-.45 1.03-.769.273-.3.491-.649.64-1.027.122-.31.197-.639.222-.971.027-.353-.001-.709-.084-1.053-.193-.793-.684-1.499-1.354-1.964-.329-.228-.694-.391-1.08-.495l-.571-.141-.081-.2.335-.528c.126-.223.214-.464.252-.718.033-.222.029-.448-.011-.669-.119-.665-.573-1.243-1.188-1.522-.218-.099-.453-.159-.691-.177-.256-.02-.517.007-.763.082-.257.078-.492.209-.699.38l-.424.367-.203-.047-.269-.633c-.156-.335-.344-.651-.572-.943-.577-.736-1.373-1.292-2.266-1.572-.393-.123-.799-.189-1.211-.208l-.241-.003z"/>\n                <path d="M11.203 4.864c1.771.297 3.233 1.5 3.901 3.122.442-.391 1.025-.622 1.668-.622.825 0 1.562.392 2.033 1h-13.361c.579-1.808 2.13-3.18 4.039-3.5h1.72z" fill-opacity=".8"/>\n                <path d="M18.805 8.364c.337.435.538.98.538 1.571 0 .512-.15.984-.412 1.386.454.107.877.293 1.253.543h-16.744c.451-.643 1.065-1.163 1.78-1.497l-.02-.432c0-.548.086-1.076.244-1.571h13.361z" fill-opacity=".6"/>\n                <path d="M20.136 11.832c1.069.687 1.779 1.883 1.779 3.246l-.009.254h-19.187c-.059-.29-.09-.59-.09-.897 0-.969.309-1.868.833-2.603h16.674z" fill-opacity=".4"/>\n                <path d="M21.906 15.332c-.111 1.711-1.339 3.118-2.961 3.5h-12.774c-1.734-.377-3.098-1.757-3.452-3.5h19.187z" fill-opacity=".2"/>\n            </g>\n        </symbol>\n    </svg>\n<\/script>\n<script type="text/x-kendo-template" id="jyt-item-hint">\n  <div class="jy-item-hint jy-item-hint--${objType}">\n      # if (count > 1) { #\n          <span class="jy-item-hint__badge">${count}</span>\n      # } #\n\n      # if (objType == "folder") { #\n          <svg class="jy-item-hint__icon">\n              <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="\\#jy-icon-file-folder" />\n          </svg>\n      # } else if (objType == "file") { #\n          <svg class="jy-item-hint__icon">\n              <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="\\#jy-icon-file-default" />\n          </svg>\n      # } else if (objType == "mixed") { #\n          <svg class="jy-item-hint__icon jy-item-hint__icon--folder">\n              <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="\\#jy-icon-file-folder" />\n          </svg>\n          <svg class="jy-item-hint__icon jy-item-hint__icon--file">\n              <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="\\#jy-icon-file-default" />\n          </svg>\n      # } #\n  </div>\n<\/script>\n\n<script type="text/x-kendo-template" id="jyt-link-widget">\n    <div class="jy-link-widget__wrap"\n        data-bind="source: ${getSourceName()}"\n        data-template="jyt-link"></div>\n\n    <div id="jy-preview-dialog-${uid}"\n         class="jy-preview-dialog"\n         data-role="junkyarddialog"\n         data-top-overlay="true"\n         data-template-id="jyt-preview-dialog"></div>\n<\/script>\n<script type="text/x-kendo-template" id="jyt-link">\n    <span class="jy-link" data-bind="css: {\n        jy-link--init: isInit,\n        jy-link--no-file: isNoFile,\n        jy-link--loading: isLoading,\n        jy-link--loaded: isLoaded,\n        jy-link--error: isError,\n        jy-link--downloading: isDownloading,\n        jy-link--forbidden: isForbidden,\n        jy-link--with-preview: isPreview,\n        jy-link--preview-loaded: previewLoaded,\n        jy-link--open-preview-available: openPreviewAvailable,\n        jy-link--docs: isDocs}">\n\n        <span class="jy-link__progress">\n            <i class="fa fa-spinner fa-spin" />\n        </span>\n\n        <span class="jy-link__not-exists">\n            <i class="fa fa-exclamation-circle" /> Файл не найден\n        </span>\n\n        <span class="jy-link__no-file">\n            <i class="fa fa-exclamation-triangle" /> Нет файла\n        </span>\n\n        <span class="jy-link__forbidden">\n            <i class="fa fa-exclamation-circle" /> Нет доступа\n        </span>\n\n        <span class="jy-link__preview" data-bind="style: {width: previewWidth, height: previewHeight}">\n            <img class="jy-link__preview__image" alt=""\n                data-bind="imageAjax: previewUrl, events: { load: onPreviewLoad }" />\n        </span>\n\n        <span class="jy-link__content" data-bind="click: onContentClick">\n            <span class="jy-link__icon">\n                <svg class="jy-icon-file"\n                    data-css-icon="jy-icon-file"\n                    data-css-icon-format="jy-icon-file-{0}"\n                    data-bind="svgIcon: data.extension"></svg>\n\n                <a class="jy-link__over-icon jy-link__download"\n                    title="Скачать файл"\n                    data-bind="attr: {href: downloadUrl.value}, click: onFileDownload, visible: hash">\n                    <i class="fa fa-download"></i>\n                </a>\n\n                <span class="jy-link__over-icon jy-link__downloading">\n                    <i class="fa fa-download"></i>\n                </span>\n            </span>\n\n            <span class="jy-link__info">\n                <span class="jy-link__title"\n                    data-bind="ellipsisText: data.title"\n                    data-placeholder="..."\n                    data-max-length="${widgetOpt.maxFileName}"\n                    data-add-title="true"></span>\n\n                <span class="jy-link__size"\n                    data-decimal-separator=","\n                    data-bind="size: data.size"></span>\n            </span>\n        </span>\n\n        <span class="jy-link__hidden"\n            id="jy-link-download-${uid}"></span>\n    </span>\n<\/script>\n\n<script type="text/x-kendo-template" id="jyt-menu-item-hint">\n    <div class="jy-menu-item-hint jy-menu-item-hint--${objType}">\n        # if (objType == "folder") { #\n            <span class="jy-menu-item-hint__content">\n                <i class="fa fa-fw fa-folder"></i>${title}\n            </span>\n        # } #\n    </div>\n<\/script>\n<script type="text/x-kendo-template" id="jyt-menu-item">\n    <span class="#if (item.isEncrypted) {#jy-menu-item--encrypted#}#"><i class="fa fa-fw ${item.icon}" data-type="${item.menuType}" data-id="${item.id}">#if (item.isEncrypted) {#<i class="fa fa-lock jy-mod-icon"></i>#}#</i>#= item.title #</span>\n<\/script>\n<script type="text/x-kendo-template" id="jyt-move-item-dialog">\n    <div id="jy-window-${uid}"\n        class="jy-window"\n        data-role="window"\n        data-title="Переместить в"\n        data-width="300"\n        data-height="500"\n        data-modal="true"\n        data-actions="[\'Close\']"\n        data-scrollable="true"\n        data-resizable="false"\n        data-visible="false">\n\n        <div class="jy-window__content jy-window__content--move-dialog">\n            <div class="jy-folder-chooser-wrap"\n                 data-role="junkyardfragment"\n                 data-bind="model: folderChooser, events: {createView: onCreateFolderChooser}"\n                 data-template-id="jyt-folder-chooser"></div>\n        </div>\n\n        <div class="jy-window__button-group">\n            <button class="jy-window__button" data-bind="click: onOk, enabled: isValid">Переместить</button>\n            <button class="jy-window__button" data-bind="click: onCancel">Отмена</button>\n        </div>\n    </div>\n<\/script>\n<script type="text/x-kendo-template" id="jyt-new-drive-dialog">\n    <div id="jy-window-${uid}"\n        class="jy-window"\n        data-role="window"\n        data-title="Новый диск"\n        data-width="500"\n        data-height="590"\n        data-modal="true"\n        data-actions="[\'Close\']"\n        data-scrollable="true"\n        data-resizable="false"\n        data-visible="false">\n\n        <div class="jy-window__content">\n            <div class="jy-input-group">\n                <label class="jy-input-group__label">Название диска</label>\n                <input type="text" class="jy-input-group__input" data-bind="value: title, focus: titleInputFocus" data-value-update="keyup"/>\n            </div>\n\n            <div class="jy-input-group">\n                <input class="jy-input-group__checkbox" type="checkbox" id="jy-drive-enable-encrypt-${uid}" data-bind="checked: isEncrypted">\n                <label class="jy-input-group__checkbox-label" for="jy-drive-enable-encrypt-${uid}">Защищенный</label>\n                <input class="jy-input-group__checkbox" type="checkbox" id="jy-drive-enable-history-${uid}" data-bind="checked: isHistory">\n                <label class="jy-input-group__checkbox-label" for="jy-drive-enable-history-${uid}">Включить историю</label>\n            </div>\n\n            <div data-role="junkyardfragment"\n                 data-bind="model: accessSettings"\n                 data-template-id="jyt-access"></div>\n        </div>\n\n        <div class="jy-window__button-group">\n            <button class="jy-window__button" data-bind="click: onOk, enabled: isValid">Создать</button>\n            <button class="jy-window__button" data-bind="click: onCancel">Отмена</button>\n        </div>\n    </div>\n<\/script>\n\n<script type="text/x-kendo-template" id="jyt-new-folder-dialog">\n    <div id="jy-window-${uid}"\n        class="jy-window"\n        data-role="window"\n        data-title="Новая папка"\n        data-width="500"\n        data-height="170"\n        data-modal="true"\n        data-actions="[\'Close\']"\n        data-scrollable="true"\n        data-resizable="false"\n        data-visible="false">\n\n        <div class="jy-window__content">\n            <div class="jy-input-group">\n                <input type="text" placeholder="Название папки" class="jy-input-group__input" data-bind="value: title, focus: titleInputFocus" data-value-update="keyup"/>\n            </div>\n        </div>\n\n        <div class="jy-window__button-group">\n            <button class="jy-window__button" data-bind="click: onOk, enabled: isValid">Создать</button>\n            <button class="jy-window__button" data-bind="click: onCancel">Отмена</button>\n        </div>\n    </div>\n<\/script>\n<script type="text/x-kendo-template" id="jyt-notification">\n    <div class="jy-notification" data-bind="css: {\n        jy-notification--leave: leave,\n        jy-notification--enter: enter,\n        jy-notification--success: success,\n        jy-notification--error: error\n    }">${message}</div>\n<\/script>\n<script type="text/x-kendo-template" id="jyt-open-file-dialog">\n    <div id="jy-window-${uid}"\n        class="jy-window"\n        data-role="window"\n        data-title="${title}"\n        data-content="${url}"\n        data-iframe="true"\n        data-width="800"\n        data-height="530"\n        data-modal="true"\n        data-actions="[\'Maximize\', \'Close\']"\n        data-scrollable="true"\n        data-resizable="true"\n        data-visible="false"></div>\n<\/script>\n<script type="text/x-kendo-template" id="jyt-path">\n    <span class="jy-path__item" data-bind="click: onPathClick, css: {jy-path__item--dropping: dropping}">\n        <span class="jy-path__name">${title}</span>\n        <span class="jy-path__separator">/</span>\n    </span>\n<\/script>\n<script type="text/x-kendo-template" id="jyt-permission-editor">\n    <div class="jy-permission-editor">\n        <div class="jy-permission-editor__button" data-bind="click: onToggle, css: {jy-permission-editor__button--opened: opened}">\n            <i class="fa fa-pencil" aria-hidden="true"></i>\n            <i class="fa fa-angle-down" aria-hidden="true"></i>\n        </div>\n\n        <ul class="jy-selector"\n             data-bind="source: items, css: {jy-selector--opened: opened}"\n             data-template="jyt-permission-item"></ul>\n    </div>\n<\/script>\n<script type="text/x-kendo-template" id="jyt-permission-item">\n    <li class="jy-selector__item" data-bind="click: onSelect, css: {jy-selector__item--selected: selected}">\n        <i class="fa fa-fw fa-check"></i> ${title}\n    </li>\n<\/script>\n<script type="text/x-kendo-template" id="jyt-preview-dialog">\n\t<div class="jy-preview" data-bind="click: onClose">\n\t\t<div class="jy-preview__toolbar" data-bind="click: onStopClick">\n\t\t\t<div class="jy-preview__filename">\n\t\t\t\t<div class="jy-icon-wrap">\n\t\t\t\t\t<svg class="jy-icon-file jy-icon-file-${kendo.ui.junkyard.fileTypeIcon(extension)}">\n\t\t\t\t\t\t<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="\\#jy-icon-file-${kendo.ui.junkyard.fileTypeIcon(extension)}"></use>\n\t\t\t\t\t</svg>\n\t\t\t\t</div>\n\t\t\t\t<span class="jy-preview__name">${title}</span>\n\t\t\t</div>\n\n\t\t\t<div class="jy-preview__edit" data-bind="click: onEdit, visible: canEdit">\n\t\t\t\t<i class="fa fa-edit"></i>&nbsp;Редактировать\n\t\t\t</div>\n\n\t\t\t<div class="jy-preview__actions">\n\t\t\t\t<div class="jy-preview__action jy-preview__action--download" data-bind="click: onDownload" title="Скачать"><i class="fa fa-download"></i></div>\n\t\t\t\t<div class="jy-preview__action jy-preview__action--close" data-bind="click: onClose" title="Закрыть">×</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="jy-preview__progress" data-bind="visible: loading">\n\t\t\t<svg class="jy-loading-hexes"\n\t\t\t\tdata-role="junkyardsvgprogress"\n\t\t\t\txmlns="http://www.w3.org/2000/svg"\n\t\t\t\tviewBox="0 0 100 100"\n\t\t\t\twidth="100"\n\t\t\t\theight="100"\n\t\t\t\tfill-rule="evenodd"\n\t\t\t\tclip-rule="evenodd"></svg>\n\t\t</div>\n\n\t\t<div class="jy-preview__control jy-preview__control--next" data-bind="visible: isNextVisible">\n\t\t\t<div class="jy-preview__control-circle"></div>\n\t\t\t<svg class="jy-preview__control-icon">\n\t\t\t\t<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="\\#jy-icon-arrow"></use>\n\t\t\t</svg>\n\t\t</div>\n\n\t\t<div class="jy-preview__control jy-preview__control--prev" data-bind="visible: isPrevVisible">\n\t\t\t<div class="jy-preview__control-circle"></div>\n\t\t\t<svg class="jy-preview__control-icon">\n\t\t\t\t<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="\\#jy-icon-arrow"></use>\n\t\t\t</svg>\n\t\t</div>\n\n\t\t<div class="jy-preview__content"\n\t\t\tdata-template="jyt-preview-dialog-content-item"\n\t\t\tdata-bind="source: contentItem, invisible: contentNotAvailable, css: {\n\t\t\t\tjy-preview__content--office: isFrame,\n\t\t\t\tjy-visualy-hidden: loading\n\t\t\t}">\n\t\t</div>\n\n\t\t<div class="jy-preview__no-content" data-bind="visible: contentNotAvailable, click: onStopClick">\n\t\t\t<div class="jy-preview__no-content-text">Предварительный просмотр недоступен.</div>\n\t\t\t<div class="jy-preview__no-content-download" data-bind="click: onDownload">\n\t\t\t\t<i class="fa fa-download"></i>&nbsp;Скачать\n\t\t\t</div>\n\t\t</div>\n\t</div>\n<\/script>\n\n<script type="text/x-kendo-template" id="jyt-preview-dialog-content-item">\n\t<div class="jy-preview__content-inner">\n\t\t# if (isImage) { #\n\t\t\t<figure data-bind="click: onStopClick">\n\t\t\t\t<img src="${url}" alt="${title}" data-bind="events: { load: onImageLoad }" />\n\t\t\t</figure>\n\t\t# } else if (isVideo) { #\n\t\t\t<div id="jyt-preview-mediaplayer-${previewUid}"\n\t\t\t\t\tdata-role="mediaplayer"\n\t\t\t\t\tdata-media="{ title: \'${title}\', source: \'${url}\' }"\n\t\t\t\t\tdata-bind="events: { ready: onMediaPlayerReady }"></div>\n\t\t# } else if (isFrame) { #\n\t\t\t<iframe src="${url}" data-bind="events: { load: onFrameLoad, click: onStopClick }"></iframe>\n\t\t# } #\n\t</div>\n<\/script>\n<script type="text/x-kendo-template" id="jyt-rename-dialog">\n    <div id="jy-window-${uid}"\n        class="jy-window"\n        data-role="window"\n        data-title="Переименовать"\n        data-width="500"\n        data-height="190"\n        data-modal="true"\n        data-actions="[\'Close\']"\n        data-scrollable="true"\n        data-resizable="false"\n        data-visible="false">\n\n        <div class="jy-window__content">\n            <div class="jy-input-group">\n                <label class="jy-input-group__label">Введите новое название</label>\n                <input type="text" class="jy-input-group__input" data-bind="value: title, focus: titleInputFocus" data-value-update="keyup"/>\n            </div>\n        </div>\n\n        <div class="jy-window__button-group">\n            <button class="jy-window__button" data-bind="click: onOk, enabled: isValid">Сохранить</button>\n            <button class="jy-window__button" data-bind="click: onCancel">Отмена</button>\n        </div>\n    </div>\n<\/script>\n<script type="text/x-kendo-template" id="jyt-restore-item-dialog">\n    <div id="jy-window-${uid}"\n        class="jy-window"\n        data-role="window"\n        data-title="Восстановить в"\n        data-width="300"\n        data-height="500"\n        data-modal="true"\n        data-actions="[\'Close\']"\n        data-scrollable="true"\n        data-resizable="false"\n        data-visible="false">\n\n        <div class="jy-window__content jy-window__content--restore-dialog">\n            <div class="jy-folder-chooser-wrap"\n                 data-role="junkyardfragment"\n                 data-bind="model: folderChooser, events: {createView: onCreateFolderChooser}"\n                 data-template-id="jyt-folder-chooser"></div>\n        </div>\n\n        <div class="jy-window__content jy-window__content--no-full-height">\n            <div class="jy-input-group">\n                <label class="jy-input-group__label">Изменить название</label>\n                <input type="text" class="jy-input-group__input" data-bind="value: name, focus: titleInputFocus" data-value-update="keyup"/>\n            </div>\n        </div>\n\n        <div class="jy-window__button-group">\n            <button class="jy-window__button" data-bind="click: onOk, enabled: isValid">Восстановить</button>\n            <button class="jy-window__button" data-bind="click: onCancel">Отмена</button>\n        </div>\n    </div>\n<\/script>\n<script type="text/x-kendo-template" id="jyt-select-file-error">\n    <div class="jy-select__file-error">\n        ${message}\n    </div>\n<\/script>\n<script type="text/x-kendo-template" id="jyt-select-file">\n    <div class="jy-select__file" data-bind="css: {\n        jy-select__file--init: isInit,\n        jy-select__file--loading: isLoading,\n        jy-select__file--loaded: isLoaded,\n        jy-select__file--error: isError,\n        jy-select__file--error-not-exists: isErrorNotExists,\n        jy-select__file--sharing: isSharing,\n        jy-select__file--shared: isShared,\n        jy-select__file--not-shared: isNotShared,\n        jy-select__file--pre-upload: isPreUpload,\n        jy-select__file--uploading: isUploading,\n        jy-select__file--upload-error: isUploadError,\n        jy-select__file--select-to-upload: isSelectToUpload,\n        jy-select__file--downloading: isDownloading,\n        jy-select__file--with-preview: isPreview,\n        jy-select__file--preview-loaded: previewLoaded,\n        jy-select__file--open-preview-available: openPreviewAvailable,\n        jy-select__file--docs: isDocs,\n        jy-select__file--show-history-btn: showHistoryBtn}, click: onContentClick">\n\n        <div class="jy-select__file__progress jy-select__file__centered">\n            <i class="fa fa-spinner fa-spin" />\n        </div>\n\n        <div class="jy-select__file__error jy-select__file__centered">\n            <i class="fa fa-exclamation-triangle" />\n        </div>\n\n        <div class="jy-select__file__not-exists jy-select__file__centered">\n            <i class="fa fa-exclamation-circle" /> Файл не найден\n        </div>\n\n        <div class="jy-select__file__sharing jy-select__file__centered">\n            <i class="fa fa-link" />\n        </div>\n\n        <div class="jy-select__file__shared jy-select__file__centered">\n            <i class="fa fa-link" />\n        </div>\n\n        <div class="jy-select__file__preview" #=(widgetOpt.previewHeightAuto ? "style=\'height: auto;\'" : "")# >\n            <img class="jy-select__file__preview__image" alt=""\n                data-bind="imageAjax: previewUrl, events: { load: onPreviewLoad }" />\n        </div>\n\n        <div class="jy-select__file__content">\n            <span class="jy-select__file__icon">\n                <svg class="jy-icon-file"\n                    data-css-icon="jy-icon-file"\n                    data-css-icon-format="jy-icon-file-{0}"\n                    data-bind="svgIcon: data.extension"></svg>\n\n                <a class="jy-select__file__over-icon jy-select__file__download"\n                    title="Скачать файл"\n                    data-bind="attr: {href: downloadUrl}, click: onDownload, visible: hash">\n                    <i class="fa fa-download"></i>\n                </a>\n\n                <span class="jy-select__file__over-icon jy-select__file__edit"\n                    title="Редактировать"\n                    data-bind="click: onEdit, visible: canEdit">\n                    <i class="fa fa-pencil"></i>\n                </span>\n\n                <span class="jy-select__file__over-icon jy-select__file__upload-repeat"\n                    title="Повторить загрузку файла"\n                    data-bind="click: onRetryUpload">\n                    <i class="fa fa-repeat"></i>\n                </span>\n\n                <span class="jy-select__file__over-icon jy-select__file__pre-upload">\n                    <i class="fa fa-upload"></i>\n                </span>\n\n                <span class="jy-select__file__over-icon jy-select__file__downloading">\n                    <i class="fa fa-download"></i>\n                </span>\n\n                <span class="jy-select__file__upload-progress"\n                    data-role="junkyardfragment"\n                    data-bind="model: uploadProgress"\n                    data-template-id="jyt-circle-progress"></span>\n            </span>\n\n            <span class="jy-select__file__info">\n                <span class="jy-select__file__title"\n                    data-bind="ellipsisText: data.title"\n                    data-placeholder="..."\n                    data-max-length="#=widgetOpt.titleMaxLength#"\n                    data-add-title="true"></span>\n\n                <span class="jy-select__file__size"\n                    data-decimal-separator=","\n                    data-bind="size: data.size"></span>\n            </span>\n        </div>\n\n        <div class="jy-select__file__remove" data-bind="click: onFileRemove, invisible: readonly">\n            <i class="fal fa-times"></i>\n        </div>\n\n        <div class="jy-select__file__history" data-bind="click: onOpenFileHistory, visible: showHistoryBtn">\n            <i class="fal fa-history"></i>\n        </div>\n    </div>\n<\/script>\n\n<script type="text/x-kendo-template" id="jyt-select-upload">\n    <input id="jy-widget-upload-${uid}"\n        accept="*/*"\n        name="upload[]"\n        type="file"\n        data-role="junkyardupload"\n        data-drop-zone="\\#jy-select-wrapper-${root.uid}"\n        data-drop-zone-filter="\\#jy-select-wrapper-${root.uid}"\n        data-cancel-on-destroy="true"\n        data-directory-drop="false",\n        data-async="{\n            autoUpload: false,\n            saveUrl: \'config\',\n            batch: false,\n            withCredentials: false}"\n        data-multiple="${widgetOpt.multiselect}"\n        data-show-file-list="false"\n        data-validation="{\n            allowedExtensions: ${allowedExtensionsOpt()},\n            maxFileSize: ${widgetOpt.uploadMaxSize},\n            minFileSize: ${widgetOpt.uploadMinSize}\n        }"\n        data-bind="events: {\n            select: onFileSelect,\n            upload: onFileUpload,\n            complete: onUploadCompleted,\n            remove: onFileRemove,\n            success: onFileSuccess,\n            cancel: onFileCancel,\n            error: onFileError,\n            progress: onFileProgress,\n            dropToZone: onDropZone,\n            clickInput: onClickInput\n        }"\n    />\n<\/script>\n<script type="text/x-kendo-template" id="jyt-select-widget">\n    <div id="jy-select-wrapper-${uid}" class="jy-select__wrapper" data-bind="css: {\n        jy-select__wrapper--auth-init: isAuthInit,\n        jy-select__wrapper--auth-progress: isAuthProgress,\n        jy-select__wrapper--auth-success: isAuthSuccess,\n        jy-select__wrapper--auth-failed: isAuthFailed,\n        jy-select__wrapper--readonly: isReadOnly}">\n\n        <div class="jy-select__auth-progress">\n            <svg class="jy-select__cloud-progress">\n                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="\\#jy-icon-cloud"></use>\n            </svg>\n        </div>\n\n        <div class="jy-select__auth-failed">\n            <svg class="jy-select__cloud-failed">\n                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="\\#jy-icon-cloud"></use>\n            </svg>\n        </div>\n\n        <div class="jy-select__files"\n            data-template="jyt-select-file"\n            data-bind="source: value.files, invisible: value.isEmpty">\n        </div>\n\n        <div class="jy-select__empty" data-bind="css: {jy-select__empty--visible: emptyVisible}">\n            <div class="jy-select__empty__inner">\n                # if (widgetOpt.emptyText) { #\n                    #= widgetOpt.emptyText #\n                # } else { #\n                    Выберите файл из хранилища или загрузите файл.\n                # } #\n            </div>\n        </div>\n\n        <div class="jy-select__button-group">\n            <div title="Загрузить файл" class="jy-select__button jy-select__button--upload"\n                data-bind="click: onLocalUpload, css: {\n                    jy-select__button--disabled: localUploadDisabled,\n                    jy-select__button--error: localUploadNotAvailable\n                }, attr: {data-upload-drive: uploader.targetDrive.title}">\n                <span class="fa fa-upload"></span>\n            </div>\n\n            <div title="Выбрать файл из хранилища" class="jy-select__button jy-select__button--cloud"\n                data-bind="click: onCloudChooseFile, css: {jy-select__button--disabled: cloudChooseFileDisabled}">\n                <span class="fa fa-cloud-upload"></span>\n            </div>\n        </div>\n\n        <div class="jy-select__drop-zone">\n            <div class="jy-select__drop-zone__icon">\n                <i class="fa fa-cloud-upload"></i>\n            </div>\n        </div>\n    </div>\n\n    <div class="jy-select__file-errors"\n        data-template="jyt-select-file-error"\n        data-bind="source: fileErrors, visible: fileErrors.length">\n    </div>\n\n    <div id="jy-cloud-file-chooser-dialog-${uid}"\n        data-role="junkyarddialog"\n        data-template-id="jyt-cloud-file-chooser-dialog"></div>\n\n    <div id="jy-preview-dialog-${uid}"\n         class="jy-preview-dialog"\n         data-role="junkyarddialog"\n         data-top-overlay="true"\n         data-template-id="jyt-preview-dialog"></div>\n\n    <div class="jy-select__hidden"\n        data-role="junkyardfragment"\n        data-bind="model: uploader.upload"\n        data-template-id="jyt-select-upload"></div>\n\n    <div class="jy-select__hidden"\n        id="jy-select-download-${uid}"></div>\n<\/script>\n<script type="text/x-kendo-template" id="jyt-share-dialog">\n    <div id="jy-window-${uid}"\n        class="jy-window"\n        data-role="window"\n        data-title="Общий доступ"\n        data-width="500"\n        data-height="490"\n        data-modal="true"\n        data-actions="[\'Close\']"\n        data-scrollable="true"\n        data-resizable="false"\n        data-visible="false">\n\n        <div class="jy-window__content">\n            <div data-role="junkyardfragment"\n                 data-bind="model: accessSettings"\n                 data-template-id="jyt-access"></div>\n        </div>\n\n        <div class="jy-window__button-group">\n            <button class="jy-window__button" data-bind="click: onOk, enabled: isValid">Сохранить</button>\n            <button class="jy-window__button" data-bind="click: onCancel">Отмена</button>\n        </div>\n    </div>\n<\/script>\n<script type="text/x-kendo-template" id="jyt-share-link-dialog">\n    <div id="jy-window-${uid}"\n        class="jy-window"\n        data-role="window"\n        data-title="Доступ по ссылке"\n        data-width="500"\n        data-height="140"\n        data-modal="true"\n        data-actions="[\'Close\']"\n        data-scrollable="true"\n        data-resizable="false"\n        data-visible="false">\n\n        <div class="jy-window__content">\n            <div class="jy-share-link">\n                <div class="jy-share-link__progress" data-bind="visible: progress">\n                    Включение доступа по ссылке...\n                </div>\n                <div class="jy-share-link__progress" data-bind="visible: error">\n                    Ошибка включения доступа по ссылке.\n                </div>\n                <div class="jy-share-link__content" data-bind="visible: contentVisible">\n                    <div class="jy-input-group">\n                        <label class="jy-input-group__label">Ссылка для загрузки файла</label>\n                        <input type="text" readonly class="jy-input-group__input"\n                            data-bind="value: downloadUrl, click: onInputAllSelect"/>\n                    </div>\n                    <div class="jy-share-link__access">\n                        Доступ включен для <strong>всех</strong>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n<\/script>\n<script type="text/x-kendo-template" id="jyt-sort">\n    <div class="jy-sort">\n        <div class="jy-sort__value">\n            <div class="jy-sort__by" data-bind="text: value.title, click: onToggle"></div>\n            <div class="jy-sort__direction" data-bind="click: onToggleDirection">\n                <i class="fa fa-arrow-up" aria-hidden="true" data-bind="visible: isAscDir"></i>\n                <i class="fa fa-arrow-down" aria-hidden="true" data-bind="visible: isDescDir"></i>\n            </div>\n        </div>\n\n        <ul class="jy-selector"\n             data-bind="source: items, css: {jy-selector--opened: opened}"\n             data-template="jyt-sort-item"></ul>\n    </div>\n<\/script>\n\n<script type="text/x-kendo-template" id="jyt-sort-item">\n    <li class="jy-selector__item" data-bind="click: onSelect, css: {jy-selector__item--selected: selected}">\n        <i class="fa fa-fw fa-check"></i> ${title}\n    </li>\n<\/script>\n<script type="text/x-kendo-template" id="jyt-user-or-group-item">\n    <span>${title}</span>\n<\/script>\n<script type="text/x-kendo-template" id="jyt-widget">\n    <div class="jy-progress-bar" data-bind="css: {jy-progress-bar--show: progressBar.visible}">\n        <div class="jy-progress-bar__line-translate">\n            <span class="jy-progress-bar__line"></span>\n        </div>\n    </div>\n    <div class="jy-progress-wait" data-bind="css: {jy-progress-wait--show: progressBar.waitVisible}">Подождите...</div>\n\n    <div class="jy-notification-bar" data-bind="css: {jy-notification-bar--show: errorBar.visible}">\n        <div data-bind="source: errorBar.items" data-template="jyt-notification"></div>\n    </div>\n\n    <div class="jy-splitter" data-role="splitter" data-panes="[{min: \'200px\', size: \'15%\'}, {}]">\n        <div class="jy-sidebar">\n            <h3 class="jy-sidebar__title">\n                <svg class="logo">\n                    <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="\\#jy-icon-cloud"></use>\n                </svg>\n                <div data-role="junkyardfragment"\n                     data-bind="model: toolbar.createBtn"\n                     data-template-id="jyt-create-btn"></div>\n            </h3>\n            <div id="jy-widget-menu-${menuTree.uid}"\n                 data-role="junkyardtreeview"\n                 data-text-field="title"\n                 data-bind="source: menuTree.dataSource, events: {change: menuTree.onSelect, dataBound: menuTree.onDataBound}"\n                 data-auto-bind="false"\n                 data-template="jyt-menu-item"\n                 class="jy-sidebar__treeview jy-treeview">\n            </div>\n\n            <ul id="jy-context-menu-${menuTreeCtx.uid}"\n                class="jy-context-menu"\n                data-role="junkyardcontextmenu"\n                data-bind="events: {select: menuTreeCtx.onSelect, open: menuTreeCtx.onOpen, close: menuTreeCtx.onClose}, source: menuTreeCtx.items"\n                data-target=".jy-sidebar"\n                data-filter=".jy-treeview .k-item"\n                data-with-target="true"\n                data-ignore=".jy-sidebar__title"\n                data-open-ignore="prevent"\n                data-css-open-target="jy-context-menu--opened"\n                data-animation="false"\n                data-item-template="jyt-context-menu-item"></ul>\n        </div>\n        <div class="jy-main" data-bind="css: {jy-main--details-opened: details.opened}">\n            <div class="jy-toolbar">\n                <div class="jy-search" data-bind="invisible: authProgress, css: { jy-search--disabled: drives.visible, jy-search--opened: searchBar.opened }">\n                    <form data-bind="events: { submit: searchBar.onSearch }">\n                        <span class="jy-search__open" data-bind="click: searchBar.onOpen, invisible: searchBar.opened"><i class="fa fa-search"></i></span>\n                        <span class="jy-search__close" data-bind="click: searchBar.onClose, visible: searchBar.opened">\n                            <svg class="jy-icon jy-icon-arrow--left">\n                                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="\\#jy-icon-arrow"></use>\n                            </svg>\n                        </span>\n                        <input class="jy-search__input" type="text" data-bind="value: searchBar.query, events: { blur: searchBar.onInputFocusOut }"/>\n                        <span class="jy-search__reset" data-bind="click: searchBar.onReset, visible: searchBar.searched">×</span>\n                    </form>\n                </div>\n\n                <div class="jy-path"\n                    data-template="jyt-path"\n                    data-bind="source: path.pathItems, css: { jy-path--loading: path.loading }"></div>\n\n                <div class="jy-toolbar__actions">\n                    <div class="jy-toolbar-action" data-bind="click: toolbar.onShareLink, visible: toolbar.canShareLink">\n                        <i class="fa fa-link" aria-hidden="true"></i>\n                    </div>\n                    <div class="jy-toolbar-action" data-bind="click: toolbar.onShare, visible: toolbar.canShare">\n                        <i class="fa fa-user-plus" aria-hidden="true"></i>\n                    </div>\n                    <div class="jy-toolbar-action" data-bind="click: toolbar.onDelete, visible: toolbar.canDelete">\n                        <i class="fa fa-trash-o" aria-hidden="true"></i>\n                    </div>\n                    <div class="jy-toolbar-action" data-bind="click: toolbar.onOpenActions, visible: toolbar.canOpenActions">\n                        <i class="fa fa-ellipsis-v" aria-hidden="true"></i>\n                    </div>\n                    <div class="jy-toolbar-divider" data-bind="visible: toolbar.hasContext"></div>\n                    <div class="jy-btn-info jy-toolbar-action" data-bind="click: toolbar.onToggleDetails, visible: toolbar.canShowDetails">\n                        <i class="fa fa-info-circle" aria-hidden="true"></i>\n                    </div>\n                    <div class="jy-btn-view jy-toolbar-action" data-bind="click: toolbar.onExecChangeView, visible: toolbar.canChangeView">\n                        <i class="fa fa-fw fa-list-ul" aria-hidden="true" data-bind="visible: toolbar.isCardView"></i>\n                        <i class="fa fa-fw fa-th" aria-hidden="true" data-bind="visible: toolbar.isGridView"></i>\n                    </div>\n                </div>\n            </div>\n\n            <div class="jy-content-view">\n                <div class="jy-upload-icon-placeholder">\n                    <i class="fa fa-cloud-upload"></i>\n                </div>\n\n                <div class="jy-card-view jy-card-view--drives" data-bind="visible: drives.isCardView">\n                    <div data-role="junkyardfragment"\n                         data-bind="model: drives.sort"\n                         data-template-id="jyt-sort"></div>\n\n                    <section class="jy-cards-section jy-cards-section--drives" data-bind="visible: drives.isDrivesVisible">\n                        <h4 class="jy-cards-section__title">Диски</h4>\n\n                        <div class="jy-cards-section__list jy-listview"\n                             data-role="listview"\n                             data-navigatable="false"\n                             data-selectable="false"\n                             data-bind="source: drives.cardDataSource"\n                             data-template="jyt-drive-item"\n                             data-auto-bind="false"></div>\n                    </section>\n\n                    <div class="jy-empty" data-bind="visible: drives.isEmptyVisible">\n                        <i class="fa fa-hdd-o"></i>\n                        <div class="jy-empty__message">\n                            Пока тут ничего нет, :( <br>\n                            для начала работы добавьте диск\n                        </div>\n                    </div>\n\n                    <div id="jy-widget-drives-selectable-${drives.uid}"\n                         data-role="junkyardselectable"\n                         data-target=".jy-card-view--drives"\n                         data-filter=".jy-cards-section__item"\n                         data-reset="true"\n                         data-multiple="true"\n                         data-css-marquee="jy-marquee"\n                         data-bind="events: {change: drives.onSelect}"></div>\n                </div>\n\n                <div class="jy-card-view jy-card-view--items" data-bind="visible: items.isCardView">\n                    <div data-role="junkyardfragment"\n                         data-bind="model: items.sort"\n                         data-template-id="jyt-sort"></div>\n\n                    <section class="jy-cards-section jy-cards-section--folders" data-bind="visible: items.isFoldersVisible">\n                        <h4 class="jy-cards-section__title">Папки</h4>\n\n                        <div class="jy-cards-section__list jy-listview"\n                            data-role="listview"\n                            data-navigatable="false"\n                            data-selectable="false"\n                            data-bind="source: items.folders"\n                            data-template="jyt-folder-item"\n                            data-auto-bind="false">\n                        </div>\n                    </section>\n\n                    <section class="jy-cards-section jy-cards-section--files" data-bind="visible: items.isFilesVisible">\n                        <h4 class="jy-cards-section__title">Файлы</h4>\n\n                        <div class="jy-cards-section__list jy-listview"\n                            data-role="listview"\n                            data-navigatable="false"\n                            data-selectable="false"\n                            data-bind="source: items.files"\n                            data-template="jyt-file-item"\n                            data-auto-bind="false">\n                        </div>\n                    </section>\n\n                    <div class="jy-empty" data-bind="visible: items.isEmptyVisible">\n                        <i class="fa fa-desktop"></i>\n                        <div class="jy-empty__message">\n                            Пока тут ничего нет, :( <br>\n                            Загрузите сюда файлы или папки\n                        </div>\n                    </div>\n\n                    <div class="jy-empty" data-bind="visible: items.isEmptySearchVisible">\n                        <i class="fa fa-search"></i>\n                        <div class="jy-empty__message">\n                            По Вашему запросу файлов не найдено :(\n                        </div>\n                    </div>\n\n                    <div class="jy-empty" data-bind="visible: items.isEmptyTrashVisible">\n                        <i class="fa fa-trash"></i>\n                        <div class="jy-empty__message">\n                            Файлов и папок в корзине нет\n                        </div>\n                    </div>\n\n                    <div id="jy-widget-items-selectable-${items.uid}"\n                         data-role="junkyardselectable"\n                         data-target=".jy-card-view--items"\n                         data-filter=".jy-cards-section__item"\n                         data-deny-filter=".jy-cards-section__item, .jy-cards-section__item *"\n                         data-reset="true"\n                         data-multiple="true"\n                         data-css-marquee="jy-marquee"\n                         data-auto-scroll="true"\n                         data-auto-scroll-offset="25"\n                         data-bind="events: {change: items.onSelect}"></div>\n\n                    <div id="jy-widget-card-view-items-draggable-${items.uid}"\n                         data-role="junkyarddraggable"\n                         data-element=".jy-card-view--items"\n                         data-draggable="{\n                             autoScroll: true,\n                             filter: \'.jy-cards-section__item\',\n                             cursorOffset: {left: 0, top: 0},\n                             group: \'jy-item\'}"\n                         data-hint-template="jyt-item-hint"\n                         data-bind="events: {\n                             hint: items.drag.onDragHint,\n                             dragstart: items.drag.onDragStart,\n                             dragend: items.drag.onDragEnd,\n                             dragcancel: items.drag.onDragCancel,\n                             keydown: items.drag.onKeyDown,\n                             keyup: items.drag.onKeyUp}"></div>\n\n                    <div id="jy-widget-card-view-items-drop-target-area-${items.uid}"\n                         data-role="junkyarddroptargetarea"\n                         data-element=".jy-card-view--items"\n                         data-droptargetarea="{filter: \'.jy-cards-section__item--folder\', group: \'jy-item\'}"\n                         data-bind="events: {\n                             dragenter: items.drag.onDragEnter,\n                             dragleave: items.drag.onDragLeave,\n                             drop: items.drag.onDrop}"></div>\n                </div>\n\n                <div class="jy-grid-view jy-grid-view--drives" data-bind="visible: drives.isGridView">\n                    <div id="jy-widget-drive-grid-${drives.uid}"\n                         data-role="grid"\n                         data-auto-bind="false"\n                         data-sortable="{ allowUnsort: false }"\n                         data-pageable="false"\n                         data-navigatable="false"\n                         data-row-template="jyt-grid-drive-item"\n                         data-bind="source: drives.gridDataSource, events: {sort: drives.onGridSort}"\n\n                         data-columns="[\n                            {\n                                field: \'title\',\n                                title: \'Название\',\n                                width: 170\n                            }\n                         ]"></div>\n\n                    <div id="jy-widget-drive-grid-selectable-${drives.uid}"\n                         data-role="junkyardselectable"\n                         data-target=".jy-grid-view--drives"\n                         data-filter=".jy-grid-item"\n                         data-reset="true"\n                         data-multiple="true"\n                         data-css-marquee="jy-marquee"\n                         data-bind="events: {change: drives.onSelect}"></div>\n                </div>\n\n                <div class="jy-grid-view jy-grid-view--items" data-bind="visible: items.isGridView">\n                    <div id="jy-widget-item-grid-${items.uid}"\n                         data-role="grid"\n                         data-auto-bind="false"\n                         data-sortable="{ allowUnsort: false }"\n                         data-pageable="false"\n                         data-navigatable="false"\n                         data-row-template="jyt-grid-item"\n                         data-bind="source: items.gridDataSource, events: {sort: items.onGridSort}"\n                         data-columns="[\n                            {\n                                field: \'title\',\n                                title: \'Название\',\n                                width: 170\n                            },\n                            {\n                                field: \'createBy\',\n                                title: \'Владелец\',\n                                width: 120,\n                                sortable: false\n                            },\n                            {\n                                field: \'modifyDate\',\n                                title: \'Дата изменения\',\n                                width: 80\n                            },\n                            {\n                                field: \'size\',\n                                title: \'Размер файла\',\n                                width: 80\n                            }\n                         ]"></div>\n\n                    <div id="jy-widget-item-grid-selectable-${items.uid}"\n                         data-role="junkyardselectable"\n                         data-target=".jy-grid-view--items"\n                         data-filter=".jy-grid-item"\n                         data-deny-filter=".jy-grid-item, .jy-grid-item *"\n                         data-reset="true"\n                         data-multiple="true"\n                         data-css-marquee="jy-marquee"\n                         data-bind="events: {change: items.onSelect}"></div>\n\n                    <div id="jy-widget-grid-view-items-draggable-${items.uid}"\n                         data-role="junkyarddraggable"\n                         data-element=".jy-grid-view--items"\n                         data-draggable="{\n                             autoScroll: true,\n                             filter: \'.jy-grid-item\',\n                             cursorOffset: {left: 0, top: 0},\n                             group: \'jy-item\'}"\n                         data-hint-template="jyt-item-hint"\n                         data-bind="events: {\n                             hint: items.drag.onDragHint,\n                             dragstart: items.drag.onDragStart,\n                             dragend: items.drag.onDragEnd,\n                             dragcancel: items.drag.onDragCancel,\n                             keydown: items.drag.onKeyDown,\n                             keyup: items.drag.onKeyUp}"></div>\n\n                    <div id="jy-widget-grid-view-items-drop-target-area-${items.uid}"\n                         data-role="junkyarddroptargetarea"\n                         data-element=".jy-grid-view--items"\n                         data-droptargetarea="{filter: \'.jy-grid-item--folder\', group: \'jy-item\'}"\n                         data-bind="events: {\n                             dragenter: items.drag.onDragEnter,\n                             dragleave: items.drag.onDragLeave,\n                             drop: items.drag.onDrop}"></div>\n                </div>\n            </div>\n\n            <div id="jy-widget-path-drop-target-area-${items.uid}"\n                data-role="junkyarddroptargetarea"\n                data-element=".jy-path"\n                data-droptargetarea="{filter: \'.jy-path__item\', group: \'jy-item\'}"\n                data-bind="events: {\n                    dragenter: items.drag.onPathDragEnter,\n                    dragleave: items.drag.onPathDragLeave,\n                    drop: items.drag.onPathDrop}"></div>\n\n            <div id="jy-widget-treeview-drop-target-area-${items.uid}"\n                data-role="junkyarddroptargetarea"\n                data-element=".jy-treeview"\n                data-droptargetarea="{filter: \'li.k-item\', group: \'jy-item\'}"\n                data-bind="events: {\n                    dragenter: items.drag.onTreeViewDragEnter,\n                    dragleave: items.drag.onTreeViewDragLeave,\n                    drop: items.drag.onTreeViewDrop}"></div>\n\n            <div id="jy-widget-menu-tree-draggable-${menuTree.uid}"\n                data-role="junkyarddraggable"\n                data-element=".jy-treeview"\n                data-draggable="{\n                    autoScroll: true,\n                    filter: \'.k-item > .k-top > .k-in, .k-item > .k-mid > .k-in, .k-item > .k-bot > .k-in\',\n                    cursorOffset: {left: 0, top: 0},\n                    group: \'jy-treeview-node\'}"\n                data-hint-template="jyt-menu-item-hint"\n                data-bind="events: {\n                    hint: menuTree.drag.onDragHint,\n                    dragstart: menuTree.drag.onDragStart,\n                    dragend: menuTree.drag.onDragEnd,\n                    dragcancel: menuTree.drag.onDragCancel,\n                    keydown: menuTree.drag.onKeyDown,\n                    keyup: menuTree.drag.onKeyUp}"></div>\n\n            <div id="jy-widget-menu-tree-drop-target-area-${menuTree.uid}"\n                data-role="junkyarddroptargetarea"\n                data-element=".jy-treeview"\n                data-droptargetarea="{filter: \'li.k-item\', group: \'jy-treeview-node\'}"\n                data-bind="events: {\n                    dragenter: menuTree.drag.onDragEnter,\n                    dragleave: menuTree.drag.onDragLeave,\n                    drop: menuTree.drag.onDrop}"></div>\n\n            <div class="jy-details-wrap"\n                 data-role="junkyardfragment"\n                 data-bind="model: details"\n                 data-template-id="jyt-details"></div>\n\n            <div data-bind="visible: items.visible">\n                <div class="jy-pager"\n                    data-role="pager"\n                    data-auto-bind="false"\n                    data-button-Count="4"\n                    data-numeric="false"\n                    data-bind="source: items.dataSource">\n                </div>\n            </div>\n\n            <div data-bind="visible: drives.visible">\n                <div class="jy-pager"\n                    data-role="pager"\n                    data-auto-bind="false"\n                    data-button-Count="4"\n                    data-numeric="false"\n                    data-bind="source: drives.dataSource">\n                </div>\n            </div>\n\n            <ul id="jy-context-menu-${mainCtx.uid}"\n                class="jy-context-menu"\n                data-role="junkyardcontextmenu"\n                data-bind="events: {select: mainCtx.onSelect, open: mainCtx.onOpen, close: mainCtx.onClose}, source: mainCtx.items"\n                data-target=".jy-main"\n                data-filter=".jy-cards-section__ctx"\n                data-with-target="true"\n                data-ignore=".jy-toolbar, .jy-upload, .jy-details"\n                data-open-ignore="prevent"\n                data-css-open-target="jy-context-menu--opened"\n                data-animation="false"\n                data-item-template="jyt-context-menu-item"></ul>\n\n            <div class="jy-upload" data-bind="css: {jy-upload--opened: upload.fileListOpened, jy-upload-button-disabled: uploadDisabled}">\n                <input id="jy-widget-upload-${upload.uid}"\n                       name="upload[]"\n                       type="file"\n                       data-role="junkyardupload"\n                       data-drop-zone=".jy-content-view"\n                       data-drop-zone-filter=".jy-card-item--folder, .jy-card-item--drive"\n                       data-cancel-on-destroy="true"\n                       data-directory-drop="false",\n                       data-async="{\n                           autoUpload: false,\n                           saveUrl: \'config\',\n                           batch: false,\n                           withCredentials: false}"\n                       data-multiple="true"\n                       data-show-file-list="true"\n                       data-bind="events: {\n                           select: upload.onFileSelect,\n                           upload: upload.onFileUpload,\n                           complete: upload.onUploadCompleted,\n                           remove: upload.onFileRemove,\n                           success: upload.onFileSuccess,\n                           cancel: upload.onFileCancel,\n                           error: upload.onFileError,\n                           fileListCreated: upload.onFileListCreated,\n                           fileListDestroyed: upload.onFileListDestroyed,\n                           dropItem: upload.onDropItem,\n                           dropToZone: upload.onDropZone,\n                           clickInput: upload.onClickInput,\n                           retryUpload: upload.onRetryUpload\n                       }"\n                       data-localization="{\n                           \'select\': \'Выберите файлы...\',\n                           \'cancel\': \'Отмена\',\n                           \'retry\': \'Повторить\',\n                           \'remove\': \'Удалить\',\n                           \'pause\': \'Пауза\',\n                           \'resume\': \'Продолжить\',\n                           \'clearSelectedFiles\': \'Очистить\',\n                           \'uploadSelectedFiles\': \'Загрузить\',\n                           \'dropFilesHere\': \'Перетащите файлы сюда для загрузки\',\n                           \'invalidFiles\': \'Недействительный файл(ы). Проверьте требования к загрузке файлов.\',\n                           \'statusUploading\': \'загружается\',\n                           \'statusUploaded\': \'загружено\',\n                           \'statusWarning\': \'предупреждение\',\n                           \'statusFailed\': \'ошибка\',\n                           \'headerStatusUploading\': \'Загружается...\',\n                           \'headerStatusPaused\': \'Пауза\',\n                           \'headerStatusUploaded\': \'Выполнено\',\n                           \'invalidMaxFileSize\': \'Слишком большой размер файла.\',\n                           \'invalidMinFileSize\': \'Размер файла слишком маленький.\',\n                           \'invalidFileExtension\': \'Тип файла не разрешен.\'}"\n                       />\n            </div>\n        </div>\n    </div>\n\n    <div class="jy-debug" data-bind="visible: commandDebug.enabled, css: {jy-debug--opened: commandDebug.opened}">\n        <div class="jy-debug__btn-open" data-bind="click: commandDebug.onToggle">\n            <i class="fa fa-bars" aria-hidden="true"></i>\n        </div>\n        <div class="jy-debug__panel">\n            <div class="jy-debug__panel__header">Список команд</div>\n            <div class="jy-debug__panel__content">\n                <ul class="jy-debug__command-list"\n                    data-bind="source: commandDebug.commands"\n                    data-template="jyt-command-debug-item">\n                </ul>\n            </div>\n        </div>\n    </div>\n\n    <div id="jy-new-drive-dialog-${uid}"\n         data-role="junkyarddialog"\n         data-template-id="jyt-new-drive-dialog"></div>\n\n    <div id="jy-new-folder-dialog-${uid}"\n         data-role="junkyarddialog"\n         data-template-id="jyt-new-folder-dialog"></div>\n\n    <div id="jy-share-drive-dialog-${uid}"\n         data-role="junkyarddialog"\n         data-template-id="jyt-share-dialog"></div>\n\n    <div id="jy-rename-dialog-${uid}"\n         data-role="junkyarddialog"\n         data-template-id="jyt-rename-dialog"></div>\n\n    <div id="jy-move-item-dialog-${uid}"\n         data-role="junkyarddialog"\n         data-template-id="jyt-move-item-dialog"></div>\n\n    <div id="jy-restore-item-dialog-${uid}"\n         data-role="junkyarddialog"\n         data-template-id="jyt-restore-item-dialog"></div>\n\n    <div id="jy-copy-item-dialog-${uid}"\n         data-role="junkyarddialog"\n         data-template-id="jyt-copy-item-dialog"></div>\n\n    <div id="jy-preview-dialog-${uid}"\n         class="jy-preview-dialog"\n         data-role="junkyarddialog"\n         data-top-overlay="true"\n         data-template-id="jyt-preview-dialog"></div>\n\n    <div id="jy-open-file-dialog-${uid}"\n         data-role="junkyarddialog"\n         data-template-id="jyt-open-file-dialog"\n         data-is-maximize="true"></div>\n\n    <div id="jy-change-size-dialog-${uid}"\n         data-role="junkyarddialog"\n         data-template-id="jyt-change-size-dialog"></div>\n\n    <div id="jy-share-link-dialog-${uid}"\n         data-role="junkyarddialog"\n         data-template-id="jyt-share-link-dialog"></div>\n\n    <div id="jy-download-iframes-${uid}"></div>\n<\/script>\n';
        extend(junkyardNS, {
            templates: templates
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.icon-initializer", [ "kendo.junkyard.ns", "kendo.junkyard.templates" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, Class = kendo.Class, jyNS = ui.junkyard, extend = $.extend, ICONS_ID = "jy-icons-" + kendo.guid();
        var IconInitializer = Class.extend({
            initialize: function() {
                this._upInstanceCounter();
                this._setupTemplates();
            },
            addIcons: function() {
                if ($("#" + ICONS_ID).length == 0) {
                    $("<div id='" + ICONS_ID + "' />").css({
                        position: "absolute",
                        left: "-10000px"
                    }).html($("#jyt-icons").html()).appendTo(document.body);
                }
            },
            removeIcons: function() {
                $("#" + ICONS_ID).remove();
            }
        });
        extend(jyNS, {
            IconInitializer: IconInitializer
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.template-initializer", [ "kendo.junkyard.ns", "kendo.junkyard.templates", "kendo.junkyard.icon-initializer" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, Class = kendo.Class, jyNS = ui.junkyard, extend = $.extend, IconInitializer = jyNS.IconInitializer, instanceCounter = 0, TEMPLATES_ID = "jy-templates-" + kendo.guid();
        var TemplateInitializer = Class.extend({
            initialize: function() {
                this._upInstanceCounter();
                this._setupTemplates();
                this._setupIcons();
            },
            _setupTemplates: function() {
                if (jyNS.templates && $("#" + TEMPLATES_ID).length == 0) {
                    $("<div id='" + TEMPLATES_ID + "' />").css({
                        position: "absolute",
                        left: "-10000px"
                    }).html(jyNS.templates).appendTo(document.body);
                }
            },
            _setupIcons: function() {
                this.icons = new IconInitializer();
                this.icons.addIcons();
            },
            _removeTemplates: function() {
                $("#" + TEMPLATES_ID).remove();
            },
            _removeIcons: function() {
                if (this.icons) {
                    this.icons.removeIcons();
                }
            },
            _upInstanceCounter: function() {
                instanceCounter++;
            },
            _downInstanceCounter: function() {
                instanceCounter--;
                if (instanceCounter < 0) {
                    instanceCounter = 0;
                }
            },
            destroy: function() {
                this._downInstanceCounter();
                if (instanceCounter === 0) {
                    this._removeTemplates();
                    this._removeIcons();
                }
            }
        });
        extend(jyNS, {
            TemplateInitializer: TemplateInitializer
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.auth", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.constants" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, Class = kendo.Class, jyNS = ui.junkyard, request = jyNS.request, HttpCodes = jyNS.HttpCodes, extend = $.extend;
        var Authenticator = Class.extend({
            init: function(widgetOptions) {
                this.options = widgetOptions;
                this.token = null;
                this.currentUser = null;
                this._enabled = this._checkTokenOpt();
                this._refreshTokenDefer = null;
            },
            _checkTokenOpt: function() {
                var opt = this.options, authOpt = opt.auth, tokenOpt = opt.auth ? opt.auth.token : null, optTokenValid = !!(tokenOpt && tokenOpt.method && tokenOpt.field && tokenOpt.createUrl) || !!authOpt.tokenProvider;
                return optTokenValid;
            },
            enabled: function(value) {
                if (!arguments.length) {
                    return this._enabled;
                }
                this._enabled = !!value;
            },
            getToken: function(refresh) {
                var that = this, defer = $.Deferred(), opt = this.options, tokenProvider = opt.auth.tokenProvider, tokenOpt = opt.auth.token, url = tokenOpt.createUrl, method = tokenOpt.method, withCredentials = tokenOpt.withCredentials;
                var processTokenResult = function(token) {
                    that.token = token;
                    that.getUserInfo(token).done(function(userData) {
                        that.currentUser = {
                            id: userData.userId,
                            isAdmin: userData.isAdmin
                        };
                        defer.resolve(token);
                    }).fail(function(error) {
                        if (!refresh && error.jqXHR && error.jqXHR.status === HttpCodes.Unauthorized) {
                            that.refreshToken().done(defer.resolve).fail(defer.reject);
                        } else {
                            defer.reject(error);
                        }
                    });
                };
                if (tokenProvider && kendo.isFunction(tokenProvider[refresh ? "refreshToken" : "fetchToken"])) {
                    tokenProvider[refresh ? "refreshToken" : "fetchToken"]().then(processTokenResult).catch(function(err) {
                        defer.reject(err);
                    });
                } else {
                    request(method, url, null, null, withCredentials).done(function(req) {
                        var response = req.response, token = response[tokenOpt.field];
                        processTokenResult(token);
                    }).fail(function(error) {
                        defer.reject(error);
                    });
                }
                return defer;
            },
            getUserInfo: function(token) {
                var userOpt = this.options.auth.user, url = userOpt.readUrl;
                return request.get(url, null, token || this.token).then(function(req) {
                    var data = req.response || {};
                    return {
                        userId: data.UserId,
                        isAdmin: data.IsAdmin
                    };
                });
            },
            refreshToken: function() {
                var that = this;
                if (!this._refreshTokenDefer) {
                    this._refreshTokenDefer = this.getToken(true).done(function(token) {
                        that._refreshTokenDefer = null;
                        return token;
                    }).fail(function(e) {
                        that._refreshTokenDefer = null;
                        return e;
                    });
                }
                return this._refreshTokenDefer;
            },
            validateOrRefreshToken: function(token) {
                var that = this, tokenValidationOpt = this.options.auth.tokenValidation, url = tokenValidationOpt.readUrl, method = tokenValidationOpt.method, withCredentials = tokenValidationOpt.withCredentials, deferred = $.Deferred();
                if (tokenValidationOpt.readUrl) {
                    request(method, url, null, token || this.token, withCredentials).done(deferred.resolve).fail(function(err) {
                        if (err.jqXHR && err.jqXHR.status === HttpCodes.Unauthorized) {
                            that.refreshToken().done(deferred.resolve).fail(deferred.reject);
                        } else {
                            deferred.reject();
                        }
                    });
                } else {
                    deferred.resolve();
                }
                return deferred.promise();
            },
            addBearerHeader: function(xhr) {
                if (this._enabled && this.token) {
                    xhr.setRequestHeader("Authorization", "Bearer " + this.token);
                }
            }
        });
        extend(jyNS, {
            Authenticator: Authenticator
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.data.base", [ "kendo.junkyard.ns", "kendo.junkyard.constants", "kendo.junkyard.utils" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, DataSource = kendo.data.DataSource, proxy = $.proxy, slice = Array.prototype.slice, HttpCodes = jyNS.HttpCodes, traceError = jyNS.traceError, resource = jyNS.resource, request = jyNS.request, Settings = jyNS.Settings;
        function makeAuthReadTrasport(auth, url, withCredentials, parameterMap, outRequest) {
            return function(e) {
                var urlValue = url.value;
                var data = e.data || {};
                if (kendo.isFunction(parameterMap)) {
                    data = parameterMap.call(null, data);
                }
                if (kendo.isFunction(urlValue)) {
                    urlValue = urlValue.call(null, data);
                }
                if (auth) {
                    resource.get(auth, urlValue, data, withCredentials, outRequest).done(function(req) {
                        e.success(req.response);
                    }).fail(function(err) {
                        e.error(err.jqXHR, err.textStatus, err.errorThrown);
                    });
                } else {
                    request.get(urlValue, data, null, withCredentials, outRequest).done(function(req) {
                        e.success(req.response);
                    }).fail(function(err) {
                        e.error(err.jqXHR, err.textStatus, err.errorThrown);
                    });
                }
            };
        }
        function makeAuthBeforeSend(auth) {
            return function(xhr) {
                if (auth && auth.enabled()) {
                    auth.addBearerHeader(xhr);
                }
            };
        }
        var AuthDataSource = DataSource.extend({
            init: function(auth, url, withCredentials, options, parameterMap, makeCustomReadTransport) {
                this._currentRequest = {};
                this._currentUrl = {
                    value: url
                };
                var transport = options.transport || {};
                transport.read = kendo.isFunction(makeCustomReadTransport) ? makeCustomReadTransport(auth, this._currentUrl, withCredentials, parameterMap, this._currentRequest) : makeAuthReadTrasport(auth, this._currentUrl, withCredentials, parameterMap, this._currentRequest);
                options.transport = transport;
                DataSource.fn.init.call(this, options);
            },
            changeUrl: function(url) {
                this._currentUrl.value = url;
                return this;
            },
            inProgress: function() {
                return this._requestInProgress;
            },
            abort: function() {
                if (this.inProgress()) {
                    var xhr = this._currentRequest.xhr;
                    if (xhr) {
                        xhr.abort();
                        this._currentRequest.xhr = null;
                    }
                }
                return this;
            },
            resetPage: function() {
                this._skip = 0;
                this._page = Settings.DefaultPage;
                return this;
            },
            setPageSize: function(pageSize) {
                this._pageSize = this.options.pageSize = pageSize;
                return this;
            },
            setUnlimPageSize: function() {
                return this.setPageSize(Settings.UnlimPaseSize);
            },
            setSort: function(sort) {
                this._sort = sort;
                return this;
            },
            setSortField: function(field, dir, compare) {
                this.setSort([ {
                    field: field,
                    dir: dir,
                    compare: compare
                } ]);
                return this;
            }
        });
        var BaseDataSource = DataSource.extend({
            init: function(auth, options) {
                DataSource.fn.init.call(this, options);
                this.transport.options.read.beforeSend = proxy(this._handleBeforeSend, this);
                this.auth = auth;
            },
            inProgress: function() {
                return this._requestInProgress;
            },
            _handleBeforeSend: function(xhr) {
                if (this.auth && this.auth.enabled()) {
                    this.auth.addBearerHeader(xhr);
                }
            },
            read: function(data) {
                var that = this, deferred = $.Deferred();
                DataSource.fn.read.call(this, data).done(deferred.resolve).fail(function(xhr) {
                    if (that.auth && that.auth.enabled() && xhr && xhr.status === HttpCodes.Unauthorized) {
                        that._refreshAuthToken(deferred, data);
                    } else {
                        var args = slice.call(arguments);
                        deferred.reject.apply(deferred, args);
                    }
                });
                return deferred.promise();
            },
            _refreshAuthToken: function(targetDeferred, targetData) {
                var that = this;
                this.auth.refreshToken().done(function(token) {
                    try {
                        DataSource.fn.read.call(that, targetData).done(targetDeferred.resolve).fail(targetDeferred.reject);
                    } catch (err) {
                        traceError("Read data failed: " + err.toString());
                        targetDeferred.reject({}, "", "Read exception");
                    }
                    return token;
                }).fail(function(err) {
                    traceError("Refresh token failed: " + err.toString());
                    targetDeferred.reject(err.jqXHR, err.textStatus, err.errorThrown);
                    return err;
                });
            }
        });
        extend(jyNS, {
            BaseDataSource: BaseDataSource,
            makeAuthBeforeSend: makeAuthBeforeSend,
            makeAuthReadTrasport: makeAuthReadTrasport,
            AuthDataSource: AuthDataSource
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.models", [ "kendo.junkyard.ns", "kendo.junkyard.constants" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, extend = $.extend, isEmptyObject = $.isEmptyObject, Model = kendo.data.Model, jyNS = ui.junkyard, isArray = Array.isArray, MenuItemType = jyNS.MenuItemType, MenuTreeIcons = jyNS.MenuTreeIcons, FileTypeIcons = jyNS.FileTypeIcons;
        var DriveModel = Model.define({
            id: "DriveId",
            fields: {
                title: {
                    type: "string",
                    field: "Title"
                },
                label: {
                    type: "string",
                    field: "Label"
                },
                permission: {
                    type: "string",
                    field: "Permission"
                },
                owner: {
                    type: "number",
                    field: "Owner"
                },
                isOwned: {
                    type: "boolean",
                    field: "IsOwned"
                },
                isFavorite: {
                    type: "boolean",
                    field: "IsFavorite"
                },
                isPrimary: {
                    type: "boolean",
                    field: "IsPrimary"
                },
                hasChildren: {
                    type: "boolean",
                    field: "HasChildren"
                },
                isEncrypted: {
                    type: "boolean",
                    field: "IsCrypted"
                },
                isHistory: {
                    type: "boolean",
                    field: "HasHistory"
                },
                isTrashBin: {
                    type: "boolean",
                    field: "HasRecycleBin"
                },
                quota: {
                    type: "number",
                    field: "Quota"
                }
            }
        });
        var DriveDetailsModel = Model.define({
            id: "DriveId",
            fields: {
                title: {
                    type: "string",
                    field: "Title"
                },
                label: {
                    type: "string",
                    field: "Label"
                },
                currentPermission: {
                    type: "string",
                    field: "CurrentPermission"
                },
                owner: {
                    type: "number",
                    field: "Owner"
                },
                isOwned: {
                    type: "boolean",
                    field: "IsOwned"
                },
                isFavorite: {
                    type: "boolean",
                    field: "IsFavorite"
                },
                isPrimary: {
                    type: "boolean",
                    field: "IsPrimary"
                },
                permissions: {
                    field: "Permissions",
                    parse: parsePermissions
                },
                itemsDefaultPermissions: {
                    field: "ItemsDefaultPermissions",
                    parse: parsePermissions
                },
                isEncrypted: {
                    type: "boolean",
                    field: "IsCrypted"
                },
                isHistory: {
                    type: "boolean",
                    field: "HasHistory"
                },
                isTrashBin: {
                    type: "boolean",
                    field: "HasRecycleBin"
                },
                quota: {
                    type: "number",
                    field: "Quota"
                },
                usedSpace: {
                    type: "number",
                    field: "UsedSpace"
                },
                systemUsedSpace: {
                    type: "number",
                    field: "SystemUsedSpace"
                }
            }
        });
        var ItemModel = Model.define({
            id: "Id",
            fields: {
                title: {
                    type: "string",
                    field: "Name"
                },
                type: {
                    type: "string",
                    field: "Type"
                },
                driveId: {
                    type: "number",
                    field: "DriveId"
                },
                folderId: {
                    type: "number",
                    field: "DirectoryId"
                },
                version: {
                    type: "number",
                    field: "Version"
                },
                lastVersion: {
                    type: "number",
                    field: "LastVersion"
                },
                linkType: {
                    type: "number",
                    field: "LinkType"
                },
                createDate: {
                    type: "date",
                    field: "CreateDate"
                },
                modifyDate: {
                    type: "date",
                    field: "ModifyDate"
                },
                createBy: {
                    type: "number",
                    field: "CreateBy"
                },
                modifyBy: {
                    type: "number",
                    field: "ModifyBy"
                },
                size: {
                    type: "number",
                    field: "Size"
                },
                childCount: {
                    type: "number",
                    field: "Count"
                },
                extension: {
                    type: "string",
                    field: "Extension"
                },
                hasSubDir: {
                    type: "boolean",
                    field: "HasSubDir"
                },
                originalPath: {
                    type: "string",
                    field: "OriginalFullPath"
                },
                originalName: {
                    type: "string",
                    field: "OriginalName"
                },
                deletedDate: {
                    type: "date",
                    field: "DeletedDate"
                },
                deleteBy: {
                    type: "number",
                    field: "DeleteBy"
                }
            }
        });
        ItemModel.prototype.isDeleted = function() {
            return !!this.deletedDate;
        };
        var ItemDetailsModel = Model.define({
            id: "Id",
            fields: {
                title: {
                    type: "string",
                    field: "Name"
                },
                type: {
                    type: "string",
                    field: "Type"
                },
                driveId: {
                    type: "number",
                    field: "DriveId"
                },
                folderId: {
                    type: "number",
                    field: "DirectoryId"
                },
                createDate: {
                    type: "string",
                    field: "CreateDate"
                },
                modifyDate: {
                    type: "date",
                    field: "ModifyDate"
                },
                createBy: {
                    type: "number",
                    field: "CreateBy"
                },
                modifyBy: {
                    type: "number",
                    field: "ModifyBy"
                },
                size: {
                    type: "number",
                    field: "Size"
                },
                childCount: {
                    type: "number",
                    field: "Count"
                },
                extension: {
                    type: "string",
                    field: "Extension"
                },
                hasSubDir: {
                    type: "boolean",
                    field: "HasSubDir"
                },
                permissions: {
                    field: "Permissions",
                    parse: parsePermissions
                },
                tags: {
                    field: "Tags",
                    parse: parseTags
                },
                description: {
                    type: "string",
                    field: "Description"
                }
            }
        });
        var ItemVersionModel = Model.define({
            id: "Id",
            fields: {
                version: {
                    type: "number",
                    field: "Version"
                },
                modifyDate: {
                    type: "date",
                    field: "ModifyDate"
                },
                modifyBy: {
                    type: "number",
                    field: "ModifyBy"
                },
                isCurrent: {
                    type: "boolean",
                    field: "IsCurrent"
                }
            }
        });
        var UserOrGroupModel = Model.define({
            id: "Id",
            fields: {
                title: {
                    type: "string",
                    field: "Title"
                },
                isUser: {
                    type: "boolean",
                    field: "IsUser"
                }
            }
        });
        var AccessItemModel = Model.define({
            id: "UniqId",
            fields: {
                itemId: {
                    type: "number",
                    field: "Id"
                },
                isUser: {
                    type: "boolean",
                    field: "IsUser"
                },
                permission: {
                    type: "string",
                    field: "Permission"
                }
            }
        });
        var PathItemModel = Model.define({
            id: "pathId",
            fields: {
                title: {
                    type: "string",
                    field: "title"
                },
                menuType: {
                    type: "number",
                    field: "menuType"
                }
            }
        });
        function parsePermissions(val) {
            val = Array.isArray(val) ? val : [];
            return createAccessItems(val);
        }
        function parseTags(val) {
            val = Array.isArray(val) ? val : [];
            return val;
        }
        function convertToMenuItem(model) {
            if (model instanceof DriveModel) {
                return kendo.observable({
                    id: model.id,
                    title: model.title,
                    menuType: MenuItemType.Drive,
                    icon: MenuTreeIcons.Drive
                });
            } else if (model instanceof ItemModel) {
                return kendo.observable({
                    id: model.id,
                    title: model.title,
                    menuType: MenuItemType.Item,
                    icon: MenuTreeIcons.Folder
                });
            } else {
                throw new Error("Cannot convert model to menu item.");
            }
        }
        function convertToPathItem(model) {
            if (model instanceof PathItemModel) {
                return model;
            } else {
                return new PathItemModel({
                    pathId: model.id,
                    title: model.title,
                    menuType: model.menuType
                });
            }
        }
        function createAccessItem(data) {
            return new AccessItemModel({
                UniqId: data.Id + ":" + +data.IsUser,
                itemId: data.Id,
                isUser: data.IsUser,
                permission: data.Permission
            });
        }
        function createAccessItems(data) {
            return (data || []).map(createAccessItem);
        }
        function isDrive(model) {
            return model && model instanceof DriveModel;
        }
        function isItem(model) {
            return model && model instanceof ItemModel;
        }
        function makeFileTypeIconMap() {
            var map = {};
            Object.keys(FileTypeIcons).forEach(function(key) {
                if (isArray(FileTypeIcons[key])) {
                    FileTypeIcons[key].forEach(function(val) {
                        map[val] = key;
                    });
                }
            });
            return map;
        }
        function fileTypeIcon(fileExt) {
            fileExt = (fileExt || "").trim().toLowerCase();
            if (!fileTypeIcon._fileTypeIconMap) {
                fileTypeIcon._fileTypeIconMap = makeFileTypeIconMap();
            }
            var icon = fileTypeIcon._fileTypeIconMap[fileExt];
            return icon ? icon : fileTypeIcon._fileTypeIconMap[""];
        }
        function modelMap(constructor, data) {
            if (data) {
                var obj = {};
                obj[constructor.idField] = data[constructor.idField];
                Object.keys(constructor.fields).forEach(function(key) {
                    var descr = constructor.fields[key];
                    obj[key] = data[descr.field];
                });
                return new constructor(obj);
            }
            return null;
        }
        function createModel(constructor, data) {
            if (!data || isEmptyObject(data)) {
                return new constructor();
            } else {
                var obj = {};
                obj[constructor.idField] = data[constructor.idField];
                var model = new constructor(obj);
                Object.keys(constructor.fields).forEach(function(key) {
                    var descr = constructor.fields[key];
                    model.set(key, data[descr.field]);
                });
                return model;
            }
        }
        function toDrive(data) {
            return modelMap(DriveModel, data);
        }
        function toItem(data) {
            return modelMap(ItemModel, data);
        }
        extend(jyNS, {
            models: {
                ItemModel: ItemModel,
                DriveModel: DriveModel,
                UserOrGroupModel: UserOrGroupModel,
                AccessItemModel: AccessItemModel,
                PathItemModel: PathItemModel,
                DriveDetailsModel: DriveDetailsModel,
                ItemDetailsModel: ItemDetailsModel,
                ItemVersionModel: ItemVersionModel,
                isDrive: isDrive,
                isItem: isItem,
                toDrive: toDrive,
                toItem: toItem,
                createModel: createModel
            },
            mapper: {
                createAccessItem: createAccessItem,
                createAccessItems: createAccessItems
            },
            convertToMenuItem: convertToMenuItem,
            convertToPathItem: convertToPathItem,
            fileTypeIcon: fileTypeIcon
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.data", [ "kendo.junkyard.ns", "kendo.junkyard.constants", "kendo.junkyard.data.base", "kendo.junkyard.models" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, proxy = $.proxy, HierarchicalDataSource = kendo.data.HierarchicalDataSource, DataSource = kendo.data.DataSource, makeAuthReadTrasport = jyNS.makeAuthReadTrasport, MenuItemType = jyNS.MenuItemType, rootMenuData = jyNS.rootMenuData, AuthDataSource = jyNS.AuthDataSource, models = jyNS.models, MenuTreeIcons = jyNS.MenuTreeIcons, Settings = jyNS.Settings, MenuIds = jyNS.MenuIds, ItemType = jyNS.ItemType, DriveSortOrder = jyNS.DriveSortOrder, ItemSortOrder = jyNS.ItemSortOrder, utils = jyNS.utils;
        var DriveDataSource = AuthDataSource.extend({
            init: function(auth, url, withCredentials, driveIds) {
                this._parameterMap = proxy(this._parameterMap, this);
                AuthDataSource.fn.init.call(this, auth, url, withCredentials, {
                    schema: {
                        data: "Items",
                        parse: function(resp) {
                            var resp = filterByDriveIds(replaceTitleIfEmpty(resp), driveIds);
                            if (resp && resp.Items) {
                                resp.TotalCount = resp.Items.length;
                            }
                            return resp;
                        },
                        total: "TotalCount",
                        model: models.DriveModel
                    },
                    serverPaging: false,
                    serverSorting: true,
                    page: Settings.DefaultPage,
                    pageSize: Settings.PaseSize
                }, this._parameterMap);
                this.paramIsFavorite = undefined;
                this.paramIsPrimary = undefined;
                this.paramIsOwned = undefined;
                this.paramSortField = undefined;
                this.paramSortDir = undefined;
            },
            _parameterMap: function(params) {
                var data = {
                    total_count: true,
                    take: Settings.UnlimPaseSize,
                    skip: 0
                };
                if (params.take !== undefined) {
                    data.take = params.take;
                }
                if (params.skip !== undefined) {
                    data.skip = params.skip;
                }
                if (params.driveId !== undefined) {
                    data.driveId = params.driveId;
                }
                if (this.paramIsPrimary !== undefined) {
                    data.is_primary = this.paramIsPrimary;
                }
                if (this.paramIsOwned !== undefined) {
                    data.is_owned = this.paramIsOwned;
                }
                if (this.paramSortField !== undefined) {
                    data.order = this.paramSortField;
                }
                if (this.paramSortDir !== undefined) {
                    data.desc = this.paramSortDir === "desc";
                }
                return data;
            },
            page: function(page) {
                if (page !== undefined) {
                    var that = this;
                    this.one("requestStart", function(e) {
                        that.trigger("pageStart", {
                            orig: e
                        });
                    });
                    this.one("requestEnd", function(e) {
                        that.trigger("pageEnd", {
                            orig: e
                        });
                    });
                }
                return DataSource.fn.page.call(this, page);
            }
        });
        var DriveDetailsDataSource = AuthDataSource.extend({
            init: function(auth, url, withCredentials) {
                AuthDataSource.fn.init.call(this, auth, url, withCredentials, {
                    schema: {
                        data: function(resp) {
                            if (!resp.Title) {
                                resp.Title = resp.Label;
                            }
                            return [ resp ];
                        },
                        model: models.DriveDetailsModel
                    }
                });
            }
        });
        var ItemDataSource = AuthDataSource.extend({
            init: function(auth, url, withCredentials) {
                this._parameterMap = proxy(this._parameterMap, this);
                AuthDataSource.fn.init.call(this, auth, url, withCredentials, {
                    schema: {
                        data: "Items",
                        total: "TotalCount",
                        model: models.ItemModel,
                        parse: parseDeletedItemName
                    },
                    serverPaging: true,
                    serverSorting: true,
                    page: Settings.DefaultPage,
                    pageSize: Settings.PaseSize
                }, this._parameterMap);
                this.paramParentId = undefined;
                this.paramDriveId = undefined;
                this.paramSortField = undefined;
                this.paramSortDir = undefined;
                this.paramSearch = undefined;
                this.paramType = undefined;
                this.isSearching = false;
            },
            _parameterMap: function(params) {
                var data = {
                    total_count: true
                };
                if (params.take !== undefined) {
                    data.take = params.take;
                }
                if (params.skip !== undefined) {
                    data.skip = params.skip;
                }
                if (this.paramParentId !== undefined) {
                    data.directory_id = this.paramParentId;
                }
                if (this.paramDriveId !== undefined) {
                    data.drive_id = this.paramDriveId;
                }
                if (this.paramSortField !== undefined) {
                    data.order = this.paramSortField;
                }
                if (this.paramSortDir !== undefined) {
                    data.desc = this.paramSortDir === "desc";
                }
                if (this.paramSearch !== undefined) {
                    data.search = this.paramSearch;
                }
                if (this.paramType !== undefined) {
                    data.type = this.paramType;
                }
                return data;
            },
            page: function(page) {
                if (page !== undefined) {
                    var that = this;
                    this.one("requestStart", function(e) {
                        that.trigger("pageStart", {
                            orig: e
                        });
                    });
                    this.one("requestEnd", function(e) {
                        that.trigger("pageEnd", {
                            orig: e
                        });
                    });
                }
                return DataSource.fn.page.call(this, page);
            }
        });
        var ItemDetailsDataSource = AuthDataSource.extend({
            init: function(auth, url, withCredentials) {
                AuthDataSource.fn.init.call(this, auth, url, withCredentials, {
                    schema: {
                        data: function(resp) {
                            return [ resp ];
                        },
                        model: models.ItemDetailsModel
                    }
                });
            }
        });
        var ItemVersionListDataSource = AuthDataSource.extend({
            init: function(auth, url, withCredentials) {
                this._parameterMap = proxy(this._parameterMap, this);
                AuthDataSource.fn.init.call(this, auth, url, withCredentials, {
                    schema: {
                        data: "Items",
                        total: "TotalCount",
                        model: models.ItemVersionModel
                    },
                    serverPaging: true,
                    page: Settings.DefaultPage,
                    pageSize: 3
                }, this._parameterMap);
                this.paramItemId = undefined;
                this.paramDriveId = undefined;
            },
            _parameterMap: function(params) {
                var data = {
                    total_count: true
                };
                if (params.take !== undefined) {
                    data.take = params.take;
                }
                if (params.skip !== undefined) {
                    data.skip = params.skip;
                }
                if (this.paramItemId !== undefined) {
                    data.item_id = this.paramItemId;
                }
                if (this.paramDriveId !== undefined) {
                    data.drive_id = this.paramDriveId;
                }
                return data;
            }
        });
        var UsersAndGroupsDataSource = AuthDataSource.extend({
            init: function(auth, url, withCredentials, converter, parameterMap, customReadTransport) {
                var that = this;
                this._parameterMap = proxy(this._parameterMap, this);
                if (!kendo.isFunction(parameterMap)) {
                    parameterMap = this._parameterMap;
                }
                AuthDataSource.fn.init.call(this, auth, url, withCredentials, {
                    schema: {
                        data: function(resp) {
                            resp = kendo.isFunction(converter) ? converter(resp) : resp;
                            var ALL = "Все";
                            return (new kendo.data.Query([ {
                                Id: 0,
                                Title: ALL,
                                title: ALL,
                                IsUser: false
                            } ]).filter(that.filter()).data || []).concat(resp || []);
                        },
                        model: models.UserOrGroupModel
                    },
                    serverFiltering: true
                }, parameterMap, customReadTransport);
            },
            _parameterMap: function(params) {
                var data = {};
                if (params.filter && params.filter.filters && params.filter.filters[0]) {
                    data.search = params.filter.filters[0].value;
                }
                return data;
            }
        });
        var AccessListDataSource = DataSource.extend({
            init: function(data) {
                DataSource.fn.init.call(this, {
                    data: data,
                    schema: {
                        model: models.AccessItemModel
                    }
                });
            }
        });
        var RootHierarchyDataSource = HierarchicalDataSource.extend({
            init: function(auth, urls, driveIds) {
                this._getDriveParameterMap = proxy(this._getDriveParameterMap, this);
                this._getItemParameterMap = proxy(this._getItemParameterMap, this);
                HierarchicalDataSource.fn.init.call(this, this._getRootDataSourceOpt({
                    auth: auth,
                    readDriveListUrl: urls.readDriveListUrl,
                    readItemListUrl: urls.readItemListUrl,
                    driveIds: driveIds
                }));
            },
            _getRootDataSourceOpt: function(opt) {
                return {
                    data: rootMenuData,
                    schema: {
                        model: {
                            id: "Id",
                            hasChildren: true,
                            fields: {
                                title: {
                                    type: "string",
                                    field: "Title"
                                },
                                menuType: {
                                    type: "number",
                                    field: "menuType",
                                    parse: function() {
                                        return MenuItemType.Menu;
                                    }
                                },
                                icon: {
                                    type: "string",
                                    field: "Icon"
                                }
                            },
                            children: this._getDriveDataSourceOpt(opt)
                        }
                    }
                };
            },
            _getDriveDataSourceOpt: function(opt) {
                return {
                    transport: {
                        read: makeAuthReadTrasport(opt.auth, {
                            value: opt.readDriveListUrl
                        }, undefined, this._getDriveParameterMap)
                    },
                    schema: {
                        data: "Items",
                        parse: function(resp) {
                            return filterByDriveIds(replaceTitleIfEmpty(resp), opt.driveIds);
                        },
                        model: {
                            id: "DriveId",
                            hasChildren: "HasSubDir",
                            fields: {
                                title: {
                                    type: "string",
                                    field: "Title"
                                },
                                menuType: {
                                    type: "number",
                                    field: "menuType",
                                    parse: function() {
                                        return MenuItemType.Drive;
                                    }
                                },
                                icon: {
                                    type: "string",
                                    field: "Icon",
                                    parse: function() {
                                        return MenuTreeIcons.Drive;
                                    }
                                },
                                isEncrypted: {
                                    type: "boolean",
                                    field: "IsCrypted"
                                },
                                quota: {
                                    type: "number",
                                    field: "Quota"
                                }
                            },
                            children: this._getItemDataSourceOpt(opt)
                        }
                    }
                };
            },
            _getItemDataSourceOpt: function(opt) {
                return {
                    transport: {
                        read: makeAuthReadTrasport(opt.auth, {
                            value: opt.readItemListUrl
                        }, undefined, this._getItemParameterMap)
                    },
                    schema: {
                        data: "Items",
                        model: {
                            id: "Id",
                            hasChildren: "HasSubDir",
                            fields: {
                                title: {
                                    type: "string",
                                    field: "Name"
                                },
                                menuType: {
                                    type: "number",
                                    field: "menuType",
                                    parse: function() {
                                        return MenuItemType.Item;
                                    }
                                },
                                icon: {
                                    type: "string",
                                    field: "Icon",
                                    parse: function() {
                                        return MenuTreeIcons.Folder;
                                    }
                                },
                                driveId: {
                                    type: "number",
                                    field: "DriveId"
                                },
                                parentId: {
                                    type: "number",
                                    field: "DirectoryId"
                                }
                            }
                        }
                    }
                };
            },
            _getDriveParameterMap: function(opt) {
                var params = {
                    skip: 0,
                    take: Settings.UnlimPaseSize,
                    total_count: true,
                    order: DriveSortOrder.Title,
                    desc: false
                };
                if (opt.Id === MenuIds.My) {
                    params.is_owned = true;
                } else if (opt.Id === MenuIds.Shared) {
                    params.is_owned = false;
                }
                return params;
            },
            _currentDriveId: null,
            _getItemParameterMap: function(opt) {
                var params = {
                    skip: 0,
                    take: Settings.UnlimPaseSize,
                    total_count: true,
                    type: ItemType.Folder,
                    order: ItemSortOrder.Name,
                    desc: false
                };
                if (opt.DriveId) {
                    params.drive_id = opt.DriveId;
                    this._currentDriveId = opt.DriveId;
                } else if (opt.Id) {
                    params.directory_id = opt.Id;
                    params.drive_id = this._currentDriveId;
                }
                return params;
            },
            makeByIdAndTypePredicate: function(id, menuType) {
                return function(item) {
                    return item.id === id && item.menuType === menuType;
                };
            },
            recursiveFindByIdAndType: function(id, menuType) {
                return this._recursiveFind(this.makeByIdAndTypePredicate(id, menuType), this);
            },
            _recursiveFind: function(predicate, ds) {
                var idx, length;
                var data = ds.data();
                var res = null;
                if (!data) {
                    return null;
                }
                for (idx = 0, length = data.length; idx < length; idx++) {
                    if (predicate(data[idx])) {
                        res = data[idx];
                        break;
                    } else {
                        if (!(data[idx].children instanceof DataSource)) {
                            continue;
                        }
                        res = this._recursiveFind(predicate, data[idx].children);
                        if (res) {
                            break;
                        }
                    }
                }
                return res;
            },
            findParentsByIdAndType: function(id, menuType) {
                var parentNodes = [];
                this._recursiveFindParents(this.makeByIdAndTypePredicate(id, menuType), this, parentNodes);
                return parentNodes;
            },
            _recursiveFindParents: function(predicate, ds, parents) {
                var idx, length, res;
                var data = ds.data();
                if (!data) {
                    return false;
                }
                for (idx = 0, length = data.length; idx < length; idx++) {
                    if (predicate(data[idx])) {
                        return true;
                    }
                    if (data[idx].children instanceof DataSource) {
                        res = this._recursiveFindParents(predicate, data[idx].children, parents);
                        if (res) {
                            parents.push(data[idx]);
                            return res;
                        }
                    }
                }
                return false;
            },
            findInSubTreeAndSelf: function(nodeId, nodeType, predicate) {
                var dataItem = this.recursiveFindByIdAndType(nodeId, nodeType);
                var result = [];
                if (dataItem) {
                    if (predicate(dataItem)) {
                        result.push(dataItem);
                    }
                    if (dataItem.children instanceof DataSource) {
                        this._recursiveFindAll(predicate, dataItem.children, result);
                    }
                }
                return result;
            },
            _recursiveFindAll: function(predicate, ds, list) {
                var idx, length;
                var data = ds.data();
                if (!data) {
                    return;
                }
                for (idx = 0, length = data.length; idx < length; idx++) {
                    if (data[idx].children instanceof DataSource) {
                        this._recursiveFindAll(predicate, data[idx].children, list);
                    }
                    if (predicate(data[idx])) {
                        list.push(data[idx]);
                    }
                }
            }
        });
        function replaceTitleIfEmpty(resp) {
            if (resp && Array.isArray(resp.Items)) {
                for (var i = 0, len = resp.Items.length; i < len; i++) {
                    var item = resp.Items[i];
                    if (!item.Title) {
                        item.Title = item.Label;
                    }
                    if (!item.IsOwned && item.LastName) {
                        item.Title += " - " + item.LastName;
                        if (item.FirstName) {
                            item.Title += " " + item.FirstName[0] + ".";
                        }
                        if (item.MiddleName) {
                            item.Title += " " + item.MiddleName[0] + ".";
                        }
                        if (item.Email) {
                            item.Title += " - " + item.Email;
                        }
                    }
                }
            }
            return resp;
        }
        function filterByDriveIds(resp, driveIds) {
            if (resp && Array.isArray(resp.Items) && Array.isArray(driveIds) && driveIds.length > 0) {
                resp.Items = resp.Items.filter(function(item) {
                    return driveIds.includes(item.DriveId);
                });
            }
            return resp;
        }
        function parseDeletedItemName(resp) {
            if (resp && Array.isArray(resp.Items)) {
                for (var i = 0, len = resp.Items.length; i < len; i++) {
                    var item = resp.Items[i];
                    var isDeleted = !!item.DeletedDate;
                    if (isDeleted) {
                        item.Name = item.OriginalName;
                        item.Extension = utils.fileExtension(item.OriginalName);
                    }
                }
            }
            return resp;
        }
        extend(jyNS, {
            ds: {
                RootHierarchyDataSource: RootHierarchyDataSource,
                ItemDataSource: ItemDataSource,
                DriveDataSource: DriveDataSource,
                UsersAndGroupsDataSource: UsersAndGroupsDataSource,
                AccessListDataSource: AccessListDataSource,
                DriveDetailsDataSource: DriveDetailsDataSource,
                ItemDetailsDataSource: ItemDetailsDataSource,
                ItemVersionListDataSource: ItemVersionListDataSource
            },
            replaceTitleIfEmpty: replaceTitleIfEmpty
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.api", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.data", "kendo.junkyard.models" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, Class = kendo.Class, jyNS = ui.junkyard, extend = $.extend, ds = jyNS.ds, models = jyNS.models, resource = jyNS.resource, utils = jyNS.utils, replaceTitleIfEmpty = jyNS.replaceTitleIfEmpty;
        var JunkyardApi = Class.extend({
            init: function(widgetOpt, auth) {
                this.widgetOpt = widgetOpt;
                this.auth = auth;
            },
            saveDrive: function(driveId, title, accessItems, flags) {
                if (driveId) {
                    return this.updateDrive(driveId, title, accessItems);
                } else {
                    return this.createDrive(title, accessItems, flags);
                }
            },
            createDrive: function(title, accessItems, flags) {
                var opt = this.widgetOpt.drives, url = opt.createUrl, data = this._createDriveData(title, accessItems, flags);
                return resource.post(this.auth, url, data);
            },
            updateDrive: function(driveId, title, accessItems) {
                var opt = this.widgetOpt.drives, url = kendo.format(opt.updateUrl, driveId), data = this._createDriveData(title, accessItems);
                return resource.put(this.auth, url, data);
            },
            renameDrive: function(driveId, title) {
                var opt = this.widgetOpt.drives, url = kendo.format(opt.renameUrl, driveId), data = {
                    CustomName: title
                };
                return resource.put(this.auth, url, data);
            },
            _createDriveData: function(title, accessItems, flags) {
                var data = {
                    Name: title,
                    Label: title,
                    Permissions: (accessItems || []).map(this._toPermModel),
                    ItemsDefaultPermissions: []
                };
                if (flags) {
                    data.IsCrypted = !!flags.isEncrypted;
                    data.HasHistory = !!flags.isHistory;
                    data.HasRecycleBin = !!flags.isTrashBin;
                }
                return data;
            },
            _toPermModel: function(accessItem) {
                return {
                    IsUser: accessItem.isUser,
                    Id: accessItem.itemId,
                    Permission: accessItem.permission
                };
            },
            getDriveDetails: function(driveId) {
                var opt = this.widgetOpt.drives;
                var url = kendo.format(opt.readDetailsUrl, driveId);
                var detailsDs = new ds.DriveDetailsDataSource(this.auth, url);
                return detailsDs.read().then(function() {
                    return detailsDs.at(0);
                });
            },
            getDriveItem: function(driveId) {
                var opt = this.widgetOpt.drives, url = opt.readListUrl + utils.toUrlQuery({
                    drive_id: driveId
                }, true);
                return resource.get(this.auth, url).then(function(res) {
                    var response = replaceTitleIfEmpty(res.response);
                    return response && response.Items ? response.Items[0] : null;
                });
            },
            getItemDetails: function(driveId, itemId) {
                var opt = this.widgetOpt.items;
                var url = opt.readDetailsUrl;
                var detailsDs = new ds.ItemDetailsDataSource(this.auth, url);
                return detailsDs.read({
                    drive_id: driveId,
                    item_id: itemId
                }).then(function() {
                    return detailsDs.at(0);
                });
            },
            getItemPath: function(driveId, itemId) {
                var opt = this.widgetOpt.items, url = opt.pathUrl + utils.toUrlQuery({
                    drive_id: driveId,
                    item_id: itemId
                }, true);
                return resource.get(this.auth, url);
            },
            getItemByHash: function(hash) {
                var opt = this.widgetOpt.items, url = opt.readItemByHashUrl + utils.toUrlQuery({
                    link: hash
                }, true);
                return resource.get(this.auth, url).then(function(res) {
                    return res.response ? models.createModel(models.ItemModel, res.response) : null;
                });
            },
            getItemByName: function(name, driveId, parentId) {
                var opt = this.widgetOpt.items, url = opt.readItemByNameUrl + utils.toUrlQuery({
                    name: name,
                    drive_id: driveId,
                    directory_id: parentId || undefined
                }, true);
                return resource.get(this.auth, url).then(function(res) {
                    return res.response ? models.createModel(models.ItemModel, res.response) : null;
                });
            },
            createFolder: function(driveId, parentId, title) {
                var opt = this.widgetOpt.items, url = opt.createFolderUrl + utils.toUrlQuery({
                    drive_id: driveId,
                    directory_id: parentId || undefined
                }, true), data = {
                    Name: title
                };
                return resource.post(this.auth, url, data);
            },
            renameItem: function(driveId, itemId, title) {
                var opt = this.widgetOpt.items, url = opt.renameUrl + utils.toUrlQuery({
                    drive_id: driveId,
                    item_id: itemId
                }, true), data = {
                    NewName: title
                };
                return resource.post(this.auth, url, data);
            },
            moveItems: function(driveId, folderId, itemIds) {
                var opt = this.widgetOpt.items, url = opt.moveUrl + utils.toUrlQuery({
                    drive_id: driveId,
                    directory_id: folderId || undefined
                }, true), data = {
                    Items: itemIds
                };
                return resource.post(this.auth, url, data);
            },
            restoreItem: function(itemId, driveId, folderId, newName) {
                var opt = this.widgetOpt.items, url = opt.deletedRestoreUrl, data = {
                    Id: itemId,
                    DriveId: driveId,
                    NewDirectoryId: folderId,
                    NewName: newName
                };
                return resource.post(this.auth, url, data);
            },
            copyItems: function(driveId, folderId, itemIds) {
                var opt = this.widgetOpt.items, url = opt.copyUrl + utils.toUrlQuery({
                    drive_id: driveId,
                    directory_id: folderId || undefined
                }, true), data = {
                    Items: itemIds
                };
                return resource.post(this.auth, url, data);
            },
            deleteItems: function(driveId, itemIds) {
                var opt = this.widgetOpt.items, url = opt.deleteUrl + utils.toUrlQuery({
                    drive_id: driveId
                }, true), data = {
                    Items: itemIds
                };
                return resource.del(this.auth, url, data);
            },
            clearTrash: function() {
                var url = this.widgetOpt.items.clearTrashUrl;
                return resource.post(this.auth, url, null);
            },
            revokeAllUrls: function(driveId, itemId) {
                var opt = this.widgetOpt.items, url = opt.revokeAllUrls + utils.toUrlQuery({
                    drive_id: driveId,
                    item_id: itemId
                }, true);
                return resource.get(this.auth, url, null);
            },
            deleteDriveById: function(driveId) {
                var opt = this.widgetOpt.drives, url = opt.deleteDriveById + utils.toUrlQuery({
                    drive_id: driveId
                }, true);
                return resource.del(this.auth, url, null);
            },
            setItemTags: function(driveId, itemId, tags) {
                var opt = this.widgetOpt.items, url = opt.setTagsUrl + utils.toUrlQuery({
                    drive_id: driveId,
                    item_id: itemId
                }, true), data = {
                    tags: tags
                };
                return resource.post(this.auth, url, data);
            },
            setItemDescription: function(driveId, itemId, description) {
                var opt = this.widgetOpt.items, url = opt.setDescriptionUrl + utils.toUrlQuery({
                    drive_id: driveId,
                    item_id: itemId
                }, true), data = {
                    Description: description
                };
                return resource.post(this.auth, url, data);
            },
            deleteDrives: function(driveIds) {
                var opt = this.widgetOpt.drives, url = opt.deleteUrl, data = {
                    Items: driveIds
                };
                return resource.del(this.auth, url, data);
            },
            changeDriveSize: function(driveId, newSize) {
                var opt = this.widgetOpt.drives, url = kendo.format(opt.changeQuotaUrl, driveId) + utils.toUrlQuery({
                    quota: newSize
                }, true);
                var data = {};
                return resource.put(this.auth, url, data);
            },
            restoreVersion: function(driveId, itemId, version) {
                var opt = this.widgetOpt.items, url = opt.restoreVersionUrl + utils.toUrlQuery({
                    drive_id: driveId,
                    item_id: itemId
                }, true), data = {
                    Version: version
                };
                return resource.post(this.auth, url, data);
            },
            createLinkByPath: function(driveId, itemId, checkPermission) {
                return this.createLinkForType(this.widgetOpt.items.linkByPathUrl, driveId, itemId, checkPermission);
            },
            createLinkById: function(driveId, itemId, checkPermission) {
                return this.createLinkForType(this.widgetOpt.items.linkByIdUrl, driveId, itemId, checkPermission);
            },
            createLinkByVersion: function(driveId, itemId, checkPermission) {
                return this.createLinkForType(this.widgetOpt.items.linkByVersionUrl, driveId, itemId, checkPermission);
            },
            createLinkForType: function(baseUrl, driveId, itemId, checkPermission) {
                var url = baseUrl + utils.toUrlQuery({
                    drive_id: driveId,
                    item_id: itemId,
                    check_permission: !!checkPermission
                }, true);
                return resource.post(this.auth, url, null).then(function(res) {
                    return res.response ? res.response.Link : null;
                });
            },
            getUserDetails: function(userId) {
                var opt = this.widgetOpt.access, converter = opt.userDetailsConverter, url = kendo.format(opt.userReadDetailsUrl, userId);
                return resource.get(this.auth, url, null, false).then(function(res) {
                    if (kendo.isFunction(converter)) {
                        return converter(res.response);
                    } else {
                        return res.response && res.response.model ? res.response.model : null;
                    }
                });
            },
            getGroupDetails: function(groupId) {
                var opt = this.widgetOpt.access, converter = opt.groupDetailsConverter, url = kendo.format(opt.groupReadDetailsUrl, groupId);
                return resource.get(this.auth, url, null, false).then(function(res) {
                    if (kendo.isFunction(converter)) {
                        return converter(res.response);
                    } else {
                        return res.response && res.response.model ? res.response.model : null;
                    }
                });
            },
            getUserTitle: function(userId) {
                return this.getUserDetails(userId).then(function(data) {
                    return data ? data.FullName : null;
                });
            },
            getGroupTitle: function(groupId) {
                return this.getGroupDetails(groupId).then(function(data) {
                    return data ? data.Name : null;
                });
            },
            getItemTitle: function(driveId, itemId) {
                return this.getItemDetails(driveId, itemId).then(function(details) {
                    return details ? details.title : null;
                });
            },
            getDriveTitle: function(driveId) {
                return this.getDriveDetails(driveId).then(function(details) {
                    return details ? details.title : null;
                });
            },
            getOrCreatePath: function(driveLabel, pathArray) {
                var opt = this.widgetOpt.items, url = opt.getOrCreatePathUrl, data = {
                    Label: driveLabel,
                    Path: pathArray
                };
                return resource.post(this.auth, url, data).then(function(res) {
                    return res.response ? models.createModel(models.ItemModel, res.response) : null;
                });
            },
            makeUploadFileUrl: function(driveId, folderId, disableAuth) {
                var opt = this.widgetOpt.upload;
                var url = opt.saveUrl + utils.toUrlQuery({
                    drive_id: driveId,
                    directory_id: folderId || undefined,
                    access_token: disableAuth ? undefined : this.auth.token
                }, true);
                return url;
            },
            makeReplaceFileUrl: function(driveId, itemId, disableAuth) {
                var opt = this.widgetOpt.upload;
                var url = opt.replaceUrl + utils.toUrlQuery({
                    drive_id: driveId,
                    item_id: itemId,
                    access_token: disableAuth ? undefined : this.auth.token
                }, true);
                return url;
            },
            makeDownloadUrl: function(driveId, itemIds, disableAuth) {
                var itemsOpt = this.widgetOpt.items;
                var url = itemsOpt.downloadUrl + utils.toUrlQuery({
                    drive_id: driveId
                }, true) + itemIds.map(function(id) {
                    return kendo.format("&item_id={0}", encodeURIComponent(id));
                }).join("") + (disableAuth ? "" : kendo.format("&access_token={0}", encodeURIComponent(this.auth.token)));
                return url;
            },
            makeDownloadVersionUrl: function(driveId, itemId, version, disableAuth) {
                var itemsOpt = this.widgetOpt.items;
                var url = itemsOpt.downloadVersionUrl + utils.toUrlQuery({
                    drive_id: driveId,
                    item_id: itemId,
                    version: version
                }, true) + (disableAuth ? "" : kendo.format("&access_token={0}", encodeURIComponent(this.auth.token)));
                return url;
            },
            makeDownloadByLinkUrl: function(link, useAuth) {
                var itemsOpt = this.widgetOpt.items;
                var url = itemsOpt.downloadByLinkUrl + utils.toUrlQuery({
                    link: link,
                    access_token: useAuth ? this.auth.token : undefined
                }, true);
                return url;
            }
        });
        extend(jyNS, {
            JunkyardApi: JunkyardApi
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.service", [ "kendo.junkyard.ns", "kendo.junkyard.api" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, Class = kendo.Class, jyNS = ui.junkyard, extend = $.extend, JunkyardApi = jyNS.JunkyardApi;
        var JunkyardService = Class.extend({
            init: function(widgetOptions, auth, broadcaster, commandManager) {
                this.widgetOpt = widgetOptions;
                this.auth = auth;
                this.broadcaster = broadcaster;
                this.commandManager = commandManager;
                this.api = new JunkyardApi(this.widgetOpt, this.auth);
            },
            broadcast: function(eventName, args) {
                this.broadcaster.trigger(eventName, args);
            },
            broadcastOn: function(eventName, handler) {
                this.broadcaster.bind(eventName, handler);
            },
            broadcastOff: function(eventName, handler) {
                this.broadcaster.unbind(eventName, handler);
            },
            broadcastOne: function(eventName, handler) {
                this.broadcaster.one(eventName, handler);
            },
            command: function(commandName, commandArgs) {
                return this.commandManager.makeCommand(commandName, commandArgs);
            }
        });
        extend(jyNS, {
            JunkyardService: JunkyardService
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.vm.base", [ "kendo.junkyard.ns" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, proxy = $.proxy, ObservableObject = kendo.data.ObservableObject, UiEvents = jyNS.UiEvents;
        var BaseViewModel = ObservableObject.extend({
            init: function(options) {
                ObservableObject.fn.init.call(this);
                this.options = options;
                this.root = options.root;
                this.widgetOpt = options.widgetOptions;
                this._baseUIEvents();
            },
            proxy: function(fnProperty, context) {
                context = context || this;
                if (kendo.isFunction(context[fnProperty])) {
                    context[fnProperty] = proxy(context[fnProperty], context);
                }
            },
            _baseUIEvents: function() {
                var uiEvents = this.root.uiEvents;
                if (uiEvents) {
                    this.proxy("onCreateView");
                    this.proxy("onDestroyView");
                    uiEvents.bind(UiEvents.CreateView, this.onCreateView).bind(UiEvents.DestroyView, this.onDestroyView);
                }
            },
            clone: function() {
                return this;
            },
            onCreateView: function() {},
            onDestroyView: function() {}
        });
        extend(jyNS, {
            BaseViewModel: BaseViewModel
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.broadcaster", [ "kendo.junkyard.ns", "kendo.junkyard.vm.base" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, ObservableObject = kendo.data.ObservableObject;
        var Broadcaster = ObservableObject.extend({
            init: function() {
                ObservableObject.fn.init.call(this);
            }
        });
        extend(jyNS, {
            Broadcaster: Broadcaster
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.vm.ui-events", [ "kendo.junkyard.ns", "kendo.junkyard.vm.base" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, BaseViewModel = jyNS.BaseViewModel;
        var UiEventsViewModel = BaseViewModel.extend({
            init: function(options) {
                BaseViewModel.fn.init.call(this, options);
            }
        });
        extend(jyNS, {
            UiEventsViewModel: UiEventsViewModel
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.vm.menu-tree-drag", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.vm.base", "kendo.junkyard.data", "kendo.junkyard.constants" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, BaseViewModel = jyNS.BaseViewModel, MenuItemType = jyNS.MenuItemType, DRAGGING = "jy-dragging", NODROP_CURSOR = "jy-dragging-cursor--no-drop", DEFAULT_CURSOR = "jy-dragging-cursor--default", COPY_CURSOR = "jy-dragging-cursor--copy", DRAGENTERSTATE = "jy-state-dragenter", TREEVIEW_CONTENT_SELECTOR = "> div > .k-in", TREEVIEW_NODE_SELECTOR = ".k-item";
        var MenuTreeDragViewModel = BaseViewModel.extend({
            init: function(options) {
                BaseViewModel.fn.init.call(this, options);
                this._state();
                this._proxy();
            },
            _state: function() {
                this._dragItems = [];
                this._menuTreeExpandedNodes = [];
                this._ctrlPressed = false;
            },
            _proxy: function() {
                this.proxy("onDragHint");
                this.proxy("onDragStart");
                this.proxy("onDragEnd");
                this.proxy("onDragCancel");
                this.proxy("onKeyDown");
                this.proxy("onKeyUp");
                this.proxy("onDragEnter");
                this.proxy("onDragLeave");
                this.proxy("onDrop");
            },
            onDragHint: function(e) {
                var hintData = e.hintData;
                if (this._isMenuItemFolder(e.target)) {
                    hintData.objType = "folder";
                    hintData.count = 1;
                    hintData.title = (e.target.text() || "").trim();
                } else {
                    e.preventDefault();
                }
            },
            onDragStart: function(e) {
                if (this._isMenuItemFolder(e.currentTarget)) {
                    this._dragStart(e);
                    this._handleCtrlPressed(e.ctrlKey || e.metaKey, e.sender);
                } else {
                    e.preventDefault();
                }
            },
            onDragEnd: function(e) {
                this._dragEnd(e);
            },
            onDragCancel: function(e) {
                this._dragEnd(e);
            },
            onKeyDown: function(e) {
                this._handleCtrlPressed(e.orig.ctrlKey || e.orig.metaKey, e.sender);
            },
            onKeyUp: function(e) {
                this._handleCtrlPressed(e.orig.ctrlKey || e.orig.metaKey, e.sender);
            },
            onDragEnter: function(e) {
                var menuTree = this.root.menuTree, uid = e.dropTarget.data("uid"), dragItem = this._dragItems[0], nodeItem = menuTree.findNodeByUid(uid);
                if (nodeItem) {
                    var canDrop = menuTree.isMenuNode(nodeItem) && !menuTree.isTrashMenu(nodeItem) || !menuTree.isMenuNode(nodeItem) && menuTree.canMoveItemsToNode(nodeItem, this._dragItems);
                    this._enableDragEnter(e.dropTarget, true);
                    if (!(dragItem && dragItem.id === nodeItem.id)) {
                        this._enableNoDropCursor(e.currentTarget, !canDrop);
                    }
                    if (canDrop) {
                        this._menuTreeExpandNode(nodeItem);
                    }
                }
            },
            onDragLeave: function(e) {
                this._enableDragEnter(e.dropTarget, false);
                this._enableNoDropCursor(e.currentTarget, false);
            },
            onDrop: function(e) {
                var menuTree = this.root.menuTree, dragItem = this._dragItems[0], currentDrive = dragItem && dragItem.driveId ? {
                    id: dragItem.driveId
                } : null, currentItem = dragItem && dragItem.parentId ? {
                    id: dragItem.parentId
                } : null, uid = e.dropTarget.data("uid"), nodeItem = menuTree.findNodeByUid(uid);
                this._enableDragEnter(e.dropTarget, false);
                this._enableNoDropCursor(e.currentTarget, false);
                if (nodeItem) {
                    if (menuTree.canMoveItemsToNode(nodeItem, this._dragItems)) {
                        var noCollapsedNodes = [ nodeItem ].concat(menuTree.findParentNodes(nodeItem.id, nodeItem.menuType));
                        this._menuTreeRemoveFromExpandedNodes(noCollapsedNodes);
                        if (!menuTree.nodeInCurrentPath(nodeItem, currentDrive, currentItem)) {
                            this._runOnDropCommand(nodeItem, this._dragItems, this._ctrlPressed);
                        }
                    }
                }
            },
            _dragStart: function(e) {
                var menuTree = this.root.menuTree, uid = e.currentTarget.closest(TREEVIEW_NODE_SELECTOR).data("uid"), dataItem = uid ? menuTree.findNodeByUid(uid) : null;
                this._dragItems = [];
                this._menuTreeExpandedNodes = [];
                if (dataItem) {
                    this._dragItems = [ dataItem ];
                }
                this._enableDragging(e.sender.draggable.element, this._dragItems, true);
                this._enableDefaultCursor(e.originalEvent.currentTarget, true);
            },
            _dragEnd: function(e) {
                this._enableDragging(e.sender.draggable.element, this._dragItems, false);
                this._enableDefaultCursor(e.originalEvent.currentTarget, false);
                this._enableCopyCursor(e.originalEvent.currentTarget, false);
                this._menuTreeCollapseExpandedNodes();
                this._dragItems = [];
                this._menuTreeExpandedNodes = [];
            },
            _isMenuItemFolder: function(element) {
                var menuItemType = $(element).find(".fa").data("type");
                return menuItemType === MenuItemType.Item;
            },
            _handleCtrlPressed: function(ctrlPressed, sender) {
                this._ctrlPressed = ctrlPressed;
                this._enableCopyCursor(sender.draggable.userEvents.surface, ctrlPressed);
            },
            _menuTreeCollapseExpandedNodes: function() {
                this._menuTreeExpandedNodes.forEach(function(node) {
                    node.set("expanded", false);
                });
            },
            _menuTreeExpandNode: function(node) {
                if (!node.expanded) {
                    node.set("expanded", true);
                    this._menuTreeExpandedNodes.push(node);
                }
            },
            _menuTreeRemoveFromExpandedNodes: function(nodeArray) {
                this._menuTreeExpandedNodes = this._menuTreeExpandedNodes.filter(function(item) {
                    return !nodeArray.some(function(n) {
                        return n.menuType === item.menuType && n.id === item.id;
                    });
                });
            },
            _runOnDropCommand: function(menuItem, dragItems, isCopy) {
                var targetDriveId = menuItem.menuType === MenuItemType.Drive ? menuItem.id : menuItem.driveId;
                var targetFolderId = menuItem.menuType === MenuItemType.Item ? menuItem.id : null;
                var findInDragItems = function(id) {
                    return dragItems.filter(function(dragItem) {
                        return dragItem.id === id;
                    })[0];
                };
                if (targetFolderId && findInDragItems(targetFolderId)) {
                    return;
                }
                var itemIds = dragItems.map(function(dragItem) {
                    return dragItem.id;
                });
                if (targetDriveId && itemIds.length > 0) {
                    if (isCopy) {
                        this.root.commandService.copyItems(targetDriveId, targetFolderId, itemIds);
                    } else {
                        this.root.commandService.moveItems(targetDriveId, targetFolderId, itemIds);
                    }
                }
            },
            _enableDragging: function(container, items, enabled) {
                items.forEach(function(item) {
                    var element = container.find("[data-uid='" + item.uid + "']");
                    if (enabled) {
                        element.find(TREEVIEW_CONTENT_SELECTOR).addClass(DRAGGING);
                    } else {
                        element.find(TREEVIEW_CONTENT_SELECTOR).removeClass(DRAGGING);
                    }
                });
            },
            _enableNoDropCursor: function(element, enabled) {
                if (enabled) {
                    $(element).addClass(NODROP_CURSOR);
                } else {
                    $(element).removeClass(NODROP_CURSOR);
                }
            },
            _enableDefaultCursor: function(element, enabled) {
                if (enabled) {
                    $(element).addClass(DEFAULT_CURSOR);
                } else {
                    $(element).removeClass(DEFAULT_CURSOR);
                }
            },
            _enableCopyCursor: function(element, enabled) {
                if (enabled) {
                    $(element).addClass(COPY_CURSOR);
                } else {
                    $(element).removeClass(COPY_CURSOR);
                }
            },
            _enableDragEnter: function(element, enabled) {
                var innerEl = $(element).find(TREEVIEW_CONTENT_SELECTOR);
                if (enabled) {
                    innerEl.addClass(DRAGENTERSTATE);
                } else {
                    innerEl.removeClass(DRAGENTERSTATE);
                }
            }
        });
        extend(jyNS, {
            MenuTreeDragViewModel: MenuTreeDragViewModel
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.vm.menu-tree", [ "kendo.junkyard.ns", "kendo.junkyard.vm.base", "kendo.junkyard.data", "kendo.junkyard.constants", "kendo.junkyard.utils", "kendo.junkyard.vm.menu-tree-drag" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, BaseViewModel = jyNS.BaseViewModel, MenuTreeDragViewModel = jyNS.MenuTreeDragViewModel, MenuItemType = jyNS.MenuItemType, trashMenuModelData = jyNS.trashMenuModelData, MenuIds = jyNS.MenuIds, utils = jyNS.utils, ds = jyNS.ds;
        var MenuTreeViewModel = BaseViewModel.extend({
            init: function(options) {
                BaseViewModel.fn.init.call(this, options);
                this._state();
                this._proxy();
                this._dataSource();
            },
            _state: function() {
                this.set("preserveItem", {
                    id: null,
                    type: null
                });
                this.set("drag", new MenuTreeDragViewModel(this.options));
                this.treeViewWidget = null;
                this._expandPaths = {};
            },
            _proxy: function() {
                this.proxy("onSelect");
                this.proxy("onDataBound");
                this.proxy("onClickPath");
                this.proxy("addTrashMenu");
            },
            _dataSource: function() {
                var drivesOpt = this.widgetOpt.drives, itemsOpt = this.widgetOpt.items, auth = this.root.service.auth, driveIds = this.widgetOpt.driveIds;
                this.set("dataSource", new ds.RootHierarchyDataSource(auth, {
                    readDriveListUrl: drivesOpt.readListUrl,
                    readItemListUrl: itemsOpt.readListUrl
                }, driveIds));
            },
            load: function() {
                return this.dataSource.read().done(this.addTrashMenu);
            },
            loadAndSelectDefault: function() {
                var that = this;
                return that.load().done(function() {
                    that.selectDefault();
                });
            },
            reloadNode: function(id, type, updateUI, saveExpand) {
                var that = this;
                var dataItem = this.dataSource.recursiveFindByIdAndType(id, type);
                if (dataItem && dataItem.children instanceof kendo.data.DataSource && dataItem.children._requestInProgress) {
                    return false;
                }
                if (dataItem && (dataItem.loaded() || !dataItem.hasChildren)) {
                    dataItem.loaded(false);
                    dataItem.set("hasChildren", true);
                    if (saveExpand) {
                        this.saveExpandedForNode(id, type);
                    }
                    var restoreExpand = function(complete) {
                        if (saveExpand) {
                            that.restoreExpandedForNode(id, type, complete);
                        } else {
                            complete();
                        }
                    };
                    if (updateUI) {
                        return dataItem.load().done(function() {
                            restoreExpand(function() {
                                that.updateUI();
                            });
                        });
                    } else {
                        return dataItem.load().done(function() {
                            restoreExpand();
                        });
                    }
                }
                return false;
            },
            saveExpandedForNode: function(nodeId, nodeType) {
                var that = this;
                var expandPaths = this.dataSource.findInSubTreeAndSelf(nodeId, nodeType, function(node) {
                    return !!node.expanded;
                }).map(function(node) {
                    return that.getPathForNode(node.id, node.menuType);
                });
                if (expandPaths.length > 0) {
                    var key = nodeId + "" + nodeType;
                    this._expandPaths[key] = expandPaths;
                }
            },
            restoreExpandedForNode: function(nodeId, nodeType, complete) {
                var that = this;
                var key = nodeId + "" + nodeType;
                if (this._expandPaths[key]) {
                    var expandPaths = this._expandPaths[key].slice();
                    var nextExpandPath = function() {
                        var expandPath = expandPaths.shift();
                        if (expandPath) {
                            that.treeViewWidget.expandPath(expandPath, nextExpandPath);
                        } else {
                            delete that._expandPaths[key];
                            complete();
                        }
                    };
                    nextExpandPath();
                }
            },
            getPathForNode: function(nodeId, nodeType) {
                var parentNodes = this.findParentNodes(nodeId, nodeType);
                return parentNodes.map(function(node) {
                    return node.id;
                }).reverse().concat(nodeId);
            },
            addTrashMenu: function() {},
            focusNode: function(node) {
                var item = this.treeViewWidget.findByUid(node.uid);
                this.treeViewWidget.current(item);
            },
            findParentNodes: function(nodeId, nodeType) {
                return this.dataSource.findParentsByIdAndType(nodeId, nodeType);
            },
            findParentNode: function(nodeId, nodeType) {
                return utils.first(this.findParentNodes(nodeId, nodeType));
            },
            findNodeByUid: function(uid) {
                return this.dataSource.getByUid(uid);
            },
            findParentItems: function(nodeId, nodeType) {
                return this.findParentNodes(nodeId, nodeType).filter(function(parentNode) {
                    return parentNode.menuType === MenuItemType.Item;
                });
            },
            findParentItemIds: function(nodeId, nodeType) {
                return this.findParentItems(nodeId, nodeType).map(function(parentNode) {
                    return parentNode.id;
                });
            },
            isTrashMenu: function(nodeItem) {
                return nodeItem && nodeItem.id === MenuIds.Trash && nodeItem.menuType === MenuItemType.Menu;
            },
            isMenuNode: function(nodeItem) {
                return nodeItem && nodeItem.menuType === MenuItemType.Menu;
            },
            isDriveNode: function(nodeItem) {
                return nodeItem && nodeItem.menuType === MenuItemType.Drive;
            },
            isItemNode: function(nodeItem) {
                return nodeItem && nodeItem.menuType === MenuItemType.Item;
            },
            nodeInCurrentPath: function(nodeItem, currentDrive, currentItem) {
                if (!nodeItem) {
                    return false;
                }
                if (this.isMenuNode(nodeItem)) {
                    return false;
                }
                if (this.isDriveNode(nodeItem)) {
                    if (!currentDrive) {
                        return false;
                    } else {
                        return !currentItem && currentDrive.id === nodeItem.id;
                    }
                }
                if (!this.isItemNode(nodeItem)) {
                    return false;
                }
                if (!currentItem) {
                    return false;
                }
                return nodeItem.id === currentItem.id;
            },
            canMoveItemsToNode: function(nodeItem, itemModels, findParentItemIdsFn) {
                if (!nodeItem) {
                    return false;
                }
                if (this.isMenuNode(nodeItem)) {
                    return false;
                }
                if (this.isDriveNode(nodeItem)) {
                    return true;
                }
                if (!this.isItemNode(nodeItem)) {
                    return false;
                }
                var existsById = function(id) {
                    return itemModels.filter(function(model) {
                        return model.id === id;
                    }).length > 0;
                };
                if (existsById(nodeItem.id)) {
                    return false;
                }
                var parentItemIds = findParentItemIdsFn ? findParentItemIdsFn(nodeItem.id, nodeItem.menuType) : this.findParentItemIds(nodeItem.id, nodeItem.menuType);
                if (parentItemIds.some(existsById)) {
                    return false;
                }
                return true;
            },
            expandNodeByElement: function(nodeElement) {
                this.treeViewWidget.expand(nodeElement);
            },
            expandNodeByUid: function(nodeUid) {
                var nodeElement = this.treeViewWidget.findByUid(nodeUid);
                if (nodeElement) {
                    this.expandNodeByElement(nodeElement);
                }
            },
            collapseNodeByUid: function(nodeUid) {
                var nodeElement = this.treeViewWidget.findByUid(nodeUid);
                if (nodeElement) {
                    this.treeViewWidget.collapse(nodeElement);
                }
            },
            selectDefault: function() {
                var treeView = this.treeViewWidget, data = this.dataSource.view(), firstDataItem = data && data[0] ? data[0] : null, menuItemElement = firstDataItem ? treeView.findByUid(firstDataItem.uid) : null;
                if (menuItemElement && menuItemElement.length > 0) {
                    treeView.select(menuItemElement);
                }
            },
            selectByUid: function(uid) {
                var treeView = this.treeViewWidget, menuItemElement = treeView.findByUid(uid);
                if (menuItemElement && menuItemElement.length > 0) {
                    treeView.select(menuItemElement);
                }
            },
            findBaseItem: function(dataItem) {
                var parents = this.findParentNodes(dataItem.id, dataItem.menuType);
                return utils.first(parents.filter(function(item) {
                    return item.menuType === MenuItemType.Menu;
                }));
            },
            findDriveItem: function(dataItem) {
                var parents = this.findParentNodes(dataItem.id, dataItem.menuType);
                return utils.first(parents.filter(function(item) {
                    return item.menuType === MenuItemType.Drive;
                }));
            },
            updatePreserveItem: function(menuItemId, menuItemType) {
                this.preserveItem.id = menuItemId;
                this.preserveItem.type = menuItemType;
            },
            updateUI: function() {
                var treeView = this.treeViewWidget;
                var oldSelectedItem = treeView.dataItem(treeView.select());
                var preserveItem = this.preserveItem;
                if (oldSelectedItem && oldSelectedItem.id === preserveItem.id && oldSelectedItem.menuType === preserveItem.type) {
                    return;
                }
                if (oldSelectedItem) {
                    oldSelectedItem.set("selected", false);
                }
                if (preserveItem.id) {
                    var dataItem = this.dataSource.recursiveFindByIdAndType(preserveItem.id, preserveItem.type);
                    if (dataItem) {
                        dataItem.set("selected", true);
                    }
                }
            },
            onDataBound: function() {
                this.updateUI();
            },
            onSelect: function(e) {
                var treeView = e.sender;
                var currentNode = treeView.select();
                var dataItem = treeView.dataItem(currentNode);
                var router = this.root.router;
                var baseItem, driveItem;
                if (dataItem) {
                    if (dataItem.menuType === MenuItemType.Menu) {
                        router.goToBase(dataItem.id);
                    } else if (dataItem.menuType === MenuItemType.Drive) {
                        baseItem = this.findBaseItem(dataItem);
                        if (baseItem) {
                            router.goToDrive(baseItem.id, dataItem.id);
                        }
                    } else if (dataItem.menuType === MenuItemType.Item) {
                        baseItem = this.findBaseItem(dataItem);
                        driveItem = this.findDriveItem(dataItem);
                        if (baseItem && driveItem) {
                            router.goToItem(baseItem.id, driveItem.id, dataItem.id);
                        }
                    }
                    this.updatePreserveItem(dataItem.id, dataItem.menuType);
                }
            },
            onCreateView: function() {
                this.treeViewWidget = $("#jy-widget-menu-" + this.uid).data("kendoJunkyardTreeView");
            }
        });
        extend(jyNS, {
            MenuTreeViewModel: MenuTreeViewModel
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.vm.progress", [ "kendo.junkyard.ns", "kendo.junkyard.vm.base" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, BaseViewModel = jyNS.BaseViewModel;
        var ProgressViewModel = BaseViewModel.extend({
            init: function(options) {
                BaseViewModel.fn.init.call(this, options);
                this._state();
            },
            _state: function() {
                this._resetState();
            },
            _resetState: function() {
                this.set("visible", false);
                this.set("progressCount", 0);
                this.set("waitVisible", false);
            },
            showProgress: function(withWait) {
                var progressCount = this.get("progressCount");
                this.set("progressCount", ++progressCount);
                this.set("visible", true);
                this.set("waitVisible", !!withWait);
            },
            hideProgress: function() {
                var progressCount = this.get("progressCount");
                this.set("progressCount", --progressCount);
                if (this.get("progressCount") <= 0) {
                    this._resetState();
                }
            }
        });
        extend(jyNS, {
            ProgressViewModel: ProgressViewModel
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.vm.errors", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.vm.base" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, BaseViewModel = jyNS.BaseViewModel, traceError = jyNS.traceError, utils = jyNS.utils, HIDE = "hide";
        var NotificationViewModel = BaseViewModel.extend({
            init: function(message, leaveDelay, hideDelay, options) {
                BaseViewModel.fn.init.call(this, options);
                this.set("message", message);
                this.set("leave", false);
                this.set("enter", false);
                this.set("success", false);
                this.set("error", false);
                this._leaveDelay = leaveDelay;
                this._hideDelay = hideDelay;
                this._enterTimeout();
            },
            _enterTimeout: function() {
                var that = this;
                var timeoutResource = setTimeout(function() {
                    that.set("enter", true);
                    that._leaveTimeout();
                    clearTimeout(timeoutResource);
                }, 10);
            },
            _leaveTimeout: function() {
                var that = this;
                var timeoutResource = setTimeout(function() {
                    that.set("leave", true);
                    that.hideWithDelay(that._hideDelay);
                    clearTimeout(timeoutResource);
                }, that._leaveDelay);
            },
            hideWithDelay: function(delay) {
                var that = this;
                var timeoutResource = setTimeout(function() {
                    that.trigger(HIDE);
                    clearTimeout(timeoutResource);
                }, delay);
            }
        });
        var ErrorItemViewModel = NotificationViewModel.extend({
            init: function(message, leaveTimeout, hideTimeout, options) {
                NotificationViewModel.fn.init.call(this, message, leaveTimeout, hideTimeout, options);
                this.set("error", true);
            }
        });
        var SuccessItemViewModel = NotificationViewModel.extend({
            init: function(message, leaveTimeout, hideTimeout, options) {
                NotificationViewModel.fn.init.call(this, message, leaveTimeout, hideTimeout, options);
                this.set("success", true);
            }
        });
        var ErrorViewModel = BaseViewModel.extend({
            init: function(options) {
                BaseViewModel.fn.init.call(this, options);
                this._state();
                this._proxy();
            },
            _state: function() {
                this.set("items", []);
            },
            _proxy: function() {
                this.proxy("_onHideNotification");
            },
            showError: function(error, format, args, reason, suppressDisplayMsg) {
                var errorMessage, consoleMessage, displayMessage, reasonMessage, formatArgs;
                var debugOpt = this.widgetOpt.debug;
                errorMessage = this.errorMessage(error);
                formatArgs = [ format ].concat(args || []).concat(errorMessage);
                consoleMessage = displayMessage = format ? kendo.format.apply(null, formatArgs) : errorMessage;
                reasonMessage = reason ? " " + this._makeReason(reason) : "";
                if (debugOpt.verbose) {
                    consoleMessage = displayMessage = displayMessage + reasonMessage;
                } else {
                    consoleMessage = consoleMessage + reasonMessage;
                }
                traceError(consoleMessage);
                if (!suppressDisplayMsg) {
                    this.items.unshift(this._makeErrorItem(displayMessage));
                }
            },
            showSuccess: function(format) {
                var args = Array.prototype.slice.call(arguments, 1);
                var message = kendo.format.apply(null, [ format ].concat(args));
                this.items.unshift(this._makeSuccessItem(message));
            },
            visible: function() {
                return this.get("items").length > 0;
            },
            errorMessage: function(error) {
                var message;
                if (error instanceof Error) {
                    message = error.toString();
                } else if (typeof error === "string") {
                    message = error;
                } else if (error.message) {
                    message = error.message;
                } else if (utils.isObject(error)) {
                    message = JSON.stringify(error);
                }
                return message;
            },
            _makeReason: function(reason) {
                var localization = this.widgetOpt.localization;
                return kendo.format(localization.reason, this.errorMessage(reason));
            },
            _makeErrorItem: function(message) {
                var opt = this.widgetOpt.error;
                var notification = new ErrorItemViewModel(message, opt.leaveTimeout, opt.hideTimeout, this.options);
                notification.bind(HIDE, this._onHideNotification);
                return notification;
            },
            _makeSuccessItem: function(message) {
                var opt = this.widgetOpt.error;
                var notification = new SuccessItemViewModel(message, opt.leaveTimeout, opt.hideTimeout, this.options);
                notification.bind(HIDE, this._onHideNotification);
                return notification;
            },
            _onHideNotification: function(e) {
                e.sender.unbind();
                this.items.remove(e.sender);
            }
        });
        extend(jyNS, {
            ErrorViewModel: ErrorViewModel
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.vm.base-list", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.vm.base", "kendo.junkyard.constants" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, ViewType = jyNS.ViewType, DataSource = kendo.data.DataSource, BaseViewModel = jyNS.BaseViewModel, MenuIds = jyNS.MenuIds, CHANGE = "change";
        var BaseListViewModel = BaseViewModel.extend({
            init: function(options) {
                BaseViewModel.fn.init.call(this, options);
                this._baseState();
                this._baseProxy();
                this._baseDs();
            },
            _baseState: function() {
                this.set("visible", false);
                this.set("dataSource", []);
                this.set("isEmptyVisible", false);
                this.set("isEmptySearchVisible", false);
                this.set("isEmptyTrashVisible", false);
                this.set("viewType", ViewType.Card);
                this.set("nullDataSource", new DataSource({
                    data: []
                }));
                this.selectedItems = [];
                this.cardSelectableWidget = null;
                this.gridSelectableWidget = null;
                this.gridWidget = null;
            },
            _baseProxy: function() {
                this.proxy("onSelect");
                this.proxy("_onPageStart");
                this.proxy("_onPageEnd");
                this.proxy("_onShowProgress");
                this.proxy("_onHideProgress");
                this.proxy("_updateEmptyVisible");
            },
            _baseDs: function() {
                this.nullDataSource.fetch();
            },
            setVisible: function(value) {
                this.set("visible", value);
            },
            emptyDataSource: function() {
                this.dataSource.data([]);
            },
            empty: function() {
                this.select([]);
                this.emptyDataSource();
                this.set("isEmptyVisible", false);
                this.set("isEmptySearchVisible", false);
                this.set("isEmptyTrashVisible", false);
                return this;
            },
            reload: function(updateUI, resetPaging) {
                var that = this, ds = this.dataSource;
                if (resetPaging && kendo.isFunction(ds.resetPage)) {
                    ds.resetPage();
                }
                return ds.abort().read().done(function() {
                    that._updateEmptyVisible();
                    if (updateUI) {
                        that.updateUI();
                    }
                });
            },
            setSelectedItems: function(selectedItems) {
                this.selectedItems = selectedItems;
            },
            dataItems: function(elements) {
                var that = this, dataItems = [];
                elements.each(function() {
                    var uid = $(this).attr("data-uid");
                    var dataItem = that.dataSource.getByUid(uid);
                    if (dataItem) {
                        dataItems.push(dataItem);
                    }
                });
                return dataItems;
            },
            selectById: function(id) {
                var dataItem = this.dataSource.get(id);
                if (dataItem) {
                    this.select([ dataItem ]);
                }
            },
            select: function(models) {
                var selectableWidget = this.viewType === ViewType.Card ? this.cardSelectableWidget : this.gridSelectableWidget;
                if (models.length > 0) {
                    selectableWidget.selectByUids(this._getModelUids(models));
                } else {
                    selectableWidget.clear();
                }
            },
            isSelected: function(model) {
                return this.selectedItems.filter(function(item) {
                    return item.id === model.id;
                }).length > 0;
            },
            isSelectedByUid: function(uid) {
                return this.selectedItems.filter(function(item) {
                    return item.uid === uid;
                }).length > 0;
            },
            clearSelect: function() {
                this.select([]);
            },
            _getModelUids: function(models) {
                return models.map(function(model) {
                    return model.uid;
                });
            },
            _getModelIds: function(models) {
                return models.map(function(model) {
                    return model.id;
                });
            },
            findByIds: function(ids) {
                var that = this;
                return ids.map(function(id) {
                    return that.dataSource.get(id);
                }).filter(function(item) {
                    return item != null;
                });
            },
            broadcastSelect: function(models) {
                this.root.broadcastService.selectContext(models);
            },
            updateUI: function() {
                this._updateSelection();
            },
            _updateSelection: function() {
                this.select(this.findByIds(this._getModelIds(this.selectedItems)));
            },
            _updateEmptyVisible: function() {
                var ds = this.dataSource, isEmpty = this.dataSource.total() === 0, isTrashMenu = this.root.path.isCurrentBase(MenuIds.Trash);
                if (ds.isSearching) {
                    this.set("isEmptyVisible", false);
                    this.set("isEmptyTrashVisible", false);
                    this.set("isEmptySearchVisible", isEmpty);
                } else {
                    this.set("isEmptySearchVisible", false);
                    this.set("isEmptyVisible", isEmpty && !isTrashMenu);
                    this.set("isEmptyTrashVisible", isEmpty && isTrashMenu);
                }
            },
            changeDs: function(ds, items) {
                ds.trigger(CHANGE, {
                    items: items
                });
            },
            isCardView: function() {
                return this.get("visible") && this.get("viewType") === ViewType.Card;
            },
            isGridView: function() {
                return this.get("visible") && this.get("viewType") === ViewType.Grid;
            },
            setViewType: function(viewType) {
                this.set("viewType", viewType);
            },
            switchViewType: function(viewType) {
                this.setViewType(viewType);
                this._viewTypeChanged = true;
                if (this.visible) {
                    this.onUpdateViewType();
                    this.updateUI();
                }
            },
            setGridDataSource: function(ds) {
                if (this.gridWidget) {
                    this.gridWidget.setDataSource(ds);
                }
            },
            onUpdateViewType: function() {
                if (this._viewTypeChanged) {
                    this.onChangeViewType();
                    this._viewTypeChanged = false;
                }
            },
            onChangeViewType: function() {},
            onSelect: function(e) {
                var dataItems = this.dataItems(e.sender.selectableWidget.value());
                this.setSelectedItems(dataItems);
                this.broadcastSelect(dataItems);
            },
            _onPageStart: function() {
                this._onShowProgress();
                this.empty();
            },
            _onPageEnd: function() {
                this._onHideProgress();
            },
            _onShowProgress: function() {
                this.root.progressBar.showProgress();
            },
            _onHideProgress: function() {
                this.root.progressBar.hideProgress();
            }
        });
        extend(jyNS, {
            BaseListViewModel: BaseListViewModel
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.vm.selector", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.vm.base", "kendo.junkyard.constants" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, BaseViewModel = jyNS.BaseViewModel, utils = jyNS.utils, SELECTED = "selected", UiEvents = jyNS.UiEvents, openedSelector = null;
        var SelectorViewModel = BaseViewModel.extend({
            init: function(options) {
                BaseViewModel.fn.init.call(this, options);
                this._state();
                this._proxy();
            },
            _state: function() {
                this.set("items", []);
                this.set("opened", false);
                this.selectedItem = null;
            },
            _proxy: function() {
                this.proxy("onDocumentClick");
            },
            _oneUIDocClick: function() {
                this.root.uiEvents.one(UiEvents.DocumentClick, this.onDocumentClick);
            },
            _select: function(id) {
                this.resetSelected();
                var model = this.findById(id);
                if (model) {
                    model.set("selected", true);
                    this.selectedItem = model;
                    this.trigger(SELECTED, {
                        item: this.selectedItem
                    });
                }
            },
            select: function(id) {
                this._select(id);
            },
            reset: function() {
                this.resetSelected();
            },
            findById: function(id) {
                return utils.first(this.items.filter(function(item) {
                    return item.id === id;
                }));
            },
            resetSelected: function() {
                if (this.selectedItem) {
                    this.selectedItem.set("selected", false);
                    this.selectedItem = null;
                }
            },
            close: function() {
                this.set("opened", false);
                openedSelector = null;
            },
            open: function() {
                if (openedSelector && openedSelector !== this) {
                    openedSelector.close();
                    openedSelector = null;
                }
                this._oneUIDocClick();
                this.set("opened", true);
                openedSelector = this;
            },
            onToggle: function(e) {
                e.stopImmediatePropagation();
                if (this.opened) {
                    this.close();
                } else {
                    this.open();
                }
            },
            onSelect: function(e) {
                this._select(e.data.id);
            },
            onDocumentClick: function() {
                this.close();
            }
        });
        extend(jyNS, {
            SelectorViewModel: SelectorViewModel
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.vm.sort", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.vm.base", "kendo.junkyard.vm.selector", "kendo.junkyard.constants" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, SelectorViewModel = jyNS.SelectorViewModel, SELECTED = "selected", CHANGE_SORT = "changeSort";
        var SortViewModel = SelectorViewModel.extend({
            init: function(options, items) {
                SelectorViewModel.fn.init.call(this, options);
                items = items || [];
                this._setupItems(items);
                this._setupEvents();
                this._selectDefault();
            },
            _state: function() {
                SelectorViewModel.fn._state.call(this);
                this.set("value", {
                    title: null,
                    id: null
                });
                this.set("direction", "desc");
            },
            _setupItems: function(items) {
                this.set("items", items);
            },
            _selectDefault: function() {
                if (this.items[0]) {
                    this._select(this.items[0].id);
                }
            },
            isAscDir: function() {
                return this.get("direction") === "asc";
            },
            isDescDir: function() {
                return this.get("direction") === "desc";
            },
            _setupEvents: function() {
                this.proxy("onSelected");
                this.bind(SELECTED, this.onSelected);
            },
            selectSort: function(field, dir) {
                this.set("direction", dir);
                this.select(field);
            },
            triggerChange: function(field, dir) {
                this.trigger(CHANGE_SORT, {
                    field: field,
                    dir: dir
                });
            },
            onSelected: function(e) {
                this.set("value", {
                    id: e.item.id,
                    title: e.item.title
                });
                this.triggerChange(e.item.id, this.direction);
            },
            onToggleDirection: function() {
                this.set("direction", this.direction === "asc" ? "desc" : "asc");
                this.triggerChange(this.value.id, this.direction);
            }
        });
        extend(jyNS, {
            SortViewModel: SortViewModel
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.vm.drag-items", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.vm.base", "kendo.junkyard.data", "kendo.junkyard.constants" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, BaseViewModel = jyNS.BaseViewModel, ItemType = jyNS.ItemType, MenuItemType = jyNS.MenuItemType, DRAGGING = "jy-dragging", DROPPING = "jy-dropping", NODROP_CURSOR = "jy-dragging-cursor--no-drop", DEFAULT_CURSOR = "jy-dragging-cursor--default", COPY_CURSOR = "jy-dragging-cursor--copy", DRAGENTERSTATE = "jy-state-dragenter", TREEVIEW_CONTENT_SELECTOR = "> div > .k-in";
        var DragItemsViewModel = BaseViewModel.extend({
            init: function(options) {
                BaseViewModel.fn.init.call(this, options);
                this._state();
                this._proxy();
            },
            _state: function() {
                this._dragItems = [];
                this._menuTreeExpandedNodes = [];
                this._ctrlPressed = false;
            },
            _proxy: function() {
                this.proxy("onDragHint");
                this.proxy("onDragStart");
                this.proxy("onDragEnd");
                this.proxy("onDragCancel");
                this.proxy("onKeyDown");
                this.proxy("onKeyUp");
                this.proxy("onDragEnter");
                this.proxy("onDragLeave");
                this.proxy("onDrop");
                this.proxy("onPathDragEnter");
                this.proxy("onPathDragLeave");
                this.proxy("onPathDrop");
                this.proxy("onTreeViewDragEnter");
                this.proxy("onTreeViewDragLeave");
                this.proxy("onTreeViewDrop");
            },
            onDragStart: function(e) {
                this._clearSelectionIfDragNoSelected(e);
                this._startDrag(e);
                this._handleCtrlPressed(e.ctrlKey || e.metaKey, e.sender);
            },
            onDragEnd: function(e) {
                this._endDrag(e);
            },
            onDragCancel: function(e) {
                this._endDrag(e);
            },
            onKeyDown: function(e) {
                this._handleCtrlPressed(e.orig.ctrlKey || e.orig.metaKey, e.sender);
            },
            onKeyUp: function(e) {
                this._handleCtrlPressed(e.orig.ctrlKey || e.orig.metaKey, e.sender);
            },
            onDragHint: function(e) {
                var hintData = e.hintData, uid = e.target.data("uid"), itemsVm = this.root.items;
                var targetItems = itemsVm.isSelectedByUid(uid) ? itemsVm.selectedItems : [ itemsVm.dataSource.getByUid(uid) ];
                hintData.objType = this._getHintObjType(targetItems);
                hintData.count = targetItems.length;
            },
            onDragEnter: function(e) {
                if (!this._hasDragging(e.dropTarget)) {
                    this._enableDropping(e.dropTarget, true);
                }
            },
            onDragLeave: function(e) {
                if (!this._hasDragging(e.dropTarget)) {
                    this._enableDropping(e.dropTarget, false);
                }
            },
            onDrop: function(e) {
                var uid = e.dropTarget.data("uid"), itemsVm = this.root.items, dataItem = itemsVm.dataSource.getByUid(uid);
                if (dataItem && !this._hasDragging(e.dropTarget)) {
                    this._enableDropping(e.dropTarget, false);
                    this._runOnDropCommand(dataItem, this._dragItems, this._ctrlPressed);
                }
            },
            onPathDragEnter: function(e) {
                var bindingTarget = e.dropTarget[0].kendoBindingTarget, pathItem = bindingTarget ? bindingTarget.source : null;
                if (pathItem) {
                    var canDrop = this._canDropToPathItem(pathItem);
                    var noDrop = pathItem.menuType === MenuItemType.Menu;
                    pathItem.set("dropping", canDrop);
                    this._enableNoDropCursor(e.currentTarget, noDrop);
                }
            },
            onPathDragLeave: function(e) {
                var bindingTarget = e.dropTarget[0].kendoBindingTarget, pathItem = bindingTarget ? bindingTarget.source : null;
                if (pathItem) {
                    pathItem.set("dropping", false);
                    this._enableNoDropCursor(e.currentTarget, false);
                }
            },
            onPathDrop: function(e) {
                var bindingTarget = e.dropTarget[0].kendoBindingTarget, pathItem = bindingTarget ? bindingTarget.source : null;
                if (pathItem) {
                    pathItem.set("dropping", false);
                    this._enableNoDropCursor(e.currentTarget, false);
                    if (this._canDropToPathItem(pathItem)) {
                        this._runOnDropToMenuItemCommand(pathItem, this._dragItems, this._ctrlPressed);
                    }
                }
            },
            onTreeViewDragEnter: function(e) {
                var menuTree = this.root.menuTree, uid = e.dropTarget.data("uid"), nodeItem = menuTree.findNodeByUid(uid);
                if (nodeItem) {
                    var canDrop = menuTree.isMenuNode(nodeItem) && !menuTree.isTrashMenu(nodeItem) || !menuTree.isMenuNode(nodeItem) && menuTree.canMoveItemsToNode(nodeItem, this._dragItems);
                    this._enableMenuTreeDragEnter(e.dropTarget, true);
                    this._enableNoDropCursor(e.currentTarget, !canDrop);
                    if (canDrop) {
                        this._menuTreeExpandNode(nodeItem);
                    }
                }
            },
            onTreeViewDragLeave: function(e) {
                this._enableMenuTreeDragEnter(e.dropTarget, false);
                this._enableNoDropCursor(e.currentTarget, false);
            },
            onTreeViewDrop: function(e) {
                var menuTree = this.root.menuTree, path = this.root.path, currentDrive = path.currentDrive, currentItem = path.currentItem, uid = e.dropTarget.data("uid"), nodeItem = menuTree.findNodeByUid(uid);
                this._enableMenuTreeDragEnter(e.dropTarget, false);
                this._enableNoDropCursor(e.currentTarget, false);
                if (nodeItem) {
                    if (menuTree.canMoveItemsToNode(nodeItem, this._dragItems)) {
                        var noCollapsedNodes = [ nodeItem ].concat(menuTree.findParentNodes(nodeItem.id, nodeItem.menuType));
                        this._menuTreeRemoveFromExpandedNodes(noCollapsedNodes);
                        if (!menuTree.nodeInCurrentPath(nodeItem, currentDrive, currentItem)) {
                            this._runOnDropToTreeMenuItemCommand(nodeItem, this._dragItems, this._ctrlPressed);
                        }
                    }
                }
            },
            _menuTreeExpandNode: function(node) {
                if (!node.expanded) {
                    node.set("expanded", true);
                    this._menuTreeExpandedNodes.push(node);
                }
            },
            _menuTreeRemoveFromExpandedNodes: function(nodeArray) {
                this._menuTreeExpandedNodes = this._menuTreeExpandedNodes.filter(function(item) {
                    return !nodeArray.some(function(n) {
                        return n.menuType === item.menuType && n.id === item.id;
                    });
                });
            },
            _menuTreeCollapseExpandedNodes: function() {
                this._menuTreeExpandedNodes.forEach(function(node) {
                    node.set("expanded", false);
                });
            },
            _clearSelectionIfDragNoSelected: function(e) {
                var uid = e.currentTarget.data("uid"), itemsVm = this.root.items;
                if (itemsVm.selectedItems.length > 0 && !itemsVm.isSelectedByUid(uid)) {
                    itemsVm.clearSelect();
                }
            },
            _startDrag: function(e) {
                var uid = e.currentTarget.data("uid"), itemsVm = this.root.items;
                this._dragItems = [];
                this._menuTreeExpandedNodes = [];
                if (itemsVm.isSelectedByUid(uid)) {
                    this._dragItems = this._dragItems.concat(itemsVm.selectedItems);
                } else {
                    this._dragItems = [ itemsVm.dataSource.getByUid(uid) ];
                }
                this._enableDragging(e.sender.draggable.element, this._dragItems, true);
                this._enableDefaultCursor(e.originalEvent.currentTarget, true);
            },
            _endDrag: function(e) {
                this._enableDragging(e.sender.draggable.element, this._dragItems, false);
                this._enableDefaultCursor(e.originalEvent.currentTarget, false);
                this._enableCopyCursor(e.originalEvent.currentTarget, false);
                this._menuTreeCollapseExpandedNodes();
                this._dragItems = [];
                this._menuTreeExpandedNodes = [];
            },
            _handleCtrlPressed: function(ctrlPressed, sender) {
                this._ctrlPressed = ctrlPressed;
                this._enableCopyCursor(sender.draggable.userEvents.surface, ctrlPressed);
            },
            _getHintObjType: function(items) {
                var folderCount = items.filter(function(item) {
                    return item.type === ItemType.Folder;
                }).length;
                var fileCount = items.filter(function(item) {
                    return item.type === ItemType.File;
                }).length;
                if (fileCount > 0 && folderCount > 0) {
                    return "mixed";
                } else if (fileCount > 0) {
                    return "file";
                } else if (folderCount > 0) {
                    return "folder";
                }
            },
            _runOnDropCommand: function(dropTargetItem, dragItems, isCopy) {
                var currentDrive = this.root.path.currentDrive;
                var findInDragItems = function(id) {
                    return dragItems.filter(function(dragItem) {
                        return dragItem.id === id;
                    })[0];
                };
                if (findInDragItems(dropTargetItem.id)) {
                    return;
                }
                var itemIds = dragItems.map(function(dragItem) {
                    return dragItem.id;
                });
                if (currentDrive && dropTargetItem && dropTargetItem.type === ItemType.Folder && itemIds.length > 0) {
                    if (isCopy) {
                        this.root.commandService.copyItems(currentDrive.id, dropTargetItem.id, itemIds);
                    } else {
                        this.root.commandService.moveItems(currentDrive.id, dropTargetItem.id, itemIds);
                    }
                }
            },
            _runOnDropToMenuItemCommand: function(menuItem, dragItems, isCopy) {
                var currentDrive = this.root.path.currentDrive;
                var targetDriveId = menuItem.menuType === MenuItemType.Drive ? menuItem.id : null;
                targetDriveId = !targetDriveId && currentDrive ? currentDrive.id : null;
                var targetFolderId = menuItem.menuType === MenuItemType.Item ? menuItem.id : null;
                var findInDragItems = function(id) {
                    return dragItems.filter(function(dragItem) {
                        return dragItem.id === id;
                    })[0];
                };
                if (targetFolderId && findInDragItems(targetFolderId)) {
                    return;
                }
                var itemIds = dragItems.map(function(dragItem) {
                    return dragItem.id;
                });
                if (targetDriveId && itemIds.length > 0) {
                    if (isCopy) {
                        this.root.commandService.copyItems(targetDriveId, targetFolderId, itemIds);
                    } else {
                        this.root.commandService.moveItems(targetDriveId, targetFolderId, itemIds);
                    }
                }
            },
            _runOnDropToTreeMenuItemCommand: function(menuItem, dragItems, isCopy) {
                var targetDriveId = menuItem.menuType === MenuItemType.Drive ? menuItem.id : menuItem.driveId;
                var targetFolderId = menuItem.menuType === MenuItemType.Item ? menuItem.id : null;
                var findInDragItems = function(id) {
                    return dragItems.filter(function(dragItem) {
                        return dragItem.id === id;
                    })[0];
                };
                if (targetFolderId && findInDragItems(targetFolderId)) {
                    return;
                }
                var itemIds = dragItems.map(function(dragItem) {
                    return dragItem.id;
                });
                if (targetDriveId && itemIds.length > 0) {
                    if (isCopy) {
                        this.root.commandService.copyItems(targetDriveId, targetFolderId, itemIds);
                    } else {
                        this.root.commandService.moveItems(targetDriveId, targetFolderId, itemIds);
                    }
                }
            },
            _canDropToPathItem: function(pathItem) {
                return this._canDropToPathFolder(pathItem) || this._canDropToPathDrive(pathItem);
            },
            _canDropToPathFolder: function(pathItem) {
                var currentFolder = this.root.path.currentItem;
                return currentFolder && (pathItem.menuType === MenuItemType.Item && pathItem.id !== currentFolder.id);
            },
            _canDropToPathDrive: function(pathItem) {
                var currentDrive = this.root.path.currentDrive;
                var currentFolder = this.root.path.currentItem;
                return currentFolder && currentDrive && pathItem.menuType === MenuItemType.Drive && currentDrive.id === pathItem.id;
            },
            _enableDragging: function(container, items, enabled) {
                items.forEach(function(item) {
                    var element = container.find("[data-uid='" + item.uid + "']");
                    if (enabled) {
                        element.addClass(DRAGGING);
                    } else {
                        element.removeClass(DRAGGING);
                    }
                });
            },
            _hasDragging: function(element) {
                return element.hasClass(DRAGGING);
            },
            _enableDropping: function(element, enabled) {
                if (enabled) {
                    $(element).addClass(DROPPING);
                } else {
                    $(element).removeClass(DROPPING);
                }
            },
            _enableNoDropCursor: function(element, enabled) {
                if (enabled) {
                    $(element).addClass(NODROP_CURSOR);
                } else {
                    $(element).removeClass(NODROP_CURSOR);
                }
            },
            _enableDefaultCursor: function(element, enabled) {
                if (enabled) {
                    $(element).addClass(DEFAULT_CURSOR);
                } else {
                    $(element).removeClass(DEFAULT_CURSOR);
                }
            },
            _enableCopyCursor: function(element, enabled) {
                if (enabled) {
                    $(element).addClass(COPY_CURSOR);
                } else {
                    $(element).removeClass(COPY_CURSOR);
                }
            },
            _enableMenuTreeDragEnter: function(element, enabled) {
                var innerEl = $(element).find(TREEVIEW_CONTENT_SELECTOR);
                if (enabled) {
                    innerEl.addClass(DRAGENTERSTATE);
                } else {
                    innerEl.removeClass(DRAGENTERSTATE);
                }
            }
        });
        extend(jyNS, {
            DragItemsViewModel: DragItemsViewModel
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.vm.items", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.vm.base", "kendo.junkyard.vm.base-list", "kendo.junkyard.vm.sort", "kendo.junkyard.vm.drag-items", "kendo.junkyard.data", "kendo.junkyard.constants" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, DataSource = kendo.data.DataSource, BaseListViewModel = jyNS.BaseListViewModel, SortViewModel = jyNS.SortViewModel, DragItemsViewModel = jyNS.DragItemsViewModel, ViewType = jyNS.ViewType, ItemType = jyNS.ItemType, ds = jyNS.ds, sortData = jyNS.itemSortData, ItemSortOrder = jyNS.ItemSortOrder, FileHandlerActionTypes = jyNS.FileHandlerActionTypes, CHANGE = "change", PAGE_START = "pageStart", PAGE_END = "pageEnd", CHANGE_SORT = "changeSort";
        var ItemsViewModel = BaseListViewModel.extend({
            init: function(options) {
                BaseListViewModel.fn.init.call(this, options);
                this._state();
                this._proxy();
                this._dataSources();
                this._setupView();
                this._setupEv();
            },
            _state: function() {
                this.set("folders", new DataSource({
                    data: []
                }));
                this.set("files", new DataSource({
                    data: []
                }));
                this.set("gridDataSource", this.nullDataSource);
                this.set("canChangeViewType", true);
                this.set("sort", new SortViewModel(this.options, sortData));
                this.set("drag", new DragItemsViewModel(this.options));
            },
            _proxy: function() {
                this.proxy("_onDataSourceChanged");
                this.proxy("onFolderDoubleClick");
                this.proxy("onFileDoubleClick");
                this.proxy("_onChangeSort");
                this.proxy("onGridSort");
                this.proxy("onDoubleClick");
            },
            _dataSources: function() {
                var itemsOpt = this.widgetOpt.items, auth = this.root.service.auth;
                this.set("dataSource", new ds.ItemDataSource(auth, itemsOpt.readListUrl));
                this.dataSource.bind(PAGE_START, this._onPageStart).bind(PAGE_END, this._onPageEnd);
                this.folders.fetch();
                this.files.fetch();
            },
            _setupView: function() {
                this.onChangeViewType();
            },
            _setupEv: function() {
                this.sort.bind(CHANGE_SORT, this._onChangeSort);
            },
            isFoldersVisible: function() {
                return this.get("folders").total() > 0;
            },
            isFilesVisible: function() {
                return this.get("files").total() > 0;
            },
            previewUrl: function(data) {
                var fileHandler = this.root.fileHandlerService.findFileHandlerByExt(data.extension), action = fileHandler ? fileHandler.findActionByType(FileHandlerActionTypes.SmallPreview) : null;
                return action ? action.makeUrl(data, this.root) || "" : "";
            },
            bindDataSourceChanged: function() {
                this.dataSource.bind(CHANGE, this._onDataSourceChanged);
            },
            unbindDataSourceChanged: function() {
                this.dataSource.unbind(CHANGE, this._onDataSourceChanged);
            },
            lazyCreateBy: function(data) {
                return data.createBy ? this.root.service.api.getUserTitle(data.createBy) : null;
            },
            _onDataSourceChanged: function(e) {
                if (!e.action && e.items) {
                    this.refreshCardItems(e.items);
                }
            },
            refreshCardItems: function(items) {
                this.folders.data(items.filter(function(item) {
                    return item.type === ItemType.Folder;
                }));
                this.files.data(items.filter(function(item) {
                    return item.type === ItemType.File;
                }));
            },
            load: function(driveId, itemId, isDeleted) {
                var ds = this.dataSource, sort = this.sort, itemsOpt = this.widgetOpt.items;
                ds.resetPage();
                ds.paramDriveId = driveId || undefined;
                ds.paramParentId = itemId || undefined;
                ds.paramSortField = sort.value.id;
                ds.paramSortDir = sort.direction;
                ds.paramSearch = undefined;
                ds.paramType = undefined;
                ds.oldParamParentId = undefined;
                ds.isSearching = false;
                ds.changeUrl(isDeleted ? itemsOpt.deletedListUrl : itemsOpt.readListUrl);
                ds.setSortField(this._convertToGridSortField(sort.value.id), sort.direction);
                return ds.abort().read().done(this._updateEmptyVisible);
            },
            sorting: function(field, dir) {
                var ds = this.dataSource;
                ds.paramSortField = field;
                ds.paramSortDir = dir;
                ds.setSortField(this._convertToGridSortField(field), dir);
                return ds.abort().read().done(this._updateEmptyVisible);
            },
            search: function(query) {
                var ds = this.dataSource, itemsOpt = this.widgetOpt.items;
                if (ds.paramParentId) {
                    ds.oldParamParentId = ds.paramParentId;
                }
                ds.resetPage();
                ds.paramParentId = undefined;
                ds.paramSearch = query;
                ds.isSearching = true;
                ds.changeUrl(itemsOpt.searchUrl);
                return ds.abort().read().done(this._updateEmptyVisible);
            },
            resetSearch: function() {
                var ds = this.dataSource, itemsOpt = this.widgetOpt.items;
                ds.resetPage();
                ds.paramParentId = ds.oldParamParentId;
                ds.paramSearch = undefined;
                ds.paramType = undefined;
                ds.isSearching = false;
                ds.changeUrl(itemsOpt.readListUrl);
                return ds.abort().read().done(this._updateEmptyVisible);
            },
            _convertToGridSortField: function(field) {
                switch (field) {
                  case ItemSortOrder.Name:
                    return "title";

                  case ItemSortOrder.Size:
                    return "size";

                  case ItemSortOrder.ModifyDate:
                    return "modifyDate";
                }
                return undefined;
            },
            _convertToSortField: function(gridFeld) {
                switch (gridFeld) {
                  case "title":
                    return ItemSortOrder.Name;

                  case "size":
                    return ItemSortOrder.Size;

                  case "modifyDate":
                    return ItemSortOrder.ModifyDate;
                }
                return undefined;
            },
            _setupCardView: function() {
                this.unbindDataSourceChanged();
                this.bindDataSourceChanged();
                this.set("gridDataSource", this.nullDataSource);
                this.refreshCardItems(this.dataSource.data());
                this.changeDs(this.nullDataSource);
            },
            _setupGridView: function() {
                this.unbindDataSourceChanged();
                this.set("gridDataSource", this.dataSource);
                this.refreshCardItems([]);
                this.changeDs(this.dataSource);
            },
            onChangeViewType: function() {
                if (this.viewType === ViewType.Card) {
                    this._setupCardView();
                } else if (this.viewType === ViewType.Grid) {
                    this._setupGridView();
                }
            },
            onDoubleClick: function(e) {
                if (e.data.type === ItemType.Folder) {
                    this.onFolderDoubleClick(e);
                } else {
                    this.onFileDoubleClick(e);
                }
            },
            onFolderDoubleClick: function(e) {
                if (!e.data.isDeleted()) {
                    this.root.commandService.openFolder(e.data);
                }
            },
            onFileDoubleClick: function(e) {
                var hasActionHandlerPreview = this.widgetOpt.actionFileHandlers.find(function(el) {
                    return el.readOnly && el.extension === e.data.extension;
                });
                if (!e.data.isDeleted()) {
                    hasActionHandlerPreview ? this.root.commandService.actionFile(e.data.driveId, e.data.id, e.data.title, hasActionHandlerPreview) : this.root.commandService.openPreview(e.data);
                }
            },
            onFolderClick: function(e) {
                if (this.isTouchDevice()) {
                    this.onFolderDoubleClick(e);
                }
            },
            isTouchDevice: function() {
                return "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
            },
            onPreviewLoad: function(e) {
                var imgElement = e.currentTarget, model = (imgElement.kendoBindingTarget || {}).source;
                if (model) {
                    model.set("previewVertical", true);
                    model.set("previewLoaded", true);
                }
            },
            _onPageStart: function() {
                this._onShowProgress();
                this.empty();
            },
            _onPageEnd: function() {
                this._onHideProgress();
            },
            _onChangeSort: function(e) {
                this._onShowProgress();
                this.sorting(e.field, e.dir).done(this._onHideProgress).fail(this._onHideProgress);
            },
            _onShowProgress: function() {
                this.root.progressBar.showProgress();
            },
            _onHideProgress: function() {
                this.root.progressBar.hideProgress();
            },
            onGridSort: function(e) {
                e.preventDefault();
                this.sort.selectSort(this._convertToSortField(e.sort.field), e.sort.dir);
            },
            onCreateView: function() {
                this.cardSelectableWidget = $("#jy-widget-items-selectable-" + this.uid).data("kendoJunkyardSelectable");
                this.gridSelectableWidget = $("#jy-widget-item-grid-selectable-" + this.uid).data("kendoJunkyardSelectable");
                this.gridWidget = $("#jy-widget-item-grid-" + this.uid).data("kendoGrid");
            }
        });
        extend(jyNS, {
            ItemsViewModel: ItemsViewModel
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.vm.drives", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.vm.base", "kendo.junkyard.vm.base-list", "kendo.junkyard.vm.sort", "kendo.junkyard.data", "kendo.junkyard.constants" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, BaseListViewModel = jyNS.BaseListViewModel, ViewType = jyNS.ViewType, ds = jyNS.ds, SortViewModel = jyNS.SortViewModel, sortData = jyNS.driveSortData, PAGE_START = "pageStart", PAGE_END = "pageEnd", CHANGE_SORT = "changeSort";
        var DrivesViewModel = BaseListViewModel.extend({
            init: function(options) {
                BaseListViewModel.fn.init.call(this, options);
                this._state();
                this._proxy();
                this._dataSources();
                this._setupView();
                this._setupEv();
            },
            _state: function() {
                this.set("canChangeViewType", false);
                this.set("sort", new SortViewModel(this.options, sortData));
                this.set("cardDataSource", this.nullDataSource);
                this.set("gridDataSource", this.nullDataSource);
            },
            _proxy: function() {
                this.proxy("onDoubleClick");
                this.proxy("_onChangeSort");
                this.proxy("onGridSort");
            },
            _dataSources: function() {
                var drivesOpt = this.widgetOpt.drives, driveIds = this.widgetOpt.driveIds, auth = this.root.service.auth;
                this.set("dataSource", new ds.DriveDataSource(auth, drivesOpt.readListUrl, false, driveIds));
                this.dataSource.bind(PAGE_START, this._onPageStart).bind(PAGE_END, this._onPageEnd);
            },
            _setupEv: function() {
                this.sort.bind(CHANGE_SORT, this._onChangeSort);
            },
            _setupView: function() {
                this.onChangeViewType();
            },
            isDrivesVisible: function() {
                return this.get("dataSource").total() > 0;
            },
            lazyOwnerName: function(data) {
                return data.owner ? this.root.service.api.getUserTitle(data.owner) : null;
            },
            load: function(isShared) {
                var ds = this.dataSource, sort = this.sort;
                ds.resetPage();
                ds.paramIsOwned = !isShared;
                ds.paramIsFavorite = isShared;
                ds.paramSortField = sort.value.id;
                ds.paramSortDir = sort.direction;
                ds.setSortField(this._convertToGridSortField(sort.value.id), sort.direction);
                return ds.abort().read().done(this._updateEmptyVisible);
            },
            sorting: function(field, dir) {
                var ds = this.dataSource;
                ds.paramSortField = field;
                ds.paramSortDir = dir;
                ds.setSortField(this._convertToGridSortField(field), dir);
                return ds.abort().read().done(this._updateEmptyVisible);
            },
            _convertToGridSortField: function(field) {
                switch (field) {
                  case "Title":
                    return "title";
                }
                return undefined;
            },
            _convertToSortField: function(gridFeld) {
                switch (gridFeld) {
                  case "title":
                    return "Title";
                }
                return undefined;
            },
            _setupCardView: function() {
                this.set("cardDataSource", this.dataSource);
                this.set("gridDataSource", this.nullDataSource);
                this.changeDs(this.dataSource);
                this.changeDs(this.nullDataSource);
            },
            _setupGridView: function() {
                this.set("cardDataSource", this.nullDataSource);
                this.set("gridDataSource", this.dataSource);
                this.changeDs(this.dataSource);
                this.changeDs(this.nullDataSource);
            },
            onDoubleClick: function(e) {
                this.root.commandService.openDrive(e.data);
            },
            onDriveClick: function(e) {
                if (this.isTouchDevice()) {
                    this.onDoubleClick(e);
                }
            },
            isTouchDevice: function() {
                return "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
            },
            _onChangeSort: function(e) {
                this._onShowProgress();
                this.sorting(e.field, e.dir).done(this._onHideProgress).fail(this._onHideProgress);
            },
            onChangeViewType: function() {
                if (this.viewType === ViewType.Card) {
                    this._setupCardView();
                } else if (this.viewType === ViewType.Grid) {
                    this._setupGridView();
                }
            },
            onGridSort: function(e) {
                e.preventDefault();
                this.sort.selectSort(this._convertToSortField(e.sort.field), e.sort.dir);
            },
            onCreateView: function() {
                this.cardSelectableWidget = $("#jy-widget-drives-selectable-" + this.uid).data("kendoJunkyardSelectable");
                this.gridSelectableWidget = $("#jy-widget-drive-grid-selectable-" + this.uid).data("kendoJunkyardSelectable");
                this.gridWidget = $("#jy-widget-drive-grid-" + this.uid).data("kendoGrid");
            }
        });
        extend(jyNS, {
            DrivesViewModel: DrivesViewModel
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.vm.toolbar", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.vm.base", "kendo.junkyard.vm.selector", "kendo.junkyard.constants", "kendo.junkyard.models" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, BaseViewModel = jyNS.BaseViewModel, ViewType = jyNS.ViewType, BroadcastEvents = jyNS.BroadcastEvents, SelectorViewModel = jyNS.SelectorViewModel, SELECTED = "selected", createBtnData = jyNS.createBtnData, models = jyNS.models;
        var CreateButtonViewModel = SelectorViewModel.extend({
            init: function(options) {
                SelectorViewModel.fn.init.call(this, options);
                this.set("items", createBtnData);
            }
        });
        var ToolbarViewModel = BaseViewModel.extend({
            init: function(options) {
                BaseViewModel.fn.init.call(this, options);
                this._state();
                this._proxy();
                this._broadcastEvents();
                this._setupEvents();
            },
            _state: function() {
                this.set("canChangeView", false);
                this.set("viewType", ViewType.Card);
                this.set("canShareLink", false);
                this.set("canShare", false);
                this.set("canDelete", false);
                this.set("canOpenActions", false);
                this.set("canShowDetails", false);
                this.set("hasContext", false);
                this.set("createBtn", new CreateButtonViewModel(this.options));
                this.contextModels = [];
            },
            _proxy: function() {
                this.proxy("onExecChangeView");
                this.proxy("onShareLink");
                this.proxy("onShare");
                this.proxy("onDelete");
                this.proxy("onOpenActions");
                this.proxy("onToggleDetails");
                this.proxy("onShare");
                this.proxy("onSelectContext");
                this.proxy("onCreateBtnSelect");
            },
            _setupEvents: function() {
                this.createBtn.bind(SELECTED, this.onCreateBtnSelect);
            },
            _broadcastEvents: function() {
                this.root.service.broadcastOn(BroadcastEvents.SelectContext, this.onSelectContext);
            },
            setContextModels: function(models) {
                this.contextModels = models || [];
                this.updateUI();
            },
            hasContextModels: function() {
                return this.contextModels.length > 0;
            },
            hasManyContext: function() {
                return this.contextModels.length > 1;
            },
            getContextModel: function() {
                return this.contextModels[0];
            },
            setCanChangeView: function(value) {
                this.set("canChangeView", !!value);
            },
            isCardView: function() {
                return this.get("viewType") === ViewType.Card;
            },
            isGridView: function() {
                return this.get("viewType") === ViewType.Grid;
            },
            toggleView: function(viewType) {
                if (viewType === ViewType.Card) {
                    this.set("viewType", ViewType.Grid);
                } else if (viewType === ViewType.Grid) {
                    this.set("viewType", ViewType.Card);
                }
            },
            updateUI: function() {
                var hasContext = this.contextModels.length > 0;
                var hasMany = this.contextModels.length > 1;
                var isDrive = hasContext ? models.isDrive(this.contextModels[0]) : false;
                var isItem = hasContext ? models.isItem(this.contextModels[0]) : false;
                var itemIsDeleted = isItem ? this.contextModels[0].isDeleted() : false;
                var createHandlers = [];
                if (this.widgetOpt.createHandlers) {
                    this.widgetOpt.createHandlers.map(function(handler) {
                        createHandlers.push({
                            id: "createHandler",
                            title: handler.title,
                            icon: handler.icon,
                            modIcon: null,
                            action: handler.action
                        });
                    });
                }
                var updateCreateBtn = this.root.path.currentDrive ? createBtnData.concat(createHandlers) : createBtnData;
                this.createBtn.set("items", updateCreateBtn);
                this.set("canShareLink", false);
                this.set("canShare", false);
                this.set("canDelete", hasContext && !isDrive && !itemIsDeleted);
                this.set("canOpenActions", false);
                this.set("canShowDetails", hasContext);
                this.set("hasContext", hasContext);
            },
            onExecChangeView: function() {
                this.toggleView(this.viewType);
                this.root.commandService.changeView(this.viewType);
            },
            onAddDrive: function() {
                this.root.commandService.addDriveDialog();
            },
            onAddEncryptedDrive: function() {
                this.root.commandService.addDriveDialog({
                    isEncrypted: true
                });
            },
            onCreateFile: function(item) {
                var path = this.root.path;
                this.root.commandService.createFile(path.currentDrive.pathId, path.currentItem ? path.currentItem.pathId : null, item);
            },
            onSelectContext: function(e) {
                this.setContextModels(e.items);
            },
            onCreateBtnSelect: function(e) {
                if (e.item.id === "addDrive") {
                    this.onAddDrive();
                } else if (e.item.id === "addEncryptedDrive") {
                    this.onAddEncryptedDrive();
                } else {
                    this.onCreateFile(e.item);
                }
            },
            onToggleDetails: function() {
                if (this.root.details.opened) {
                    this.root.commandService.closeDetails();
                } else if (this.hasContextModels()) {
                    var model = this.getContextModel();
                    if (model instanceof models.DriveModel) {
                        this.root.commandService.showDriveDetails(model.id, model.title);
                    } else if (model instanceof models.ItemModel) {
                        this.root.commandService.showItemDetails(model.driveId, model.id, model.title, model.type);
                    }
                }
            },
            onDelete: function() {
                if (this.hasContextModels()) {
                    var items = this.contextModels.filter(function(item) {
                        return item instanceof models.ItemModel;
                    });
                    if (items.length > 0) {
                        var itemIds = items.map(function(item) {
                            return item.id;
                        });
                        this.root.commandService.deleteItemsWithConfirm(items[0].driveId, items[0].folderId, itemIds, items[0].type);
                    }
                }
            }
        });
        extend(jyNS, {
            ToolbarViewModel: ToolbarViewModel
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.vm.command-debug", [ "kendo.junkyard.ns", "kendo.junkyard.vm.base", "kendo.junkyard.data", "kendo.junkyard.constants" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, BaseViewModel = jyNS.BaseViewModel;
        var CommandDebugViewModel = BaseViewModel.extend({
            init: function(options) {
                BaseViewModel.fn.init.call(this, options);
                this._state();
                this._proxy();
            },
            _proxy: function() {
                this.proxy("onToggle");
            },
            _state: function() {
                this.set("commands", []);
                var debugPanel = JSON.parse(localStorage.getItem("commandDebugPanel")) || {};
                this.set("opened", !!debugPanel.opened);
                this.set("enabled", this.widgetOpt.debug.command);
            },
            onToggle: function() {
                this.set("opened", !this.get("opened"));
                var debugPanel = JSON.parse(localStorage.getItem("commandDebugPanel")) || {};
                debugPanel.opened = this.get("opened");
                localStorage.setItem("commandDebugPanel", JSON.stringify(debugPanel));
            },
            addCommand: function(command) {
                this.commands.unshift(command);
            },
            lastErrorMessage: function(data) {
                var lastError = data.get("lastError");
                return lastError ? this.root.errorBar.errorMessage(lastError) : "";
            }
        });
        extend(jyNS, {
            CommandDebugViewModel: CommandDebugViewModel
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.vm.upload", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.vm.base", "kendo.junkyard.models" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, bindingTargetSource = jyNS.bindingTargetSource, BaseViewModel = jyNS.BaseViewModel, models = jyNS.models;
        var UploadViewModel = BaseViewModel.extend({
            init: function(options) {
                BaseViewModel.fn.init.call(this, options);
                this._state();
                this._proxy();
            },
            _state: function() {
                this.set("fileListOpened", false);
                this.lastDriveId = null;
                this.lastItemId = null;
                this.uploadWidget = null;
                this._reloadUIDefers = {};
            },
            _proxy: function() {
                this.proxy("onFileSelect");
                this.proxy("onFileUpload");
                this.proxy("onUploadCompleted");
                this.proxy("onFileRemove");
                this.proxy("onFileSuccess");
                this.proxy("onFileCancel");
                this.proxy("onFileError");
                this.proxy("onFileListCreated");
                this.proxy("onFileListDestroyed");
                this.proxy("onDropItem");
                this.proxy("onDropZone");
                this.proxy("onClickInput");
                this.proxy("onRetryUpload");
            },
            setItemId: function(itemId) {
                this.lastItemId = itemId;
            },
            setDriveId: function(driveId) {
                this.lastDriveId = driveId;
            },
            _prepareUploadUrl: function(driveId, folderId) {
                var api = this.root.service.api;
                var asyncOpt = this.uploadWidget.options.async;
                asyncOpt.saveUrl = api.makeUploadFileUrl(driveId, folderId);
            },
            currentDriveId: function() {
                var currentDrive = this.root.path.currentDrive;
                return currentDrive ? currentDrive.id : null;
            },
            currentItemId: function() {
                var currentItem = this.root.path.currentItem;
                return currentItem ? currentItem.id : null;
            },
            showError: function(format, args, reason) {
                var message = kendo.format.apply(null, [ format ].concat(args || []));
                this.root.errorBar.showError(message, null, null, reason);
            },
            clickInput: function(driveId, itemId) {
                if (this.uploadWidget) {
                    this.uploadWidget.element.trigger("click", [ driveId, itemId ]);
                }
            },
            _setFileParams: function(files) {
                var that = this;
                (files || []).forEach(function(file) {
                    file.params = {
                        driveId: that.lastDriveId,
                        itemId: that.lastItemId
                    };
                });
            },
            _uploadFileByUid: function(fileUid) {
                if (this.uploadWidget) {
                    this.uploadWidget.uploadFileByUid(fileUid);
                }
            },
            _cancelUploadByUid: function(fileUid) {
                if (this.uploadWidget) {
                    this.uploadWidget.cancelUploadByUid(fileUid);
                }
            },
            _retryUploadByUid: function(fileUid) {
                if (this.uploadWidget) {
                    this.uploadWidget.retryUploadByUid(fileUid);
                }
            },
            _clearFileByUid: function(fileUid) {
                if (this.uploadWidget) {
                    this.uploadWidget.clearFileByUid(fileUid);
                }
            },
            _changeFileNameByUid: function(fileUid, newName) {
                if (this.uploadWidget) {
                    this.uploadWidget.changeFileNameByUid(fileUid, newName);
                }
            },
            _tryPopulateFormData: function(e) {
                if (this.uploadWidget) {
                    var formData = new FormData(), changed = false, saveField = this.uploadWidget.options.async.saveField, fieldName = this.uploadWidget.name;
                    e.files.forEach(function(file) {
                        if (file.newName) {
                            formData.append(saveField || fieldName, file.rawFile, file.newName);
                            changed = true;
                        }
                    });
                    if (changed) {
                        e.formData = formData;
                    }
                }
            },
            _updateUI: function(file) {
                var params = file.params || {}, driveId = params.driveId || null, itemId = params.itemId || null, currentDriveId = this.currentDriveId(), currentItemId = this.currentItemId();
                if (driveId && currentDriveId === driveId && itemId === currentItemId) {
                    this._reloadUI(driveId, itemId);
                }
            },
            _reloadUI: function(driveId, itemId) {
                var that = this, hash = "" + driveId + itemId, defer = this._reloadUIDefers[hash];
                if (!defer) {
                    var remDefer = function() {
                        delete that._reloadUIDefers[hash];
                    };
                    defer = this.root.commandService.reloadUI(driveId, itemId).done(remDefer).fail(remDefer);
                    this._reloadUIDefers[hash] = defer;
                }
            },
            _preFileUpload: function(file, retry) {
                var that = this, root = this.root, itemService = root.itemService, fileUid = file.uid, fileName = file.name, params = file.params;
                if (params) {
                    itemService.requestUniqName(fileName, params.driveId, params.itemId).done(function(requestedName) {
                        that._changeFileNameByUid(fileUid, requestedName);
                        if (retry) {
                            that._retryUploadByUid(fileUid);
                        } else {
                            that._uploadFileByUid(fileUid);
                        }
                    }).fail(function() {
                        if (retry) {
                            that._retryUploadByUid(fileUid);
                        } else {
                            that._uploadFileByUid(fileUid);
                        }
                    });
                }
            },
            onFileSelect: function(e) {
                var that = this, localization = this.widgetOpt.localization;
                if (!this.lastDriveId) {
                    e.preventDefault();
                    this.showError(localization.driveNotFound);
                } else {
                    e.sender.expandFileList();
                    this._setFileParams(e.files);
                    e.files.forEach(function(file) {
                        that._preFileUpload(file, false);
                    });
                }
            },
            onFileUpload: function(e) {
                var files = e.files, params = files && files[0] ? files[0].params : null;
                if (params) {
                    e.sender.fileListScrollTop();
                    this._prepareUploadUrl(params.driveId, params.itemId);
                    this._tryPopulateFormData(e);
                } else {
                    e.preventDefault();
                }
            },
            onFileSuccess: function(e) {
                if (e.files[0]) {
                    this._updateUI(e.files[0]);
                }
            },
            onFileCancel: function(e) {
                var file = e.files[0], localization = this.widgetOpt.localization;
                this.showError(localization.cancelUpload, [ file.name ]);
            },
            onFileError: function(e) {
                var file = e.files[0], localization = this.widgetOpt.localization;
                if (e.operation === "upload") {
                    var xhr = e.XMLHttpRequest;
                    var message = localization.uploadFailed;
                    if (xhr.status === 403) {
                        message = localization.noAccess;
                    }
                    this.showError(message, [ file.name ], kendo.format(localization.requestFailed, xhr.status, xhr.statusText));
                } else {
                    this.showError(localization.uploadFailed, [ file.name ]);
                }
            },
            onRetryUpload: function(e) {
                var that = this, file = e.files && e.files[0];
                if (file && !file.retryStarted) {
                    e.preventDefault();
                    e.files.forEach(function(file) {
                        file.retryStarted = true;
                        that._preFileUpload(file, true);
                    });
                } else {
                    delete file.retryStarted;
                }
            },
            onUploadCompleted: function() {},
            onFileRemove: function() {},
            onFileListCreated: function() {
                this.set("fileListOpened", true);
            },
            onFileListDestroyed: function() {
                this.set("fileListOpened", false);
            },
            onDropItem: function(e) {
                var model = bindingTargetSource(e.item.closest("[data-uid]")[0]);
                if (models.isDrive(model)) {
                    this.setDriveId(model.id);
                    this.setItemId(this.currentItemId());
                } else if (models.isItem(model)) {
                    this.setDriveId(this.currentDriveId());
                    this.setItemId(model.id);
                }
            },
            onDropZone: function() {
                this.setDriveId(this.currentDriveId());
                this.setItemId(this.currentItemId());
            },
            onClickInput: function(e) {
                var driveId = e.params[0] || this.currentDriveId(), itemId = e.params[1] || this.currentItemId();
                if (driveId) {
                    this.setDriveId(driveId);
                    this.setItemId(itemId);
                } else {
                    e.preventDefault();
                }
            },
            onCreateView: function() {
                this.uploadWidget = $("#jy-widget-upload-" + this.uid).data("kendoJunkyardUpload");
            }
        });
        extend(jyNS, {
            UploadViewModel: UploadViewModel
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.vm.pager", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.vm.base", "kendo.junkyard.constants" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, BaseViewModel = jyNS.BaseViewModel;
        var PagerViewModel = BaseViewModel.extend({
            init: function(options) {
                BaseViewModel.fn.init.call(this, options);
                this._state();
            },
            _state: function() {
                this.set("dataSource", []);
            },
            setDataSource: function(ds) {
                this.set("dataSource", ds);
            }
        });
        extend(jyNS, {
            PagerViewModel: PagerViewModel
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.vm.contextmenu", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.vm.base", "kendo.junkyard.constants", "kendo.junkyard.models" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, BaseViewModel = jyNS.BaseViewModel, utils = jyNS.utils;
        var ContextMenuViewModel = BaseViewModel.extend({
            init: function(options, items) {
                BaseViewModel.fn.init.call(this, options);
                this._state(items || []);
                this._proxy();
            },
            _state: function(items) {
                var itemsWithHandlers = items.slice();
                if (this.widgetOpt.createHandlers) {
                    this.widgetOpt.createHandlers.map(function(handler, index, handlers) {
                        itemsWithHandlers.splice(2 + index, 0, {
                            title: handler.title,
                            command: "menuItemCreateFile",
                            icon: handler.icon,
                            separator: index === handlers.length - 1,
                            enabled: true,
                            visible: true,
                            action: handler.action
                        });
                    });
                }
                if (this.widgetOpt.actionFileHandlers) {
                    this.widgetOpt.actionFileHandlers.map(function(handler, index) {
                        itemsWithHandlers.splice(2 + index, 0, {
                            title: handler.title,
                            command: "menuItemActionFile",
                            icon: handler.icon,
                            separator: false,
                            enabled: true,
                            visible: true,
                            readOnly: handler.readOnly,
                            extension: handler.extension,
                            action: handler.action
                        });
                    });
                }
                this.set("items", new kendo.data.DataSource({
                    data: itemsWithHandlers
                }));
                this.byCommand = null;
                this.contextModels = [];
                this.openTarget = null;
                this.openContextModel = null;
            },
            _proxy: function() {
                this.proxy("onOpen");
                this.proxy("onClose");
                this.proxy("onSelect");
            },
            getByCommand: function() {
                if (this.byCommand == null) {
                    var res = {};
                    this.items.data().forEach(function(item) {
                        res[item.command] = item;
                    });
                    this.byCommand = res;
                }
                return this.byCommand;
            },
            findCommand: function(name) {
                var byCommand = this.getByCommand();
                return byCommand[name];
            },
            enableItem: function(command, value) {
                var byCommand = this.getByCommand();
                if (byCommand[command]) {
                    byCommand[command].set("enabled", !!value);
                }
            },
            currentHandler: function(target) {
                var uid = $(target).closest("[data-uid]").attr("data-uid");
                return this.items.data().find(function(item) {
                    return item.uid === uid;
                });
            },
            visibleHandlers: function(command, value) {
                this.items.data().forEach(function(item) {
                    if (item.command === command) {
                        item.set("visible", !!value);
                    }
                });
            },
            visibleActionHandler: function(command, isFile, value) {
                var extension = isFile ? this.openContextModel.extension : null;
                this.items.data().forEach(function(item) {
                    if (item.command === command) {
                        item.set("visible", !!value);
                        if (item.extension !== extension) {
                            item.set("visible", false);
                        }
                    }
                });
            },
            visibleItem: function(command, value) {
                var byCommand = this.getByCommand();
                if (byCommand[command]) {
                    byCommand[command].set("visible", !!value);
                }
            },
            separatorItem: function(command, value) {
                var byCommand = this.getByCommand();
                if (byCommand[command]) {
                    byCommand[command].set("separator", !!value);
                }
            },
            isAllHidden: function() {
                var byCommand = this.getByCommand();
                return !Object.keys(byCommand).map(function(key) {
                    return byCommand[key].visible;
                }).includes(true);
            },
            disabled: function(data) {
                return !data.get("enabled");
            },
            context: function(models) {
                this.contextModels = models;
            },
            hasContextModels: function() {
                return this.contextModels.length > 0;
            },
            hasManyContextModels: function() {
                return this.contextModels.length > 1;
            },
            hasOneContextModel: function() {
                return this.contextModels.length === 1;
            },
            getFirstContextModel: function() {
                return utils.first(this.contextModels);
            },
            preUpdate: function(openContextModel) {},
            update: function(openContextModel) {},
            postUpdate: function(openContextModel) {},
            findContextModels: function(target) {
                return null;
            },
            findOpenContextModel: function(target) {
                return null;
            },
            onOpen: function(e) {
                var item = e.item, target = e.target, isOpenSubMenu = item && $(item).hasClass("k-item");
                if (isOpenSubMenu) {
                    return;
                }
                var openContextModel = this.findOpenContextModel(target);
                this.openContextModel = openContextModel;
                this.openTarget = target;
                this.preUpdate(openContextModel);
                this.context(this.findContextModels(target));
                this.update(openContextModel);
                this.postUpdate(openContextModel);
                if (this.isAllHidden()) {
                    e.preventDefault();
                }
            },
            onClose: function() {
                this.contextModels = [];
                this.openTarget = null;
                this.openContextModel = null;
            },
            onSelect: function(e) {
                var command = $(e.item).attr("data-command");
                var commandFn = command + "Command";
                if (kendo.isFunction(this[commandFn])) {
                    this[commandFn].call(this, this.contextModels, e.item);
                }
            },
            onCreateView: function() {
                this.contextMenuWidget = $("#jy-context-menu-" + this.uid).data("kendoJunkyardContextMenu");
            },
            onDestroyView: function() {
                if (this.contextMenuWidget) {
                    this.contextMenuWidget.destroy();
                    this.contextMenuWidget = null;
                }
            }
        });
        extend(jyNS, {
            ContextMenuViewModel: ContextMenuViewModel
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.vm.menu-tree-ctx", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.vm.base", "kendo.junkyard.constants", "kendo.junkyard.models", "kendo.junkyard.vm.contextmenu" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, contextMenuData = jyNS.contextMenuData, MenuItemType = jyNS.MenuItemType, ItemType = jyNS.ItemType, MenuIds = jyNS.MenuIds, ContextMenuViewModel = jyNS.ContextMenuViewModel;
        var MenuTreeContextMenuViewModel = ContextMenuViewModel.extend({
            init: function(options) {
                ContextMenuViewModel.fn.init.call(this, options, contextMenuData);
            },
            update: function() {
                var contextModel = this.contextModels[0], hasContext = !!contextModel, isMenu = contextModel ? contextModel.menuType === MenuItemType.Menu : false, isDrive = contextModel ? contextModel.menuType === MenuItemType.Drive : false, isItem = contextModel ? contextModel.menuType === MenuItemType.Item : false, currentUser = this.getCurrentUser(), userIsAdmin = currentUser ? currentUser.isAdmin : false, isTrashMenu = isMenu ? contextModel.id === MenuIds.Trash : false, permission = contextModel ? contextModel.Permission : "";
                this.visibleHandlers("menuItemCreateFile", hasContext && !isMenu && (isDrive || isItem));
                this.visibleHandlers("menuItemActionFile", false);
                this.visibleItem("menuItemAddDrive", !isItem && !isDrive && !isTrashMenu);
                this.visibleItem("menuItemAddFolder", hasContext && !isMenu && (isDrive || isItem));
                this.visibleItem("menuItemUploadFiles", hasContext && !isMenu && (isDrive || isItem));
                this.visibleItem("menuItemShare", hasContext && !isMenu && isDrive);
                this.visibleItem("menuItemShareLink", false);
                this.visibleItem("menuItemRevokeAllUrls", false);
                this.visibleItem("menuItemMove", hasContext && !isMenu && isItem);
                this.visibleItem("menuItemCopy", hasContext && !isMenu && isItem);
                this.visibleItem("menuItemRename", hasContext && !isMenu && (isDrive || isItem));
                this.visibleItem("menuItemOpenDetails", hasContext && !isMenu && (isDrive || isItem));
                this.visibleItem("menuItemDownload", hasContext && !isMenu && isItem);
                this.visibleItem("menuItemDelete", hasContext && (permission === "Admin" && (isDrive || isItem)));
                this.visibleItem("menuItemChangeSize", hasContext && isDrive && userIsAdmin);
                this.visibleItem("menuItemClearTrash", isTrashMenu);
                this.separatorItem("menuItemChangeSize", hasContext && isDrive && userIsAdmin);
            },
            postUpdate: function() {
                if (this.hasContextModels()) {
                    this.focusContextModel(this.getFirstContextModel());
                }
            },
            findContextModels: function(target) {
                var uid = $(target).closest("[data-uid]").attr("data-uid");
                var res = [];
                if (uid) {
                    var dataItem = this.root.menuTree.dataSource.getByUid(uid);
                    if (dataItem) {
                        res.push(dataItem);
                    }
                }
                return res;
            },
            focusContextModel: function(model) {
                this.root.menuTree.focusNode(model);
            },
            isDrive: function(model) {
                return model && model.menuType === MenuItemType.Drive;
            },
            isItem: function(model) {
                return model && model.menuType === MenuItemType.Item;
            },
            getPathItems: function(model) {
                return this.root.menuTree.findParentNodes(model.id, model.menuType).reverse().map(function(path) {
                    return {
                        id: path.id,
                        menuType: path.menuType
                    };
                });
            },
            getCurrentUser: function() {
                return this.root.service.auth.currentUser;
            },
            menuItemAddDriveCommand: function() {
                this.root.commandService.addDriveDialog();
            },
            menuItemOpenDetailsCommand: function() {
                if (this.hasContextModels()) {
                    var model = this.getFirstContextModel();
                    if (this.isDrive(model)) {
                        this.root.commandService.showDriveDetails(model.id, model.title);
                    } else if (this.isItem(model)) {
                        this.root.commandService.showItemDetails(model.driveId, model.id, model.title, ItemType.Folder);
                    }
                }
            },
            menuItemAddFolderCommand: function() {
                if (this.hasContextModels()) {
                    var model = this.getFirstContextModel();
                    if (this.isDrive(model)) {
                        this.root.commandService.addFolderDialog(model.id);
                    } else if (this.isItem(model)) {
                        this.root.commandService.addFolderDialog(model.driveId, model.id);
                    }
                }
            },
            menuItemCreateFileCommand: function(e, target) {
                var currenthandler = this.currentHandler(target), model = this.getFirstContextModel();
                if (this.hasOneContextModel()) {
                    var model = this.getFirstContextModel();
                    if (this.isItem(model)) {
                        this.root.commandService.createFile(model.driveId, model.id, currenthandler);
                    } else if (this.isDrive(model)) {
                        this.root.commandService.createFile(model.id, null, currenthandler);
                    }
                }
            },
            menuItemShareCommand: function() {
                if (this.hasOneContextModel()) {
                    var model = this.getFirstContextModel();
                    if (this.isDrive(model)) {
                        this.root.commandService.shareDriveDialog(model.id);
                    } else if (this.isItem(model)) {
                        this.root.commandService.shareItemDialog(model.driveId, model.id);
                    }
                }
            },
            menuItemUploadFilesCommand: function() {
                if (this.hasOneContextModel()) {
                    var model = this.getFirstContextModel();
                    if (this.isDrive(model)) {
                        this.root.commandService.upload(model.id, null);
                    } else if (this.isItem(model)) {
                        this.root.commandService.upload(model.driveId, model.id);
                    }
                }
            },
            menuItemRenameCommand: function() {
                if (this.hasOneContextModel()) {
                    var model = this.getFirstContextModel();
                    if (this.isDrive(model)) {
                        this.root.commandService.renameDriveDialog(model.id, model.title);
                    } else if (this.isItem(model)) {
                        this.root.commandService.renameItemDialog(model.driveId, model.id, model.title);
                    }
                }
            },
            menuItemMoveCommand: function() {
                if (this.hasOneContextModel()) {
                    var model = this.getFirstContextModel();
                    if (this.isItem(model)) {
                        this.root.commandService.moveDialog([ model.id ], this.getPathItems(model));
                    }
                }
            },
            menuItemCopyCommand: function() {
                if (this.hasOneContextModel()) {
                    var model = this.getFirstContextModel();
                    if (this.isItem(model)) {
                        this.root.commandService.copyDialog([ model.id ], this.getPathItems(model));
                    }
                }
            },
            menuItemDeleteCommand: function() {
                if (this.hasOneContextModel()) {
                    var model = this.getFirstContextModel();
                    if (this.isItem(model)) {
                        this.root.commandService.deleteItemsWithConfirm(model.driveId, model.parentId, [ model.id ], ItemType.Folder);
                    } else if (this.isDrive(model)) {
                        this.root.commandService.deleteDriveByIdDialog(model.id);
                    }
                }
            },
            menuItemDownloadCommand: function() {
                if (this.hasOneContextModel()) {
                    var model = this.getFirstContextModel();
                    if (this.isItem(model)) {
                        this.root.commandService.downloadItem(model.driveId, [ model.id ]);
                    }
                }
            },
            menuItemChangeSizeCommand: function() {
                if (this.hasOneContextModel()) {
                    var model = this.getFirstContextModel();
                    if (this.isDrive(model)) {
                        this.root.commandService.changeDriveSizeDialog(model.id, model.quota);
                    }
                }
            },
            menuItemClearTrashCommand: function() {
                this.root.commandService.сlearTrashDialog();
            }
        });
        extend(jyNS, {
            MenuTreeContextMenuViewModel: MenuTreeContextMenuViewModel
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.vm.main-ctx", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.vm.base", "kendo.junkyard.constants", "kendo.junkyard.models", "kendo.junkyard.vm.contextmenu" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, contextMenuData = jyNS.contextMenuData, models = jyNS.models, ItemType = jyNS.ItemType, MenuIds = jyNS.MenuIds, FileHandlerActionTypes = jyNS.FileHandlerActionTypes, ContextMenuViewModel = jyNS.ContextMenuViewModel;
        var MainContextMenuViewModel = ContextMenuViewModel.extend({
            init: function(options) {
                ContextMenuViewModel.fn.init.call(this, options, contextMenuData);
            },
            update: function(openContextModel) {
                var contextModel = this.contextModels[0], hasContext = this.contextModels.length > 0, hasMany = this.contextModels.length > 1, isDrive = contextModel ? contextModel instanceof models.DriveModel : false, isItem = contextModel ? contextModel instanceof models.ItemModel : false, itemIsDeleted = isItem ? contextModel.isDeleted() : false, isFile = isItem ? contextModel.type === ItemType.File : false, isFolder = isItem ? contextModel.type === ItemType.Folder : false, isItemsVisible = this.root.items.visible, isDrivesVisible = this.root.drives.visible, customAction = this.findCustomAction(openContextModel), isCustomAction = !!customAction, currentUser = this.getCurrentUser(), userIsAdmin = currentUser ? currentUser.isAdmin : false, isTrashMenu = this.root.path.isCurrentBase(MenuIds.Trash), noTrash = !isTrashMenu && !itemIsDeleted, permission = contextModel ? contextModel.permission : "";
                this.visibleHandlers("menuItemCreateFile", !hasMany && (isFolder || isDrive) || !hasContext && isItemsVisible && noTrash);
                this.visibleActionHandler("menuItemActionFile", isFile, !hasMany && isFile && noTrash);
                this.visibleItem("menuItemAddDrive", !hasMany && isDrivesVisible && !isDrive && noTrash);
                this.visibleItem("menuItemAddFolder", !hasMany && (isFolder || isDrive) || !hasContext && isItemsVisible && noTrash);
                this.visibleItem("menuItemUploadFiles", !hasMany && (isFolder || isDrive) || !hasContext && isItemsVisible && noTrash);
                this.visibleItem("menuItemCustom", !hasMany && isFile && isCustomAction && noTrash);
                this.visibleItem("menuItemShare", !hasMany && isDrive && noTrash);
                this.visibleItem("menuItemShareLink", !hasMany && isFile && noTrash);
                this.visibleItem("menuItemRevokeAllUrls", isFile);
                this.visibleItem("menuItemMove", isItem && noTrash);
                this.visibleItem("menuItemCopy", isItem && noTrash);
                this.visibleItem("menuItemRename", !hasMany && hasContext && noTrash);
                this.visibleItem("menuItemOpenDetails", !hasMany && (isItem || isDrive) && noTrash);
                this.visibleItem("menuItemDownload", isItem && noTrash);
                this.visibleItem("menuItemDelete", !hasMany && isFile || permission === "Admin" && (isDrive || isItem));
                this.visibleItem("menuItemChangeSize", !hasMany && isDrive && userIsAdmin && noTrash);
                this.visibleItem("menuItemRestore", itemIsDeleted && isTrashMenu);
                this.separatorItem("menuItemMove", hasMany && isItem && noTrash);
                this.separatorItem("menuItemChangeSize", !hasMany && isDrive && userIsAdmin && noTrash);
                if (isCustomAction) {
                    var customCommand = this.findCommand("menuItemCustom");
                    if (customCommand) {
                        customCommand.set("title", customAction.displayName);
                        customCommand.set("icon", customAction.icon);
                    }
                }
            },
            preUpdate: function(openContextModel) {
                if (openContextModel && !this.isSelected(openContextModel)) {
                    this.select(openContextModel);
                } else if (!openContextModel) {
                    this.clearSelection();
                }
            },
            findContextModels: function(target) {
                var itemsVm = this.root.items, drivesVm = this.root.drives, res = [];
                if (itemsVm.visible && itemsVm.selectedItems.length > 0) {
                    return itemsVm.selectedItems.slice();
                } else if (drivesVm.visible && drivesVm.selectedItems.length > 0) {
                    return drivesVm.selectedItems.slice();
                }
                var contextModel = this.findOpenContextModel(target);
                if (contextModel) {
                    res.push(contextModel);
                }
                return res;
            },
            findOpenContextModel: function(target) {
                var itemsVm = this.root.items, drivesVm = this.root.drives, uid = $(target).closest("[data-uid]").attr("data-uid"), res = null;
                if (uid) {
                    if (itemsVm.visible) {
                        res = itemsVm.dataSource.getByUid(uid);
                    } else if (drivesVm.visible) {
                        res = drivesVm.dataSource.getByUid(uid);
                    }
                }
                return res;
            },
            findCustomAction: function(contextModel) {
                if (this.isItem(contextModel) && contextModel.extension) {
                    var fileHandler = this.root.fileHandlerService.findFileHandlerByExt(contextModel.extension);
                    return fileHandler ? fileHandler.findActionByType(FileHandlerActionTypes.Custom) : null;
                }
                return null;
            },
            select: function(model) {
                if (this.isDrive(model)) {
                    this.root.drives.select([ model ]);
                } else if (this.isItem(model)) {
                    this.root.items.select([ model ]);
                }
            },
            clearSelection: function() {
                var itemsVm = this.root.items, drivesVm = this.root.drives;
                if (drivesVm.visible) {
                    this.root.drives.select([]);
                } else if (itemsVm.visible) {
                    this.root.items.select([]);
                }
            },
            isSelected: function(model) {
                if (this.isDrive(model)) {
                    return this.root.drives.isSelected(model);
                } else if (this.isItem(model)) {
                    return this.root.items.isSelected(model);
                } else {
                    return false;
                }
            },
            isDrive: function(model) {
                return model && model instanceof models.DriveModel;
            },
            isItem: function(model) {
                return model && model instanceof models.ItemModel;
            },
            getCurrentDrive: function() {
                return this.root.path.currentDrive;
            },
            getCurrentItem: function() {
                return this.root.path.currentItem;
            },
            getCurrentDriveId: function() {
                return this.getCurrentDrive() ? this.getCurrentDrive().id : null;
            },
            getCurrentItemId: function() {
                return this.getCurrentItem() ? this.getCurrentItem().id : null;
            },
            getCurrentPathItems: function() {
                return this.root.path.pathItems.map(function(path) {
                    return {
                        id: path.id,
                        menuType: path.menuType
                    };
                });
            },
            getCurrentUser: function() {
                return this.root.service.auth.currentUser;
            },
            menuItemAddDriveCommand: function() {
                this.root.commandService.addDriveDialog();
            },
            menuItemOpenDetailsCommand: function() {
                if (this.hasContextModels()) {
                    var model = this.getFirstContextModel();
                    if (this.isDrive(model)) {
                        this.root.commandService.showDriveDetails(model.id, model.title);
                    } else if (this.isItem(model)) {
                        this.root.commandService.showItemDetails(model.driveId, model.id, model.title, model.type);
                    }
                }
            },
            menuItemCreateFileCommand: function(e, target) {
                var currentDrive, currentItem, currenthandler = this.currentHandler(target), model = this.getFirstContextModel();
                if (this.isDrive(model)) {
                    this.root.commandService.createFile(model.id, null, currenthandler);
                } else if (this.isItem(model)) {
                    currentDrive = this.getCurrentDrive();
                    if (currentDrive) {
                        this.root.commandService.createFile(currentDrive.id, model.id, currenthandler);
                    }
                } else if (!this.hasContextModels()) {
                    currentDrive = this.getCurrentDrive();
                    currentItem = this.getCurrentItem();
                    if (currentDrive) {
                        this.root.commandService.createFile(currentDrive.id, currentItem ? currentItem.id : null, currenthandler);
                    }
                }
            },
            menuItemActionFileCommand: function(e, target) {
                var model = this.getFirstContextModel(), currenthandler = this.currentHandler(target);
                this.root.commandService.actionFile(model.driveId, model.id, model.title, currenthandler);
            },
            menuItemAddFolderCommand: function() {
                var currentDrive, currentItem;
                var model = this.getFirstContextModel();
                if (this.isDrive(model)) {
                    this.root.commandService.addFolderDialog(model.id);
                } else if (this.isItem(model)) {
                    currentDrive = this.getCurrentDrive();
                    if (currentDrive) {
                        this.root.commandService.addFolderDialog(currentDrive.id, model.id);
                    }
                } else if (!this.hasContextModels()) {
                    currentDrive = this.getCurrentDrive();
                    currentItem = this.getCurrentItem();
                    if (currentDrive) {
                        this.root.commandService.addFolderDialog(currentDrive.id, currentItem ? currentItem.id : null);
                    }
                }
            },
            menuItemShareCommand: function() {
                if (this.hasOneContextModel()) {
                    var model = this.getFirstContextModel();
                    if (this.isDrive(model)) {
                        this.root.commandService.shareDriveDialog(model.id);
                    } else if (this.isItem(model)) {
                        this.root.commandService.shareItemDialog(model.driveId, model.id);
                    }
                }
            },
            menuItemShareLinkCommand: function() {
                if (this.hasOneContextModel()) {
                    var model = this.getFirstContextModel();
                    if (this.isItem(model)) {
                        this.root.commandService.shareLinkDialog(model.driveId, model.id);
                    }
                }
            },
            menuItemRevokeAllUrlsCommand: function() {
                if (this.hasOneContextModel()) {
                    var model = this.getFirstContextModel();
                    if (this.isItem(model)) {
                        this.root.commandService.revokeAllUrlsDialog(this.getCurrentDriveId(), model.id);
                    }
                }
            },
            menuItemUploadFilesCommand: function() {
                if (this.hasOneContextModel()) {
                    var model = this.getFirstContextModel();
                    if (this.isDrive(model)) {
                        this.root.commandService.upload(model.id, null);
                    } else if (this.isItem(model) && this.getCurrentDriveId()) {
                        this.root.commandService.upload(this.getCurrentDriveId(), model.id);
                    }
                } else if (!this.hasContextModels() && this.getCurrentDriveId()) {
                    this.root.commandService.upload(this.getCurrentDriveId(), this.getCurrentItemId());
                }
            },
            menuItemRenameCommand: function() {
                if (this.hasOneContextModel()) {
                    var model = this.getFirstContextModel();
                    if (this.isDrive(model)) {
                        this.root.commandService.renameDriveDialog(model.id, model.title);
                    } else if (this.isItem(model) && this.getCurrentDriveId()) {
                        this.root.commandService.renameItemDialog(this.getCurrentDriveId(), model.id, model.title);
                    }
                }
            },
            menuItemMoveCommand: function() {
                if (this.hasContextModels()) {
                    var that = this;
                    var models = this.contextModels.filter(function(model) {
                        return that.isItem(model);
                    });
                    if (models.length > 0) {
                        var itemIds = models.map(function(model) {
                            return model.id;
                        });
                        this.root.commandService.moveDialog(itemIds, this.getCurrentPathItems());
                    }
                }
            },
            menuItemRestoreCommand: function() {
                if (this.hasContextModels()) {
                    var model = this.getFirstContextModel();
                    if (this.isItem(model)) {
                        this.root.commandService.restoreDialog(model.id, this.getCurrentPathItems(), model.title);
                    }
                }
            },
            menuItemCopyCommand: function() {
                if (this.hasContextModels()) {
                    var that = this;
                    var models = this.contextModels.filter(function(model) {
                        return that.isItem(model);
                    });
                    if (models.length > 0) {
                        var itemIds = models.map(function(model) {
                            return model.id;
                        });
                        this.root.commandService.copyDialog(itemIds, this.getCurrentPathItems());
                    }
                }
            },
            menuItemDeleteCommand: function() {
                if (this.hasContextModels()) {
                    var that = this;
                    var items = this.contextModels.filter(function(model) {
                        return that.isItem(model);
                    });
                    if (items.length > 0 && this.getCurrentDriveId()) {
                        var itemIds = items.map(function(model) {
                            return model.id;
                        });
                        var itemType = items[0].type;
                        this.root.commandService.deleteItemsWithConfirm(this.getCurrentDriveId(), this.getCurrentItemId(), itemIds, itemType);
                    } else {
                        var drives = this.contextModels.filter(function(model) {
                            return that.isDrive(model);
                        });
                        if (drives.length > 0) {
                            var driveIds = drives.map(function(model) {
                                return model.id;
                            });
                            this.root.commandService.deleteDriveByIdDialog(driveIds);
                        }
                    }
                }
            },
            menuItemDownloadCommand: function() {
                if (this.hasContextModels()) {
                    var that = this;
                    var models = this.contextModels.filter(function(model) {
                        return that.isItem(model);
                    });
                    if (models.length > 0 && this.getCurrentDriveId()) {
                        var itemIds = models.map(function(model) {
                            return model.id;
                        });
                        this.root.commandService.downloadItem(this.getCurrentDriveId(), itemIds);
                    }
                }
            },
            menuItemCustomCommand: function() {
                if (this.hasOneContextModel()) {
                    var model = this.getFirstContextModel();
                    if (this.isItem(model)) {
                        this.root.commandService.openFile(model, FileHandlerActionTypes.Custom);
                    }
                }
            },
            menuItemChangeSizeCommand: function() {
                if (this.hasOneContextModel()) {
                    var model = this.getFirstContextModel();
                    if (this.isDrive(model)) {
                        this.root.commandService.changeDriveSizeDialog(model.id, model.quota);
                    }
                }
            }
        });
        extend(jyNS, {
            MainContextMenuViewModel: MainContextMenuViewModel
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.vm.details", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.data", "kendo.junkyard.vm.base", "kendo.junkyard.vm.selector", "kendo.junkyard.constants", "kendo.junkyard.models" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, throttle = kendo.throttle, jyNS = ui.junkyard, extend = $.extend, when = $.when, ds = jyNS.ds, ItemType = jyNS.ItemType, BaseViewModel = jyNS.BaseViewModel, BroadcastEvents = jyNS.BroadcastEvents, permissionData = jyNS.permissionData, FileHandlerActionTypes = jyNS.FileHandlerActionTypes, utils = jyNS.utils, models = jyNS.models;
        var SAVE_DELAY = 1500;
        var DetailsViewModel = BaseViewModel.extend({
            init: function(options) {
                BaseViewModel.fn.init.call(this, options);
                this._state();
                this._proxy();
                this._broadcastEvents();
            },
            _state: function() {
                this.set("opened", false);
                this.set("loading", false);
                this.set("details", null);
            },
            _proxy: function() {
                this.proxy("_driveDetailsDone");
                this.proxy("_dirveDetailsFail");
                this.proxy("_itemDetailsDone");
                this.proxy("_itemDetailsFail");
                this.proxy("onSelectContext");
                this.proxy("onItemDescriptionChanged");
                this.itemDescriptionChangedHandler = throttle(this.onItemDescriptionChanged, SAVE_DELAY);
            },
            _broadcastEvents: function() {
                this.root.service.broadcastOn(BroadcastEvents.SelectContext, this.onSelectContext);
            },
            showDrive: function(driveId, title) {
                this.set("opened", true);
                this.setDetailsModel(this.createShortModel(title, true));
                return this.loadDriveDetails(driveId);
            },
            showItem: function(driveId, itemId, title, itemType) {
                this.set("opened", true);
                this.setDetailsModel(this.createShortModel(title, false, itemType === ItemType.File, itemType === ItemType.Folder));
                return this.loadItemDetails(driveId, itemId);
            },
            loadDriveDetails: function(driveId) {
                this.setLoading(true);
                return this.root.service.api.getDriveDetails(driveId).done(this._driveDetailsDone).fail(this._dirveDetailsFail);
            },
            reloadDriveDetails: function() {
                if (this.details) {
                    this.loadDriveDetails(this.details.driveId);
                }
            },
            _driveDetailsDone: function(driveDetails) {
                this.setLoading(false);
                if (driveDetails) {
                    var model = this.createModelFromDriveDetails(driveDetails);
                    this.set("details", model);
                }
            },
            _dirveDetailsFail: function(err) {
                this.setLoading(false);
                throw err;
            },
            loadItemDetails: function(driveId, itemId) {
                this.setLoading(true);
                return when(this.root.service.api.getItemDetails(driveId, itemId), this.root.service.api.getDriveDetails(driveId)).then(function(itemDetails, driveDetails) {
                    if (itemDetails) {
                        itemDetails.driveDetails = driveDetails;
                    }
                    return itemDetails;
                }).done(this._itemDetailsDone).fail(this._itemDetailsFail);
            },
            _itemDetailsDone: function(itemDetails) {
                this.setLoading(false);
                if (itemDetails) {
                    var model = this.createModelFromItemDetails(itemDetails);
                    this.set("details", model);
                }
            },
            _itemDetailsFail: function() {
                this.setLoading(false);
            },
            isOpenedForItems: function(itemIds) {
                var that = this;
                return (itemIds || []).map(function(itemId) {
                    return that.isOpenedForItem(itemId);
                }).indexOf(true) > -1;
            },
            isOpenedForItem: function(itemId) {
                var details = this.details;
                return details && details.isItem && details.id === itemId;
            },
            isOpenedForDrive: function(driveId) {
                var details = this.details;
                return details && details.isDrive && details.id === driveId;
            },
            isOpenedForDrives: function(driveIds) {
                var that = this;
                return (driveIds || []).map(function(driveId) {
                    return that.isOpenedForDrive(driveId);
                }).indexOf(true) > -1;
            },
            setLoading: function(value) {
                this.set("loading", value);
            },
            close: function() {
                this.set("opened", false);
            },
            setDetailsModel: function(model) {
                this.set("details", model);
            },
            createModelFromDriveDetails: function(driveDetails) {
                var driveOpt = this.widgetOpt.drives, quota = driveDetails.quota || 0, usedSpace = driveDetails.usedSpace || 0, freeSpace = usedSpace > quota ? 0 : quota - usedSpace, usedPercent = quota > 0 ? usedSpace * 100 / quota : 1;
                if (usedPercent < 1) {
                    usedPercent = 1;
                }
                if (usedPercent > 100) {
                    usedPercent = 100;
                }
                return {
                    id: driveDetails.id,
                    driveId: driveDetails.id,
                    folderId: null,
                    isDrive: true,
                    isItem: false,
                    isFile: false,
                    isFolder: false,
                    isFileTypeIcon: false,
                    isPreviewLoading: false,
                    previewUrl: "",
                    title: driveDetails.title,
                    label: driveDetails.label,
                    webdavUrl: kendo.format(driveOpt.webdavUrl, driveDetails.label),
                    extension: null,
                    owner: driveDetails.owner,
                    isOwned: driveDetails.isOwned,
                    size: 0,
                    sizeText: null,
                    createDate: null,
                    modifyDate: null,
                    createBy: null,
                    modifyBy: null,
                    access: {
                        enabled: true,
                        isPrivate: !driveDetails.permissions.length,
                        items: driveDetails.permissions
                    },
                    space: {
                        isUnlimited: quota <= 0,
                        quotaTitle: utils.formatSize(quota),
                        freeTitle: utils.formatSize(freeSpace),
                        usedPercent: usedPercent + "%",
                        usedTitle: utils.formatSize(usedSpace),
                        ends: usedPercent >= 90
                    },
                    isEncrypted: driveDetails.isEncrypted,
                    isHistory: driveDetails.isHistory,
                    isTrashBin: driveDetails.isTrashBin,
                    propertyTab: true,
                    historyTab: false,
                    tabsEnabled: false,
                    historyLoading: false,
                    historyLoaded: false,
                    historyDataSource: null,
                    itemModel: null
                };
            },
            createModelFromItemDetails: function(itemDetails) {
                var api = this.root.service.api;
                var auth = this.root.service.auth;
                var itemsOpt = this.widgetOpt.items;
                var currentUser = this.root.service.auth.currentUser;
                var createByMe = currentUser && itemDetails.createBy == currentUser.id;
                var modifyByMe = currentUser && itemDetails.modifyBy == currentUser.id;
                var createByTitle = !createByMe && itemDetails.createBy ? api.getUserTitle(itemDetails.createBy) : null;
                var modifyByTitle = !modifyByMe && itemDetails.modifyBy ? api.getUserTitle(itemDetails.modifyBy) : null;
                var previewUrl = itemDetails.extension ? this.getPreviewImageUrl(itemDetails) : "";
                var isFile = itemDetails.type === ItemType.File;
                var driveDetails = itemDetails.driveDetails;
                var historyDataSource = isFile ? new ds.ItemVersionListDataSource(auth, itemsOpt.versionReadListUrl) : null;
                var itemModel = null;
                var tags = (itemDetails.tags || []).join(",");
                var description = itemDetails.description;
                if (isFile) {
                    itemModel = new models.ItemModel();
                    var jsonData = itemDetails.toJSON();
                    delete jsonData.driveDetails;
                    delete jsonData.permissions;
                    itemModel.accept(jsonData);
                }
                return {
                    id: itemDetails.id,
                    driveId: itemDetails.driveId,
                    folderId: itemDetails.folderId,
                    isDrive: false,
                    isItem: true,
                    isFile: itemDetails.type === ItemType.File,
                    isFolder: itemDetails.type === ItemType.Folder,
                    isFileTypeIcon: isFile && !previewUrl,
                    isPreviewLoading: !!previewUrl,
                    previewUrl: previewUrl,
                    title: itemDetails.title,
                    label: null,
                    webdavUrl: null,
                    extension: itemDetails.extension,
                    owner: itemDetails.createBy,
                    isOwned: currentUser && currentUser.id == itemDetails.createBy,
                    size: itemDetails.size,
                    sizeText: utils.formatSize(itemDetails.size),
                    createDate: itemDetails.createDate ? utils.formatDateTime(itemDetails.createDate) : null,
                    modifyDate: itemDetails.modifyDate ? utils.formatDateTime(itemDetails.modifyDate) : null,
                    modifyDateTime: itemDetails.modifyDate,
                    createBy: createByMe ? "мной" : createByTitle,
                    modifyBy: modifyByMe ? "мной" : modifyByTitle,
                    modifyById: itemDetails.modifyBy,
                    access: {
                        enabled: itemDetails.type === ItemType.File,
                        isPrivate: !itemDetails.permissions.length,
                        items: itemDetails.permissions
                    },
                    space: {},
                    isEncrypted: driveDetails.isEncrypted,
                    isHistory: driveDetails.isHistory,
                    isTrashBin: driveDetails.isTrashBin,
                    propertyTab: true,
                    historyTab: false,
                    tabsEnabled: isFile && driveDetails.isHistory,
                    historyLoading: false,
                    historyLoaded: false,
                    historyDataSource: historyDataSource,
                    itemModel: itemModel,
                    tags: tags,
                    description: description,
                    descriptionSaving: false
                };
            },
            createShortModel: function(title, isDrive, isFile, isFolder) {
                return {
                    isDrive: isDrive,
                    isItem: isFile || isFolder,
                    isFile: isFile,
                    isFolder: isFolder,
                    title: title
                };
            },
            fileTypeIconClass: function() {
                var details = this.get("details");
                return details ? kendo.format("jy-icon-file-{0}", kendo.ui.junkyard.fileTypeIcon(details.extension)) : null;
            },
            fileTypeSvgIconRef: function() {
                var details = this.get("details");
                var iconRef = details ? kendo.format("#jy-icon-file-{0}", kendo.ui.junkyard.fileTypeIcon(details.extension)) : null;
                if (iconRef) {
                    return kendo.format('<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="{0}"></use>', iconRef);
                }
                return "";
            },
            accessTitle: function(data) {
                if (data.title) {
                    return data.title;
                } else if (!data.itemId) {
                    return "Все";
                } else if (data.isUser) {
                    return this.root.service.api.getUserTitle(data.itemId);
                } else {
                    return this.root.service.api.getGroupTitle(data.itemId);
                }
            },
            permissionTitle: function(data) {
                var perm = utils.first(permissionData.filter(function(item) {
                    return item.id === data.permission;
                }));
                return perm ? perm.title : "Неопределено";
            },
            ownerTitle: function() {
                var details = this.get("details");
                var currentUser = this.root.service.auth.currentUser;
                if (details && details.owner) {
                    if (currentUser && details.owner == currentUser.id) {
                        return "я";
                    } else {
                        return this.root.service.api.getUserTitle(details.owner);
                    }
                }
                return "";
            },
            locationTitle: function() {
                var details = this.get("details");
                if (details) {
                    if (details.isDrive) {
                        return details.isOwned ? "Мои диски" : "Общие";
                    } else if (details.isItem) {
                        if (details.folderId && details.driveId) {
                            return this.root.service.api.getItemTitle(details.driveId, details.folderId);
                        } else if (details.driveId) {
                            return this.root.service.api.getDriveTitle(details.driveId);
                        }
                    }
                }
                return "";
            },
            historyModifyDate: function(data) {
                return data.modifyDate ? utils.formatDateTime(data.modifyDate) : null;
            },
            historyModifyBy: function(data) {
                return data.modifyBy ? this.root.service.api.getUserTitle(data.modifyBy) : null;
            },
            getPreviewImageUrl: function(itemDetails) {
                var fileHandler = this.root.fileHandlerService.findFileHandlerByExt(itemDetails.extension), action = fileHandler ? fileHandler.findActionByType(FileHandlerActionTypes.SmallPreview) : null;
                return action ? action.makeUrl(itemDetails, this.root) || "" : "";
            },
            openPropertyTab: function() {
                if (this.details) {
                    this.details.set("propertyTab", true);
                    this.details.set("historyTab", false);
                }
            },
            openHistoryTab: function() {
                if (this.details) {
                    this.details.set("propertyTab", false);
                    this.details.set("historyTab", true);
                    this._loadHistory(this.details);
                }
            },
            _loadHistory: function(details) {
                var that = this, historyDataSource = details.historyDataSource, historyLoaded = details.historyLoaded;
                if (historyDataSource && !historyLoaded) {
                    details.set("historyLoading", true);
                    historyDataSource.paramItemId = details.id;
                    historyDataSource.paramDriveId = details.driveId;
                    historyDataSource.abort().read().done(function() {
                        that._addCurrentVersionToHistory(that.details, historyDataSource);
                        details.set("historyLoaded", true);
                        details.set("historyLoading", false);
                    }).fail(function() {
                        details.set("historyLoaded", false);
                        details.set("historyLoading", false);
                    });
                }
            },
            _addCurrentVersionToHistory: function(details, ds) {
                if (details) {
                    ds.data().unshift(new models.ItemVersionModel({
                        Id: kendo.guid(),
                        version: null,
                        modifyDate: details.modifyDateTime,
                        modifyBy: details.modifyById,
                        isCurrent: true
                    }));
                }
            },
            _selectionAllText: function(input, text) {
                text = text || "";
                if (input && text.length > 0) {
                    input.setSelectionRange(0, text.length);
                }
            },
            onSelectContext: function(e) {
                var contextModel = (e.items || [])[0];
                if (contextModel && this.opened) {
                    if (contextModel instanceof models.DriveModel) {
                        this.showDrive(contextModel.id, contextModel.title);
                    } else if (contextModel instanceof models.ItemModel) {
                        this.showItem(contextModel.driveId, contextModel.id, contextModel.title, contextModel.type);
                    }
                }
            },
            onInputAllSelect: function(e) {
                if (this.details) {
                    this._selectionAllText(e.currentTarget, this.details.webdavUrl);
                }
            },
            onCopyToClipboard: function(e) {
                if (this.details) {
                    var ref = $(e.currentTarget).attr("data-ref");
                    if (ref) {
                        var input = $("#" + ref);
                        if (input.length) {
                            input.focus();
                            this._selectionAllText(input[0], this.details.webdavUrl);
                            document.execCommand("copy");
                            e.currentTarget.focus();
                        }
                    }
                }
            },
            onPreviewLoad: function() {
                if (this.details) {
                    this.details.set("isPreviewLoading", false);
                }
            },
            onOpenPreviewVersion: function(e) {
                if (this.details && this.details.itemModel) {
                    var self = this;
                    var currentHandler = this.widgetOpt.actionFileHandlers.find(function(elm) {
                        return elm.extension === self.details.itemModel.extension && elm.readOnly;
                    });
                    if (currentHandler) {
                        this.root.commandService.actionFile(this.details.itemModel.driveId, this.details.itemModel.id, this.details.itemModel.title, currentHandler, e.data.version);
                    } else {
                        this.root.commandService.openPreview(this.details.itemModel, e.data.version);
                    }
                }
            },
            onRestoreVersion: function(e) {
                var that = this, details = this.details, api = this.root.service.api, errorBar = that.root.errorBar, localization = that.widgetOpt.localization;
                if (details) {
                    details.set("historyLoaded", false);
                    details.set("historyLoading", true);
                    details.historyDataSource.abort().data([]);
                    api.restoreVersion(details.driveId, details.id, e.data.version).done(function() {
                        details.set("historyLoading", false);
                        that._loadHistory(details);
                        errorBar.showSuccess(localization.restoreVersionSuccess);
                    }).fail(function() {
                        details.set("historyLoading", false);
                        that._loadHistory(details);
                        errorBar.showError(localization.restoreVersionFailed);
                    });
                }
            },
            onItemTagsChanged: function(e) {
                var details = this.details, api = this.root.service.api, tags = e.sender.getValue();
                var tagsArray = tags ? tags.split(",") : [];
                api.setItemTags(details.driveId, details.id, tagsArray);
            },
            onItemDescriptionChanged: function(e) {
                var details = this.details, api = this.root.service.api;
                details.set("descriptionSaving", true);
                api.setItemDescription(details.driveId, details.id, details.description).done(function() {
                    details.set("descriptionSaving", false);
                }).fail(function() {
                    details.set("descriptionSaving", false);
                });
            }
        });
        extend(jyNS, {
            DetailsViewModel: DetailsViewModel
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.shadow-router", [ "kendo.junkyard.ns" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, History = kendo.History, CHANGE = "change", BACK = "back", SAME = "same", INIT = "init";
        var ShadowHistoryAdapter = kendo.Class.extend({
            init: function(location) {
                this.location = location;
                this.callback = null;
            },
            back: function() {},
            forward: function() {},
            length: function() {
                return 0;
            },
            replaceLocation: function(url) {
                this.location = url;
                this.dispatchChangeLocation();
            },
            navigate: function(to) {
                this.location = to;
                this.dispatchChangeLocation();
            },
            replace: function(to) {
                this.replaceLocation(to);
            },
            normalize: function(url) {
                return url;
            },
            change: function(callback) {
                this.callback = callback;
            },
            stop: function() {},
            current: function() {
                return this.location;
            },
            normalizeCurrent: function(options) {
                return false;
            },
            dispatchChangeLocation: function() {
                var that = this;
                setTimeout(function() {
                    if (that.callback) {
                        that.callback();
                    }
                }, 0);
            }
        });
        var ShadowHistory = History.extend({
            createAdapter: function(options) {
                return new ShadowHistoryAdapter(options.initLocation);
            }
        });
        var ShadowRouter = kendo.Router.extend({
            init: function(options) {
                kendo.Router.fn.init.call(this, options);
                this.initLocation = (options || {}).initLocation;
                this.history = new ShadowHistory();
            },
            destroy: function() {
                this.history.unbind(CHANGE, this._urlChangedProxy);
                this.history.unbind(SAME, this._sameProxy);
                this.history.unbind(BACK, this._backProxy);
                this.unbind();
            },
            start: function() {
                var that = this, sameProxy = function() {
                    that._same();
                }, backProxy = function(e) {
                    that._back(e);
                }, urlChangedProxy = function(e) {
                    that._urlChanged(e);
                };
                this.history.start({
                    same: sameProxy,
                    change: urlChangedProxy,
                    back: backProxy,
                    pushState: that.pushState,
                    hashBang: that.hashBang,
                    root: that.root,
                    initLocation: that.initLocation
                });
                var initEventObject = {
                    url: this.history.current || "/",
                    preventDefault: $.noop
                };
                if (!that.trigger(INIT, initEventObject)) {
                    that._urlChanged(initEventObject);
                }
                this._urlChangedProxy = urlChangedProxy;
                this._backProxy = backProxy;
            },
            navigate: function(url, silent) {
                this.history.navigate(url, silent);
            },
            replace: function(url, silent) {
                this.history.replace(url, silent);
            }
        });
        extend(jyNS, {
            ShadowRouter: ShadowRouter
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.vm.router", [ "kendo.junkyard.ns", "kendo.junkyard.shadow-router", "kendo.junkyard.vm.base" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, utils = jyNS.utils, MenuIds = jyNS.MenuIds, ShadowRouter = jyNS.ShadowRouter, BaseViewModel = jyNS.BaseViewModel;
        var RouterViewModel = BaseViewModel.extend({
            init: function(options) {
                BaseViewModel.fn.init.call(this, options);
                this._state();
                this._proxy();
                this._routeMap();
            },
            _state: function() {
                if (this.widgetOpt.enableRoutes) {
                    this.router = new kendo.Router({
                        root: this.widgetOpt.router
                    });
                } else {
                    this.router = new ShadowRouter({
                        root: this.widgetOpt.router,
                        initLocation: this.widgetOpt.initLocation
                    });
                }
            },
            _proxy: function() {
                this.proxy("onRouteChanged");
                this.proxy("onRootPath");
                this.proxy("onRouteMissing");
            },
            _routeMap: function() {
                this.router.route("/", this.onRootPath);
                this.router.route("/:startPath(/drive/:driveId)(/folders/:folderId)", this.onRouteChanged);
                this.router.bind("routeMissing", this.onRouteMissing);
            },
            start: function() {
                this.router.start();
            },
            startAsync: function() {
                var that = this;
                utils.async(function() {
                    that.start();
                });
            },
            goToDrive: function(base, driveId, silent) {
                this.router.navigate(kendo.format("/{0}/drive/{1}", base, driveId), silent);
            },
            goToFolder: function(base, driveId, folderId, silent) {
                this.router.navigate(kendo.format("/{0}/drive/{1}/folders/{2}", base, driveId, folderId), silent);
            },
            goToBase: function(base, silent) {
                this.router.navigate(kendo.format("/{0}", base), silent);
            },
            goToItem: function(base, driveId, folderId, silent) {
                if (driveId && folderId) {
                    this.goToFolder(base, driveId, folderId, silent);
                } else if (driveId) {
                    this.goToDrive(base, driveId, silent);
                } else {
                    this.goToBase(base, silent);
                }
            },
            onRouteChanged: function(startPath, driveId, folderId) {
                startPath = (startPath || "").toLowerCase();
                driveId = +driveId || undefined;
                folderId = +folderId || undefined;
                this.root.commandService.openObject(startPath, driveId, folderId);
            },
            onRootPath: function() {
                this.goToBase(MenuIds.My);
            },
            onRouteMissing: function() {
                this.goToBase(MenuIds.My);
            }
        });
        extend(jyNS, {
            RouterViewModel: RouterViewModel
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.vm.path", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.vm.base", "kendo.junkyard.vm.selector", "kendo.junkyard.constants", "kendo.junkyard.models" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, when = $.when, models = jyNS.models, utils = jyNS.utils, convertToPathItem = jyNS.convertToPathItem, rootMenuData = jyNS.rootMenuData, trashMenuModelData = jyNS.trashMenuModelData, MenuItemType = jyNS.MenuItemType, BaseViewModel = jyNS.BaseViewModel;
        var PathViewModel = BaseViewModel.extend({
            init: function(options) {
                BaseViewModel.fn.init.call(this, options);
                this._state();
                this._proxy();
            },
            _state: function() {
                this.set("currentBase", null);
                this.set("currentDrive", null);
                this.set("currentItem", null);
                this.set("pathItems", []);
                this.set("loading", false);
            },
            _proxy: function() {},
            reset: function() {
                this.resetPathItems();
                this.set("currentBase", null);
                this.set("currentDrive", null);
                this.set("currentItem", null);
            },
            load: function(basePath, driveId, itemId) {
                var that = this, path = [], defers = [], basePathItem = this.getBasePathItem(basePath);
                this.reset();
                if (basePathItem) {
                    this.set("currentBase", this.createPathItem(basePathItem.id, basePathItem.title, MenuItemType.Menu));
                    if (!driveId) {
                        path.push(basePathItem);
                    }
                }
                if (driveId) {
                    this.set("currentDrive", this.createPathItem(driveId, null, MenuItemType.Drive));
                    defers.push(this._loadDrivePathItem(driveId).done(function(pathItem) {
                        if (pathItem) {
                            that.currentDrive.set("title", pathItem.title);
                            path.unshift(pathItem);
                        }
                        if (basePathItem) {
                            path.unshift(basePathItem);
                        }
                    }));
                }
                if (driveId && itemId) {
                    this.set("currentItem", this.createPathItem(itemId, null, MenuItemType.Item));
                    defers.push(this._loadItemPath(driveId, itemId).done(function(pathItems) {
                        pathItems = pathItems || [];
                        var currentItem = utils.first(pathItems.filter(function(pathItem) {
                            return pathItem.id === itemId;
                        }));
                        if (currentItem) {
                            that.currentItem.set("title", currentItem.title);
                        }
                        path.push.apply(path, pathItems);
                    }));
                }
                this.set("loading", true);
                return when.apply(null, defers).done(function() {
                    that.set("loading", false);
                    that.setPathItems(path);
                }).fail(function() {
                    that.set("loading", false);
                });
            },
            reload: function() {
                var base = this.currentBase ? this.currentBase.id : null;
                var driveId = this.currentDrive ? this.currentDrive.id : null;
                var itemId = this.currentItem ? this.currentItem.id : null;
                return this.load(base, driveId, itemId);
            },
            includePath: function(id, menuType) {
                return this.pathItems.filter(function(pathItem) {
                    return pathItem.menuType === menuType;
                }).map(function(pathItem) {
                    return pathItem.id === id;
                }).indexOf(true) > -1;
            },
            _loadDrivePathItem: function(driveId) {
                var that = this, api = this.root.service.api;
                return api.getDriveItem(driveId).then(function(resp) {
                    var model = null;
                    if (resp) {
                        var drive = models.toDrive(resp);
                        model = that.createPathItem(drive.id, drive.title, MenuItemType.Drive);
                    }
                    return model;
                });
            },
            _loadItemPath: function(driveId, itemId) {
                var that = this, api = this.root.service.api;
                return api.getItemPath(driveId, itemId).then(function(res) {
                    var path = [], response = (res.response || {}).Path;
                    if (Array.isArray(response)) {
                        path = response.map(models.toItem).map(function(model) {
                            return that.createPathItem(model.id, model.title, MenuItemType.Item);
                        });
                    }
                    return path;
                });
            },
            getBasePathItem: function(basePath) {
                var baseMenuItem = this.findBaseMenuItem(basePath);
                return baseMenuItem ? this.createPathItem(baseMenuItem.Id, baseMenuItem.Title, MenuItemType.Menu) : null;
            },
            findBaseMenuItem: function(basePath) {
                var trashMenuItem = extend({}, trashMenuModelData);
                trashMenuItem.Title = trashMenuItem.title;
                return utils.first(rootMenuData.concat(trashMenuItem).filter(function(item) {
                    return item.Id === basePath;
                }));
            },
            isCurrentBase: function(id) {
                var currentBase = this.get("currentBase");
                return currentBase ? currentBase.id === id : false;
            },
            setPathItems: function(models) {
                this.set("pathItems", (models || []).map(convertToPathItem));
            },
            resetPathItems: function() {
                this.setPathItems([]);
            },
            addPathItem: function(id, title, menuType) {
                this.pathItems.push(this.createPathItem(id, title, menuType));
            },
            removePathItem: function(id, menuType) {
                var toRemove = this.findByIdAndType(id, menuType);
                if (toRemove) {
                    this.pathItems.remove(toRemove);
                }
            },
            findByIdAndType: function(id, menuType) {
                return utils.first(this.pathItems.filter(function(pathItem) {
                    return pathItem.id === id && pathItem.menuType === menuType;
                }));
            },
            createPathItem: function(id, title, menuType) {
                return new models.PathItemModel({
                    pathId: id,
                    title: title,
                    menuType: menuType
                });
            },
            onPathClick: function(e) {
                var router = this.root.router, pathItem = e.data;
                if (pathItem.menuType === MenuItemType.Menu) {
                    router.goToBase(pathItem.id);
                } else if (pathItem.menuType === MenuItemType.Drive) {
                    router.goToDrive(this.currentBase.id, pathItem.id);
                } else if (pathItem.menuType === MenuItemType.Item) {
                    router.goToItem(this.currentBase.id, this.currentDrive.id, pathItem.id);
                }
            }
        });
        extend(jyNS, {
            PathViewModel: PathViewModel
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.vm.search", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.vm.base", "kendo.junkyard.vm.selector", "kendo.junkyard.constants", "kendo.junkyard.models" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, BaseViewModel = jyNS.BaseViewModel, SEARCH = "search", RESET = "reset";
        var SearchViewModel = BaseViewModel.extend({
            init: function(options) {
                BaseViewModel.fn.init.call(this, options);
                this._state();
                this._proxy();
            },
            _state: function() {
                this.set("opened", false);
                this.set("searched", false);
                this.set("query", "");
            },
            _proxy: function() {
                this.proxy("onSearch");
                this.proxy("onReset");
                this.proxy("onOpen");
                this.proxy("onClose");
                this.proxy("onInputFocusOut");
            },
            search: function(query) {
                this.set("searched", true);
                this.root.items.empty().search(query);
                this.trigger(SEARCH, {
                    query: query
                });
            },
            reset: function() {
                var itemsVm = this.root.items;
                if (itemsVm.visible) {
                    itemsVm.empty().resetSearch(true);
                }
                this.set("query", "");
                this.set("searched", false);
                this.trigger(RESET);
            },
            close: function() {
                this.set("query", "");
                this.set("searched", false);
                this.set("opened", false);
            },
            onSearch: function(e) {
                e.preventDefault();
                e.stopPropagation();
                if (!this.query && this.searched) {
                    this.reset();
                } else {
                    this.search(this.query);
                }
            },
            onReset: function() {
                if (this.searched) {
                    this.reset();
                }
            },
            onOpen: function() {
                this.set("opened", true);
                this.set("query", "");
            },
            onClose: function() {
                if (this.searched) {
                    this.reset();
                }
                this.set("opened", false);
            },
            onInputFocusOut: function() {
                this.trimQuery();
                if (!this.query) {
                    this.onClose();
                }
            },
            trimQuery: function() {
                this.set("query", (this.query || "").trim());
            }
        });
        extend(jyNS, {
            SearchViewModel: SearchViewModel
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.vm.selection", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.vm.base", "kendo.junkyard.constants", "kendo.junkyard.models" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, BaseViewModel = jyNS.BaseViewModel, BroadcastEvents = jyNS.BroadcastEvents, ItemType = jyNS.ItemType, modelsUtil = jyNS.models, SELECT = "select";
        var SelectionViewModel = BaseViewModel.extend({
            init: function(options) {
                BaseViewModel.fn.init.call(this, options);
                this._state();
                this._proxy();
                this._broadcastEvents();
            },
            _state: function() {
                this.selectedModels = [];
            },
            _proxy: function() {
                this.proxy("onSelectContext");
            },
            _broadcastEvents: function() {
                this.root.service.broadcastOn(BroadcastEvents.SelectContext, this.onSelectContext);
            },
            setSelectedModels: function(models, noTriggerSelect) {
                this.selectedModels = this._toObject(this._filter(models));
                if (!noTriggerSelect) {
                    this.notifySelect();
                }
            },
            notifySelect: function() {
                this.trigger(SELECT, {
                    items: this.selectedModels.slice()
                });
            },
            onSelectContext: function(e) {
                if (this._canSetSelected()) {
                    this.setSelectedModels(e.items || []);
                }
            },
            _canSetSelected: function() {
                var widgetOpt = this.widgetOpt, selectionExclude = widgetOpt.selectionExclude, path = this.root.path;
                return !selectionExclude || !path.isCurrentBase(selectionExclude);
            },
            _filter: function(models) {
                var widgetOpt = this.widgetOpt, selectionItem = widgetOpt.selectionItem;
                if (selectionItem === "file") {
                    return models.filter(this._filePredicate);
                } else if (selectionItem === "folder") {
                    return models.filter(this._folderPredicate);
                } else if (selectionItem === "disk") {
                    return models.filter(this._diskPredicate);
                }
                return models;
            },
            _toObject: function(models) {
                var that = this;
                return models.map(function(model) {
                    return that._modelId(model.idField, model.toJSON());
                });
            },
            _modelId: function(idField, data) {
                data.id = data[idField];
                return data;
            },
            _folderPredicate: function(model) {
                return model instanceof modelsUtil.ItemModel && model.type === ItemType.Folder;
            },
            _filePredicate: function(model) {
                return model instanceof modelsUtil.ItemModel && model.type === ItemType.File;
            },
            _diskPredicate: function(model) {
                return model instanceof modelsUtil.DriveModel;
            }
        });
        extend(jyNS, {
            SelectionViewModel: SelectionViewModel
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.command.state-handlers", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.constants" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, Class = kendo.Class, jyNS = ui.junkyard, extend = $.extend, progressWaitData = jyNS.progressWaitData, suppressDisplayErrorData = jyNS.suppressDisplayErrorData;
        var BaseCommandStateHandler = Class.extend({
            init: function(rootViewModel) {
                this.root = rootViewModel;
            },
            onCommandStateChanged: function() {}
        });
        var DebugCommandStateHandler = BaseCommandStateHandler.extend({
            init: function(rootViewModel) {
                BaseCommandStateHandler.fn.init.call(this, rootViewModel);
            },
            onCommandStateChanged: function(e) {
                var command = e.sender;
                if (command.isCreated()) {
                    this.root.commandDebug.addCommand(command);
                }
            }
        });
        var ProgressCommandStateHandler = BaseCommandStateHandler.extend({
            init: function(rootViewModel) {
                BaseCommandStateHandler.fn.init.call(this, rootViewModel);
            },
            onCommandStateChanged: function(e) {
                var command = e.sender;
                if (command.isRunning()) {
                    this.root.progressBar.showProgress(this.isProgressWait(command.type));
                } else if (command.isCompleted()) {
                    this.root.progressBar.hideProgress();
                }
            },
            isProgressWait: function(commandType) {
                return !!progressWaitData[commandType];
            }
        });
        var ErrorCommandStateHandler = BaseCommandStateHandler.extend({
            init: function(rootViewModel) {
                BaseCommandStateHandler.fn.init.call(this, rootViewModel);
            },
            onCommandStateChanged: function(e) {
                var command = e.sender;
                if (command.isFailed()) {
                    var localization = this.root.widgetOpt.localization;
                    this.root.errorBar.showError(command.lastError, localization.commandFailed, [ command.type ], null, suppressDisplayErrorData[command.type]);
                }
            }
        });
        extend(jyNS, {
            DebugCommandStateHandler: DebugCommandStateHandler,
            ProgressCommandStateHandler: ProgressCommandStateHandler,
            ErrorCommandStateHandler: ErrorCommandStateHandler
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.vm.access", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.vm.base", "kendo.junkyard.vm.selector", "kendo.junkyard.constants", "kendo.junkyard.models" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, BaseViewModel = jyNS.BaseViewModel, SelectorViewModel = jyNS.SelectorViewModel, permissionData = jyNS.permissionData, ds = jyNS.ds, utils = jyNS.utils, models = jyNS.models, Permissions = jyNS.Permissions, mapper = jyNS.mapper, SELECTED = "selected";
        var PermissionEditorViewModel = SelectorViewModel.extend({
            init: function(options, defaultPermId) {
                SelectorViewModel.fn.init.call(this, options);
                this.proxy("onSelected");
                this.bind(SELECTED, this.onSelected);
                this.set("items", permissionData);
                this.set("value", "");
                this.defaultPermId = defaultPermId;
                if (defaultPermId) {
                    this._select(defaultPermId);
                }
            },
            onSelected: function(e) {
                this.set("value", e.item.title);
            },
            reset: function() {
                SelectorViewModel.fn.reset.call(this);
                if (this.defaultPermId) {
                    this.select(this.defaultPermId);
                }
            }
        });
        var AccessViewModel = BaseViewModel.extend({
            init: function(options) {
                BaseViewModel.fn.init.call(this, options);
                this._state();
                this._proxy();
                this._setupEvents();
            },
            _state: function() {
                var accessOpt = this.widgetOpt.access, auth = this.root.service.auth;
                this.set("accessList", new ds.AccessListDataSource([]));
                this.set("userAndGroups", new ds.UsersAndGroupsDataSource(auth, accessOpt.userAndGroupsReadUrl, false, accessOpt.userAndGroupsConverter, accessOpt.userAndGroupsParamMap, accessOpt.userAndGroupsReadTransport));
                this.set("selectedUserOrGroup", null);
                this.set("accessListLoading", false);
                this.set("addPermissionEditor", new PermissionEditorViewModel(this.options, Permissions.Read));
                this.set("addActionsVisible", false);
                this.permissionEditors = {};
            },
            _proxy: function() {
                this.proxy("onHideAccessListLoading");
                this.proxy("onAddPermissionSelected");
            },
            _setupEvents: function() {
                this.addPermissionEditor.bind(SELECTED, this.onAddPermissionSelected);
            },
            permissionTitle: function(data) {
                var permission = this.findPermission(data.get("permission"));
                return permission ? permission.title : null;
            },
            findPermission: function(permission) {
                return utils.first(permissionData.filter(function(item) {
                    return item.id === permission;
                }));
            },
            makePermissionEditorId: function(data) {
                return "" + data.id + data.isUser;
            },
            createPermissionEditor: function(data) {
                var id = this.makePermissionEditorId(data);
                if (!this.permissionEditors[id]) {
                    this.permissionEditors[id] = new PermissionEditorViewModel(this.options, data.permission);
                    this.permissionEditors[id].bind(SELECTED, function(e) {
                        data.set("permission", e.item.id);
                    });
                }
                return this.permissionEditors[id];
            },
            updateAddActionsVisible: function() {
                var visible = this.addPermissionEditor.selectedItem && this.selectedUserOrGroup;
                this.set("addActionsVisible", visible);
            },
            findAccessItemBy: function(itemId, isUser) {
                var data = this.accessList.data().filter(function(item) {
                    return item.itemId === itemId && item.isUser === isUser;
                });
                return data[0] ? data[0] : null;
            },
            values: function() {
                var accessItems = this.accessList.data();
                return accessItems.toJSON();
            },
            setData: function(data) {
                this.accessList.data(mapper.createAccessItems(data));
            },
            setAccessItems: function(accessItems) {
                this.accessList.data(accessItems);
            },
            accessItemTitle: function(data) {
                if (data.title) {
                    return data.title;
                } else if (!data.itemId) {
                    return "Все";
                } else if (data.isUser) {
                    return this.root.service.api.getUserTitle(data.itemId);
                } else {
                    return this.root.service.api.getGroupTitle(data.itemId);
                }
            },
            cancelAdd: function() {
                this.set("selectedUserOrGroup", null);
                this.addPermissionEditor.reset();
                this.set("addActionsVisible", false);
            },
            onHideAccessListLoading: function() {
                this.set("accessListLoading", false);
            },
            onSelectUserOrGroup: function() {
                this.updateAddActionsVisible();
            },
            onAddPermissionSelected: function() {
                this.updateAddActionsVisible();
            },
            onAddAccess: function() {
                var userOrGroup = this.selectedUserOrGroup, perm = this.addPermissionEditor.selectedItem;
                if (userOrGroup && perm) {
                    var model = new models.AccessItemModel({
                        UniqId: kendo.guid(),
                        itemId: userOrGroup.id,
                        isUser: userOrGroup.isUser,
                        permission: perm.id,
                        title: userOrGroup.title
                    });
                    var accessItem = this.findAccessItemBy(model.itemId, model.isUser);
                    if (!accessItem) {
                        this.accessList.pushCreate(model);
                    }
                    this.cancelAdd();
                }
            },
            onCancelAdd: function() {
                this.cancelAdd();
            },
            onRemoveAccess: function(e) {
                var id = this.makePermissionEditorId(e.data);
                delete this.permissionEditors[id];
                this.accessList.pushDestroy(e.data);
            }
        });
        extend(jyNS, {
            AccessViewModel: AccessViewModel
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.vm.new-drive-dialog", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.vm.base", "kendo.junkyard.vm.access", "kendo.junkyard.constants" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, BaseViewModel = jyNS.BaseViewModel, AccessViewModel = jyNS.AccessViewModel, CLOSE = "close";
        var NewDriveDialogViewModel = BaseViewModel.extend({
            init: function(flags, options) {
                BaseViewModel.fn.init.call(this, options);
                this._state(flags);
                this._proxy();
                this._setupEvents();
            },
            _state: function(flags) {
                flags = flags || {};
                this.set("title", "");
                this.set("isEncrypted", !!flags.isEncrypted);
                this.set("isHistory", !!flags.isHistory);
                this.set("isTrashBin", !!flags.isTrashBin);
                this.set("titleInputFocus", false);
                this.set("accessSettings", new AccessViewModel(this.options));
            },
            _proxy: function() {},
            _setupEvents: function() {
                var that = this;
                this.bind("afterOpenDialog", function() {
                    that.set("titleInputFocus", true);
                });
            },
            isSaveable: function(title) {
                return !/[<>\/|\\?*"':]/.test(title);
            },
            isValid: function() {
                return this.get("title") !== "" && this.isSaveable(this.get("title")) && !this.get("accessSettings.accessListLoading");
            },
            onOk: function() {
                if (this.isValid()) {
                    this.root.commandService.addDrive(this.title, this.accessSettings.values(), {
                        isEncrypted: this.isEncrypted,
                        isHistory: this.isHistory,
                        isTrashBin: this.isTrashBin
                    });
                    this.close();
                }
            },
            onCancel: function() {
                this.close();
            },
            close: function() {
                this.trigger(CLOSE);
            }
        });
        extend(jyNS, {
            NewDriveDialogViewModel: NewDriveDialogViewModel
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.vm.new-folder-dialog", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.vm.base", "kendo.junkyard.vm.access", "kendo.junkyard.constants" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, BaseViewModel = jyNS.BaseViewModel, CLOSE = "close";
        var NewFolderDialogViewModel = BaseViewModel.extend({
            init: function(driveId, parentId, options) {
                BaseViewModel.fn.init.call(this, options);
                this._state(driveId, parentId);
                this._proxy();
                this._setupEvents();
            },
            _state: function(driveId, parentId) {
                this.set("title", "");
                this.set("titleInputFocus", false);
                this.set("driveId", driveId);
                this.set("parentId", parentId);
            },
            _proxy: function() {},
            _setupEvents: function() {
                var that = this;
                this.bind("afterOpenDialog", function() {
                    that.set("titleInputFocus", true);
                });
            },
            isSaveable: function(title) {
                return !/[<>\/|\\?*"':]/.test(title);
            },
            isValid: function() {
                return this.get("title") !== "" && this.isSaveable(this.get("title")) && this.get("driveId") != null;
            },
            onOk: function() {
                if (this.isValid()) {
                    this.root.commandService.addFolder(this.driveId, this.parentId, this.title);
                    this.close();
                }
            },
            onCancel: function() {
                this.close();
            },
            close: function() {
                this.trigger(CLOSE);
            }
        });
        extend(jyNS, {
            NewFolderDialogViewModel: NewFolderDialogViewModel
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.vm.share-drive-dialog", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.vm.base", "kendo.junkyard.vm.access", "kendo.junkyard.constants" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, BaseViewModel = jyNS.BaseViewModel, AccessViewModel = jyNS.AccessViewModel, CLOSE = "close";
        var ShareDriveDialogViewModel = BaseViewModel.extend({
            init: function(driveId, options) {
                BaseViewModel.fn.init.call(this, options);
                this._state(driveId);
                this._proxy();
            },
            _state: function(driveId) {
                this.set("driveId", driveId);
                this.set("driveTitle", null);
                this.set("accessSettings", new AccessViewModel(this.options));
            },
            _proxy: function() {
                this.proxy("_onFetchDetailsDone");
            },
            load: function() {
                this.accessSettings.set("accessListLoading", true);
                return this.root.service.api.getDriveDetails(this.driveId).done(this._onFetchDetailsDone).done(this.accessSettings.onHideAccessListLoading).fail(this.accessSettings.onHideAccessListLoading);
            },
            _onFetchDetailsDone: function(driveDetails) {
                if (driveDetails) {
                    this.set("driveTitle", driveDetails.title);
                    this.accessSettings.setAccessItems(driveDetails.permissions);
                }
            },
            isValid: function() {
                return this.get("driveId") && this.get("driveTitle") && !this.get("accessSettings.accessListLoading");
            },
            onOk: function() {
                if (this.isValid()) {
                    this.root.commandService.updateDrive(this.driveId, this.driveTitle, this.accessSettings.values());
                    this.close();
                }
            },
            onCancel: function() {
                this.close();
            },
            close: function() {
                this.trigger(CLOSE);
            }
        });
        extend(jyNS, {
            ShareDriveDialogViewModel: ShareDriveDialogViewModel
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.vm.share-item-dialog", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.vm.base", "kendo.junkyard.vm.access", "kendo.junkyard.constants" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, BaseViewModel = jyNS.BaseViewModel, AccessViewModel = jyNS.AccessViewModel, CLOSE = "close";
        var ShareItemDialogViewModel = BaseViewModel.extend({
            init: function(driveId, itemId, options) {
                BaseViewModel.fn.init.call(this, options);
                this._state(driveId, itemId);
                this._proxy();
            },
            _state: function(driveId, itemId) {
                this.set("driveId", driveId);
                this.set("itemId", itemId);
                this.set("accessSettings", new AccessViewModel(this.options));
            },
            _proxy: function() {},
            load: function() {
                return $.Deferred().resolve().promise();
            },
            isValid: function() {
                return this.get("driveId") && this.get("itemId") && !this.get("accessSettings.accessListLoading");
            },
            onOk: function() {
                if (this.isValid()) {
                    this.close();
                }
            },
            onCancel: function() {
                this.close();
            },
            close: function() {
                this.trigger(CLOSE);
            }
        });
        extend(jyNS, {
            ShareItemDialogViewModel: ShareItemDialogViewModel
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.vm.rename-drive-dialog", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.vm.base", "kendo.junkyard.vm.access", "kendo.junkyard.constants" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, BaseViewModel = jyNS.BaseViewModel, CLOSE = "close";
        var RenameDriveDialogViewModel = BaseViewModel.extend({
            init: function(driveId, title, options) {
                BaseViewModel.fn.init.call(this, options);
                this._state(driveId, title);
                this._proxy();
                this._setupEvents();
            },
            _state: function(driveId, title) {
                this.set("title", title);
                this.set("titleInputFocus", false);
                this.set("driveId", driveId);
            },
            _proxy: function() {},
            _setupEvents: function() {
                var that = this;
                this.bind("afterOpenDialog", function() {
                    that.set("titleInputFocus", true);
                });
            },
            isSaveable: function(title) {
                return !/[<>\/|\\?*"':]/.test(title);
            },
            isValid: function() {
                return this.get("title") !== "" && this.isSaveable(this.get("title")) && this.get("driveId") != null;
            },
            onOk: function() {
                if (this.isValid()) {
                    this.root.commandService.renameDrive(this.driveId, this.title);
                    this.close();
                }
            },
            onCancel: function() {
                this.close();
            },
            close: function() {
                this.trigger(CLOSE);
            }
        });
        extend(jyNS, {
            RenameDriveDialogViewModel: RenameDriveDialogViewModel
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.vm.rename-item-dialog", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.vm.base", "kendo.junkyard.vm.access", "kendo.junkyard.constants" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, BaseViewModel = jyNS.BaseViewModel, CLOSE = "close";
        var RenameItemDialogViewModel = BaseViewModel.extend({
            init: function(driveId, itemId, title, options) {
                BaseViewModel.fn.init.call(this, options);
                this._state(driveId, itemId, title);
                this._proxy();
                this._setupEvents();
            },
            _state: function(driveId, itemId, title) {
                this.set("title", title);
                this.set("titleInputFocus", false);
                this.set("itemId", itemId);
                this.set("driveId", driveId);
            },
            _proxy: function() {},
            _setupEvents: function() {
                var that = this;
                this.bind("afterOpenDialog", function() {
                    that.set("titleInputFocus", true);
                });
            },
            isSaveable: function(title) {
                return !/[<>\/|\\?*"':]/.test(title);
            },
            isValid: function() {
                return this.get("title") !== "" && this.isSaveable(this.get("title")) && this.get("itemId") != null && this.get("driveId") != null;
            },
            onOk: function() {
                if (this.isValid()) {
                    this.root.commandService.renameItem(this.driveId, this.itemId, this.title);
                    this.close();
                }
            },
            onCancel: function() {
                this.close();
            },
            close: function() {
                this.trigger(CLOSE);
            }
        });
        extend(jyNS, {
            RenameItemDialogViewModel: RenameItemDialogViewModel
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.vm.folder-chooser", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.vm.base", "kendo.junkyard.constants", "kendo.junkyard.data" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, ds = jyNS.ds, BaseViewModel = jyNS.BaseViewModel, MenuItemType = jyNS.MenuItemType, utils = jyNS.utils, SELECT = "select", CREATE_VIEW = "createView";
        var FolderChooserViewModel = BaseViewModel.extend({
            init: function(options) {
                BaseViewModel.fn.init.call(this, options);
                this._state();
                this._proxy();
                this._dataSource();
                this._setupEvents();
            },
            _state: function() {
                this.set("dataSource", []);
                this.set("selectedItem", null);
                this.treeViewWidget = null;
            },
            _proxy: function() {
                this.proxy("onCreateView");
            },
            _dataSource: function() {
                var drivesOpt = this.widgetOpt.drives, itemsOpt = this.widgetOpt.items, auth = this.root.service.auth, driveIds = this.widgetOpt.driveIds;
                this.set("dataSource", new ds.RootHierarchyDataSource(auth, {
                    readDriveListUrl: drivesOpt.readListUrl,
                    readItemListUrl: itemsOpt.readListUrl
                }, driveIds));
            },
            _setupEvents: function() {
                this.bind(CREATE_VIEW, this.onCreateView);
            },
            _expandPath: function(path, complete) {
                if (!this.treeViewWidget) {
                    return;
                }
                var that = this;
                var pathIds = path.map(function(item) {
                    return item.id;
                });
                this.treeViewWidget.expandPath(pathIds, function() {
                    var lastItem = path[path.length - 1];
                    if (lastItem) {
                        that._select(lastItem.id, lastItem.menuType);
                    }
                    if (complete) {
                        complete();
                    }
                });
            },
            _select: function(menuId, menuType) {
                var treeView = this.treeViewWidget;
                var dataItem = this.dataSource.recursiveFindByIdAndType(menuId, menuType);
                if (dataItem) {
                    treeView.select(treeView.findByUid(dataItem.uid));
                }
            },
            load: function(initPath, constraintByInitPath) {
                var that = this;
                return this.dataSource.read().done(function() {
                    if (initPath) {
                        that._expandPath(initPath, function() {
                            if (constraintByInitPath) {
                                that._filterDataSource(initPath);
                            }
                        });
                    }
                });
            },
            _filterDataSource: function(initPath) {
                var menu = initPath[0];
                var drive = initPath[1];
                var filter = {
                    logic: "or",
                    filters: []
                };
                if (drive && menu) {
                    filter.filters.push({
                        logic: "and",
                        filters: [ {
                            field: "id",
                            operator: "eq",
                            value: menu.id
                        }, {
                            field: "menuType",
                            operator: "eq",
                            value: MenuItemType.Menu
                        } ]
                    });
                    filter.filters.push({
                        logic: "and",
                        filters: [ {
                            field: "id",
                            operator: "eq",
                            value: drive.id
                        }, {
                            field: "menuType",
                            operator: "eq",
                            value: MenuItemType.Drive
                        } ]
                    });
                    filter.filters.push({
                        logic: "and",
                        filters: [ {
                            field: "menuType",
                            operator: "eq",
                            value: MenuItemType.Item
                        } ]
                    });
                    this.dataSource.filter(filter);
                } else if (menu) {
                    filter.filters.push({
                        logic: "and",
                        filters: [ {
                            field: "id",
                            operator: "eq",
                            value: menu.id
                        }, {
                            field: "menuType",
                            operator: "eq",
                            value: MenuItemType.Menu
                        } ]
                    });
                    filter.filters.push({
                        logic: "and",
                        filters: [ {
                            field: "menuType",
                            operator: "eq",
                            value: MenuItemType.Drive
                        } ]
                    });
                    filter.filters.push({
                        logic: "and",
                        filters: [ {
                            field: "menuType",
                            operator: "eq",
                            value: MenuItemType.Item
                        } ]
                    });
                    this.dataSource.filter(filter);
                }
            },
            findDriveByItemId: function(itemId) {
                var parents = this.dataSource.findParentsByIdAndType(itemId, MenuItemType.Item);
                return utils.first(parents.filter(function(parent) {
                    return parent.menuType === MenuItemType.Drive;
                }));
            },
            findDriveIdByItemId: function(itemId) {
                var drive = this.findDriveByItemId(itemId);
                return drive ? drive.id : null;
            },
            findParentNodes: function(nodeId, nodeType) {
                return this.dataSource.findParentsByIdAndType(nodeId, nodeType);
            },
            findParentItems: function(nodeId, nodeType) {
                return this.findParentNodes(nodeId, nodeType).filter(function(parentNode) {
                    return parentNode.menuType === MenuItemType.Item;
                });
            },
            findParentItemIds: function(nodeId, nodeType) {
                return this.findParentItems(nodeId, nodeType).map(function(parentNode) {
                    return parentNode.id;
                });
            },
            onSelect: function(e) {
                var treeView = e.sender;
                var currentNode = treeView.select();
                var dataItem = treeView.dataItem(currentNode);
                if (dataItem && (dataItem.menuType === MenuItemType.Item || dataItem.menuType === MenuItemType.Drive)) {
                    this.set("selectedItem", {
                        id: dataItem.id,
                        title: dataItem.title,
                        type: dataItem.menuType,
                        menuType: dataItem.menuType
                    });
                } else {
                    this.set("selectedItem", null);
                }
                this.trigger(SELECT, {
                    item: this.selectedItem
                });
            },
            onCreateView: function() {
                this.treeViewWidget = $("#jy-tree-view-" + this.uid).data("kendoJunkyardTreeView");
            }
        });
        extend(jyNS, {
            FolderChooserViewModel: FolderChooserViewModel
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.vm.move-item-dialog", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.vm.base", "kendo.junkyard.vm.access", "kendo.junkyard.constants", "kendo.junkyard.vm.folder-chooser" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, BaseViewModel = jyNS.BaseViewModel, MenuItemType = jyNS.MenuItemType, FolderChooserViewModel = jyNS.FolderChooserViewModel, CLOSE = "close";
        var MoveItemDialogViewModel = BaseViewModel.extend({
            init: function(itemIds, initPath, options) {
                BaseViewModel.fn.init.call(this, options);
                this._state(itemIds, initPath);
                this._proxy();
            },
            _state: function(itemIds, initPath) {
                this.set("itemIds", itemIds);
                this.set("initPath", initPath);
                this.set("folderChooser", new FolderChooserViewModel(this.options));
            },
            _proxy: function() {
                this.proxy("_findParentItemIds");
            },
            _selectedDriveId: function() {
                var selectedItem = this.folderChooser.selectedItem;
                if (selectedItem.type === MenuItemType.Drive) {
                    return selectedItem.id;
                } else if (selectedItem.type === MenuItemType.Item) {
                    return this.folderChooser.findDriveIdByItemId(selectedItem.id);
                }
                return null;
            },
            _selectedFolderId: function() {
                var selectedItem = this.folderChooser.selectedItem;
                return selectedItem.type === MenuItemType.Item ? selectedItem.id : null;
            },
            _selectedItemIds: function() {
                return this.itemIds.map(function(val) {
                    return val;
                });
            },
            _getInitDrive: function() {
                return this.initPath.length > 0 && this.initPath[1] && this.initPath[1].menuType === MenuItemType.Drive ? this.initPath[1] : null;
            },
            _getInitFolder: function() {
                var lastIndex = this.initPath.length - 1;
                return this.initPath.length > 0 && this.initPath[lastIndex] && this.initPath[lastIndex].menuType === MenuItemType.Item ? this.initPath[lastIndex] : null;
            },
            _findParentItemIds: function(nodeId, nodeType) {
                return this.folderChooser.findParentItemIds(nodeId, nodeType);
            },
            _canMoveTo: function(nodeItem, itemIds) {
                var menuTree = this.root.menuTree, itemObjs = itemIds.map(function(itemId) {
                    return {
                        id: itemId
                    };
                }), initDrive = this._getInitDrive(), initFolder = this._getInitFolder();
                if (initDrive && nodeItem) {
                    return menuTree.canMoveItemsToNode(nodeItem, itemObjs, this._findParentItemIds) && !menuTree.nodeInCurrentPath(nodeItem, initDrive, initFolder);
                }
                return false;
            },
            isValid: function() {
                return this.get("folderChooser.selectedItem") && this.get("itemIds").length > 0 && this._canMoveTo(this.folderChooser.selectedItem, this.itemIds);
            },
            onOk: function() {
                if (this.isValid()) {
                    this.root.commandService.moveItems(this._selectedDriveId(), this._selectedFolderId(), this._selectedItemIds());
                    this.close();
                }
            },
            onCancel: function() {
                this.close();
            },
            close: function() {
                this.trigger(CLOSE);
            },
            onCreateFolderChooser: function() {
                this.folderChooser.load(this.initPath);
            }
        });
        extend(jyNS, {
            MoveItemDialogViewModel: MoveItemDialogViewModel
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.vm.restore-item-dialog", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.vm.base", "kendo.junkyard.vm.access", "kendo.junkyard.constants", "kendo.junkyard.vm.folder-chooser" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, BaseViewModel = jyNS.BaseViewModel, MenuItemType = jyNS.MenuItemType, FolderChooserViewModel = jyNS.FolderChooserViewModel, CLOSE = "close";
        var RestoreItemDialogViewModel = BaseViewModel.extend({
            init: function(itemId, initPath, name, options) {
                BaseViewModel.fn.init.call(this, options);
                this._state(itemId, initPath, name);
                this._proxy();
                this._setupEvents();
            },
            _state: function(itemId, initPath, name) {
                this.set("itemId", itemId);
                this.set("name", name);
                this.set("initPath", initPath);
                this.set("titleInputFocus", false);
                this.set("folderChooser", new FolderChooserViewModel(this.options));
            },
            _proxy: function() {
                this.proxy("_findParentItemIds");
            },
            _setupEvents: function() {
                var that = this;
                this.bind("afterOpenDialog", function() {
                    that.set("titleInputFocus", true);
                });
            },
            _selectedDriveId: function() {
                var selectedItem = this.folderChooser.selectedItem;
                if (selectedItem.type === MenuItemType.Drive) {
                    return selectedItem.id;
                } else if (selectedItem.type === MenuItemType.Item) {
                    return this.folderChooser.findDriveIdByItemId(selectedItem.id);
                }
                return null;
            },
            _selectedFolderId: function() {
                var selectedItem = this.folderChooser.selectedItem;
                return selectedItem.type === MenuItemType.Item ? selectedItem.id : null;
            },
            _findParentItemIds: function(nodeId, nodeType) {
                return this.folderChooser.findParentItemIds(nodeId, nodeType);
            },
            isValid: function() {
                return this.get("folderChooser.selectedItem") && this.get("name") !== "";
            },
            onOk: function() {
                if (this.isValid()) {
                    this.root.commandService.restoreItems(this._selectedDriveId(), this._selectedFolderId(), this.get("itemId"), this.get("name"));
                    this.close();
                }
            },
            onCancel: function() {
                this.close();
            },
            close: function() {
                this.trigger(CLOSE);
            },
            onCreateFolderChooser: function() {
                this.folderChooser.load(this.initPath);
            }
        });
        extend(jyNS, {
            RestoreItemDialogViewModel: RestoreItemDialogViewModel
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.vm.copy-item-dialog", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.vm.base", "kendo.junkyard.vm.access", "kendo.junkyard.constants", "kendo.junkyard.vm.folder-chooser" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, BaseViewModel = jyNS.BaseViewModel, MenuItemType = jyNS.MenuItemType, FolderChooserViewModel = jyNS.FolderChooserViewModel, CLOSE = "close";
        var CopyItemDialogViewModel = BaseViewModel.extend({
            init: function(itemIds, initPath, options) {
                BaseViewModel.fn.init.call(this, options);
                this._state(itemIds, initPath);
                this._proxy();
            },
            _state: function(itemIds, initPath) {
                this.set("itemIds", itemIds);
                this.set("initPath", initPath);
                this.set("folderChooser", new FolderChooserViewModel(this.options));
            },
            _proxy: function() {
                this.proxy("_findParentItemIds");
            },
            _selectedDriveId: function() {
                var selectedItem = this.folderChooser.selectedItem;
                if (selectedItem.type === MenuItemType.Drive) {
                    return selectedItem.id;
                } else if (selectedItem.type === MenuItemType.Item) {
                    return this.folderChooser.findDriveIdByItemId(selectedItem.id);
                }
                return null;
            },
            _selectedFolderId: function() {
                var selectedItem = this.folderChooser.selectedItem;
                return selectedItem.type === MenuItemType.Item ? selectedItem.id : null;
            },
            _selectedItemIds: function() {
                return this.itemIds.map(function(val) {
                    return val;
                });
            },
            _getInitDrive: function() {
                return this.initPath.length > 0 && this.initPath[1] && this.initPath[1].menuType === MenuItemType.Drive ? this.initPath[1] : null;
            },
            _getInitFolder: function() {
                var lastIndex = this.initPath.length - 1;
                return this.initPath.length > 0 && this.initPath[lastIndex] && this.initPath[lastIndex].menuType === MenuItemType.Item ? this.initPath[lastIndex] : null;
            },
            _findParentItemIds: function(nodeId, nodeType) {
                return this.folderChooser.findParentItemIds(nodeId, nodeType);
            },
            _canCopyTo: function(nodeItem, itemIds) {
                var menuTree = this.root.menuTree, itemObjs = itemIds.map(function(itemId) {
                    return {
                        id: itemId
                    };
                }), initDrive = this._getInitDrive(), initFolder = this._getInitFolder();
                if (initDrive && nodeItem) {
                    return menuTree.canMoveItemsToNode(nodeItem, itemObjs, this._findParentItemIds) && !menuTree.nodeInCurrentPath(nodeItem, initDrive, initFolder);
                }
                return false;
            },
            isValid: function() {
                return this.get("folderChooser.selectedItem") && this.get("itemIds").length > 0 && this._canCopyTo(this.folderChooser.selectedItem, this.itemIds);
            },
            onOk: function() {
                if (this.isValid()) {
                    this.root.commandService.copyItems(this._selectedDriveId(), this._selectedFolderId(), this._selectedItemIds());
                    this.close();
                }
            },
            onCancel: function() {
                this.close();
            },
            close: function() {
                this.trigger(CLOSE);
            },
            onCreateFolderChooser: function() {
                this.folderChooser.load(this.initPath);
            }
        });
        extend(jyNS, {
            CopyItemDialogViewModel: CopyItemDialogViewModel
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.vm.preview-dialog", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.vm.base", "kendo.junkyard.vm.selector", "kendo.junkyard.constants", "kendo.junkyard.models" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, BaseViewModel = jyNS.BaseViewModel, FileHandlerActionTypes = jyNS.FileHandlerActionTypes, FileHandlerContentTypes = jyNS.FileHandlerContentTypes, utils = jyNS.utils, CLOSE = "close", CREATE_VIEW = "createView", CLOSE_VIEW = "closeView", CLICK = "click";
        var PreviewDialogViewModel = BaseViewModel.extend({
            init: function(itemModel, actions, version, options, noValidateToken) {
                BaseViewModel.fn.init.call(this, options);
                this._item = itemModel;
                this._actions = actions || [];
                this._version = version;
                this._state();
                this._proxy();
                this._setupEvents();
                if (!this.contentNotAvailable) {
                    if (noValidateToken) {
                        this._initContentItem();
                    } else {
                        this._validateTokenAndMakeUrl();
                    }
                }
            },
            _state: function() {
                this.set("extension", this._item.extension);
                this.set("title", this._item.title);
                this.set("canPreview", this._canPreview());
                this.set("canEdit", this._canEdit());
                this.set("isImage", this.canPreview && this._checkContentType(FileHandlerContentTypes.Image));
                this.set("isVideo", this.canPreview && this._checkContentType(FileHandlerContentTypes.Video));
                this.set("isFrame", this.canPreview && this._checkContentType(FileHandlerContentTypes.Iframe));
                this.set("contentNotAvailable", !(this.isImage || this.isVideo || this.isFrame));
                this.set("loading", !this.contentNotAvailable);
                this.set("contentItem", []);
                this.set("preventClose", false);
            },
            _proxy: function() {
                this.proxy("onCreateDialog");
                this.proxy("onCloseDialog");
                this.proxy("onStopClick");
                this.proxy("onMediaPlayerClick");
                this.proxy("onKeydown");
            },
            _setupEvents: function() {
                this.bind(CREATE_VIEW, this.onCreateDialog).bind(CLOSE_VIEW, this.onCloseDialog);
            },
            _makeUrl: function() {
                var previewAction = this._findActionByType(FileHandlerActionTypes.Preview);
                return previewAction ? previewAction.makeUrl(this._item, this.root, {
                    version: this._version
                }) || null : null;
            },
            _validateTokenAndMakeUrl: function() {
                var that = this, auth = this.root.service.auth;
                auth.validateOrRefreshToken().done(function() {
                    that._initContentItem();
                });
            },
            _initContentItem: function() {
                this.set("contentItem", [ this._createContentItem() ]);
                this.onInitMediaplayer();
            },
            _createContentItem: function() {
                return {
                    previewUid: this.uid,
                    url: this._makeUrl(),
                    title: this.title,
                    isImage: this.isImage,
                    isVideo: this.isVideo,
                    isFrame: this.isFrame
                };
            },
            _canEdit: function() {
                return !!this._findActionByType(FileHandlerActionTypes.Open);
            },
            _canPreview: function() {
                return !!this._findActionByType(FileHandlerActionTypes.Preview);
            },
            _findActionByType: function(type) {
                return utils.first(this._actions.filter(function(action) {
                    return action.type === type;
                }));
            },
            _findActionByContentType: function(type) {
                return utils.first(this._actions.filter(function(action) {
                    return action.contentType === type;
                }));
            },
            _checkContentType: function(fileHandlerContentType) {
                return !!this._findActionByContentType(fileHandlerContentType);
            },
            close: function() {
                this.trigger(CLOSE);
            },
            isNextVisible: function() {
                return false;
            },
            isPrevVisible: function() {
                return false;
            },
            onNext: function() {},
            onPrev: function() {},
            onClose: function() {
                if (!this.preventClose) {
                    this.close();
                } else {
                    this.set("preventClose", false);
                }
            },
            onDownload: function() {
                this.root.commandService.downloadItem(this._item.driveId, [ this._item.id ], this._version);
            },
            onEdit: function() {
                this.root.commandService.openFile(this._item, null, this._version);
            },
            onImageLoad: function() {
                this.set("loading", false);
            },
            onFrameLoad: function() {
                this.set("loading", false);
            },
            onStopClick: function(e) {
                e.preventDefault();
                e.stopPropagation();
            },
            onCreateDialog: function() {
                $(document).on("keydown", this.onKeydown);
            },
            onCloseDialog: function() {
                this.onRemoveMediaplayer();
                $(document).off("keydown", this.onKeydown);
            },
            onInitMediaplayer: function() {
                $("#jyt-preview-mediaplayer-" + this.uid).on(CLICK, this.onMediaPlayerClick);
            },
            onRemoveMediaplayer: function() {
                $("#jyt-preview-mediaplayer-" + this.uid).off(CLICK, this.onMediaPlayerClick);
            },
            onMediaPlayerClick: function() {
                this.set("preventClose", true);
            },
            onMediaPlayerReady: function() {
                this.set("loading", false);
            },
            onKeydown: function(e) {
                if (e.keyCode == kendo.keys.ESC) {
                    this.close();
                }
            }
        });
        extend(jyNS, {
            PreviewDialogViewModel: PreviewDialogViewModel
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.vm.open-file-dialog", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.vm.base", "kendo.junkyard.vm.selector", "kendo.junkyard.constants", "kendo.junkyard.models" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, BaseViewModel = jyNS.BaseViewModel, CLOSE = "close";
        var OpenFileDialogViewModel = BaseViewModel.extend({
            init: function(itemModel, openAction, options) {
                BaseViewModel.fn.init.call(this, options);
                this._state(itemModel, openAction);
                this._proxy();
            },
            _state: function(itemModel, openAction) {
                this._item = itemModel;
                this._openAction = openAction;
                this.set("url", null);
                this.set("title", itemModel.title);
                if (openAction) {
                    this.set("url", openAction.getUrl({
                        file: itemModel,
                        root: this.root
                    }));
                }
            },
            _proxy: function() {},
            close: function() {
                this.trigger(CLOSE);
            },
            onClose: function() {
                this.close();
            }
        });
        extend(jyNS, {
            OpenFileDialogViewModel: OpenFileDialogViewModel
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.vm.change-drive-size-dialog", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.vm.base", "kendo.junkyard.vm.access", "kendo.junkyard.constants" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, BaseViewModel = jyNS.BaseViewModel, CLOSE = "close", NUMERICTEXTBOX = "kendoNumericTextBox";
        var ChangeDriveSizeDialogViewModel = BaseViewModel.extend({
            init: function(driveId, initSize, options) {
                BaseViewModel.fn.init.call(this, options);
                this._state(driveId, initSize);
                this._proxy();
                this._setupEvents();
            },
            _state: function(driveId, initSize) {
                this.set("size", this._bytesToGb(initSize) || null);
                this.set("driveId", driveId);
            },
            _proxy: function() {},
            _setupEvents: function() {
                var that = this;
                this.one("afterOpenDialog", function() {
                    that._setupWidgets();
                });
            },
            _setupWidgets: function() {
                var sizeNumericTextBox = $("#jy-numeric-" + this.uid).data(NUMERICTEXTBOX);
                if (sizeNumericTextBox) {
                    sizeNumericTextBox.element.on("keyup", function(e) {
                        if (!((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105))) {
                            sizeNumericTextBox.value(sizeNumericTextBox.element.val());
                            sizeNumericTextBox.trigger("change");
                        }
                    });
                    sizeNumericTextBox.bind("spin", function() {
                        sizeNumericTextBox.trigger("change");
                    });
                }
            },
            isValid: function() {
                return this.get("size") > 0 && this.get("driveId") != null;
            },
            onOk: function() {
                if (this.isValid()) {
                    this.root.commandService.changeDriveSize(this.driveId, this._gbToBytes(this.size));
                    this.close();
                }
            },
            onCancel: function() {
                this.close();
            },
            close: function() {
                this.trigger(CLOSE);
            },
            _bytesToGb: function(bytes) {
                bytes = bytes || 0;
                return bytes / 1024 / 1024 / 1024;
            },
            _gbToBytes: function(gb) {
                gb = gb || 0;
                return gb * 1024 * 1024 * 1024;
            }
        });
        extend(jyNS, {
            ChangeDriveSizeDialogViewModel: ChangeDriveSizeDialogViewModel
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.vm.share-link-dialog", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.vm.base", "kendo.junkyard.vm.access", "kendo.junkyard.constants" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, BaseViewModel = jyNS.BaseViewModel, CLOSE = "close";
        var ShareLinkDialogViewModel = BaseViewModel.extend({
            init: function(driveId, itemId, options) {
                BaseViewModel.fn.init.call(this, options);
                this._state(driveId, itemId);
                this._proxy();
                this._shareLink();
            },
            _state: function(driveId, itemId) {
                this.set("itemId", itemId);
                this.set("driveId", driveId);
                this.set("progress", false);
                this.set("error", false);
                this.set("contentVisible", false);
                this.set("downloadUrl", null);
            },
            _proxy: function() {
                this.proxy("_shareSuccess");
                this.proxy("_shareFailed");
            },
            _shareLink: function() {
                var api = this.root.service.api;
                this.set("progress", true);
                api.createLinkById(this.driveId, this.itemId).done(this._shareSuccess).fail(this._shareFailed);
            },
            _shareSuccess: function(hash) {
                this.set("progress", false);
                if (hash) {
                    this.set("downloadUrl", this._createUrlFromHash(hash));
                    this.set("contentVisible", true);
                } else {
                    this.set("error", true);
                }
            },
            _createUrlFromHash: function(hash) {
                var api = this.root.service.api;
                var url = api.makeDownloadByLinkUrl(hash);
                if (!url.startsWith("http")) {
                    if (!url.startsWith("/")) {
                        url = "/" + url;
                    }
                    url = location.origin + url;
                }
                return url;
            },
            _shareFailed: function() {
                this.set("progress", false);
                this.set("error", true);
            },
            onInputAllSelect: function(e) {
                this._selectionAllText(e.currentTarget, this.downloadUrl);
            },
            _selectionAllText: function(input, text) {
                text = text || "";
                if (input && text.length > 0) {
                    input.setSelectionRange(0, text.length);
                }
            },
            close: function() {
                this.trigger(CLOSE);
            }
        });
        extend(jyNS, {
            ShareLinkDialogViewModel: ShareLinkDialogViewModel
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.command-service", [ "kendo.junkyard.ns", "kendo.junkyard.constants", "kendo.junkyard.vm.new-drive-dialog", "kendo.junkyard.vm.new-folder-dialog", "kendo.junkyard.vm.share-drive-dialog", "kendo.junkyard.vm.share-item-dialog", "kendo.junkyard.vm.rename-drive-dialog", "kendo.junkyard.vm.rename-item-dialog", "kendo.junkyard.vm.move-item-dialog", "kendo.junkyard.vm.restore-item-dialog", "kendo.junkyard.vm.copy-item-dialog", "kendo.junkyard.vm.preview-dialog", "kendo.junkyard.vm.open-file-dialog", "kendo.junkyard.vm.change-drive-size-dialog", "kendo.junkyard.vm.share-link-dialog" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, Class = kendo.Class, jyNS = ui.junkyard, extend = $.extend, Commands = jyNS.Commands, NewDriveDialogViewModel = jyNS.NewDriveDialogViewModel, NewFolderDialogViewModel = jyNS.NewFolderDialogViewModel, ShareDriveDialogViewModel = jyNS.ShareDriveDialogViewModel, ShareItemDialogViewModel = jyNS.ShareItemDialogViewModel, RenameDriveDialogViewModel = jyNS.RenameDriveDialogViewModel, RenameItemDialogViewModel = jyNS.RenameItemDialogViewModel, MoveItemDialogViewModel = jyNS.MoveItemDialogViewModel, RestoreItemDialogViewModel = jyNS.RestoreItemDialogViewModel, CopyItemDialogViewModel = jyNS.CopyItemDialogViewModel, PreviewDialogViewModel = jyNS.PreviewDialogViewModel, OpenFileDialogViewModel = jyNS.OpenFileDialogViewModel, ChangeDriveSizeDialogViewModel = jyNS.ChangeDriveSizeDialogViewModel, ShareLinkDialogViewModel = jyNS.ShareLinkDialogViewModel;
        var CommandService = Class.extend({
            init: function(service, options) {
                this.service = service;
                this.options = options;
            },
            addDriveDialog: function(flags) {
                var viewModel = new NewDriveDialogViewModel(flags, this.options);
                return this.service.command(Commands.AddDriveDialog, {
                    viewModel: viewModel,
                    noSerializeArgs: true
                }).exec();
            },
            addFolderDialog: function(driveId, parentId) {
                var viewModel = new NewFolderDialogViewModel(driveId, parentId, this.options);
                return this.service.command(Commands.AddFolderDialog, {
                    viewModel: viewModel,
                    noSerializeArgs: true
                }).exec();
            },
            shareDriveDialog: function(driveId) {
                var viewModel = new ShareDriveDialogViewModel(driveId, this.options);
                return this.service.command(Commands.ShareDriveDialog, {
                    viewModel: viewModel,
                    noSerializeArgs: true
                }).exec();
            },
            shareItemDialog: function(driveId, itemId) {
                var viewModel = new ShareItemDialogViewModel(driveId, itemId, this.options);
                return this.service.command(Commands.ShareDriveDialog, {
                    viewModel: viewModel,
                    noSerializeArgs: true
                }).exec();
            },
            shareLinkDialog: function(driveId, itemId) {
                var viewModel = new ShareLinkDialogViewModel(driveId, itemId, this.options);
                return this.service.command(Commands.ShareLinkDialog, {
                    viewModel: viewModel,
                    noSerializeArgs: true
                }).exec();
            },
            renameDriveDialog: function(driveId, title) {
                var viewModel = new RenameDriveDialogViewModel(driveId, title, this.options);
                return this.service.command(Commands.RenameDialog, {
                    viewModel: viewModel,
                    noSerializeArgs: true
                }).exec();
            },
            renameItemDialog: function(driveId, itemId, title) {
                var viewModel = new RenameItemDialogViewModel(driveId, itemId, title, this.options);
                return this.service.command(Commands.RenameDialog, {
                    viewModel: viewModel,
                    noSerializeArgs: true
                }).exec();
            },
            moveDialog: function(itemIds, initPath) {
                var viewModel = new MoveItemDialogViewModel(itemIds, initPath, this.options);
                return this.service.command(Commands.MoveDialog, {
                    viewModel: viewModel,
                    noSerializeArgs: true
                }).exec();
            },
            restoreDialog: function(itemId, initPath, name) {
                var viewModel = new RestoreItemDialogViewModel(itemId, initPath, name, this.options);
                return this.service.command(Commands.RestoreDialog, {
                    viewModel: viewModel,
                    noSerializeArgs: true
                }).exec();
            },
            copyDialog: function(itemIds, initPath) {
                var viewModel = new CopyItemDialogViewModel(itemIds, initPath, this.options);
                return this.service.command(Commands.CopyDialog, {
                    viewModel: viewModel,
                    noSerializeArgs: true
                }).exec();
            },
            previewDialog: function(itemModel, actions, version) {
                var viewModel = new PreviewDialogViewModel(itemModel, actions, version, this.options);
                return this.service.command(Commands.PreviewDialog, {
                    viewModel: viewModel,
                    noSerializeArgs: true
                }).exec();
            },
            openFileDialog: function(itemModel, openAction) {
                var viewModel = new OpenFileDialogViewModel(itemModel, openAction, this.options);
                return this.service.command(Commands.OpenFileDialog, {
                    viewModel: viewModel,
                    noSerializeArgs: true
                }).exec();
            },
            changeDriveSizeDialog: function(driveId, oldSize) {
                var viewModel = new ChangeDriveSizeDialogViewModel(driveId, oldSize, this.options);
                return this.service.command(Commands.ChangeSizeDialog, {
                    viewModel: viewModel,
                    noSerializeArgs: true
                }).exec();
            },
            changeView: function(viewType) {
                return this.service.command(Commands.ChangeView, {
                    viewType: viewType
                }).exec();
            },
            openDrive: function(driveItem) {
                return this.service.command(Commands.OpenDrive, {
                    item: driveItem
                }).exec();
            },
            openFolder: function(itemModel) {
                return this.service.command(Commands.OpenFolder, {
                    item: itemModel
                }).exec();
            },
            openFile: function(itemModel, actionType, version) {
                return this.service.command(Commands.OpenFile, {
                    item: itemModel,
                    actionType: actionType,
                    version: version
                }).exec();
            },
            openPreview: function(itemModel, version) {
                return this.service.command(Commands.OpenPreview, {
                    item: itemModel,
                    version: version
                }).exec();
            },
            addDrive: function(title, accessItems, flags) {
                return this.service.command(Commands.SaveDrive, {
                    driveId: null,
                    title: title,
                    accessItems: accessItems,
                    flags: flags,
                    selectAfterSave: true
                }).exec();
            },
            updateDrive: function(driveId, title, accessItems) {
                return this.service.command(Commands.SaveDrive, {
                    driveId: driveId,
                    title: title,
                    accessItems: accessItems
                }).exec();
            },
            renameDrive: function(driveId, title) {
                return this.service.command(Commands.RenameDrive, {
                    driveId: driveId,
                    title: title
                }).exec();
            },
            renameItem: function(driveId, itemId, title) {
                return this.service.command(Commands.RenameItem, {
                    driveId: driveId,
                    itemId: itemId,
                    title: title
                }).exec();
            },
            moveItems: function(driveId, folderId, itemIds) {
                return this.service.command(Commands.MoveItem, {
                    driveId: driveId,
                    folderId: folderId,
                    itemIds: itemIds
                }).exec();
            },
            restoreItems: function(driveId, folderId, itemId, newName) {
                return this.service.command(Commands.RestoreItem, {
                    driveId: driveId,
                    folderId: folderId,
                    itemId: itemId,
                    newName: newName
                }).exec();
            },
            copyItems: function(driveId, folderId, itemIds) {
                return this.service.command(Commands.CopyItem, {
                    driveId: driveId,
                    folderId: folderId,
                    itemIds: itemIds
                }).exec();
            },
            deleteItems: function(driveId, folderId, itemIds) {
                return this.service.command(Commands.DeleteItem, {
                    driveId: driveId,
                    folderId: folderId,
                    itemIds: itemIds
                }).exec();
            },
            deleteItemsWithConfirm: function(driveId, folderId, itemIds, itemType) {
                return this.service.command(Commands.DeleteItemWithConfirm, {
                    driveId: driveId,
                    folderId: folderId,
                    itemIds: itemIds,
                    itemType: itemType
                }).exec();
            },
            deleteDrives: function(driveIds) {
                return this.service.command(Commands.DeleteDrive, {
                    driveIds: driveIds
                }).exec();
            },
            addFolder: function(driveId, parentId, title) {
                return this.service.command(Commands.CreateFolder, {
                    driveId: driveId,
                    parentId: parentId,
                    title: title
                }).exec();
            },
            createFile: function(driveId, directoryId, item) {
                return this.service.command(Commands.CreateFile, {
                    driveId: driveId,
                    directoryId: directoryId,
                    item: item
                }).exec();
            },
            actionFile: function(driveId, id, title, item, version) {
                return this.service.command(Commands.ActionFile, {
                    driveId: driveId,
                    id: id,
                    title: title,
                    item: item,
                    version: version
                }).exec();
            },
            showDriveDetails: function(driveId, title) {
                return this.service.command(Commands.ShowDetails, {
                    driveId: driveId,
                    title: title
                }).exec();
            },
            showItems: function(driveId, itemId, isShared) {
                return this.service.command(Commands.ShowItems, {
                    driveId: driveId,
                    itemId: itemId,
                    isShared: isShared
                }).exec();
            },
            showDrives: function(isShared) {
                return this.service.command(Commands.ShowDrives, {
                    isShared: isShared
                }).exec();
            },
            showItemDetails: function(driveId, itemId, title, itemType) {
                return this.service.command(Commands.ShowDetails, {
                    driveId: driveId,
                    itemId: itemId,
                    title: title,
                    itemType: itemType
                }).exec();
            },
            showDeletedItems: function() {
                return this.service.command(Commands.ShowDeletedItems, {}).exec();
            },
            closeDetails: function() {
                return this.service.command(Commands.CloseDetails).exec();
            },
            upload: function(driveId, itemId) {
                return this.service.command(Commands.Upload, {
                    driveId: driveId,
                    itemId: itemId
                }).exec();
            },
            reloadUI: function(driveId, itemId) {
                return this.service.command(Commands.ReloadUI, {
                    driveId: driveId,
                    itemId: itemId
                }).exec();
            },
            downloadItem: function(driveId, itemIds, version) {
                return this.service.command(Commands.DownloadItem, {
                    driveId: driveId,
                    itemIds: itemIds,
                    version: version
                }).exec();
            },
            openObject: function(base, driveId, folderId) {
                return this.service.command(Commands.OpenObject, {
                    base: base,
                    driveId: driveId,
                    folderId: folderId
                }).exec();
            },
            changeDriveSize: function(driveId, newSize) {
                return this.service.command(Commands.ChangeDriveSize, {
                    driveId: driveId,
                    size: newSize
                }).exec();
            },
            "сlearTrashDialog": function() {
                return this.service.command(Commands.ClearTrash).exec();
            },
            revokeAllUrlsDialog: function(driveId, itemId) {
                return this.service.command(Commands.RevokeAllUrls, {
                    driveId: driveId,
                    itemId: itemId
                }).exec();
            },
            deleteDriveByIdDialog: function(driveId) {
                return this.service.command(Commands.DeleteDriveById, {
                    driveId: driveId
                }).exec();
            }
        });
        extend(jyNS, {
            CommandService: CommandService
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.commandutil", [ "kendo.junkyard.ns", "kendo.junkyard.utils" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, Class = kendo.Class, jyNS = ui.junkyard, extend = $.extend, proxy = $.proxy, CHANGE = "change";
        function registerCommand(name, constructor) {
            if (!registerCommand.registered) {
                registerCommand.registered = {};
            }
            registerCommand.registered[name] = constructor;
        }
        function makeCommandFactory(rootViewModel) {
            function createCommand(commandName, commandArgs, isForeground) {
                if (registerCommand.registered[commandName] === undefined) {
                    throw new Error("Could not found command: " + commandName);
                }
                var commandConstructor = registerCommand.registered[commandName];
                if (typeof commandConstructor !== "function") {
                    throw new Error("Could not found command constructor: " + commandName);
                }
                var command = new commandConstructor({
                    root: rootViewModel,
                    args: commandArgs,
                    type: commandName,
                    foreground: isForeground
                });
                return command;
            }
            return createCommand;
        }
        var CommandManager = Class.extend({
            init: function(rootViewModel, isDebug, stateHandlers) {
                this.isDebug = isDebug;
                this._onCommandChanged = proxy(this._onCommandChanged, this);
                this._commandFactory = makeCommandFactory(rootViewModel);
                this.stateHandlers = stateHandlers || [];
            },
            makeCommand: function(commandName, commandArgs, isForeground) {
                isForeground = isForeground === undefined ? true : isForeground;
                var command = this._commandFactory(commandName, commandArgs, isForeground);
                command.bind(CHANGE, this._onCommandChanged);
                command.notifyStateChanged();
                return command;
            },
            _onCommandChanged: function(e) {
                if (e.field === "state") {
                    var c = this.stateHandlers.length;
                    for (var i = 0; i < c; i++) {
                        this.stateHandlers[i].onCommandStateChanged(e);
                    }
                }
            }
        });
        CommandManager.register = registerCommand;
        extend(jyNS, {
            CommandManager: CommandManager
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.broadcast-service", [ "kendo.junkyard.ns", "kendo.junkyard.constants" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, Class = kendo.Class, jyNS = ui.junkyard, extend = $.extend, BroadcastEvents = jyNS.BroadcastEvents;
        var BroadcastService = Class.extend({
            init: function(service, options) {
                this.service = service;
                this.options = options;
            },
            selectContext: function(models) {
                this.service.broadcast(BroadcastEvents.SelectContext, {
                    items: models
                });
            }
        });
        extend(jyNS, {
            BroadcastService: BroadcastService
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.file-handler", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.constants" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, Class = kendo.Class, jyNS = ui.junkyard, extend = $.extend, FileHandlerContentTypes = jyNS.FileHandlerContentTypes;
        var FileHandlerAction = Class.extend({
            init: function(properties) {
                properties = properties || {};
                this.type = properties.type;
                this.url = properties.url;
                this.extensions = properties.extensions || [];
                this.contentType = properties.contentType || FileHandlerContentTypes.Iframe;
                this.displayName = properties.displayName;
                this.actionRef = properties.actionRef;
                this.icon = properties.icon;
            },
            getUrl: function(data) {
                if (kendo.isFunction(this.url)) {
                    return this.url(data);
                } else {
                    return this.url;
                }
            },
            makeUrl: function(file, root, params) {
                return this.getUrl({
                    file: file,
                    root: root,
                    params: params || {}
                });
            },
            allowExtension: function(extension) {
                extension = (extension || "").toLowerCase();
                return this.extensions.filter(function(ext) {
                    return (ext || "").toLowerCase() === extension;
                }).length > 0;
            }
        });
        var FileHandler = Class.extend({
            init: function(properties) {
                var that = this;
                this.fileTypeIconUrl = properties.fileTypeIconUrl;
                this.actions = {};
                this.extensions = {};
                (properties.actions || []).forEach(function(props) {
                    var action = new FileHandlerAction(props);
                    that.actions[action.type] = action;
                });
                Object.keys(this.actions).forEach(function(key) {
                    var action = that.actions[key];
                    action.extensions.forEach(function(extension) {
                        that.extensions[extension] = true;
                    });
                });
            },
            getActions: function() {
                var that = this;
                return Object.keys(this.actions).map(function(key) {
                    return that.actions[key];
                });
            },
            hasAction: function(type) {
                return !!this.actions[type];
            },
            getFileTypeIconUrl: function(data) {
                if (kendo.isFunction(this.fileTypeIconUrl)) {
                    return this.fileTypeIconUrl(data);
                } else {
                    return this.fileTypeIconUrl;
                }
            },
            findActionByType: function(type) {
                return this.actions[type];
            },
            resolveActionRef: function(action) {
                return action && action.actionRef ? this.findActionByType(action.actionRef) : action;
            },
            allowExtension: function(extension) {
                return this.extensions[(extension || "").toLowerCase()];
            }
        });
        extend(jyNS, {
            FileHandler: FileHandler
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.file-handler-service", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.file-handler" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, Class = kendo.Class, jyNS = ui.junkyard, extend = $.extend, utils = jyNS.utils, FileHandler = jyNS.FileHandler;
        var FileHandlerService = Class.extend({
            init: function() {
                this._fileHandlers = [];
            },
            getFileHandlers: function() {
                return this._fileHandlers.slice();
            },
            addFileHandler: function(properties) {
                this._fileHandlers.push(new FileHandler(properties));
            },
            removeFileHandlerByExt: function(fileExtension) {
                var that = this;
                this.findFileHandlersByExt(fileExtension).forEach(function(fileHandler) {
                    that._removeFileHandler(fileHandler);
                });
            },
            findFileHandlersByExt: function(fileExtension) {
                return this._fileHandlers.filter(function(fileHandler) {
                    return fileHandler.allowExtension(fileExtension);
                });
            },
            findFileHandlerByExt: function(fileExtension) {
                return utils.first(this.findFileHandlersByExt(fileExtension));
            },
            _removeFileHandler: function(fileHandler) {
                var index = this._fileHandlers.indexOf(fileHandler);
                if (index > -1) {
                    this._fileHandlers.splice(index, 1);
                }
            }
        });
        extend(jyNS, {
            FileHandlerService: FileHandlerService
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.item-service", [ "kendo.junkyard.ns", "kendo.junkyard.data", "kendo.junkyard.utils" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, Class = kendo.Class, jyNS = ui.junkyard, ds = jyNS.ds, utils = jyNS.utils, extend = $.extend;
        var JunkyardItemService = Class.extend({
            init: function(widgetOptions, api) {
                this.widgetOpt = widgetOptions;
                this.api = api;
            },
            requestUniqName: function(sourceName, driveId, parentId) {
                var api = this.api;
                var defer = $.Deferred();
                var that = this;
                api.getItemByName(sourceName, driveId, parentId).done(function(item) {
                    if (item) {
                        that._getUniqName(sourceName, driveId, parentId).done(defer.resolve).fail(defer.reject);
                    } else {
                        defer.resolve(sourceName);
                    }
                }).fail(function() {
                    defer.resolve(sourceName);
                });
                return defer.promise();
            },
            requestDownloadItems: function(iframeContainer, delay, urlOptions) {
                var that = this;
                var defer = $.Deferred();
                this.api.auth.validateOrRefreshToken().done(function() {
                    setTimeout(function() {
                        defer.resolve();
                    }, delay);
                    that._downloadItems(iframeContainer, urlOptions);
                }).fail(function(e) {
                    defer.reject(e);
                });
                return defer.promise();
            },
            requestDownloadByHash: function(iframeContainer, delay, hash) {
                var that = this;
                var defer = $.Deferred();
                setTimeout(function() {
                    defer.resolve();
                }, delay);
                that._downloadItems(iframeContainer, {
                    hash: hash
                });
                return defer.promise();
            },
            _downloadItems: function(iframeContainer, urlOptions) {
                $("<iframe>").hide().prop("src", this.makeDownloadUrl(urlOptions)).appendTo($(iframeContainer));
            },
            makeDownloadUrl: function(urlOptions) {
                var api = this.api, hash = urlOptions.hash, driveId = urlOptions.driveId, itemIds = urlOptions.itemIds, version = urlOptions.version, useAuth = urlOptions.useAuth;
                if (hash) {
                    return api.makeDownloadByLinkUrl(urlOptions.hash, useAuth);
                } else if (version) {
                    return api.makeDownloadVersionUrl(driveId, itemIds[0], version);
                } else {
                    return api.makeDownloadUrl(driveId, itemIds);
                }
            },
            _getUniqName: function(sourceName, driveId, parentId) {
                var itemsOpt = this.widgetOpt.items, auth = this.api.auth, defer = $.Deferred(), fileNames = {};
                var dataSource = new ds.ItemDataSource(auth, itemsOpt.readListUrl);
                dataSource.paramDriveId = driveId || undefined;
                dataSource.paramParentId = parentId || undefined;
                var fetchListSuccess = function() {
                    dataSource.data().forEach(function(item) {
                        fileNames[item.title] = true;
                    });
                    if (!fileNames[sourceName]) {
                        defer.resolve(sourceName);
                    } else {
                        var num = 0;
                        var sourceParts = utils.fileNameParts(sourceName);
                        var name = sourceParts.name;
                        var extension = sourceParts.extension ? "." + sourceParts.extension : "";
                        var newName = sourceName;
                        while (fileNames[newName]) {
                            num++;
                            newName = name + " (" + num + ")" + extension;
                        }
                        defer.resolve(newName);
                    }
                };
                dataSource.resetPage().setUnlimPageSize().read().done(fetchListSuccess).fail(defer.reject);
                return defer.promise();
            }
        });
        extend(jyNS, {
            JunkyardItemService: JunkyardItemService
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.vm.root", [ "kendo.junkyard.ns", "kendo.junkyard.auth", "kendo.junkyard.service", "kendo.junkyard.broadcaster", "kendo.junkyard.vm.base", "kendo.junkyard.vm.ui-events", "kendo.junkyard.vm.menu-tree", "kendo.junkyard.vm.progress", "kendo.junkyard.vm.errors", "kendo.junkyard.vm.items", "kendo.junkyard.vm.drives", "kendo.junkyard.vm.toolbar", "kendo.junkyard.vm.command-debug", "kendo.junkyard.vm.upload", "kendo.junkyard.vm.pager", "kendo.junkyard.vm.menu-tree-ctx", "kendo.junkyard.vm.main-ctx", "kendo.junkyard.vm.details", "kendo.junkyard.vm.router", "kendo.junkyard.vm.path", "kendo.junkyard.vm.search", "kendo.junkyard.vm.selection", "kendo.junkyard.command.state-handlers", "kendo.junkyard.command-service", "kendo.junkyard.commandutil", "kendo.junkyard.constants", "kendo.junkyard.broadcast-service", "kendo.junkyard.file-handler-service", "kendo.junkyard.item-service" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, MenuIds = jyNS.MenuIds, Commands = jyNS.Commands, Authenticator = jyNS.Authenticator, Broadcaster = jyNS.Broadcaster, CommandManager = jyNS.CommandManager, BaseViewModel = jyNS.BaseViewModel, UiEventsViewModel = jyNS.UiEventsViewModel, MenuTreeViewModel = jyNS.MenuTreeViewModel, JunkyardService = jyNS.JunkyardService, ProgressViewModel = jyNS.ProgressViewModel, ErrorViewModel = jyNS.ErrorViewModel, ItemsViewModel = jyNS.ItemsViewModel, DrivesViewModel = jyNS.DrivesViewModel, ToolbarViewModel = jyNS.ToolbarViewModel, UploadViewModel = jyNS.UploadViewModel, PagerViewModel = jyNS.PagerViewModel, MenuTreeContextMenuViewModel = jyNS.MenuTreeContextMenuViewModel, MainContextMenuViewModel = jyNS.MainContextMenuViewModel, CommandDebugViewModel = jyNS.CommandDebugViewModel, DetailsViewModel = jyNS.DetailsViewModel, RouterViewModel = jyNS.RouterViewModel, PathViewModel = jyNS.PathViewModel, SearchViewModel = jyNS.SearchViewModel, SelectionViewModel = jyNS.SelectionViewModel, DebugCommandStateHandler = jyNS.DebugCommandStateHandler, ProgressCommandStateHandler = jyNS.ProgressCommandStateHandler, ErrorCommandStateHandler = jyNS.ErrorCommandStateHandler, CommandService = jyNS.CommandService, BroadcastService = jyNS.BroadcastService, FileHandlerService = jyNS.FileHandlerService, JunkyardItemService = jyNS.JunkyardItemService;
        var RootViewModel = BaseViewModel.extend({
            init: function(widgetOptions) {
                BaseViewModel.fn.init.call(this, {
                    widgetOptions: widgetOptions,
                    root: this
                });
                this._state();
                this._services();
                this._viewModels();
                this._baseUIEvents();
            },
            _state: function() {
                this.set("authProgress", false);
            },
            _services: function() {
                var auth = new Authenticator(this.widgetOpt);
                var broadcaster = new Broadcaster();
                var commandManager = new CommandManager(this, this.widgetOpt.debug.command, this._stateHandlers());
                this.service = new JunkyardService(this.widgetOpt, auth, broadcaster, commandManager);
                this.commandService = new CommandService(this.service, this.options);
                this.broadcastService = new BroadcastService(this.service, this.options);
                this.fileHandlerService = new FileHandlerService();
                this.itemService = new JunkyardItemService(this.widgetOpt, this.service.api);
            },
            _stateHandlers: function() {
                var handlers = [], debugOpt = this.widgetOpt.debug;
                if (debugOpt.command) {
                    handlers.push(new DebugCommandStateHandler(this));
                }
                handlers.push(new ProgressCommandStateHandler(this));
                handlers.push(new ErrorCommandStateHandler(this));
                return handlers;
            },
            _viewModels: function() {
                var opt = this.options;
                this.set("uiEvents", new UiEventsViewModel(opt));
                this.set("menuTree", new MenuTreeViewModel(opt));
                this.set("progressBar", new ProgressViewModel(opt));
                this.set("errorBar", new ErrorViewModel(opt));
                this.set("commandDebug", new CommandDebugViewModel(opt));
                this.set("items", new ItemsViewModel(opt));
                this.set("drives", new DrivesViewModel(opt));
                this.set("toolbar", new ToolbarViewModel(opt));
                this.set("upload", new UploadViewModel(opt));
                this.set("pager", new PagerViewModel(opt));
                this.set("menuTreeCtx", new MenuTreeContextMenuViewModel(opt));
                this.set("mainCtx", new MainContextMenuViewModel(opt));
                this.set("details", new DetailsViewModel(opt));
                this.set("router", new RouterViewModel(opt));
                this.set("path", new PathViewModel(opt));
                this.set("searchBar", new SearchViewModel(opt));
                this.set("selection", new SelectionViewModel(opt));
            },
            setAuthProgress: function(value) {
                this.set("authProgress", value);
            },
            startup: function() {
                this.service.command(Commands.Startup).exec();
            },
            auth: function() {
                var that = this, auth = this.root.service.auth, defer = $.Deferred();
                if (auth.enabled()) {
                    this.setAuthProgress(true);
                    auth.getToken().done(function() {
                        that.setAuthProgress(false);
                        defer.resolve();
                    }).fail(defer.reject);
                } else {
                    defer.resolve();
                }
                return defer;
            },
            uploadDisabled: function() {
                var progress = this.get("authProgress"), driveVisible = this.drives.get("visible"), isTrashMenu = this.root.path.isCurrentBase(MenuIds.Trash);
                return progress || driveVisible || isTrashMenu;
            },
            onCreateView: function() {
                if (this.widgetOpt.autoBind) {
                    this.startup();
                }
            },
            dummy: function() {}
        });
        extend(jyNS, {
            RootViewModel: RootViewModel
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.default-config", [ "kendo.junkyard.ns", "kendo.junkyard.constants" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, ImageSize = jyNS.ImageSize, extend = $.extend;
        function createDefaultConfig(options) {
            var opt = extend({
                serverApi: "",
                authApi: "",
                routerRoot: "/",
                isDebug: false,
                asyncInit: true,
                enableRoutes: true,
                initLocation: "/",
                persistSelection: false,
                selectionItem: "all",
                selectionExclude: "trash",
                tokenProvider: null,
                driveIds: [],
                userAndGroupsReadUrl: "",
                userReadDetailsUrl: "",
                groupReadDetailsUrl: "",
                userAndGroupsConverter: null,
                userDetailsConverter: null,
                groupDetailsConverter: null,
                userAndGroupsParamMap: null,
                userAndGroupsReadTransport: null
            }, options);
            return {
                templateId: "jyt-widget",
                autoBind: true,
                asyncInit: opt.asyncInit,
                enableRoutes: opt.enableRoutes,
                initLocation: opt.initLocation,
                persistSelection: opt.persistSelection,
                selectionItem: opt.selectionItem,
                selectionExclude: opt.selectionExclude,
                driveIds: opt.driveIds,
                debug: {
                    command: opt.isDebug,
                    verbose: opt.isDebug
                },
                drives: {
                    readListUrl: opt.serverApi + "/drives",
                    readDetailsUrl: opt.serverApi + "/drives/by_id/{0}",
                    createUrl: opt.serverApi + "/drives",
                    updateUrl: opt.serverApi + "/drives/by_id/{0}/edit",
                    renameUrl: opt.serverApi + "/drives/by_id/{0}/name",
                    webdavUrl: opt.serverApi + "/webdav/{0}",
                    deleteUrl: "data/delete-drives.json",
                    changeQuotaUrl: opt.serverApi + "/drives/by_id/{0}/quota",
                    deleteDriveById: opt.serverApi + "/drives"
                },
                items: {
                    createFolderUrl: opt.serverApi + "/items",
                    readListUrl: opt.serverApi + "/items",
                    renameUrl: opt.serverApi + "/items/rename",
                    moveUrl: opt.serverApi + "/items/move",
                    copyUrl: opt.serverApi + "/items/copy",
                    downloadUrl: opt.serverApi + "/files/download",
                    downloadVersionUrl: opt.serverApi + "/files/version",
                    downloadByLinkUrl: opt.serverApi + "/link/download",
                    pathUrl: opt.serverApi + "/items/path",
                    deleteUrl: opt.serverApi + "/items",
                    readDetailsUrl: opt.serverApi + "/items/detail",
                    versionReadListUrl: opt.serverApi + "/items/versions",
                    searchUrl: opt.serverApi + "/items/search",
                    restoreVersionUrl: opt.serverApi + "/items/restore",
                    deletedListUrl: opt.serverApi + "/items/deleted",
                    deletedRestoreUrl: opt.serverApi + "/items/deleted/restore",
                    clearTrashUrl: opt.serverApi + "/items/deleted/cleanbin",
                    revokeAllUrls: opt.serverApi + "/link/revoke",
                    linkByPathUrl: opt.serverApi + "/link/path_link/by_id",
                    linkByIdUrl: opt.serverApi + "/link/file_link/by_id",
                    linkByVersionUrl: opt.serverApi + "/link/version_link/by_id",
                    readItemByHashUrl: opt.serverApi + "/link/info",
                    readItemByNameUrl: opt.serverApi + "/items/by_name",
                    getOrCreatePathUrl: opt.serverApi + "/items/by_path",
                    setTagsUrl: opt.serverApi + "/items/tags",
                    setDescriptionUrl: opt.serverApi + "/items/description"
                },
                access: {
                    userAndGroupsReadUrl: opt.userAndGroupsReadUrl,
                    userReadDetailsUrl: opt.userReadDetailsUrl,
                    groupReadDetailsUrl: opt.groupReadDetailsUrl,
                    userAndGroupsConverter: opt.userAndGroupsConverter,
                    userDetailsConverter: opt.userDetailsConverter,
                    groupDetailsConverter: opt.groupDetailsConverter,
                    userAndGroupsParamMap: opt.userAndGroupsParamMap,
                    userAndGroupsReadTransport: opt.userAndGroupsReadTransport
                },
                upload: {
                    saveUrl: opt.serverApi + "/files/upload",
                    replaceUrl: opt.serverApi + "/files/replace"
                },
                error: {
                    leaveTimeout: 5e3,
                    hideTimeout: 300
                },
                router: {
                    root: opt.routerRoot
                },
                auth: {
                    token: {
                        createUrl: "",
                        field: "Token",
                        method: "GET",
                        withCredentials: false
                    },
                    tokenProvider: opt.tokenProvider,
                    tokenValidation: {
                        readUrl: opt.serverApi + "/info/current",
                        method: "GET",
                        withCredentials: false
                    },
                    user: {
                        readUrl: opt.serverApi + "/info/current"
                    }
                },
                localization: {
                    reason: "Причина: {0}",
                    cancelUpload: 'Загрузка файла "{0}" отменена пользователем.',
                    uploadFailed: 'Ошибка при загрузке файла "{0}" на сервер.',
                    requestFailed: "Ошибка запроса: {0}, {1}",
                    driveNotFound: "Диск не найден.",
                    commandFailed: 'Команда "{0}" завершилась с ошибкой: {1}',
                    addFolderSuccess: 'Добавлена папка "{0}".',
                    addDriveSuccess: 'Добавлен диск "{0}".',
                    InvalidAuthToken: "Неправильный ключ авторизации.",
                    deleteFolderTitle: "Удаление папки",
                    deleteFileTitle: "Удаление файла",
                    clearTrashTitle: "Очистка корзины",
                    clearTrashMessage: "Вы действительно хотите очистить корзину? Отменить это действие будет невозможно",
                    revokeAllUrlsTitle: "Убрать все ссылки ?",
                    revokeAllUrlsMessage: "Вы действительно хотите убрать все ссылки?",
                    deleteDriveByIdTitle: "Удаление объекта",
                    deleteDriveByIdMessage: "Вы действительно хотите безвозвратно удалить выбранный объект?",
                    deleteMultipleTitle: "Удаление объектов",
                    deleteFolder: "Вы действительно хотите безвозвратно удалить выбранную папку?",
                    deleteFile: "Вы действительно хотите безвозвратно удалить выбранный файл?",
                    deleteMultiple: "Вы действительно хотите безвозвратно удалить выбранные объекты?",
                    changeDriveSizeSuccess: "Размер диска успешно изменен.",
                    noAccess: "Недостаточно прав. Обратитесь к администратору.",
                    restoreVersionFailed: "Не удалось восстановить выбранную версию файла.",
                    restoreVersionSuccess: "Версия файла успешно восстановлена.",
                    confirm: {
                        okText: "Да",
                        cancel: "Отмена"
                    }
                }
            };
        }
        function createDefaultFileHandlers(obj, options) {
            var opt = extend({
                fileHandlerApi: ""
            }, options);
            if (!kendo.isFunction(obj.addFileHandler)) {
                return;
            }
            obj.addFileHandler({
                actions: [ {
                    type: "open",
                    url: function(data) {
                        var utils = kendo.ui.junkyard.utils, file = data.file, version = data.params.version;
                        return opt.fileHandlerApi + "/Document/Spreadsheets" + utils.toUrlQuery({
                            fileName: file.title,
                            drive_id: file.driveId,
                            item_id: file.id,
                            version: version
                        }, true);
                    },
                    extensions: [ "_xlsx" ]
                }, {
                    type: "custom",
                    displayName: "Редактировать таблицу",
                    icon: "fa-file-excel-o",
                    actionRef: "open",
                    extensions: [ "_xlsx" ]
                }, {
                    type: "preview",
                    url: function(data) {
                        var utils = kendo.ui.junkyard.utils, file = data.file, version = data.params.version;
                        return opt.fileHandlerApi + "/Document/SpreadsheetsView" + utils.toUrlQuery({
                            fileName: file.title,
                            drive_id: file.driveId,
                            item_id: file.id,
                            version: version
                        }, true);
                    },
                    extensions: [ "_xlsx" ]
                } ]
            });
            obj.addFileHandler({
                actions: [ {
                    type: "open",
                    url: function(data) {
                        var utils = kendo.ui.junkyard.utils, file = data.file, version = data.params.version;
                        return opt.fileHandlerApi + "/Document/Doc" + utils.toUrlQuery({
                            fileName: file.title,
                            drive_id: file.driveId,
                            item_id: file.id,
                            version: version
                        }, true);
                    },
                    extensions: [ "_docx" ]
                }, {
                    type: "custom",
                    displayName: "Редактировать документ",
                    icon: "fa-file-word-o",
                    actionRef: "open",
                    extensions: [ "_docx" ]
                }, {
                    type: "preview",
                    url: function(data) {
                        var utils = kendo.ui.junkyard.utils, file = data.file, version = data.params.version;
                        return opt.fileHandlerApi + "/Document/DocView" + utils.toUrlQuery({
                            fileName: file.title,
                            drive_id: file.driveId,
                            item_id: file.id,
                            version: version
                        }, true);
                    },
                    extensions: [ "_docx" ]
                } ]
            });
            obj.addFileHandler({
                actions: [ {
                    type: "preview",
                    url: function(data) {
                        var utils = kendo.ui.junkyard.utils, file = data.file, version = data.params.version;
                        return opt.fileHandlerApi + "/document/pdf" + utils.toUrlQuery({
                            fileName: file.title,
                            drive_id: file.driveId,
                            item_id: file.id,
                            version: version
                        }, true);
                    },
                    extensions: [ "_pdf" ]
                } ]
            });
            obj.addFileHandler({
                actions: [ {
                    type: "preview",
                    url: function(data) {
                        var utils = kendo.ui.junkyard.utils, file = data.file, version = data.params.version;
                        return opt.fileHandlerApi + "/document/odt" + utils.toUrlQuery({
                            fileName: file.title,
                            drive_id: file.driveId,
                            item_id: file.id,
                            version: version
                        }, true);
                    },
                    extensions: [ "_odt" ]
                } ]
            });
            obj.addFileHandler({
                actions: [ {
                    type: "preview",
                    url: function(data) {
                        var api = data.root.service.api, file = data.file;
                        return api.makeDownloadUrl(file.driveId, [ file.id ]) + kendo.format("&_{0}", Date.now());
                    },
                    extensions: [ "png", "jpg", "jpeg", "gif" ],
                    contentType: "image"
                }, {
                    type: "smallPreview",
                    url: function(data) {
                        var utils = kendo.ui.junkyard.utils, api = data.root.service.api, file = data.file;
                        return opt.fileHandlerApi + "/preview/download" + utils.toUrlQuery({
                            drive_id: file.driveId,
                            item_id: file.id,
                            size: ImageSize.M,
                            access_token: api.auth.token,
                            _: Date.now()
                        }, true);
                    },
                    extensions: [ "png", "jpg", "jpeg", "gif", "tiff", "bmp", "pdf", "doc", "docx", "txt", "rtf", "html", "xml", "epub", "xls", "xlsx" ],
                    contentType: "image"
                } ]
            });
            obj.addFileHandler({
                actions: [ {
                    type: "preview",
                    url: function(data) {
                        var api = data.root.service.api, file = data.file;
                        return api.makeDownloadUrl(file.driveId, [ file.id ]) + kendo.format("&_{0}", Date.now());
                    },
                    extensions: [ "mp4", "webm", "mkv" ],
                    contentType: "video"
                } ]
            });
        }
        function createDefaultFileHandlersForSelectWidget(obj, options) {
            var opt = extend({
                fileHandlerApi: ""
            }, options);
            if (!kendo.isFunction(obj.addFileHandler)) {
                return;
            }
            obj.addFileHandler({
                actions: [ {
                    type: "preview",
                    url: function(data) {
                        var api = data.root.api, file = data.file;
                        return api.makeDownloadUrl(file.driveId, [ file.id ]) + kendo.format("&_{0}", Date.now());
                    },
                    extensions: [ "png", "jpg", "jpeg", "gif" ],
                    contentType: "image"
                }, {
                    type: "smallPreview",
                    url: function(data) {
                        var utils = kendo.ui.junkyard.utils, api = data.root.api, file = data.file;
                        return opt.fileHandlerApi + "/preview/download" + utils.toUrlQuery({
                            drive_id: file.driveId,
                            item_id: file.id,
                            size: ImageSize.M,
                            access_token: api.auth.token,
                            _: Date.now()
                        }, true);
                    },
                    extensions: [ "png", "jpg", "jpeg", "gif", "tiff", "bmp", "pdf", "doc", "docx", "txt", "rtf", "html", "xml", "epub", "xls", "xlsx" ],
                    contentType: "image"
                } ]
            });
            obj.addFileHandler({
                actions: [ {
                    type: "open",
                    url: function(data) {
                        var utils = kendo.ui.junkyard.utils, file = data.file, version = data.params.version;
                        return opt.fileHandlerApi + "/Document/Doc" + utils.toUrlQuery({
                            fileName: file.title,
                            drive_id: file.driveId,
                            item_id: file.id,
                            version: version
                        }, true);
                    },
                    extensions: [ "_docx" ]
                }, {
                    type: "preview",
                    url: function(data) {
                        var utils = kendo.ui.junkyard.utils, file = data.file, version = data.params.version;
                        return opt.fileHandlerApi + "/Document/DocView" + utils.toUrlQuery({
                            fileName: file.title,
                            drive_id: file.driveId,
                            item_id: file.id,
                            version: version
                        }, true);
                    },
                    extensions: [ "_docx" ]
                } ]
            });
            obj.addFileHandler({
                actions: [ {
                    type: "open",
                    url: function(data) {
                        var utils = kendo.ui.junkyard.utils, file = data.file, version = data.params.version;
                        return opt.fileHandlerApi + "/Document/Spreadsheets" + utils.toUrlQuery({
                            fileName: file.title,
                            drive_id: file.driveId,
                            item_id: file.id,
                            version: version
                        }, true);
                    },
                    extensions: [ "_xlsx" ]
                }, {
                    type: "preview",
                    url: function(data) {
                        var utils = kendo.ui.junkyard.utils, file = data.file, version = data.params.version;
                        return opt.fileHandlerApi + "/Document/SpreadsheetsView" + utils.toUrlQuery({
                            fileName: file.title,
                            drive_id: file.driveId,
                            item_id: file.id,
                            version: version
                        }, true);
                    },
                    extensions: [ "_xlsx" ]
                } ]
            });
            obj.addFileHandler({
                actions: [ {
                    type: "preview",
                    url: function(data) {
                        var utils = kendo.ui.junkyard.utils, file = data.file, version = data.params.version;
                        return opt.fileHandlerApi + "/document/pdf" + utils.toUrlQuery({
                            fileName: file.title,
                            drive_id: file.driveId,
                            item_id: file.id,
                            version: version
                        }, true);
                    },
                    extensions: [ "_pdf" ]
                } ]
            });
            obj.addFileHandler({
                actions: [ {
                    type: "preview",
                    url: function(data) {
                        var utils = kendo.ui.junkyard.utils, file = data.file, version = data.params.version;
                        return opt.fileHandlerApi + "/document/odt" + utils.toUrlQuery({
                            fileName: file.title,
                            drive_id: file.driveId,
                            item_id: file.id,
                            version: version
                        }, true);
                    },
                    extensions: [ "_odt" ]
                } ]
            });
        }
        function createDefaultFileHandlersForLinkWidget(obj, options) {
            var opt = extend({
                fileHandlerApi: ""
            }, options);
            if (!kendo.isFunction(obj.addFileHandler)) {
                return;
            }
            obj.addFileHandler({
                actions: [ {
                    type: "preview",
                    url: function(data) {
                        var api = data.root.api, linkVm = data.root.linkVm, hash = linkVm.hash, secure = linkVm.secure;
                        return api.makeDownloadByLinkUrl(hash, secure) + kendo.format("&_{0}", Date.now());
                    },
                    extensions: [ "png", "jpg", "jpeg", "gif" ],
                    contentType: "image"
                }, {
                    type: "smallPreview",
                    url: function(data) {
                        var utils = kendo.ui.junkyard.utils, widgetOpt = data.root.widgetOpt, linkVm = data.root.linkVm, hash = linkVm.hash, size = widgetOpt.previewSize || ImageSize.M, api = data.root.api;
                        return opt.fileHandlerApi + "/preview/link" + utils.toUrlQuery({
                            link: hash,
                            size: size,
                            access_token: linkVm.secure ? api.auth.token : undefined,
                            _: Date.now()
                        }, true);
                    },
                    extensions: [ "png", "jpg", "jpeg", "gif", "tiff", "bmp", "pdf", "doc", "docx", "txt", "rtf", "html", "xml", "epub", "xls", "xlsx" ],
                    contentType: "image"
                }, {
                    type: "imageLink",
                    url: function(data) {
                        var utils = kendo.ui.junkyard.utils, link = data.link, size = data.previewSize || ImageSize.M;
                        return data.fileHandlerApi + "/preview/by_link" + utils.toUrlQuery({
                            link: link,
                            size: size
                        }, true);
                    },
                    extensions: [ "png", "jpg", "jpeg", "gif", "tiff", "bmp", "pdf", "doc", "docx", "txt", "rtf", "html", "xml", "epub", "xls", "xlsx" ],
                    contentType: "image"
                } ]
            });
            obj.addFileHandler({
                actions: [ {
                    type: "open",
                    url: function(data) {
                        var utils = kendo.ui.junkyard.utils, file = data.file, version = data.params.version;
                        return opt.fileHandlerApi + "/Document/Doc" + utils.toUrlQuery({
                            fileName: file.title,
                            drive_id: file.driveId,
                            item_id: file.id,
                            version: version
                        }, true);
                    },
                    extensions: [ "_docx" ]
                }, {
                    type: "preview",
                    url: function(data) {
                        var utils = kendo.ui.junkyard.utils, file = data.file, version = data.params.version;
                        return opt.fileHandlerApi + "/Document/DocView" + utils.toUrlQuery({
                            fileName: file.title,
                            drive_id: file.driveId,
                            item_id: file.id,
                            version: version
                        }, true);
                    },
                    extensions: [ "_docx" ]
                } ]
            });
            obj.addFileHandler({
                actions: [ {
                    type: "open",
                    url: function(data) {
                        var utils = kendo.ui.junkyard.utils, file = data.file, version = data.params.version;
                        return opt.fileHandlerApi + "/Document/Spreadsheets" + utils.toUrlQuery({
                            fileName: file.title,
                            drive_id: file.driveId,
                            item_id: file.id,
                            version: version
                        }, true);
                    },
                    extensions: [ "_xlsx" ]
                }, {
                    type: "preview",
                    url: function(data) {
                        var utils = kendo.ui.junkyard.utils, file = data.file, version = data.params.version;
                        return opt.fileHandlerApi + "/Document/SpreadsheetsView" + utils.toUrlQuery({
                            fileName: file.title,
                            drive_id: file.driveId,
                            item_id: file.id,
                            version: version
                        }, true);
                    },
                    extensions: [ "_xlsx" ]
                } ]
            });
            obj.addFileHandler({
                actions: [ {
                    type: "preview",
                    url: function(data) {
                        var utils = kendo.ui.junkyard.utils, file = data.file, version = data.params.version;
                        return opt.fileHandlerApi + "/document/pdf" + utils.toUrlQuery({
                            fileName: file.title,
                            drive_id: file.driveId,
                            item_id: file.id,
                            version: version
                        }, true);
                    },
                    extensions: [ "_pdf" ]
                } ]
            });
            obj.addFileHandler({
                actions: [ {
                    type: "preview",
                    url: function(data) {
                        var utils = kendo.ui.junkyard.utils, file = data.file, version = data.params.version;
                        return opt.fileHandlerApi + "/document/odt" + utils.toUrlQuery({
                            fileName: file.title,
                            drive_id: file.driveId,
                            item_id: file.id,
                            version: version
                        }, true);
                    },
                    extensions: [ "_odt" ]
                } ]
            });
        }
        extend(jyNS, {
            defaultConfig: createDefaultConfig,
            defaultFileHandlers: createDefaultFileHandlers,
            createDefaultFileHandlersForSelectWidget: createDefaultFileHandlersForSelectWidget,
            createDefaultFileHandlersForLinkWidget: createDefaultFileHandlersForLinkWidget
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard", [ "kendo.junkyard.ns", "kendo.junkyard.constants", "kendo.junkyard.utils", "kendo.junkyard.template-initializer", "kendo.junkyard.vm.root", "kendo.junkyard.default-config" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, Widget = ui.Widget, jyNS = ui.junkyard, proxy = $.proxy, extend = $.extend, TemplateInitializer = jyNS.TemplateInitializer, RootViewModel = jyNS.RootViewModel, UiEvents = jyNS.UiEvents, utils = jyNS.utils, defaultConfig = jyNS.defaultConfig, defaultFileHandlers = jyNS.defaultFileHandlers, NS = ".kendoJunkyard", INIT = "init", SELECT = "select";
        var Junkyard = Widget.extend({
            init: function(element, options) {
                var that = this;
                Widget.fn.init.call(this, element, options);
                this._defaultOptions();
                this._element();
                this._tryInitTemplates();
                var render = function() {
                    that._viewModel();
                    that._defaultFileHandlers();
                    that._initEvents();
                    that._renderView();
                    that.trigger(INIT);
                };
                if (this.options.asyncInit) {
                    utils.async(function() {
                        render();
                    });
                } else {
                    render();
                }
                kendo.notify(this);
            },
            options: {
                name: "Junkyard",
                useDefaultConfig: true,
                useDefaultHandlers: true,
                serverApi: "",
                authApi: "",
                fileHandlerApi: "",
                createHandlers: [],
                actionFileHandlers: [],
                debugMode: false,
                templateId: "",
                autoBind: true,
                asyncInit: true,
                enableRoutes: true,
                initLocation: "/",
                persistSelection: false,
                selectionItem: "all",
                selectionExclude: "trash",
                driveIds: [],
                debug: {
                    command: false,
                    verbose: false
                },
                drives: {
                    readListUrl: "",
                    createUrl: "",
                    updateUrl: "",
                    readDetailsUrl: "",
                    renameUrl: "",
                    webdavUrl: "",
                    deleteUrl: "",
                    changeQuotaUrl: "",
                    deleteDriveById: ""
                },
                items: {
                    createFolderUrl: "",
                    readListUrl: "",
                    renameUrl: "",
                    moveUrl: "",
                    copyUrl: "",
                    downloadUrl: "",
                    downloadVersionUrl: "",
                    downloadByLinkUrl: "",
                    pathUrl: "",
                    deleteUrl: "",
                    readDetailsUrl: "",
                    versionReadListUrl: "",
                    searchUrl: "",
                    restoreVersionUrl: "",
                    deletedListUrl: "",
                    deletedRestoreUrl: "",
                    clearTrashUrl: "",
                    revokeAllUrls: "",
                    linkByPathUrl: "",
                    linkByIdUrl: "",
                    linkByVersionUrl: "",
                    readItemByHashUrl: "",
                    readItemByNameUrl: "",
                    getOrCreatePathUrl: "",
                    setTagsUrl: "",
                    setDescriptionUrl: ""
                },
                access: {
                    userAndGroupsReadUrl: "",
                    userReadDetailsUrl: "",
                    groupReadDetailsUrl: "",
                    userAndGroupsConverter: null,
                    userDetailsConverter: null,
                    groupDetailsConverter: null,
                    userAndGroupsParamMap: null,
                    userAndGroupsReadTransport: null
                },
                upload: {
                    saveUrl: "",
                    replaceUrl: ""
                },
                auth: {
                    token: {
                        createUrl: "",
                        field: "",
                        method: "POST",
                        withCredentials: false
                    },
                    tokenProvider: null,
                    tokenValidation: {
                        readUrl: "",
                        method: "GET",
                        withCredentials: false
                    },
                    user: {
                        readUrl: ""
                    }
                },
                error: {
                    leaveTimeout: 3e3,
                    hideTimeout: 300
                },
                router: {
                    root: "/"
                },
                localization: {
                    reason: "Reason: {0}",
                    cancelUpload: 'File "{0}" upload was canceled.',
                    uploadFailed: 'File "{0}" upload failed.',
                    requestFailed: "Request failed:  {0}, {1}",
                    driveNotFound: "Drive not found.",
                    commandFailed: '"{0}" failed: {1}',
                    addFolderSuccess: 'Folder "{0}" was added.',
                    addDriveSuccess: 'Drive "{0}" was added.',
                    InvalidAuthToken: "Invalid auth token.",
                    deleteFolderTitle: "",
                    deleteFileTitle: "",
                    clearTrashTitle: "",
                    clearTrashMessage: "",
                    revokeAllUrlsTitle: "",
                    revokeAllUrlsMessage: "",
                    deleteDriveByIdTitle: "",
                    deleteDriveByIdMessage: "",
                    deleteMultipleTitle: "",
                    deleteFolder: "",
                    deleteFile: "",
                    deleteMultiple: "",
                    changeDriveSizeSuccess: "",
                    restoreVersionFailed: "",
                    restoreVersionSuccess: "",
                    noAccess: "",
                    confirm: {
                        okText: "Ok",
                        cancel: "Cancel"
                    }
                }
            },
            events: [ INIT, SELECT ],
            _element: function() {
                this.element.addClass("jy-widget").attr("role", "junkyard");
            },
            clearElement: function() {
                this.element.removeClass("jy-widget").removeAttr("role", "junkyard").html("");
            },
            _defaultOptions: function() {
                var opt = this.options;
                if (opt.useDefaultConfig) {
                    var defConfOpt = {
                        serverApi: opt.serverApi,
                        authApi: opt.authApi,
                        isDebug: opt.debugMode,
                        asyncInit: opt.asyncInit,
                        enableRoutes: opt.enableRoutes,
                        initLocation: opt.initLocation,
                        persistSelection: opt.persistSelection,
                        selectionItem: opt.selectionItem,
                        selectionExclude: opt.selectionExclude,
                        tokenProvider: opt.auth.tokenProvider,
                        driveIds: opt.driveIds,
                        userAndGroupsReadUrl: opt.access.userAndGroupsReadUrl,
                        userReadDetailsUrl: opt.access.userReadDetailsUrl,
                        groupReadDetailsUrl: opt.access.groupReadDetailsUrl,
                        userAndGroupsConverter: opt.access.userAndGroupsConverter,
                        userDetailsConverter: opt.access.userDetailsConverter,
                        groupDetailsConverter: opt.access.groupDetailsConverter,
                        userAndGroupsParamMap: opt.access.userAndGroupsParamMap,
                        userAndGroupsReadTransport: opt.access.userAndGroupsReadTransport
                    };
                    extend(this.options, defaultConfig(defConfOpt));
                }
            },
            _defaultFileHandlers: function() {
                var opt = this.options;
                if (opt.useDefaultHandlers) {
                    defaultFileHandlers(this, {
                        fileHandlerApi: opt.fileHandlerApi
                    });
                }
            },
            _viewModel: function() {
                this.viewModel = new RootViewModel(this.options);
            },
            _renderView: function() {
                var options = this.options, template = options.templateId;
                if (template) {
                    this.view = new kendo.View(template, {
                        model: this.viewModel,
                        evalTemplate: true,
                        wrap: false
                    });
                    this.view.render(this.element);
                    kendo.resize(this.element);
                    this._triggerCreateView();
                }
            },
            _initEvents: function() {
                $(window.document).on("click" + NS, proxy(this._onDocumentClick, this));
                this.selectHandler = proxy(this._onSelect, this);
                this.viewModel.selection.bind(SELECT, this.selectHandler);
            },
            _delEvents: function() {
                $(window.document).off(NS);
                this.viewModel.selection.unbind(SELECT, this.selectHandler);
            },
            _onDocumentClick: function(e) {
                this.viewModel.uiEvents.trigger(UiEvents.DocumentClick, {
                    origin: e
                });
            },
            _onSelect: function(e) {
                this.trigger(SELECT, {
                    items: e.items
                });
            },
            _triggerCreateView: function() {
                this.viewModel.uiEvents.trigger(UiEvents.CreateView);
            },
            _triggerDestroyView: function() {
                this.viewModel.uiEvents.trigger(UiEvents.DestroyView);
            },
            _tryInitTemplates: function() {
                this.templateInitializer = new TemplateInitializer();
                this.templateInitializer.initialize();
            },
            _tryRemoveTemplates: function() {
                if (this.templateInitializer) {
                    this.templateInitializer.destroy();
                    this.templateInitializer = null;
                }
            },
            addFileHandler: function(properties) {
                if (this.viewModel) {
                    this.viewModel.fileHandlerService.addFileHandler(properties);
                }
            },
            removeFileHandlerByExt: function(fileExtension) {
                if (this.viewModel) {
                    this.viewModel.fileHandlerService.removeFileHandlerByExt(fileExtension);
                }
            },
            destroy: function() {
                this._triggerDestroyView();
                this._delEvents();
                if (this.view) {
                    this.view.destroy();
                }
                this._tryRemoveTemplates();
                Widget.fn.destroy.call(this);
                this.element = this.viewModel = this.view = null;
            }
        });
        kendo.ui.plugin(Junkyard);
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.vm.circle-progress", [ "kendo.junkyard.ns", "kendo.junkyard.vm.base" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, BaseViewModel = jyNS.BaseViewModel;
        var CircleProgressViewModel = BaseViewModel.extend({
            init: function(options) {
                BaseViewModel.fn.init.call(this, options);
                this._state();
            },
            _state: function() {
                this.set("visible", true);
                this.set("textVisible", true);
                this.set("max", 0);
                this.set("min", 0);
                this.set("value", 0);
                this.set("percent", 0);
                this.set("initDashOffset", 301.635);
                this.set("dashOffset", this.initDashOffset);
                this.set("dashArray", kendo.format("{0}, {0}", this.initDashOffset));
            },
            setVisible: function(visible) {
                this.set("visible", visible);
                return this;
            },
            setTextVisible: function(textVisible) {
                this.set("textVisible", textVisible);
                return this;
            },
            setValue: function(value) {
                this.set("value", value);
                this._update();
                return this;
            },
            setMax: function(max) {
                this.set("max", max);
                this._update();
                return this;
            },
            setMin: function(min) {
                this.set("min", min);
                this._update();
                return this;
            },
            _update: function() {
                if (this.value > this.max) {
                    this.set("value", this.max);
                }
                if (this.value < this.min) {
                    this.set("value", this.min);
                }
                if (this.max !== 0) {
                    this.set("percent", this.value / this.max * 100);
                }
                var absDashOffset = this.initDashOffset * this.percent / 100;
                this.set("dashOffset", this.initDashOffset - absDashOffset);
            }
        });
        extend(jyNS, {
            CircleProgressViewModel: CircleProgressViewModel
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.vm.select-file", [ "kendo.junkyard.ns", "kendo.junkyard.vm.base", "kendo.junkyard.vm.circle-progress", "kendo.junkyard.constants" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, LinkTypes = jyNS.LinkTypes, BaseViewModel = jyNS.BaseViewModel, ImageTypeExt = jyNS.ImageTypeExt, FileHandlerActionTypes = jyNS.FileHandlerActionTypes, CircleProgressViewModel = jyNS.CircleProgressViewModel;
        var FileStatus = {
            Init: "Init",
            Loading: "Loading",
            Error: "Error",
            NotExists: "NotExists",
            Loaded: "Loaded",
            Sharing: "Sharing",
            Shared: "Shared",
            NotShared: "NotShared",
            PreUpload: "PreUpload",
            Uploading: "Uploading",
            UploadError: "UploadError",
            SelectToUpload: "SelectToUpload",
            Downloading: "Downloading"
        };
        var SelectFileViewModel = BaseViewModel.extend({
            init: function(hash, options) {
                BaseViewModel.fn.init.call(this, options);
                this._state(hash);
                this._proxy();
            },
            _state: function(hash) {
                this.set("hash", hash);
                this.set("status", FileStatus.Init);
                this.set("data", null);
                this.set("needShare", false);
                this.set("uploadProgress", null);
                this.set("params", null);
                this.set("previewLoaded", false);
                this.set("showHistoryBtn", this.widgetOpt.showHistoryBtn);
            },
            _proxy: function() {
                this.proxy("loadSuccess");
                this.proxy("loadFailed");
                this.proxy("shareSuccess");
                this.proxy("shareFailed");
            },
            reset: function() {
                this.set("hash", null);
                this.set("status", FileStatus.Init);
                this.set("data", null);
                this.set("needShare", false);
                this.set("uploadProgress", null);
                this.set("params", null);
                this.set("previewLoaded", false);
                return this;
            },
            load: function() {
                var that = this;
                if (this.needShare) {
                    this.share().done(function() {
                        that.loadData();
                    });
                } else {
                    this.loadData();
                }
            },
            share: function() {
                var root = this.root, api = root.api, widgetOpt = this.widgetOpt, linkType = widgetOpt.linkType;
                var fn = "createLinkById";
                if (linkType === LinkTypes.ByPath) {
                    fn = "createLinkByPath";
                } else if (linkType === LinkTypes.ByVersion) {
                    fn = "createLinkByVersion";
                }
                this.set("status", FileStatus.Sharing);
                return api[fn].call(api, this.data.driveId, this.data.id, widgetOpt.secureShare).done(this.shareSuccess).fail(this.shareFailed);
            },
            loadData: function() {
                var root = this.root, api = root.api;
                this.set("status", FileStatus.Loading);
                return api.getItemByHash(this.hash).done(this.loadSuccess).fail(this.loadFailed);
            },
            loadSuccess: function(item) {
                if (item) {
                    this.set("data", item);
                    this.set("status", FileStatus.Loaded);
                    this.trigger("loaded");
                } else {
                    this.set("status", FileStatus.NotExists);
                }
            },
            loadFailed: function(err) {
                if (err.jqXHR && err.jqXHR.status === 404) {
                    this.set("status", FileStatus.NotExists);
                } else {
                    this.set("status", FileStatus.Error);
                }
            },
            shareSuccess: function(hash) {
                if (hash) {
                    this.set("hash", hash);
                    this.set("status", FileStatus.Shared);
                    this.trigger("shared");
                } else {
                    this.set("status", FileStatus.Error);
                }
            },
            shareFailed: function() {
                this.set("status", FileStatus.Error);
            },
            setFileId: function(fileId) {
                if (!this.data) {
                    this.set("data", {});
                }
                this.data.set("id", fileId);
                return this;
            },
            setDriveId: function(driveId) {
                if (!this.data) {
                    this.set("data", {});
                }
                this.data.set("driveId", driveId);
                return this;
            },
            setData: function(data) {
                this.set("data", data);
            },
            setParams: function(params) {
                this.set("params", params);
            },
            setName: function(name) {
                if (this.data) {
                    this.data.set("title", name);
                }
            },
            setNeedShare: function(needShare) {
                this.set("needShare", needShare);
                return this;
            },
            setStatus: function(status) {
                this.set("status", status);
                return this;
            },
            downloadUrl: function() {
                var api = this.root.api;
                var hash = this.get("hash");
                return hash ? api.makeDownloadByLinkUrl(hash) : null;
            },
            createUploadProgress: function() {
                var uploadProgress = new CircleProgressViewModel(this.options);
                this.set("uploadProgress", uploadProgress);
                return uploadProgress;
            },
            removeUploadProgress: function() {
                this.set("uploadProgress", null);
                return this;
            },
            isPreview: function() {
                var data = this.get("data"), showPreview = this.widgetOpt.showPreview, isLoaded = this.isLoaded(), action = data && data.extension ? this.findSmallPreviewAction(data.extension) : null;
                return showPreview && isLoaded && action != null;
            },
            openPreviewAvailable: function() {
                var showPreview = this.widgetOpt.showPreview, openFileHandler = this.widgetOpt.openFileHandler, isLoaded = this.isLoaded(), data = this.get("data"), action = data && data.extension ? this.findPreviewAction(data.extension) : null;
                return showPreview && isLoaded && action != null || isLoaded && typeof openFileHandler === "function";
            },
            openPreview: function() {
                var openFileHandler = this.widgetOpt.openFileHandler;
                if (this.data && this.isLoaded()) {
                    if (typeof openFileHandler === "function") {
                        var result = openFileHandler({
                            file: this.data,
                            link: this.hash
                        });
                        if (result === false) {
                            this.showPreviewDialog();
                        }
                    } else {
                        this.showPreviewDialog();
                    }
                }
            },
            showPreviewDialog: function() {
                var actions = this.findHandlerActions(this.data.extension);
                this.root.showPreviewDialog(this.data, actions, undefined);
            },
            previewUrl: function() {
                if (this.isPreview()) {
                    var data = this.get("data");
                    var action = this.findSmallPreviewAction(data.extension);
                    var url = action.makeUrl(data, this.root);
                    if (url) {
                        return url;
                    }
                }
                return "";
            },
            onPreviewLoad: function() {
                this.set("previewLoaded", this.isPreview());
            },
            findSmallPreviewAction: function(extension) {
                var fileHandler = this.root.fileHandlerService.findFileHandlerByExt(extension);
                return fileHandler ? fileHandler.findActionByType(FileHandlerActionTypes.SmallPreview) : null;
            },
            findPreviewAction: function(extension) {
                var fileHandler = this.root.fileHandlerService.findFileHandlerByExt(extension);
                return fileHandler ? fileHandler.findActionByType(FileHandlerActionTypes.Preview) : null;
            },
            findHandlerActions: function(extension) {
                var fileHandler = this.root.fileHandlerService.findFileHandlerByExt(extension);
                return fileHandler ? fileHandler.getActions() : [];
            },
            openCropEditor: function() {
                this.root.openCropEditorForFile(this);
            },
            cropEditorSupport: function() {
                return this.widgetOpt.cropEditorImageTypes.indexOf(this.getImageType()) >= 0;
            },
            getImageType: function() {
                var data = this.get("data");
                var extension = data ? data.extension : null;
                return extension ? this._findImageTypeByExt(extension) : null;
            },
            _findImageTypeByExt: function(extension) {
                extension = extension === "jpeg" ? "jpg" : extension;
                var result = null;
                for (var imageType in ImageTypeExt) {
                    if (ImageTypeExt[imageType] === extension) {
                        result = imageType;
                        break;
                    }
                }
                return result;
            },
            download: function() {
                this.onDownload(null);
            },
            onContentClick: function() {
                if (this.openPreviewAvailable()) {
                    this.openPreview();
                }
            },
            onOpenFileHistory: function(e) {
                var openFileHistoryHandler = this.widgetOpt.openFileHistoryHandler;
                e.preventDefault();
                e.stopPropagation();
                if (this.data && this.isLoaded()) {
                    if (typeof openFileHistoryHandler === "function") {
                        openFileHistoryHandler({
                            file: this.data,
                            link: this.hash
                        });
                    }
                }
            },
            onDownload: function(e) {
                var that = this, root = this.root, itemService = root.itemService, downloadOkDelay = this.widgetOpt.downloadOkDelay, secureShare = this.widgetOpt.secureShare, prevStatus = this.status;
                if (e) {
                    this.stopEvent(e);
                }
                if (this.hash) {
                    this.setStatus(FileStatus.Downloading);
                    itemService.requestDownloadItems(root.getDownloadContainerEl(), downloadOkDelay, {
                        hash: this.hash,
                        useAuth: secureShare
                    }).done(function() {
                        that.setStatus(prevStatus);
                    }).fail(function() {
                        that.setStatus(prevStatus);
                    });
                }
            },
            onEdit: function(e) {
                this.stopEvent(e);
                this.openCropEditor();
            },
            canEdit: function() {
                return !this.widgetOpt.readonly && this.isPreview() && this.cropEditorSupport();
            },
            stopEvent: function(e) {
                e.preventDefault();
                e.stopPropagation();
            },
            isDocs: function() {
                var data = this.get("data");
                var extension = data ? data.extension : null;
                var fileIconType = extension ? kendo.ui.junkyard.fileTypeIcon(extension) : null;
                return [ "docs", "pdf", "tables" ].indexOf(fileIconType) !== -1;
            },
            isInit: function() {
                return this.get("status") === FileStatus.Init;
            },
            isLoaded: function() {
                return this.get("status") === FileStatus.Loaded;
            },
            isLoading: function() {
                return this.get("status") === FileStatus.Loading;
            },
            isError: function() {
                return this.get("status") === FileStatus.Error;
            },
            isErrorNotExists: function() {
                return this.get("status") === FileStatus.NotExists;
            },
            isSharing: function() {
                return this.get("status") === FileStatus.Sharing;
            },
            isShared: function() {
                return this.get("status") === FileStatus.Shared;
            },
            isNotShared: function() {
                return this.get("status") === FileStatus.NotShared;
            },
            isPreUpload: function() {
                return this.get("status") === FileStatus.PreUpload;
            },
            isUploading: function() {
                return this.get("status") === FileStatus.Uploading;
            },
            isUploadError: function() {
                return this.get("status") === FileStatus.UploadError;
            },
            isSelectToUpload: function() {
                return this.get("status") === FileStatus.SelectToUpload;
            },
            isDownloading: function() {
                return this.get("status") === FileStatus.Downloading;
            }
        });
        extend(jyNS, {
            SelectFileViewModel: SelectFileViewModel
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.vm.select-value", [ "kendo.junkyard.ns", "kendo.junkyard.vm.base", "kendo.junkyard.vm.select-file" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, ObservableArray = kendo.data.ObservableArray, BaseViewModel = jyNS.BaseViewModel, SelectFileViewModel = jyNS.SelectFileViewModel, VALUE_CHANGED = "valueChanged";
        var SelectValueViewModel = BaseViewModel.extend({
            init: function(options) {
                BaseViewModel.fn.init.call(this, options);
                this._state();
                this._proxy();
                this._authReady();
            },
            _state: function() {
                this.set("files", []);
                this.set("canLoad", false);
                this.set("readonly", false);
            },
            _proxy: function() {
                this.proxy("onFileShared");
            },
            _authReady: function() {
                var that = this, root = this.root;
                root.setAuthReady(function() {
                    that.load();
                    that.setCanLoad(true);
                });
            },
            load: function() {
                this.files.forEach(function(file) {
                    file.load();
                });
            },
            setReadOnly: function(flag) {
                this.set("readonly", flag);
            },
            setCanLoad: function(value) {
                this.set("canLoad", value);
            },
            setValue: function(value, noTriggerChange) {
                var that = this;
                if (value == null || value.length === 0) {
                    this.clearValue(noTriggerChange);
                    return;
                }
                if (value instanceof ObservableArray) {
                    value = value.toJSON();
                } else if (!Array.isArray(value)) {
                    value = [ value ];
                }
                this.files.empty();
                value.forEach(function(val) {
                    var hash = that._getHashFromValue(val);
                    if (hash) {
                        that.addFile(hash);
                    }
                });
                if (!noTriggerChange) {
                    this.notifyValueChanged();
                }
            },
            getValue: function() {
                var that = this;
                if (this.widgetOpt.multiselect) {
                    return this.files.filter(function(file) {
                        return !!file.hash;
                    }).map(function(file) {
                        return that._createValue(file);
                    });
                } else {
                    return this.files[0] ? that._createValue(this.files[0]) : null;
                }
            },
            _createValue: function(file) {
                var widgetOpt = this.widgetOpt, valuePrimitive = widgetOpt.valuePrimitive, dataValueField = widgetOpt.dataValueField;
                if (file.hash) {
                    if (valuePrimitive) {
                        return file.hash;
                    } else {
                        var res = {};
                        res[dataValueField] = file.hash;
                        return res;
                    }
                } else {
                    return null;
                }
            },
            _getHashFromValue: function(value) {
                var widgetOpt = this.widgetOpt, valuePrimitive = widgetOpt.valuePrimitive, dataValueField = widgetOpt.dataValueField;
                if (valuePrimitive) {
                    return value;
                } else if (value != null) {
                    return value[dataValueField];
                } else {
                    return null;
                }
            },
            clearValue: function(noTriggerChange) {
                this._clearFiles();
                if (!noTriggerChange) {
                    this.notifyValueChanged();
                }
            },
            notifyValueChanged: function() {
                this.trigger(VALUE_CHANGED, {
                    value: this.getValue()
                });
            },
            addFile: function(hash) {
                var file = new SelectFileViewModel(hash, this.options);
                if (this.canLoad) {
                    file.load();
                }
                this.files.push(file);
            },
            removeFile: function(file) {
                this.files.remove(file);
                file.unbind();
            },
            findFileByDriveAndId: function(driveId, id) {
                return this.files.find(function(file) {
                    return file.data && file.data.driveId === driveId && file.data.id === id;
                });
            },
            mergeNotSharedValue: function(value, noTriggerChange, callback) {
                this.mergeNotSharedFiles(value || [], callback);
                if (!noTriggerChange) {
                    this.notifyValueChanged();
                }
            },
            setNotSharedValue: function(value, noTriggerChange, callback) {
                this.files.empty();
                this.mergeNotSharedFiles(value || [], callback);
                if (!noTriggerChange) {
                    this.notifyValueChanged();
                }
            },
            mergeNotSharedFiles: function(filesData, callback) {
                var that = this;
                var add = filesData.filter(function(fileData) {
                    return !that.files.find(function(file) {
                        return file.data && file.data.id === fileData.itemId && file.data.driveId === fileData.driveId;
                    });
                });
                if (add.length > 0) {
                    add.forEach(function(fileData) {
                        that.addNotSharedFile(fileData.itemId, fileData.driveId, callback);
                    });
                }
            },
            addNotSharedFile: function(fileId, driveId, callback) {
                var file = new SelectFileViewModel(null, this.options);
                file.setFileId(fileId).setDriveId(driveId).setNeedShare(true).one("shared", this.onFileShared);
                if (callback) {
                    file.one("loaded", callback);
                }
                if (this.canLoad) {
                    file.load();
                }
                this.files.push(file);
            },
            fileToNotShared: function(file, fileId, driveId) {
                file.reset().setFileId(fileId).setDriveId(driveId).setNeedShare(true).unbind("shared", this.onFileShared).one("shared", this.onFileShared).load();
            },
            fileCount: function() {
                return this.get("files").length;
            },
            loaded: function() {
                return !this.get("files").some(function(file) {
                    return file.isInit() || file.isLoading() || file.isSharing() || file.isUploading();
                });
            },
            isEmpty: function() {
                return this.fileCount() === 0;
            },
            _clearFiles: function() {
                var that = this;
                that.files.forEach(function(file) {
                    if (!that.trigger("fileRemove", {
                        item: file
                    })) {
                        that.removeFile(file);
                    }
                });
            },
            onFileRemove: function(e) {
                e.preventDefault();
                e.stopPropagation();
                if (!this.trigger("fileRemove", {
                    item: e.data
                })) {
                    this.removeFile(e.data);
                    this.notifyValueChanged();
                }
            },
            onRetryUpload: function(e) {
                this.trigger("retryUpload", {
                    item: e.data
                });
            },
            onFileShared: function(e) {
                if (this.files.indexOf(e.sender) > -1) {
                    this.notifyValueChanged();
                }
            }
        });
        extend(jyNS, {
            SelectValueViewModel: SelectValueViewModel
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.vm.select-upload", [ "kendo.junkyard.ns", "kendo.junkyard.vm.base" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, BaseViewModel = jyNS.BaseViewModel;
        var SelectUploadViewModel = BaseViewModel.extend({
            init: function(options) {
                BaseViewModel.fn.init.call(this, options);
                this._state();
                this._proxy();
                this._setupEvents();
            },
            _state: function() {
                this.driveId = null;
                this.itemId = null;
                this.readonly = false;
                this.fileExtensions = null;
                this.uploadWidget = null;
            },
            _proxy: function() {
                this.proxy("onCreate");
            },
            _setupEvents: function() {
                this.bind("createView", this.onCreate);
            },
            setItemId: function(itemId) {
                this.itemId = itemId;
                return this;
            },
            setDriveId: function(driveId) {
                this.driveId = driveId;
                return this;
            },
            setReadOnly: function(flag) {
                this.readonly = flag;
                if (this.uploadWidget) {
                    this.uploadWidget.enable(!flag);
                }
                return this;
            },
            setAccepts: function(fileExtensions) {
                this.fileExtensions = fileExtensions;
                if (this.uploadWidget) {
                    var accept = fileExtensions.map(function(x) {
                        return x.indexOf("/") >= 0 ? x : "." + x;
                    }).join(",");
                    var widget = this.uploadWidget.element[0];
                    $(widget).attr("accept", accept);
                }
                return this;
            },
            clickInput: function(driveId, itemId) {
                if (this.uploadWidget) {
                    this.uploadWidget.element.trigger("click", [ driveId, itemId ]);
                }
            },
            _updateUploadUrl: function(driveId, itemId) {
                if (this.uploadWidget) {
                    var api = this.root.api;
                    var asyncOpt = this.uploadWidget.options.async;
                    asyncOpt.saveUrl = api.makeUploadFileUrl(driveId, itemId);
                }
            },
            _setFileParams: function(files) {
                var that = this;
                (files || []).forEach(function(file) {
                    file.params = {
                        driveId: that.driveId,
                        itemId: that.itemId
                    };
                });
            },
            _populateFormData: function(e) {
                if (this.uploadWidget) {
                    var formData = new FormData(), saveField = this.uploadWidget.options.async.saveField, fieldName = this.uploadWidget.name, formName = saveField || fieldName;
                    e.files.forEach(function(file) {
                        if (file.newName) {
                            formData.append(formName, file.newBlob || file.rawFile, file.newName);
                        } else if (file.newBlob) {
                            formData.append(formName, file.newBlob, file.rawFile.name);
                        } else {
                            formData.append(formName, file.rawFile, file.rawFile.name);
                        }
                    });
                    e.formData = formData;
                }
            },
            allowedExtensionsOpt: function() {
                var ext = this.widgetOpt.uploadExt || [];
                return ext.length > 0 ? "['" + ext.join("','") + "']" : "[]";
            },
            uploadFileByUid: function(fileUid) {
                if (this.uploadWidget) {
                    this.uploadWidget.uploadFileByUid(fileUid);
                }
            },
            cancelUploadByUid: function(fileUid) {
                if (this.uploadWidget) {
                    this.uploadWidget.cancelUploadByUid(fileUid);
                }
            },
            retryUploadByUid: function(fileUid) {
                if (this.uploadWidget) {
                    this.uploadWidget.retryUploadByUid(fileUid);
                }
            },
            clearFileByUid: function(fileUid) {
                if (this.uploadWidget) {
                    this.uploadWidget.clearFileByUid(fileUid);
                }
            },
            changeFileNameByUid: function(fileUid, newName) {
                if (this.uploadWidget) {
                    this.uploadWidget.changeFileNameByUid(fileUid, newName);
                }
            },
            changeFileBlobByUid: function(fileUid, newBlob) {
                if (this.uploadWidget) {
                    this.uploadWidget.changeFileBlobByUid(fileUid, newBlob);
                }
            },
            selectRawFile: function(rawFile) {
                if (this.uploadWidget) {
                    this.uploadWidget.selectRawFile(rawFile);
                }
            },
            canUpload: function() {
                return !!this.driveId;
            },
            onFileSelect: function(e) {
                this._setFileParams(e.files);
                this.trigger("beforeFileSelect", {
                    files: e.files
                });
                for (var i = 0; i < e.files.length; i++) {
                    this.trigger("fileSelect", {
                        file: e.files[i]
                    });
                }
            },
            onFileUpload: function(e) {
                var files = e.files, params = files && files[0] ? files[0].params : null;
                if (params) {
                    this._updateUploadUrl(params.driveId, params.itemId);
                    this.trigger("fileUpload", {
                        file: e.files[0]
                    });
                    this._populateFormData(e);
                } else {
                    e.preventDefault();
                }
            },
            onFileSuccess: function(e) {
                this.trigger("fileSuccess", {
                    file: e.files[0],
                    response: e.response
                });
            },
            onFileCancel: function(e) {
                this.trigger("fileCancel", {
                    file: e.files[0]
                });
            },
            onFileError: function(e) {
                this.trigger("fileError", {
                    file: e.files[0]
                });
            },
            onFileProgress: function(e) {
                this.trigger("fileProgress", {
                    file: e.files[0],
                    percent: e.percentComplete
                });
            },
            onFileRemove: function(e) {
                this.trigger("fileRemove", {
                    file: e.files[0]
                });
            },
            onUploadCompleted: function() {
                this.trigger("uploadCompleted");
            },
            onDropZone: function() {},
            onClickInput: function(e) {
                var driveId = e.params[0], itemId = e.params[1];
                if (!driveId) {
                    e.preventDefault();
                    return;
                }
                this.setDriveId(driveId).setItemId(itemId);
            },
            onCreate: function() {
                var widgetId = "#jy-widget-upload-" + this.uid;
                this.uploadWidget = $(widgetId).data("kendoJunkyardUpload");
                this.uploadWidget.enable(!this.readonly);
                if (this.fileExtensions) {
                    this.setAccepts(this.fileExtensions);
                }
            }
        });
        extend(jyNS, {
            SelectUploadViewModel: SelectUploadViewModel
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.vm.select-uploader", [ "kendo.junkyard.ns", "kendo.junkyard.vm.base", "kendo.junkyard.vm.select-upload", "kendo.junkyard.data", "kendo.junkyard.vm.select-file", "kendo.junkyard.constants" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, BaseViewModel = jyNS.BaseViewModel, SelectUploadViewModel = jyNS.SelectUploadViewModel, SelectFileViewModel = jyNS.SelectFileViewModel, URL = window.URL || window.webkitURL, ds = jyNS.ds;
        var SelectUploaderViewModel = BaseViewModel.extend({
            init: function(options) {
                BaseViewModel.fn.init.call(this, options);
                this._state();
                this._proxy();
                this._authReady();
            },
            _state: function() {
                this.set("targetDrive", null);
                this.set("targetFolder", null);
                this.set("targetDriveError", false);
                this.set("upload", null);
                this.set("readonly", false);
                this.set("fileExtensions", null);
                this.set("cropEditorDisabled", false);
                this.files = {};
            },
            _proxy: function() {
                this.proxy("onFileSelect");
                this.proxy("onFileUpload");
                this.proxy("onFileProgress");
                this.proxy("onFileSuccess");
                this.proxy("onFileError");
                this.proxy("onFileRemove");
                this.proxy("onRetryUpload");
                this.proxy("onUploadCompleted");
                this.proxy("onBeforeFileSelect");
            },
            _authReady: function() {
                var that = this, root = this.root;
                root.setAuthReady(function() {
                    that._loadTargetDrive();
                });
            },
            _loadTargetDrive: function() {
                var fileStorageOpt = this.widgetOpt.fileStorage, drivesOpt = fileStorageOpt.drives, auth = this.root.auth, widgetOpt = this.widgetOpt;
                var driveDs = new ds.DriveDataSource(auth, drivesOpt.readListUrl);
                driveDs.setUnlimPageSize();
                if (widgetOpt.uploadDrivePrimary) {
                    driveDs.paramIsPrimary = true;
                }
                if (widgetOpt.uploadDriveOwned) {
                    driveDs.paramIsOwned = true;
                }
                return driveDs.abort().read().done(this._loadTargetDriveSuccess(driveDs)).fail(this._loadTargetDriveFailed());
            },
            _loadTargetDriveSuccess: function(ds) {
                var that = this;
                return function() {
                    var widgetOpt = that.widgetOpt, uploadDrivePrimary = widgetOpt.uploadDrivePrimary, uploadDriveOwned = widgetOpt.uploadDriveOwned, uploadDriveFirst = widgetOpt.uploadDriveFirst, uploadDrive = widgetOpt.uploadDrive, uploadFolderPath = widgetOpt.uploadFolderPath;
                    var findDrive = function(label) {
                        return ds.data().find(function(drive) {
                            return drive.label === label;
                        });
                    };
                    if (uploadDrivePrimary || uploadDriveOwned) {
                        if (uploadDrive) {
                            that.set("targetDrive", findDrive(uploadDrive));
                        } else if (uploadDriveFirst) {
                            that.set("targetDrive", ds.at(0));
                        }
                    } else if (uploadDrive) {
                        that.set("targetDrive", findDrive(uploadDrive));
                    } else if (uploadDriveFirst) {
                        that.set("targetDrive", ds.at(0));
                    }
                    if (that.targetDrive) {
                        if (uploadFolderPath) {
                            that._setupUploadByFolderPath(that.targetDrive.label, uploadFolderPath);
                        } else {
                            that._setupUpload(that.targetDrive);
                        }
                    }
                };
            },
            _setupUploadByFolderPath: function(driveLabel, folderPath) {
                var that = this;
                that._getOrCreatePath(driveLabel, folderPath).done(function(itemModel) {
                    if (itemModel) {
                        that.set("targetFolder", itemModel);
                        that._setupUpload(that.targetDrive, that.targetFolder);
                    } else {
                        that.set("targetDrive", null);
                    }
                }).fail(function() {
                    that.set("targetDrive", null);
                    that.set("targetDriveError", true);
                });
            },
            _getOrCreatePath: function(driveLabel, folderPath) {
                var api = this.root.api;
                var paths = this._folderPathToArray(folderPath);
                return api.getOrCreatePath(driveLabel, paths);
            },
            _folderPathToArray: function(path) {
                path = path || "";
                path = this._normalizeSlash(path);
                path = this._trimSlash(path);
                return path ? path.split("/").filter(function(str) {
                    return !!str;
                }) : [];
            },
            _normalizeSlash: function(str) {
                var replacement = "/";
                str = str.replace(new RegExp("\\\\", "g"), replacement);
                return str;
            },
            _trimSlash: function(str) {
                str = str.replace(/^\/|\/$/g, "");
                return str;
            },
            _loadTargetDriveFailed: function() {
                var that = this;
                return function() {
                    that.set("targetDriveError", true);
                };
            },
            isTargetDrive: function() {
                return !!this.get("targetDrive");
            },
            isTargetDriveError: function() {
                return this.get("targetDriveError");
            },
            setReadOnly: function(flag) {
                this.set("readonly", flag);
                if (this.upload) {
                    this.upload.setReadOnly(flag);
                }
            },
            setAccepts: function(fileExtensions) {
                this.set("fileExtensions", fileExtensions);
                if (this.upload) {
                    this.upload.setAccepts(fileExtensions);
                }
            },
            _setupUpload: function(drive, folder) {
                var root = this.root, value = root.value;
                var uploadVm = new SelectUploadViewModel(this.options);
                uploadVm.setDriveId(drive.id).setItemId(folder ? folder.id : null).setReadOnly(this.readonly).setAccepts(this.fileExtensions).bind("fileUpload", this.onFileUpload).bind("fileProgress", this.onFileProgress).bind("fileSuccess", this.onFileSuccess).bind("fileError", this.onFileError).bind("fileSelect", this.onFileSelect).bind("beforeFileSelect", this.onBeforeFileSelect).bind("uploadCompleted", this.onUploadCompleted);
                this.set("upload", uploadVm);
                value.bind("fileRemove", this.onFileRemove);
                value.bind("retryUpload", this.onRetryUpload);
            },
            _removeUpload: function() {
                var root = this.root, value = root.value;
                this.set("upload", null);
                value.unbind("fileRemove", this.onFileRemove).unbind("retryUpload", this.onRetryUpload);
            },
            _findFileUid: function(fileVm) {
                var result = null;
                for (var uid in this.files) {
                    if (this.files[uid] === fileVm) {
                        result = uid;
                        break;
                    }
                }
                return result;
            },
            clickInput: function() {
                if (this.targetDrive && this.upload) {
                    this.upload.clickInput(this.targetDrive.id, this.targetFolder ? this.targetFolder.id : null);
                }
            },
            createRawFile: function(fileName, blob) {
                var lastModified = new Date();
                blob.lastModified = lastModified.getTime();
                blob.lastModifiedDate = lastModified;
                blob.name = fileName;
                blob.webkitRelativePath = "";
                return blob;
            },
            selectRawFile: function(rawFile) {
                if (this.upload) {
                    this.upload.selectRawFile(rawFile);
                }
            },
            disableCropEditor: function(flag) {
                this.set("cropEditorDisabled", flag);
            },
            _createFileVm: function(file) {
                var fileVm = new SelectFileViewModel(null, this.options);
                fileVm.setData({
                    title: file.name,
                    size: file.size,
                    extension: (file.extension || "").replace(".", "")
                });
                fileVm.setParams(file.params);
                return fileVm;
            },
            _changeFileVmName: function(uid, newName) {
                if (this.files[uid]) {
                    this.files[uid].setName(newName);
                }
            },
            _preFileUpload: function(fileVm, fileUid, retry) {
                var that = this, root = that.root, itemService = root.itemService, fileName = fileVm.data.title, params = fileVm.params;
                fileVm.setStatus("PreUpload");
                if (params) {
                    itemService.requestUniqName(fileName, params.driveId, params.itemId).done(function(requestedName) {
                        if (that.upload) {
                            that._changeFileVmName(fileUid, requestedName);
                            that.upload.changeFileNameByUid(fileUid, requestedName);
                            if (retry) {
                                that.upload.retryUploadByUid(fileUid);
                            } else {
                                that.upload.uploadFileByUid(fileUid);
                            }
                        }
                    }).fail(function() {
                        if (that.upload) {
                            if (retry) {
                                that.upload.retryUploadByUid(fileUid);
                            } else {
                                that.upload.uploadFileByUid(fileUid);
                            }
                        }
                    });
                }
            },
            _canUseCropEditor: function(file) {
                var cropEditor = this.widgetOpt.cropEditor;
                return cropEditor && !this.cropEditorDisabled && this._cropEditorAllowed(file.rawFile.type);
            },
            _cropEditorAllowed: function(type) {
                var cropEditorImageTypes = this.widgetOpt.cropEditorImageTypes;
                return cropEditorImageTypes.indexOf((type || "").toLowerCase()) >= 0;
            },
            _openCropEditor: function(file) {
                var that = this, root = this.root, value = root.value, fileUid = file.uid, inputImageType = file.rawFile.type, outputFileName = file.newName || file.name, sourceImageUrl = URL.createObjectURL(file.rawFile);
                root.showCropEditorDialog(sourceImageUrl, inputImageType, outputFileName, function(e) {
                    URL.revokeObjectURL(sourceImageUrl);
                    sourceImageUrl = null;
                    if (e.result) {
                        that.onCropEditorResult(e.sender, fileUid, outputFileName);
                    } else {
                        value.onFileRemove({
                            data: that.files[fileUid]
                        });
                    }
                });
            },
            _showErrors: function(fileName, errors) {
                this.root.showFileErrors(fileName, errors);
            },
            _clearAllErrors: function() {
                this.root.clearAllFileErrors();
            },
            onCropEditorResult: function(dialog, fileUid, originFileName) {
                var that = this, fileVm = this.files[fileUid], dialogVm = dialog.viewModel;
                if (!fileVm) {
                    return;
                }
                var outputImageType = dialogVm.getOutputImageType();
                var outputFileName = dialogVm.getOutputFileName();
                var fillColor = dialogVm.getOutputFillColor();
                if (outputFileName !== originFileName) {
                    this._changeFileVmName(fileUid, outputFileName);
                    this.upload.changeFileNameByUid(fileUid, outputFileName);
                }
                dialogVm.getOutputBlob(function(blob) {
                    that.upload.changeFileBlobByUid(fileUid, blob);
                    that._preFileUpload(fileVm, fileUid, false);
                }, outputImageType, undefined, fillColor);
            },
            onBeforeFileSelect: function() {
                this._clearAllErrors();
            },
            onFileSelect: function(e) {
                var root = this.root, value = root.value, file = e.file, validationErrors = file.validationErrors, multiselect = this.widgetOpt.multiselect;
                if (validationErrors && validationErrors.length > 0) {
                    this._showErrors(file.name, validationErrors);
                    return;
                }
                var fileVm = this._createFileVm(file);
                fileVm.setStatus("SelectToUpload");
                this.files[file.uid] = fileVm;
                if (!multiselect) {
                    value.clearValue();
                }
                value.files.push(fileVm);
                if (this._canUseCropEditor(file)) {
                    this._openCropEditor(file);
                } else {
                    this._preFileUpload(fileVm, file.uid, false);
                }
            },
            onFileUpload: function(e) {
                var file = e.file, fileVm = this.files[file.uid];
                if (fileVm) {
                    var uploadProgress = fileVm.uploadProgress ? fileVm.uploadProgress : fileVm.createUploadProgress();
                    uploadProgress.setMax(100).setValue(0);
                    fileVm.setStatus("Uploading");
                }
            },
            onFileProgress: function(e) {
                var file = e.file, fileVm = this.files[file.uid];
                if (fileVm) {
                    fileVm.uploadProgress.setValue(e.percent);
                }
            },
            onFileSuccess: function(e) {
                var value = this.root.value, file = e.file, fileVm = this.files[file.uid], response = e.response || {};
                if (fileVm) {
                    fileVm.removeUploadProgress();
                    if (Array.isArray(response) && response[0] && file.params.driveId) {
                        value.fileToNotShared(fileVm, response[0], file.params.driveId);
                    } else {
                        fileVm.setStatus("NotShared");
                    }
                }
                delete this.files[file.uid];
            },
            onFileError: function(e) {
                var file = e.file, fileVm = this.files[file.uid];
                if (fileVm) {
                    fileVm.setStatus("UploadError");
                }
            },
            onFileRemove: function(e) {
                var fileUid = this._findFileUid(e.item);
                if (fileUid) {
                    if (e.item.isUploading()) {
                        this.upload.cancelUploadByUid(fileUid);
                    } else {
                        this.upload.clearFileByUid(fileUid);
                    }
                    delete this.files[fileUid];
                }
            },
            onRetryUpload: function(e) {
                if (e.item.isUploadError()) {
                    var fileUid = this._findFileUid(e.item);
                    if (fileUid) {
                        this._preFileUpload(e.item, fileUid, true);
                    }
                }
            },
            onUploadCompleted: function() {}
        });
        extend(jyNS, {
            SelectUploaderViewModel: SelectUploaderViewModel
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.vm.select-file-error", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.vm.base", "kendo.junkyard.constants" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, utils = jyNS.utils, BaseViewModel = jyNS.BaseViewModel;
        var SelectFileErrorViewModel = BaseViewModel.extend({
            init: function(fileName, errorType, options) {
                BaseViewModel.fn.init.call(this, options);
                this._state(fileName, errorType);
                this._proxy();
            },
            _state: function(fileName, errorType) {
                this.set("message", this._createMessage(fileName, errorType));
            },
            _proxy: function() {},
            _createMessage: function(fileName, errorType) {
                var localization = this.widgetOpt.localization, uploadExt = this.widgetOpt.uploadExt, uploadMaxSize = this.widgetOpt.uploadMaxSize, uploadMinSize = this.widgetOpt.uploadMinSize;
                switch (errorType) {
                  case "invalidMaxFileSize":
                    return kendo.format(localization[errorType], fileName, utils.formatSize(uploadMaxSize));

                  case "invalidMinFileSize":
                    return kendo.format(localization[errorType], fileName, utils.formatSize(uploadMinSize));

                  case "invalidFileExtension":
                    return kendo.format(localization[errorType], fileName, (uploadExt || []).join(", "));

                  default:
                    return "";
                }
            }
        });
        extend(jyNS, {
            SelectFileErrorViewModel: SelectFileErrorViewModel
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.vm.cloud-file-chooser-dialog", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.vm.base", "kendo.junkyard.constants" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, BaseViewModel = jyNS.BaseViewModel, utils = jyNS.utils, CLOSE = "close", DEF_WND_WIDTH = 1420, DEF_WND_HEIGHT = 780, WND_MARGIN = 30, WND_2MARGIN = WND_MARGIN * 2;
        var CloudFileChooserDialogViewModel = BaseViewModel.extend({
            init: function(options) {
                BaseViewModel.fn.init.call(this, options);
                this._state();
                this._proxy();
                this.bind("beforeOpenDialog", this._beforeOpenDialog);
                this.bind("createView", this._onCreateView);
            },
            _state: function() {
                this.set("selectedItems", []);
                this.set("selectedModels", []);
                this.set("dialogResult", false);
                this.set("windowOpt", this._windowOpt());
            },
            _proxy: function() {
                this.proxy("_beforeOpenDialog");
            },
            isValid: function() {
                return this.get("selectedItems").length > 0;
            },
            getSelectedItems: function() {
                return this.selectedItems.toJSON();
            },
            getSelectedModels: function() {
                return this.selectedModels.toJSON();
            },
            selectedItemsCount: function() {
                return this.get("selectedItems").length;
            },
            onOk: function() {
                if (this.isValid()) {
                    this.set("dialogResult", true);
                    this.close();
                }
            },
            onCancel: function() {
                this.close();
            },
            close: function() {
                this.trigger(CLOSE);
            },
            _windowOpt: function() {
                var doc = $(document), viewportWidth = doc.width(), viewportHeight = doc.height();
                var opt = {
                    width: DEF_WND_WIDTH,
                    height: DEF_WND_HEIGHT
                };
                if (opt.width > viewportWidth) {
                    opt.width = viewportWidth - WND_2MARGIN;
                }
                if (opt.height > viewportHeight) {
                    opt.height = viewportHeight - WND_2MARGIN;
                }
                return opt;
            },
            _beforeOpenDialog: function(e) {
                var windowOpt = this.windowOpt;
                var windowSizeChanged = windowOpt.width !== DEF_WND_WIDTH || windowOpt.height !== DEF_WND_HEIGHT;
                e.dialog.options.isMaximize = windowSizeChanged;
            },
            onSelect: function(e) {
                var items = e.items.map(this._fileData);
                var models = e.items.map(this._fileModel);
                if (this.widgetOpt.multiselect) {
                    this.set("selectedItems", items);
                    this.set("selectedModels", models);
                } else {
                    var firstItem = utils.first(items);
                    var firstModel = utils.first(models);
                    this.set("selectedItems", firstItem ? [ firstItem ] : []);
                    this.set("selectedModels", firstModel ? [ firstModel ] : []);
                }
            },
            _fileData: function(item) {
                return {
                    itemId: item.id,
                    driveId: item.driveId
                };
            },
            _fileModel: function(item) {
                return {
                    id: item.id,
                    driveId: item.driveId,
                    extension: item.extension,
                    title: item.title,
                    size: item.size,
                    type: item.type
                };
            },
            _onCreateView: function() {
                var junkyardWidget = $("#jy-junkyard-" + this.uid).data("kendoJunkyard");
                this._initOptions(junkyardWidget);
            },
            _initOptions: function(widget) {
                var fileStorageOpt = this.widgetOpt.fileStorage;
                var authOpt = extend(true, {}, fileStorageOpt.auth);
                var accessOpt = extend(true, {}, fileStorageOpt.access);
                var createHandlersOpt = this.widgetOpt.createHandlers;
                var actionFileHandlersOpt = this.widgetOpt.actionFileHandlers;
                var driveIds = fileStorageOpt.driveIds;
                extend(true, widget.options, {
                    auth: authOpt,
                    access: accessOpt,
                    createHandlers: createHandlersOpt,
                    actionFileHandlers: actionFileHandlersOpt,
                    driveIds: driveIds
                });
            }
        });
        extend(jyNS, {
            CloudFileChooserDialogViewModel: CloudFileChooserDialogViewModel
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.vm.crop-editor-dialog", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.vm.base", "kendo.junkyard.constants" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, BaseViewModel = jyNS.BaseViewModel, AspectRatioTypes = jyNS.AspectRatioTypes, CLOSE = "close";
        var CropEditorDialogViewModel = BaseViewModel.extend({
            init: function(sourceImageUrl, inputImageType, outputFileName, options) {
                BaseViewModel.fn.init.call(this, options);
                this._state(sourceImageUrl, inputImageType, outputFileName);
                this._proxy();
                this.bind("createView", this.onCreateView);
                this.bind("closeView", this.onDestroyView);
            },
            _state: function(sourceImageUrl, inputImageType, outputFileName) {
                this.set("sourceImageUrl", sourceImageUrl);
                this.set("inputImageType", inputImageType);
                this.set("outputFileName", outputFileName);
                this.set("cropAspectRatio", AspectRatioTypes.RatioFree);
                this.set("cropFixedAspectRatio", false);
                this.set("dialogResult", false);
                this.set("isValid", false);
                this._cropEditor = null;
            },
            _proxy: function() {
                this.proxy("onCreateView");
                this.proxy("onDestroyView");
            },
            onOk: function() {
                this.set("dialogResult", true);
                this.close();
            },
            onCropChange: function(e) {
                var vm = e.sender.viewModel;
                this.set("isValid", vm.croppedNonZero());
            },
            onCropEditorInit: function(e) {
                var cropEditor = e.sender;
                cropEditor.viewModel.setInputImageType(this.inputImageType);
                cropEditor.viewModel.setOutputFileName(this.outputFileName);
            },
            onCancel: function() {
                this.close();
            },
            close: function() {
                this.trigger(CLOSE);
            },
            setCropAspectRatio: function(cropAspectRatio) {
                this.set("cropAspectRatio", cropAspectRatio);
            },
            setCropFixedAspectRatio: function(cropFixedAspectRatio) {
                this.set("cropFixedAspectRatio", cropFixedAspectRatio);
            },
            getCropEditor: function() {
                return this._cropEditor;
            },
            getOutputImageType: function() {
                return this._cropEditor ? this._cropEditor.viewModel.getOutputImageType() : null;
            },
            getOutputFileName: function() {
                return this._cropEditor ? this._cropEditor.viewModel.getOutputFileName() : null;
            },
            getOutputFillColor: function() {
                return this._cropEditor ? this._cropEditor.viewModel.getOutputFillColor() : null;
            },
            getOutputBlob: function(callback, imageType, quality, fillColor) {
                return this._cropEditor ? this._cropEditor.viewModel.getCroppedBlob(callback, imageType, quality, fillColor) : null;
            },
            onCreateView: function() {
                this._cropEditor = $("#jy-crop-editor-" + this.uid).data("kendoJunkyardCropEditor");
            },
            onDestroyView: function() {
                this._cropEditor = null;
                this.sourceImageUrl = null;
            }
        });
        extend(jyNS, {
            CropEditorDialogViewModel: CropEditorDialogViewModel
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.vm.select-widget", [ "kendo.junkyard.ns", "kendo.junkyard.auth", "kendo.junkyard.api", "kendo.junkyard.item-service", "kendo.junkyard.vm.base", "kendo.junkyard.vm.ui-events", "kendo.junkyard.vm.select-value", "kendo.junkyard.vm.select-uploader", "kendo.junkyard.vm.select-file-error", "kendo.junkyard.vm.cloud-file-chooser-dialog", "kendo.junkyard.vm.crop-editor-dialog", "kendo.junkyard.vm.preview-dialog", "kendo.junkyard.file-handler-service", "kendo.junkyard.constants", "kendo.junkyard.commandutil" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, Commands = jyNS.Commands, CommandManager = jyNS.CommandManager, BaseViewModel = jyNS.BaseViewModel, JunkyardApi = jyNS.JunkyardApi, JunkyardItemService = jyNS.JunkyardItemService, FileHandlerService = jyNS.FileHandlerService, Authenticator = jyNS.Authenticator, SelectValueViewModel = jyNS.SelectValueViewModel, SelectUploaderViewModel = jyNS.SelectUploaderViewModel, SelectFileErrorViewModel = jyNS.SelectFileErrorViewModel, CloudFileChooserDialogViewModel = jyNS.CloudFileChooserDialogViewModel, CropEditorDialogViewModel = jyNS.CropEditorDialogViewModel, UiEventsViewModel = jyNS.UiEventsViewModel, PreviewDialogViewModel = jyNS.PreviewDialogViewModel, INVALIDFILEEXTENSION = "invalidFileExtension", CLOSE = "close", CLOSED = "closed";
        var AuthStatus = {
            Init: "Init",
            Progress: "Progress",
            Failed: "Failed",
            Success: "Success"
        };
        var SelectWidgetViewModel = BaseViewModel.extend({
            init: function(widgetOptions) {
                BaseViewModel.fn.init.call(this, {
                    widgetOptions: widgetOptions,
                    root: this
                });
                this._state();
                this._proxy();
                this._services();
                this._viewModels();
                this._baseUIEvents();
                if (this.widgetOpt.readonly) {
                    this.setReadOnly(true);
                }
                this.setAccepts(this.widgetOpt.fileExtensions);
            },
            _state: function() {
                this.set("btnDisabled", false);
                this.set("isReadOnly", false);
                this.set("localUploadBtnDisabled", false);
                this.set("cloudChooseFileBtnDisabled", false);
                this.set("authStatus", AuthStatus.Init);
                this.set("fileErrors", []);
                this.authReady = $.Deferred();
            },
            _proxy: function() {
                this.proxy("onCloudFileChooserResult");
                this.proxy("onCropEditorForFileResult");
            },
            _services: function() {
                this.auth = new Authenticator(this.widgetOpt.fileStorage);
                this.api = new JunkyardApi(this.widgetOpt.fileStorage, this.auth);
                this.itemService = new JunkyardItemService(this.widgetOpt.fileStorage, this.api);
                this.fileHandlerService = new FileHandlerService();
                this.commandService = this._createCommandService();
                this.commandManager = new CommandManager(this, false, []);
                this.service = {
                    auth: this.auth
                };
            },
            _viewModels: function() {
                this.set("uiEvents", new UiEventsViewModel(this.options));
                this.set("value", new SelectValueViewModel(this.options));
                this.set("uploader", new SelectUploaderViewModel(this.options));
            },
            _createCommandService: function() {
                var that = this;
                return {
                    downloadItem: function(driveId, itemIds) {
                        var fileVm = that.value.findFileByDriveAndId(driveId, itemIds[0]);
                        if (fileVm) {
                            fileVm.download();
                        }
                    },
                    openFile: function(itemModel, actionType, version) {
                        return that.commandManager.makeCommand(Commands.OpenFile, {
                            item: itemModel,
                            actionType: actionType,
                            version: version
                        }).exec();
                    }
                };
            },
            setAuthReady: function(fn) {
                if (this.isAuthSuccess()) {
                    fn();
                } else {
                    this.authReady.done(fn);
                }
            },
            authenticate: function() {
                var that = this, auth = this.auth, defer = $.Deferred();
                if (auth.enabled()) {
                    this.set("authStatus", AuthStatus.Progress);
                    auth.getToken().done(function() {
                        that.set("authStatus", AuthStatus.Success);
                        defer.resolve();
                    }).fail(function(e) {
                        that.set("authStatus", AuthStatus.Failed);
                        defer.reject(e);
                    });
                } else {
                    this.set("authStatus", AuthStatus.Success);
                    defer.resolve();
                }
                return defer.promise();
            },
            isAuthInit: function() {
                return this.get("authStatus") === AuthStatus.Init;
            },
            isAuthProgress: function() {
                return this.get("authStatus") === AuthStatus.Progress;
            },
            isAuthSuccess: function() {
                return this.get("authStatus") === AuthStatus.Success;
            },
            isAuthFailed: function() {
                return this.get("authStatus") === AuthStatus.Failed;
            },
            emptyVisible: function() {
                return this.widgetOpt.emptyVisible && this.value.isEmpty() && this.isAuthSuccess();
            },
            setReadOnly: function(flag) {
                this.set("isReadOnly", flag);
                this.set("btnDisabled", flag);
                this.value.setReadOnly(flag);
                this.uploader.setReadOnly(flag);
            },
            setAccepts: function(fileExtensions) {
                this.uploader.setAccepts(fileExtensions);
            },
            localUploadDisabled: function() {
                return this.get("btnDisabled") || this.get("localUploadBtnDisabled") || !this.isAuthSuccess() || !this.widgetOpt.multiselect && !this.get("value").loaded() || !this.uploader.isTargetDrive();
            },
            cloudChooseFileDisabled: function() {
                return this.get("btnDisabled") || this.get("cloudChooseFileBtnDisabled") || !this.isAuthSuccess() || !this.widgetOpt.multiselect && !this.get("value").loaded();
            },
            localUploadNotAvailable: function() {
                return this.uploader.isTargetDriveError();
            },
            enableButtons: function(value) {
                this.set("localUploadBtnDisabled", value);
                this.set("cloudChooseFileBtnDisabled", value);
            },
            getDownloadContainerEl: function() {
                return $("#jy-select-download-" + this.uid);
            },
            getWrapperEl: function() {
                return $("#jy-select-wrapper-" + this.uid);
            },
            addFileHandler: function(properties) {
                this.fileHandlerService.addFileHandler(properties);
            },
            removeFileHandlerByExt: function(fileExtension) {
                this.fileHandlerService.removeFileHandlerByExt(fileExtension);
            },
            clearAllFileErrors: function() {
                this.fileErrors.empty();
            },
            showFileErrors: function(fileName, errors) {
                var that = this;
                (errors || []).forEach(function(errorType) {
                    that.fileErrors.push(new SelectFileErrorViewModel(fileName, errorType, that.options));
                });
            },
            showCloudFileChooserDialog: function() {
                var dialog = $("#jy-cloud-file-chooser-dialog-" + this.root.uid).data("kendoJunkyardDialog");
                var viewModel = new CloudFileChooserDialogViewModel(this.options);
                dialog.one(CLOSE, this.onCloudFileChooserResult).open(viewModel);
            },
            showPreviewDialog: function(itemModel, actions, version) {
                var dialog = $("#jy-preview-dialog-" + this.root.uid).data("kendoJunkyardDialog");
                var viewModel = new PreviewDialogViewModel(itemModel, actions, version, this.options);
                dialog.open(viewModel);
            },
            showCropEditorDialog: function(sourceImageUrl, inputImageType, outputFileName, callback) {
                var dialog = $("<div/>").appendTo(this.getWrapperEl()).kendoJunkyardDialog({
                    templateId: "jyt-crop-editor-dialog"
                }).data("kendoJunkyardDialog");
                var viewModel = new CropEditorDialogViewModel(sourceImageUrl, inputImageType, outputFileName, this.options);
                viewModel.setCropAspectRatio(this.widgetOpt.cropAspectRatio);
                viewModel.setCropFixedAspectRatio(this.widgetOpt.cropFixedAspectRatio);
                dialog.one(CLOSE, callback).one(CLOSED, function() {
                    var element = dialog.element;
                    dialog.destroy();
                    element.remove();
                }).open(viewModel);
            },
            openCropEditorForFile: function(fileVm) {
                var that = this;
                if (!fileVm.isLoaded() || !fileVm.data || !fileVm.cropEditorSupport()) {
                    return false;
                }
                var sourceUrl = this.api.makeDownloadUrl(fileVm.data.driveId, [ fileVm.data.id ]) + kendo.format("&_{0}", Date.now());
                this.showCropEditorDialog(sourceUrl, fileVm.getImageType(), fileVm.data.title, function(e) {
                    if (e.result) {
                        that.value.onFileRemove({
                            data: fileVm
                        });
                        that.onCropEditorForFileResult(e);
                    }
                });
                return true;
            },
            validateFiles: function(files) {
                var allowedExtensions = this._parseAllowedExtensions(this.widgetOpt.uploadExt);
                for (var i = 0; i < files.length; i++) {
                    this._validateFileExtension(files[i], allowedExtensions);
                }
            },
            _validateFileExtension: function(file, allowedExtensions) {
                if (allowedExtensions.length > 0) {
                    var ext = file.extension || "";
                    var dotExt = ext.substring(0, 1) === "." ? ext : "." + ext;
                    if (allowedExtensions.indexOf(dotExt.toLowerCase()) < 0) {
                        file.validationErrors = file.validationErrors || [];
                        if ($.inArray(INVALIDFILEEXTENSION, file.validationErrors) === -1) {
                            file.validationErrors.push(INVALIDFILEEXTENSION);
                        }
                    }
                }
            },
            _parseAllowedExtensions: function(extensions) {
                return (extensions || []).map(function(ext) {
                    var parsedExt = ext.substring(0, 1) === "." ? ext : "." + ext;
                    return parsedExt.toLowerCase();
                });
            },
            onCropEditorForFileResult: function(e) {
                if (e.result) {
                    var that = this;
                    var dialogVm = e.sender.viewModel;
                    var outputImageType = dialogVm.getOutputImageType();
                    var outputFileName = dialogVm.getOutputFileName();
                    var fillColor = dialogVm.getOutputFillColor();
                    dialogVm.getOutputBlob(function(blob) {
                        var rawFile = that.uploader.createRawFile(outputFileName, blob);
                        that.uploader.disableCropEditor(true);
                        that.uploader.selectRawFile(rawFile);
                        that.uploader.disableCropEditor(false);
                    }, outputImageType, undefined, fillColor);
                }
            },
            onCreateView: function() {
                var that = this;
                this.authenticate().done(function() {
                    that.authReady.resolve();
                }).fail(function(err) {
                    that.authReady.reject(err);
                });
            },
            onLocalUpload: function() {
                if (!this.localUploadDisabled()) {
                    this.uploader.clickInput();
                }
            },
            onCloudChooseFile: function() {
                if (!this.cloudChooseFileDisabled()) {
                    this.showCloudFileChooserDialog();
                }
            },
            onCloudFileChooserResult: function(e) {
                if (e.result) {
                    var vm = e.sender.viewModel, value = [];
                    var files = vm.getSelectedModels();
                    this.clearAllFileErrors();
                    this.validateFiles(files);
                    for (var i = 0; i < files.length; i++) {
                        var file = files[i];
                        if (file.validationErrors && file.validationErrors.length > 0) {
                            this.showFileErrors(file.title, file.validationErrors);
                        } else {
                            value.push({
                                itemId: file.id,
                                driveId: file.driveId
                            });
                        }
                    }
                    if (value.length > 0) {
                        if (this.widgetOpt.multiselect) {
                            this.value.mergeNotSharedValue(value);
                        } else {
                            this.value.setNotSharedValue(value);
                        }
                    }
                }
            }
        });
        extend(jyNS, {
            SelectWidgetViewModel: SelectWidgetViewModel
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.select", [ "kendo.junkyard.ns", "kendo.junkyard.constants", "kendo.junkyard.utils", "kendo.junkyard.template-initializer", "kendo.junkyard.vm.select-widget", "kendo.junkyard.default-config" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, Widget = ui.Widget, jyNS = ui.junkyard, proxy = $.proxy, TemplateInitializer = jyNS.TemplateInitializer, SelectWidgetViewModel = jyNS.SelectWidgetViewModel, UiEvents = jyNS.UiEvents, ImageTypes = jyNS.ImageTypes, utils = jyNS.utils, defaultConfig = jyNS.defaultConfig, AspectRatioTypes = jyNS.AspectRatioTypes, LinkTypes = jyNS.LinkTypes, createDefaultFileHandlersForSelectWidget = jyNS.createDefaultFileHandlersForSelectWidget, NS = ".kendoJunkyardSelect", INIT = "init", CHANGE = "change";
        var JunkyardSelect = Widget.extend({
            init: function(element, options) {
                Widget.fn.init.call(this, element, options);
                this._element();
                this._fileStorageOpt();
                this._tryInitTemplates();
                this._renderAsync();
                kendo.notify(this);
            },
            options: {
                name: "JunkyardSelect",
                multiselect: false,
                serverApi: "",
                authApi: "",
                fileHandlerApi: "",
                createHandlers: [],
                actionFileHandlers: [],
                openFileHandler: null,
                openFileHistoryHandler: null,
                showHistoryBtn: false,
                useDefaultHandlers: true,
                debugMode: false,
                templateId: "jyt-select-widget",
                asyncInit: true,
                fileStorage: {},
                emptyVisible: true,
                emptyText: null,
                uploadDrive: null,
                uploadDrivePrimary: false,
                uploadDriveOwned: false,
                uploadDriveFirst: false,
                uploadFolderPath: null,
                uploadExt: [],
                uploadMaxSize: 0,
                uploadMinSize: 0,
                downloadOkDelay: 1500,
                readonly: false,
                valuePrimitive: true,
                dataValueField: "value",
                secureShare: false,
                showPreview: true,
                previewHeightAuto: false,
                fileExtensions: null,
                cropEditor: false,
                cropEditorImageTypes: [ ImageTypes.JPG, ImageTypes.PNG, ImageTypes.GIF, ImageTypes.SVG, ImageTypes.WEBP ],
                cropAspectRatio: AspectRatioTypes.RatioFree,
                cropFixedAspectRatio: false,
                linkType: LinkTypes.ById,
                localization: {
                    invalidMaxFileSize: 'Размер файла "{0}" не должен превышать {1}.',
                    invalidMinFileSize: 'Размер файла "{0}" должен быть не менее {1}.',
                    invalidFileExtension: 'Тип файла "{0}" не разрешен. Допустимые типы файлов: {1}'
                },
                tokenProvider: null,
                userAndGroupsReadUrl: "",
                userReadDetailsUrl: "",
                groupReadDetailsUrl: "",
                userAndGroupsConverter: null,
                userDetailsConverter: null,
                groupDetailsConverter: null,
                userAndGroupsParamMap: null,
                userAndGroupsReadTransport: null,
                driveIds: [],
                titleMaxLength: 31
            },
            events: [ INIT, CHANGE ],
            setValue: function(value, noTriggerChange) {
                if (this.viewModel) {
                    this.viewModel.value.setValue(value, noTriggerChange);
                }
            },
            getValue: function() {
                if (this.viewModel) {
                    return this.viewModel.value.getValue();
                }
                return this.options.multiselect ? [] : null;
            },
            setReadOnly: function(readonly) {
                if (this.viewModel) {
                    this.viewModel.setReadOnly(readonly);
                }
            },
            addFileHandler: function(properties) {
                if (this.viewModel) {
                    this.viewModel.addFileHandler(properties);
                }
            },
            removeFileHandlerByExt: function(fileExtension) {
                if (this.viewModel) {
                    this.viewModel.removeFileHandlerByExt(fileExtension);
                }
            },
            _renderAsync: function() {
                var that = this;
                var render = function() {
                    that._viewModel();
                    that._initEvents();
                    that._fileStorageHandlers();
                    that._renderView();
                    that.trigger(INIT);
                };
                if (this.options.asyncInit) {
                    utils.async(render);
                } else {
                    render();
                }
            },
            _element: function() {
                this.element.addClass("jy-select-widget").attr("role", "junkyardselect");
            },
            clearElement: function() {
                this.element.removeClass("jy-select-widget").removeAttr("role", "junkyardselect").html("");
            },
            _viewModel: function() {
                this.viewModel = new SelectWidgetViewModel(this.options);
            },
            _renderView: function() {
                var options = this.options, template = options.templateId;
                if (template) {
                    this.view = new kendo.View(template, {
                        model: this.viewModel,
                        evalTemplate: true,
                        wrap: false
                    });
                    this.view.render(this.element);
                    kendo.resize(this.element);
                    this._triggerCreateView();
                }
            },
            _fileStorageOpt: function() {
                var opt = this.options;
                opt.fileStorage = defaultConfig({
                    serverApi: opt.serverApi,
                    authApi: opt.authApi,
                    isDebug: opt.debugMode,
                    tokenProvider: opt.tokenProvider,
                    driveIds: opt.driveIds,
                    userAndGroupsReadUrl: opt.userAndGroupsReadUrl,
                    userReadDetailsUrl: opt.userReadDetailsUrl,
                    groupReadDetailsUrl: opt.groupReadDetailsUrl,
                    userAndGroupsConverter: opt.userAndGroupsConverter,
                    userDetailsConverter: opt.userDetailsConverter,
                    groupDetailsConverter: opt.groupDetailsConverter,
                    userAndGroupsParamMap: opt.userAndGroupsParamMap,
                    userAndGroupsReadTransport: opt.userAndGroupsReadTransport
                });
            },
            _fileStorageHandlers: function() {
                if (this.options.useDefaultHandlers) {
                    createDefaultFileHandlersForSelectWidget(this, {
                        fileHandlerApi: this.options.fileHandlerApi
                    });
                }
            },
            _initEvents: function() {
                $(window.document).on("click" + NS, proxy(this._onDocumentClick, this));
                this._valueChangedHandler = proxy(this._valueChanged, this);
                this.viewModel.value.bind("valueChanged", this._valueChangedHandler);
            },
            _delEvents: function() {
                $(window.document).off(NS);
                if (this.viewModel) {
                    this.viewModel.value.unbind("valueChanged", this._valueChangedHandler);
                }
            },
            _onDocumentClick: function(e) {
                if (this.viewModel) {
                    this.viewModel.uiEvents.trigger(UiEvents.DocumentClick, {
                        origin: e
                    });
                }
            },
            _valueChanged: function(e) {
                this.trigger(CHANGE, {
                    value: e.value
                });
            },
            _triggerCreateView: function() {
                if (this.viewModel) {
                    this.viewModel.uiEvents.trigger(UiEvents.CreateView);
                }
            },
            _triggerDestroyView: function() {
                if (this.viewModel) {
                    this.viewModel.uiEvents.trigger(UiEvents.DestroyView);
                }
            },
            _tryInitTemplates: function() {
                this.templateInitializer = new TemplateInitializer();
                this.templateInitializer.initialize();
            },
            _tryRemoveTemplates: function() {
                if (this.templateInitializer) {
                    this.templateInitializer.destroy();
                    this.templateInitializer = null;
                }
            },
            destroy: function() {
                this._triggerDestroyView();
                this._delEvents();
                if (this.view) {
                    this.view.destroy();
                }
                this._tryRemoveTemplates();
                Widget.fn.destroy.call(this);
                this.element = this.viewModel = this.view = null;
            }
        });
        kendo.ui.plugin(JunkyardSelect);
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.vm.link", [ "kendo.junkyard.ns", "kendo.junkyard.item-service", "kendo.junkyard.vm.base", "kendo.junkyard.utils", "kendo.junkyard.models", "kendo.junkyard.vm.ui-events", "kendo.junkyard.constants" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, utils = jyNS.utils, models = jyNS.models, request = jyNS.request, extend = $.extend, FileHandlerActionTypes = jyNS.FileHandlerActionTypes, BaseViewModel = jyNS.BaseViewModel;
        var LinkStatus = {
            Init: "Init",
            Loading: "Loading",
            Error: "Error",
            Loaded: "Loaded",
            Downloading: "Downloading",
            NoFile: "NoFile",
            Forbidden: "Forbidden"
        };
        var LinkViewModel = BaseViewModel.extend({
            init: function(options) {
                BaseViewModel.fn.init.call(this, options);
                this._state();
                this._proxy();
            },
            _state: function() {
                this.set("hash", null);
                this.set("version", 0);
                this.set("data", null);
                this.set("downloadUrl", {
                    value: null
                });
                this.set("status", LinkStatus.NoFile);
                this.set("secure", false);
                this.set("previewLoaded", false);
            },
            _proxy: function() {},
            setHash: function(hash) {
                if (this.hash !== hash) {
                    this.version++;
                    this.set("hash", hash);
                    this._updateHash(hash);
                }
            },
            setStatus: function(status) {
                this.set("status", status);
            },
            downloadFile: function() {
                var canDownload = this.isLoaded() && this.hash;
                if (canDownload) {
                    if (this.secure) {
                        this._secureDownload(this.hash);
                    } else {
                        this._noSecureDownload(this.hash);
                    }
                }
            },
            getDownloadUrl: function() {
                return this.get("downloadUrl");
            },
            onFileDownload: function(e) {
                if (e) {
                    e.preventDefault();
                    e.stopPropagation();
                }
                this.downloadFile();
            },
            _updateDownloadUrl: function(hash) {
                var url = hash ? this.root.api.makeDownloadByLinkUrl(hash) : null;
                this.downloadUrl.set("value", url);
            },
            _updateHash: function(hash) {
                this._resetPreviewLoaded();
                this._updateDownloadUrl(null);
                if (hash) {
                    this.setStatus(LinkStatus.Loading);
                    var defer;
                    if (this.secure) {
                        defer = this._secureLoadData(hash);
                    } else {
                        defer = this._noSecureLoadData(hash);
                    }
                    defer.done(this._loadDataSuccess(this.version)).fail(this._loadDataFailed(this.version));
                } else {
                    this.setStatus(LinkStatus.NoFile);
                }
            },
            _resetPreviewLoaded: function() {
                this.set("previewLoaded", false);
            },
            _noSecureLoadData: function(hash) {
                var opt = this.widgetOpt.fileStorage.items, url = opt.readItemByHashUrl + utils.toUrlQuery({
                    link: hash
                }, true);
                return request.get(url).then(function(res) {
                    return res.response ? models.createModel(models.ItemModel, res.response) : null;
                });
            },
            _secureLoadData: function(hash) {
                var api = this.root.api;
                return api.getItemByHash(hash);
            },
            _loadDataSuccess: function(version) {
                var that = this;
                return function(model) {
                    if (that.version === version) {
                        if (model) {
                            that.set("data", model);
                            that.setStatus(LinkStatus.Loaded);
                            that._updateDownloadUrl(that.hash);
                        } else {
                            that.setStatus(LinkStatus.Error);
                            that._updateDownloadUrl(null);
                        }
                    }
                };
            },
            _loadDataFailed: function(version) {
                var that = this;
                return function(error) {
                    if (that.version === version) {
                        if (that._isUnauthorized(error)) {
                            that.set("secure", true);
                            that.setStatus(LinkStatus.Loading);
                            that._tryAuth().done(function() {
                                that._updateHash(that.hash);
                            }).fail(function() {
                                that.setStatus(LinkStatus.Forbidden);
                                that._updateDownloadUrl(null);
                            });
                        } else {
                            that.setStatus(LinkStatus.Error);
                            that._updateDownloadUrl(null);
                        }
                    }
                };
            },
            _tryAuth: function() {
                return this.root.auth.getToken();
            },
            _noSecureDownload: function(hash) {
                var that = this, root = this.root, itemService = root.itemService, downloadOkDelay = this.widgetOpt.downloadOkDelay, prevStatus = this.status;
                this.setStatus(LinkStatus.Downloading);
                itemService.requestDownloadByHash(this._downloadContainer(), downloadOkDelay, hash).done(function() {
                    that.setStatus(prevStatus);
                }).fail(function() {
                    that.setStatus(prevStatus);
                });
            },
            _secureDownload: function(hash) {
                var that = this, root = this.root, itemService = root.itemService, downloadOkDelay = this.widgetOpt.downloadOkDelay, prevStatus = this.status;
                this.setStatus(LinkStatus.Downloading);
                itemService.requestDownloadItems(this._downloadContainer(), downloadOkDelay, {
                    hash: hash,
                    useAuth: true
                }).done(function() {
                    that.setStatus(prevStatus);
                }).fail(function() {
                    that.setStatus(prevStatus);
                });
            },
            _downloadContainer: function() {
                return $("#jy-link-download-" + this.uid);
            },
            _isUnauthorized: function(httpError) {
                if (httpError.jqXHR && httpError.jqXHR.status === 401) {
                    return true;
                }
                return false;
            },
            isPreview: function() {
                var data = this.get("data"), showPreview = this.widgetOpt.showPreview, isState = this.isLoaded() || this.isDownloading(), action = data && data.extension ? this.findSmallPreviewAction(data.extension) : null;
                return showPreview && isState && action != null;
            },
            openPreviewAvailable: function() {
                var showPreview = this.widgetOpt.showPreview, openFileHandler = this.widgetOpt.openFileHandler, isLoaded = this.isLoaded(), data = this.get("data"), action = data && data.extension ? this.findPreviewAction(data.extension) : null;
                return showPreview && isLoaded && action != null || isLoaded && typeof openFileHandler === "function";
            },
            openPreview: function() {
                var openFileHandler = this.widgetOpt.openFileHandler;
                if (this.data && this.isLoaded()) {
                    if (typeof openFileHandler === "function") {
                        var result = openFileHandler({
                            file: this.data,
                            link: this.hash
                        });
                        if (result === false) {
                            this.showPreviewDialog();
                        }
                    } else {
                        this.showPreviewDialog();
                    }
                }
            },
            showPreviewDialog: function() {
                var actions = this.findHandlerActions(this.data.extension);
                var noValidateToken = actions[0] && actions[0].contentType === "image" ? !this.secure : false;
                this.root.showPreviewDialog(this.data, actions, undefined, noValidateToken);
            },
            previewUrl: function() {
                if (this.isPreview()) {
                    var data = this.get("data"), action = this.findSmallPreviewAction(data.extension), url = action.makeUrl(data, this.root);
                    if (url) {
                        return url;
                    }
                }
                return "";
            },
            previewWidth: function() {
                var width = this.widgetOpt.previewWidth;
                return width ? width + "px" : "auto";
            },
            previewHeight: function() {
                var height = this.widgetOpt.previewHeight;
                return height ? height + "px" : "auto";
            },
            onContentClick: function() {
                if (this.openPreviewAvailable()) {
                    this.openPreview();
                }
            },
            onPreviewLoad: function() {
                this.set("previewLoaded", this.isPreview());
            },
            findSmallPreviewAction: function(extension) {
                var fileHandler = this.root.fileHandlerService.findFileHandlerByExt(extension);
                return fileHandler ? fileHandler.findActionByType(FileHandlerActionTypes.SmallPreview) : null;
            },
            findPreviewAction: function(extension) {
                var fileHandler = this.root.fileHandlerService.findFileHandlerByExt(extension);
                return fileHandler ? fileHandler.findActionByType(FileHandlerActionTypes.Preview) : null;
            },
            findHandlerActions: function(extension) {
                var fileHandler = this.root.fileHandlerService.findFileHandlerByExt(extension);
                return fileHandler ? fileHandler.getActions() : [];
            },
            isDocs: function() {
                var data = this.get("data");
                var extension = data ? data.extension : null;
                var fileIconType = extension ? kendo.ui.junkyard.fileTypeIcon(extension) : null;
                return [ "docs", "pdf", "tables" ].indexOf(fileIconType) !== -1;
            },
            isInit: function() {
                return this.get("status") === LinkStatus.Init;
            },
            isLoaded: function() {
                return this.get("status") === LinkStatus.Loaded;
            },
            isLoading: function() {
                return this.get("status") === LinkStatus.Loading;
            },
            isError: function() {
                return this.get("status") === LinkStatus.Error;
            },
            isDownloading: function() {
                return this.get("status") === LinkStatus.Downloading;
            },
            isNoFile: function() {
                return this.get("status") === LinkStatus.NoFile;
            },
            isForbidden: function() {
                return this.get("status") === LinkStatus.Forbidden;
            }
        });
        extend(jyNS, {
            LinkViewModel: LinkViewModel
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.vm.link-widget", [ "kendo.junkyard.ns", "kendo.junkyard.item-service", "kendo.junkyard.vm.base", "kendo.junkyard.vm.link", "kendo.junkyard.vm.preview-dialog", "kendo.junkyard.api", "kendo.junkyard.vm.ui-events", "kendo.junkyard.auth", "kendo.junkyard.file-handler-service", "kendo.junkyard.commandutil", "kendo.junkyard.constants" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, Commands = jyNS.Commands, CommandManager = jyNS.CommandManager, Authenticator = jyNS.Authenticator, JunkyardApi = jyNS.JunkyardApi, LinkViewModel = jyNS.LinkViewModel, BaseViewModel = jyNS.BaseViewModel, PreviewDialogViewModel = jyNS.PreviewDialogViewModel, JunkyardItemService = jyNS.JunkyardItemService, FileHandlerService = jyNS.FileHandlerService, UiEventsViewModel = jyNS.UiEventsViewModel;
        var LinkWidgetViewModel = BaseViewModel.extend({
            init: function(widgetOptions) {
                BaseViewModel.fn.init.call(this, {
                    widgetOptions: widgetOptions,
                    root: this
                });
                this._state();
                this._proxy();
                this._services();
                this._viewModels();
                this._baseUIEvents();
            },
            _state: function() {},
            _proxy: function() {},
            _services: function() {
                this.auth = new Authenticator(this.widgetOpt.fileStorage);
                this.api = new JunkyardApi(this.widgetOpt.fileStorage, this.auth);
                this.itemService = new JunkyardItemService(this.widgetOpt.fileStorage, this.api);
                this.fileHandlerService = new FileHandlerService();
                this.commandService = this._createCommandService();
                this.commandManager = new CommandManager(this, false, []);
                this.service = {
                    auth: this.auth
                };
            },
            _viewModels: function() {
                this.linkVm = new LinkViewModel(this.options);
                this.set(this.getSourceName(), [ this.linkVm ]);
                this.set("uiEvents", new UiEventsViewModel(this.options));
            },
            _createCommandService: function() {
                var that = this;
                return {
                    downloadItem: function() {
                        that.downloadFile();
                    },
                    openFile: function(itemModel, actionType, version) {
                        return that.commandManager.makeCommand(Commands.OpenFile, {
                            item: itemModel,
                            actionType: actionType,
                            version: version
                        }).exec();
                    }
                };
            },
            setValue: function(value) {
                if (this.widgetOpt.valuePrimitive) {
                    this.linkVm.setHash(value);
                } else if (value) {
                    this.linkVm.setHash(value[this.widgetOpt.dataValueField]);
                } else {
                    this.linkVm.setHash(null);
                }
            },
            getSourceName: function() {
                return "_source" + this.uid.replace(/-/g, "_");
            },
            getDownloadUrl: function() {
                return this.linkVm.getDownloadUrl();
            },
            downloadFile: function() {
                this.linkVm.downloadFile();
            },
            addFileHandler: function(properties) {
                this.fileHandlerService.addFileHandler(properties);
            },
            removeFileHandlerByExt: function(fileExtension) {
                this.fileHandlerService.removeFileHandlerByExt(fileExtension);
            },
            showPreviewDialog: function(itemModel, actions, version, noValidateToken) {
                var dialog = $("#jy-preview-dialog-" + this.root.uid).data("kendoJunkyardDialog");
                var viewModel = new PreviewDialogViewModel(itemModel, actions, version, this.options, noValidateToken);
                dialog.open(viewModel);
            },
            onCreateView: function() {
                if (this.widgetOpt.link) {
                    this.setValue(this.widgetOpt.link);
                }
            }
        });
        extend(jyNS, {
            LinkWidgetViewModel: LinkWidgetViewModel
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.link", [ "kendo.junkyard.ns", "kendo.junkyard.constants", "kendo.junkyard.utils", "kendo.junkyard.template-initializer", "kendo.junkyard.default-config", "kendo.junkyard.vm.link-widget" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, Widget = ui.Widget, jyNS = ui.junkyard, TemplateInitializer = jyNS.TemplateInitializer, UiEvents = jyNS.UiEvents, utils = jyNS.utils, LinkWidgetViewModel = jyNS.LinkWidgetViewModel, createDefaultFileHandlersForLinkWidget = jyNS.createDefaultFileHandlersForLinkWidget, defaultConfig = jyNS.defaultConfig, ImageSize = jyNS.ImageSize, INIT = "init";
        var JunkyardLink = Widget.extend({
            init: function(element, options) {
                Widget.fn.init.call(this, element, options);
                this._element();
                this._fileStorageOpt();
                this._tryInitTemplates();
                this._renderAsync();
                kendo.notify(this);
            },
            options: {
                name: "JunkyardLink",
                debugMode: false,
                templateId: "jyt-link-widget",
                asyncInit: true,
                fileStorage: {},
                link: null,
                serverApi: "",
                authApi: "",
                fileHandlerApi: "",
                useDefaultHandlers: true,
                downloadOkDelay: 1500,
                valuePrimitive: true,
                dataValueField: "value",
                maxFileName: 31,
                showPreview: false,
                previewWidth: 223,
                previewHeight: 126,
                previewSize: null,
                tokenProvider: null,
                openFileHandler: null,
                userAndGroupsReadUrl: "",
                userReadDetailsUrl: "",
                groupReadDetailsUrl: "",
                userAndGroupsConverter: null,
                userDetailsConverter: null,
                groupDetailsConverter: null,
                userAndGroupsParamMap: null,
                userAndGroupsReadTransport: null
            },
            events: [ INIT ],
            setValue: function(value) {
                if (this.viewModel) {
                    this.viewModel.setValue(value);
                }
            },
            addFileHandler: function(properties) {
                if (this.viewModel) {
                    this.viewModel.addFileHandler(properties);
                }
            },
            removeFileHandlerByExt: function(fileExtension) {
                if (this.viewModel) {
                    this.viewModel.removeFileHandlerByExt(fileExtension);
                }
            },
            _renderAsync: function() {
                var that = this;
                var render = function() {
                    that._viewModel();
                    that._fileStorageHandlers();
                    that._renderView();
                    that.trigger(INIT);
                };
                if (that.options.asyncInit) {
                    utils.async(render);
                } else {
                    render();
                }
            },
            _element: function() {
                this.element.addClass("jy-link-widget").attr("role", "junkyardlink");
            },
            clearElement: function() {
                this.element.removeClass("jy-link-widget").removeAttr("role", "junkyardlink").html("");
            },
            _viewModel: function() {
                this.viewModel = new LinkWidgetViewModel(this.options);
            },
            _renderView: function() {
                var options = this.options, template = options.templateId;
                if (template) {
                    this.view = new kendo.View(template, {
                        model: this.viewModel,
                        evalTemplate: true,
                        wrap: false
                    });
                    this.view.render(this.element);
                    kendo.resize(this.element);
                    this._triggerCreateView();
                }
            },
            _fileStorageOpt: function() {
                var opt = this.options;
                opt.fileStorage = defaultConfig({
                    serverApi: opt.serverApi,
                    authApi: opt.authApi,
                    isDebug: opt.debugMode,
                    tokenProvider: opt.tokenProvider,
                    userAndGroupsReadUrl: opt.userAndGroupsReadUrl,
                    userReadDetailsUrl: opt.userReadDetailsUrl,
                    groupReadDetailsUrl: opt.groupReadDetailsUrl,
                    userAndGroupsConverter: opt.userAndGroupsConverter,
                    userDetailsConverter: opt.userDetailsConverter,
                    groupDetailsConverter: opt.groupDetailsConverter,
                    userAndGroupsParamMap: opt.userAndGroupsParamMap,
                    userAndGroupsReadTransport: opt.userAndGroupsReadTransport
                });
            },
            _fileStorageHandlers: function() {
                if (this.options.useDefaultHandlers) {
                    createDefaultFileHandlersForLinkWidget(this, {
                        fileHandlerApi: this.options.fileHandlerApi
                    });
                }
            },
            _triggerCreateView: function() {
                if (this.viewModel) {
                    this.viewModel.uiEvents.trigger(UiEvents.CreateView);
                }
            },
            _triggerDestroyView: function() {
                if (this.viewModel) {
                    this.viewModel.uiEvents.trigger(UiEvents.DestroyView);
                }
            },
            _tryInitTemplates: function() {
                this.templateInitializer = new TemplateInitializer();
                this.templateInitializer.initialize();
            },
            _tryRemoveTemplates: function() {
                if (this.templateInitializer) {
                    this.templateInitializer.destroy();
                    this.templateInitializer = null;
                }
            },
            destroy: function() {
                this._triggerDestroyView();
                if (this.view) {
                    this.view.destroy();
                }
                this._tryRemoveTemplates();
                Widget.fn.destroy.call(this);
                this.element = this.viewModel = this.view = null;
            }
        });
        kendo.ui.plugin(JunkyardLink);
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.image-link", [ "kendo.junkyard.ns", "kendo.junkyard.constants", "kendo.junkyard.file-handler-service" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, FileHandlerService = jyNS.FileHandlerService, createDefaultFileHandlersForLinkWidget = jyNS.createDefaultFileHandlersForLinkWidget;
        var fileHandlerService = new FileHandlerService();
        createDefaultFileHandlersForLinkWidget({
            addFileHandler: function(properties) {
                fileHandlerService.addFileHandler(properties);
            }
        });
        var fileHandler = fileHandlerService.findFileHandlerByExt("png");
        var imageLinkAction = fileHandler.findActionByType("imageLink");
        function imageHtml(src, width, height, css) {
            css = css ? 'class="' + css + '"' : "";
            width = width ? "width:" + width + "px;" : "";
            height = height ? "height:" + height + "px;" : "";
            src = src ? 'src="' + src + '"' : "";
            var style = width || height ? 'style="' + width + height + '"' : "";
            return '<img alt="" ' + src + " " + style + " " + css + " />";
        }
        function wrapImageHtml(width, height, css, innerHtml) {
            css = css ? 'class="' + css + '"' : "";
            width = width ? "width:" + width + "px;" : "";
            height = height ? "height:" + height + "px;" : "";
            var style = width || height ? 'style="' + width + height + '"' : "";
            return "<span " + style + " " + css + " >" + innerHtml + "</span>";
        }
        function wrapCircleImageHtml(url, width, height, css) {
            css = css ? 'class="' + css + '"' : "";
            width = width ? "width:" + width + "px;" : "";
            height = height ? "height:" + height + "px;" : "";
            var background = url ? "background-image:url('" + url + "');" : "";
            var style = width || height || background ? 'style="' + width + height + background + '"' : "";
            return "<span " + style + " " + css + " ></span>";
        }
        function createImageLinkUrl(link, options) {
            options = options || {};
            var serverApi = options.serverApi || "", fileHandlerApi = options.fileHandlerApi || "", defaultUrl = options.defaultUrl || "";
            return imageLinkAction && link && serverApi ? imageLinkAction.getUrl({
                link: link,
                fileHandlerApi: fileHandlerApi,
                previewSize: options.previewSize
            }) : defaultUrl;
        }
        function createImageLinkHtml(link, options) {
            options = options || {};
            var url = createImageLinkUrl(link, options), width = options.width, height = options.height, wrap = options.wrap;
            if (wrap) {
                return wrapImageHtml(width, height, "jy-image-link-wrap", imageHtml(url, null, null, "jy-image-link"));
            } else {
                return imageHtml(url, width, height, "jy-image-link");
            }
        }
        function createCircleImageLinkHtml(link, options) {
            options = options || {};
            var url = createImageLinkUrl(link, options), size = options.size || 100, wrap = options.wrap;
            if (wrap) {
                return wrapCircleImageHtml(url, size, size, "jy-circle-image-link-wrap");
            } else {
                return imageHtml(url, size, size, "jy-circle-image-link");
            }
        }
        function createImageLink(link, options) {
            return $(createImageLinkHtml(link, options));
        }
        function createCircleImageLink(link, options) {
            return $(createCircleImageLinkHtml(link, options));
        }
        extend(jyNS, {
            createImageLinkUrl: createImageLinkUrl,
            createImageLink: createImageLink,
            createImageLinkHtml: createImageLinkHtml,
            createCircleImageLink: createCircleImageLink,
            createCircleImageLinkHtml: createCircleImageLinkHtml
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.vm.crop-editor-widget", [ "kendo.junkyard.ns", "kendo.junkyard.vm.base", "kendo.junkyard.utils", "kendo.junkyard.constants" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, extend = $.extend, BaseViewModel = jyNS.BaseViewModel, utils = jyNS.utils, ImageTypes = jyNS.ImageTypes, ImageTypeExt = jyNS.ImageTypeExt, AspectRatioTypes = jyNS.AspectRatioTypes, CROPPED_MAX_WIDTH = 8192, CROPPED_MAX_HEIGHT = 8192, HIDE_ZOOM_DELAY = 1e3, DOT = ".", CROP_CHANGE = "cropChange", DEFAULT_OUTPUT_BACKGROUND_COLOR = "#ffffff";
        var EditorStatus = {
            Init: "Init",
            NoImage: "NoImage",
            Loading: "Loading",
            Ready: "Ready",
            NoSupport: "NoSupport"
        };
        var BackgroundTransparentSupport = {};
        BackgroundTransparentSupport[ImageTypes.JPG] = false;
        BackgroundTransparentSupport[ImageTypes.PNG] = true;
        var CropEditorWidgetViewModel = BaseViewModel.extend({
            init: function(widgetOptions) {
                BaseViewModel.fn.init.call(this, {
                    widgetOptions: widgetOptions,
                    root: this
                });
                this._proxy();
                this._state();
                this.bind("DestroyView", this.onDestroyView);
            },
            _state: function() {
                this.set("sourceUrl", null);
                this.set("cropperSupport", window.Cropper != null);
                this.set("status", this.cropperSupport ? EditorStatus.NoImage : EditorStatus.NoSupport);
                this.set("croppedWidth", 0);
                this.set("croppedHeight", 0);
                this.set("zoom", 0);
                this.set("zoomVisible", false);
                this.set("currentAspectRatio", this.widgetOpt.aspectRatio || AspectRatioTypes.RatioFree);
                this.set("outputImageType", null);
                this.set("outputFileName", null);
                this.set("outputInfoVisible", true);
                this.set("outputBackgroundColor", DEFAULT_OUTPUT_BACKGROUND_COLOR);
                this.set("outputBackgroundColorValue", null);
                this.set("outputBackgroundTransparent", true);
                this.set("outputBackgroundTransparentVisible", true);
                this.set("outputBackgroundColorPickerEnabled", false);
                this._initOutputFormats();
                this._initAspectRatioList();
                this._initActions();
                this._cropper = null;
                this._hideZoomTimeout = null;
            },
            _proxy: function() {
                this.proxy("onDestroyView");
                this.proxy("_handleDragModeMove");
                this.proxy("_handleDragModeCrop");
                this.proxy("_handleZoomIn");
                this.proxy("_handleZoomOut");
                this.proxy("_handleMoveLeft");
                this.proxy("_handleMoveRight");
                this.proxy("_handleMoveUp");
                this.proxy("_handleMoveDown");
                this.proxy("_handleRotateLeft");
                this.proxy("_handleRotateRight");
                this.proxy("_handleFlipHorizontal");
                this.proxy("_handleFlipVertical");
                this.proxy("_handleClear");
                this.proxy("_handleDisable");
                this.proxy("_handleReset");
            },
            _initAspectRatioList: function() {
                var fixedAspectRatioOpt = this.widgetOpt.fixedAspectRatio, aspectRatioOpt = this.widgetOpt.aspectRatio;
                var aspectRatioList = [ {
                    id: AspectRatioTypes.Ratio16x9,
                    label: AspectRatioTypes.Ratio16x9
                }, {
                    id: AspectRatioTypes.Ratio4x3,
                    label: AspectRatioTypes.Ratio4x3
                }, {
                    id: AspectRatioTypes.Ratio1x1,
                    label: AspectRatioTypes.Ratio1x1
                }, {
                    id: AspectRatioTypes.Ratio2x3,
                    label: AspectRatioTypes.Ratio2x3
                }, {
                    id: AspectRatioTypes.RatioFree,
                    label: "",
                    icon: "arrows-alt"
                } ];
                if (fixedAspectRatioOpt) {
                    aspectRatioList = aspectRatioList.filter(function(data) {
                        return data.id === aspectRatioOpt;
                    });
                }
                this.set("aspectRatioList", aspectRatioList);
            },
            _getAspectRatioValue: function(type) {
                switch (type) {
                  case AspectRatioTypes.Ratio16x9:
                    return 16 / 9;

                  case AspectRatioTypes.Ratio4x3:
                    return 4 / 3;

                  case AspectRatioTypes.Ratio1x1:
                    return 1 / 1;

                  case AspectRatioTypes.Ratio2x3:
                    return 2 / 3;

                  case AspectRatioTypes.RatioFree:
                    return 0;

                  default:
                    return 0;
                }
            },
            _initOutputFormats: function() {
                this.set("outputFormats", [ {
                    id: ImageTypes.JPG,
                    label: ImageTypeExt[ImageTypes.JPG]
                }, {
                    id: ImageTypes.PNG,
                    label: ImageTypeExt[ImageTypes.PNG]
                } ]);
            },
            _initActions: function() {
                this.set("actions", [ {
                    id: "dragModeMove",
                    icon: "arrows",
                    title: "Перемещение",
                    active: false,
                    click: this._handleDragModeMove
                }, {
                    id: "dragModeCrop",
                    icon: "crop",
                    title: "Рамка",
                    active: false,
                    click: this._handleDragModeCrop
                }, {
                    id: "zoomIn",
                    icon: "search-plus",
                    title: "Увеличить",
                    active: false,
                    click: this._handleZoomIn
                }, {
                    id: "zoomOut",
                    icon: "search-minus",
                    title: "Уменьшить",
                    active: false,
                    click: this._handleZoomOut
                }, {
                    id: "moveLeft",
                    icon: "arrow-left",
                    title: "Сдвиг влево",
                    active: false,
                    click: this._handleMoveLeft
                }, {
                    id: "moveRight",
                    icon: "arrow-right",
                    title: "Сдвиг вправо",
                    active: false,
                    click: this._handleMoveRight
                }, {
                    id: "moveUp",
                    icon: "arrow-up",
                    title: "Сдвиг вверх",
                    active: false,
                    click: this._handleMoveUp
                }, {
                    id: "moveDown",
                    icon: "arrow-down",
                    title: "Сдвиг вниз",
                    active: false,
                    click: this._handleMoveDown
                }, {
                    id: "rotateLeft",
                    icon: "rotate-left",
                    title: "Повернуть влево на 45°",
                    active: false,
                    click: this._handleRotateLeft
                }, {
                    id: "rotateRight",
                    icon: "rotate-right",
                    title: "Повернуть вправо на 45°",
                    active: false,
                    click: this._handleRotateRight
                }, {
                    id: "flipHorizontal",
                    icon: "arrows-h",
                    title: "Отразить по горизонтали",
                    active: false,
                    click: this._handleFlipHorizontal
                }, {
                    id: "flipVertical",
                    icon: "arrows-v",
                    title: "Отразить по вертикали",
                    active: false,
                    click: this._handleFlipVertical
                }, {
                    id: "clear",
                    icon: "remove",
                    title: "Очистить выделение",
                    active: false,
                    click: this._handleClear
                }, {
                    id: "disable",
                    icon: "lock",
                    title: "Заблокировать выделение",
                    active: false,
                    click: this._handleDisable
                }, {
                    id: "reset",
                    icon: "refresh",
                    title: "Сбросить изменения",
                    active: false,
                    click: this._handleReset
                } ]);
                this._actionActiveOn("dragModeCrop");
            },
            setStatus: function(status) {
                this.set("status", status);
            },
            setSourceUrl: function(sourceUrl) {
                if (!this.cropperSupport) {
                    return;
                }
                if (sourceUrl == null) {
                    this.clearSource();
                } else {
                    this.replaceSource(sourceUrl);
                }
            },
            setInputImageType: function(inputImageType) {
                var outputImageType;
                switch (inputImageType) {
                  case ImageTypes.WEBP:
                  case ImageTypes.SVG:
                  case ImageTypes.GIF:
                    outputImageType = ImageTypes.PNG;
                    break;

                  case ImageTypes.PNG:
                  case ImageTypes.JPG:
                    outputImageType = inputImageType;
                    break;

                  default:
                    outputImageType = ImageTypes.PNG;
                    break;
                }
                this.setOutputImageType(outputImageType);
            },
            setOutputImageType: function(outputImageType) {
                this.set("outputImageType", outputImageType);
                this._updateFileNameExtension(outputImageType);
                this.updateOutputBackgroundByImageType(outputImageType);
            },
            setOutputFileName: function(outputFileName) {
                this.set("outputFileName", outputFileName);
                if (this.outputImageType) {
                    this._updateFileNameExtension(this.outputImageType);
                }
            },
            _updateFileNameExtension: function(imageType) {
                if (this.outputFileName) {
                    var ext = ImageTypeExt[imageType];
                    if (ext) {
                        var parts = utils.fileNameParts(this.outputFileName);
                        this.set("outputFileName", parts.name + DOT + ext);
                    }
                }
            },
            getOutputImageType: function() {
                return this.outputImageType;
            },
            getOutputFileName: function() {
                return this.outputFileName;
            },
            getOutputFillColor: function() {
                return this.outputBackgroundTransparent ? undefined : this.outputBackgroundColor;
            },
            setOutputInfoVisible: function(visible) {
                this.set("outputInfoVisible", visible);
            },
            replaceSource: function(sourceUrl) {
                this.setStatus(EditorStatus.Loading);
                this.destroyCropper();
                this.set("sourceUrl", sourceUrl);
            },
            clearSource: function() {
                this.set("sourceUrl", null);
                this.destroyCropper();
                this.setStatus(EditorStatus.NoImage);
            },
            createCropper: function() {
                if (!this._cropper) {
                    this._cropper = new window.Cropper(this.getImageElement(), this.getCropperOptions());
                }
            },
            destroyCropper: function() {
                if (this._cropper) {
                    this._cropper.destroy();
                    this._cropper = null;
                }
            },
            getCropperOptions: function() {
                var that = this, aspectRatioOpt = this.widgetOpt.aspectRatio;
                var options = {
                    preview: this.getPreviewElement(),
                    ready: function() {
                        that.setStatus(EditorStatus.Ready);
                    },
                    crop: function(e) {
                        that.onCropBoxChanged(e);
                    },
                    zoom: function(e) {
                        that.onZoomChanged(e);
                    }
                };
                if (aspectRatioOpt !== AspectRatioTypes.RatioFree) {
                    options.aspectRatio = this._getAspectRatioValue(aspectRatioOpt);
                }
                return options;
            },
            getCropper: function() {
                return this._cropper;
            },
            getCroppedCanvas: function(fillColor) {
                if (this._cropper) {
                    var options = {
                        maxWidth: CROPPED_MAX_WIDTH,
                        maxHeight: CROPPED_MAX_HEIGHT
                    };
                    if (fillColor) {
                        options.fillColor = fillColor;
                    }
                    return this._cropper.getCroppedCanvas(options);
                }
                return null;
            },
            getCroppedDataURL: function(imageType, quality, fillColor) {
                var canvas = this.getCroppedCanvas(fillColor);
                return canvas ? canvas.toDataURL(imageType, quality) : null;
            },
            getCroppedBlob: function(callback, imageType, quality, fillColor) {
                var canvas = this.getCroppedCanvas(fillColor);
                return canvas ? canvas.toBlob(callback, imageType, quality) : null;
            },
            croppedNonZero: function() {
                return this.croppedWidth > 0 && this.croppedHeight > 0;
            },
            resize: function() {
                if (this._cropper) {
                    this._cropper.resize();
                }
            },
            showZoomInfo: function(ratio) {
                var that = this;
                this.set("zoom", Math.round(ratio * 100));
                this.set("zoomVisible", true);
                this.clearZoomTimeout();
                this._hideZoomTimeout = setTimeout(function() {
                    that.set("zoomVisible", false);
                }, HIDE_ZOOM_DELAY);
            },
            clearZoomTimeout: function() {
                clearTimeout(this._hideZoomTimeout);
            },
            onCropBoxChanged: function(e) {
                var data = e.detail;
                var width = Math.round(data.width);
                var height = Math.round(data.height);
                width = width > CROPPED_MAX_WIDTH ? CROPPED_MAX_WIDTH : width;
                height = height > CROPPED_MAX_HEIGHT ? CROPPED_MAX_HEIGHT : height;
                this.set("croppedWidth", width);
                this.set("croppedHeight", height);
                this.trigger(CROP_CHANGE);
            },
            onZoomChanged: function(e) {
                this.showZoomInfo(e.detail.ratio);
            },
            onSourceLoaded: function() {
                if (!this.cropperSupport) {
                    return;
                }
                this.createCropper();
            },
            onSourceError: function() {
                if (!this.cropperSupport) {
                    return;
                }
                this.clearSource();
            },
            onDestroyView: function() {
                this.destroyCropper();
                this.sourceUrl = null;
            },
            onOutputFormatClick: function(e) {
                this.set("outputImageType", e.data.id);
                this._updateFileNameExtension(this.outputImageType);
                this.updateOutputBackgroundByImageType(this.outputImageType);
            },
            isOutputFormatActive: function(data) {
                return this.get("outputImageType") === data.id;
            },
            onOutputBackgroundColorSelect: function(e) {
                this.set("outputBackgroundColor", e.value);
            },
            updateOutputBackgroundParams: function() {
                if (this.outputBackgroundTransparent) {
                    this.set("outputBackgroundColorValue", null);
                    this.set("outputBackgroundColorPickerEnabled", false);
                } else {
                    this.set("outputBackgroundColorValue", this.outputBackgroundColor);
                    this.set("outputBackgroundColorPickerEnabled", true);
                }
            },
            updateOutputBackgroundByImageType: function(imageType) {
                var transparentSupport = !!BackgroundTransparentSupport[imageType];
                if (transparentSupport) {
                    this.set("outputBackgroundTransparentVisible", true);
                    if (this._oldOutputBackgroundTransparent !== undefined) {
                        this.set("outputBackgroundTransparent", this._oldOutputBackgroundTransparent);
                    }
                } else {
                    this._oldOutputBackgroundTransparent = this.outputBackgroundTransparent;
                    this.set("outputBackgroundTransparentVisible", false);
                    this.set("outputBackgroundTransparent", false);
                }
                this.updateOutputBackgroundParams();
            },
            onOutputBackgroundTransparentChange: function() {
                this.updateOutputBackgroundParams();
            },
            isAspectRatioActive: function(data) {
                return this.get("currentAspectRatio") === data.id;
            },
            onAspectRatioClick: function(e) {
                this.set("currentAspectRatio", e.data.id);
                this.setCropperAspectRatio(this._getAspectRatioValue(e.data.id));
            },
            setCropperAspectRatio: function(aspectRatio) {
                if (this._cropper) {
                    this._cropper.setAspectRatio(aspectRatio);
                }
            },
            isInit: function() {
                return this.get("status") === EditorStatus.Init;
            },
            isNoImage: function() {
                return this.get("status") === EditorStatus.NoImage;
            },
            isLoading: function() {
                return this.get("status") === EditorStatus.Loading;
            },
            isReady: function() {
                return this.get("status") === EditorStatus.Ready;
            },
            isNoSupport: function() {
                return this.get("status") === EditorStatus.NoSupport;
            },
            getImageElement: function() {
                return $("#jy-crop-editor-image-" + this.uid)[0];
            },
            getPreviewElement: function() {
                return $("#jy-crop-editor-preview-" + this.uid)[0];
            },
            _findAction: function(actionId) {
                return this.actions.find(function(action) {
                    return action.id === actionId;
                });
            },
            _actionActivate: function(e) {
                if (e.data.active) {
                    return false;
                }
                e.data.set("active", true);
                return true;
            },
            _actionActiveOn: function(actionId) {
                var action = this._findAction(actionId);
                if (action) {
                    action.set("active", true);
                }
            },
            _actionActiveOff: function(actionId) {
                var action = this._findAction(actionId);
                if (action) {
                    action.set("active", false);
                }
            },
            _actionDisableAllExcept: function(exceptArray, flag) {
                this.actions.forEach(function(action) {
                    if (exceptArray.indexOf(action.id) === -1) {
                        action.set("disabled", flag);
                    }
                });
            },
            _actionDisabled: function(e) {
                return !!e.data.disabled;
            },
            _handleDragModeMove: function(e) {
                if (this._actionDisabled(e) || !this._actionActivate(e)) {
                    return;
                }
                this._actionActiveOff("dragModeCrop");
                if (this._cropper) {
                    this._cropper.setDragMode("move");
                }
            },
            _handleDragModeCrop: function(e) {
                if (this._actionDisabled(e) || !this._actionActivate(e)) {
                    return;
                }
                this._actionActiveOff("dragModeMove");
                if (this._cropper) {
                    this._cropper.setDragMode("crop");
                }
            },
            _handleZoomIn: function(e) {
                if (this._actionDisabled(e)) {
                    return;
                }
                if (this._cropper) {
                    this._cropper.zoom(.1);
                }
            },
            _handleZoomOut: function(e) {
                if (this._actionDisabled(e)) {
                    return;
                }
                if (this._cropper) {
                    this._cropper.zoom(-.1);
                }
            },
            _handleMoveLeft: function(e) {
                if (this._actionDisabled(e)) {
                    return;
                }
                if (this._cropper) {
                    this._cropper.move(-10, 0);
                }
            },
            _handleMoveRight: function(e) {
                if (this._actionDisabled(e)) {
                    return;
                }
                if (this._cropper) {
                    this._cropper.move(10, 0);
                }
            },
            _handleMoveUp: function(e) {
                if (this._actionDisabled(e)) {
                    return;
                }
                if (this._cropper) {
                    this._cropper.move(0, -10);
                }
            },
            _handleMoveDown: function(e) {
                if (this._actionDisabled(e)) {
                    return;
                }
                if (this._cropper) {
                    this._cropper.move(0, 10);
                }
            },
            _handleRotateLeft: function(e) {
                if (this._actionDisabled(e)) {
                    return;
                }
                if (this._cropper) {
                    this._cropper.rotate(-45);
                }
            },
            _handleRotateRight: function(e) {
                if (this._actionDisabled(e)) {
                    return;
                }
                if (this._cropper) {
                    this._cropper.rotate(45);
                }
            },
            _handleFlipHorizontal: function(e) {
                if (this._actionDisabled(e)) {
                    return;
                }
                var scaleX = e.data.active ? 1 : -1;
                e.data.set("active", !e.data.active);
                if (this._cropper) {
                    this._cropper.scaleX(scaleX);
                }
            },
            _handleFlipVertical: function(e) {
                if (this._actionDisabled(e)) {
                    return;
                }
                var scaleY = e.data.active ? 1 : -1;
                e.data.set("active", !e.data.active);
                if (this._cropper) {
                    this._cropper.scaleY(scaleY);
                }
            },
            _handleClear: function(e) {
                if (this._actionDisabled(e)) {
                    return;
                }
                if (this._cropper) {
                    this._cropper.clear();
                }
            },
            _handleDisable: function(e) {
                if (this._actionDisabled(e)) {
                    return;
                }
                if (this._cropper) {
                    if (e.data.active) {
                        this._cropper.enable();
                        this._actionDisableAllExcept([ "disable" ], false);
                    } else {
                        this._cropper.disable();
                        this._actionDisableAllExcept([ "disable" ], true);
                    }
                }
                e.data.set("active", !e.data.active);
            },
            _handleReset: function(e) {
                if (this._actionDisabled(e)) {
                    return;
                }
                if (this._cropper) {
                    this._cropper.reset();
                    this._cropper.crop();
                }
            }
        });
        extend(jyNS, {
            CropEditorWidgetViewModel: CropEditorWidgetViewModel
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.crop-editor", [ "kendo.junkyard.ns", "kendo.junkyard.constants", "kendo.junkyard.utils", "kendo.junkyard.template-initializer", "kendo.junkyard.vm.crop-editor-widget" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, Widget = ui.Widget, jyNS = ui.junkyard, TemplateInitializer = jyNS.TemplateInitializer, utils = jyNS.utils, AspectRatioTypes = jyNS.AspectRatioTypes, CropEditorWidgetViewModel = jyNS.CropEditorWidgetViewModel, INIT = "init", CROP_CHANGE = "cropChange";
        var JunkyardCropEditor = Widget.extend({
            init: function(element, options) {
                Widget.fn.init.call(this, element, options);
                this._element();
                this._initTemplates();
                this._renderAsync();
                kendo.notify(this);
            },
            options: {
                name: "JunkyardCropEditor",
                templateId: "jyt-crop-editor-widget",
                aspectRatio: AspectRatioTypes.RatioFree,
                fixedAspectRatio: false
            },
            events: [ INIT, CROP_CHANGE ],
            setImageUrl: function(imageUrl) {
                if (this.viewModel) {
                    this.viewModel.setSourceUrl(imageUrl);
                }
            },
            _element: function() {
                this.element.addClass("jy-crop-editor-widget").attr("role", "junkyardcropeditor");
            },
            clearElement: function() {
                this.element.removeClass("jy-crop-editor-widget").removeAttr("role", "junkyardcropeditor").html("");
            },
            _renderAsync: function() {
                var that = this;
                utils.async(function() {
                    that._renderView();
                    that.trigger(INIT);
                });
            },
            _renderView: function() {
                var that = this, options = this.options, template = options.templateId;
                if (template) {
                    this.viewModel = new CropEditorWidgetViewModel(this.options);
                    this.viewModel.bind(CROP_CHANGE, function() {
                        that.trigger(CROP_CHANGE);
                    });
                    this.view = new kendo.View(template, {
                        model: this.viewModel,
                        evalTemplate: true,
                        wrap: false
                    });
                    this.view.render(this.element);
                    kendo.resize(this.element);
                    this.viewModel.trigger("CreateView");
                }
            },
            _triggerDestroyView: function() {
                if (this.viewModel) {
                    this.viewModel.trigger("DestroyView");
                }
            },
            _initTemplates: function() {
                this.templateInitializer = new TemplateInitializer();
                this.templateInitializer.initialize();
            },
            _removeTemplates: function() {
                if (this.templateInitializer) {
                    this.templateInitializer.destroy();
                    this.templateInitializer = null;
                }
            },
            _resize: function() {
                if (this.viewModel) {
                    this.viewModel.resize();
                }
            },
            destroy: function() {
                this._triggerDestroyView();
                if (this.view) {
                    this.view.destroy();
                }
                this._removeTemplates();
                Widget.fn.destroy.call(this);
                this.element = this.viewModel = this.view = null;
            }
        });
        kendo.ui.plugin(JunkyardCropEditor);
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.treeview", [], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui;
        var JunkyardTreeView = ui.TreeView.extend({
            init: function(element, options) {
                ui.TreeView.fn.init.call(this, element, options);
            },
            options: {
                name: "JunkyardTreeView"
            },
            events: (ui.TreeView.fn.events || []).concat([])
        });
        kendo.ui.plugin(JunkyardTreeView);
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.contextmenu", [], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, proxy = $.proxy, NS = ".kendoMenu", DEFAULT = "default", PREVENT = "prevent", OPEN = "open", CLOSE = "close", CHANGE = "change", DATABINDING = "dataBinding", DATABOUND = "dataBound";
        var JunkyardContextMenu = ui.ContextMenu.extend({
            init: function(element, options) {
                ui.ContextMenu.fn.init.call(this, element, options);
                this._dataSource();
                this.bind(OPEN, proxy(this._onOpen, this));
                this.bind(CLOSE, proxy(this._onClose, this));
            },
            options: {
                name: "JunkyardContextMenu",
                withTarget: false,
                ignore: "",
                openIgnore: DEFAULT,
                cssOpenTarget: "",
                itemTemplate: "",
                autoBind: true
            },
            _dataSource: function() {
                this._onChangeDataSource = proxy(this._onChangeDataSource, this);
                this.dataSource = new kendo.data.DataSource({
                    data: []
                });
                this.dataSource.bind(CHANGE, this._onChangeDataSource);
                if (this.options.autoBind) {
                    this.dataSource.fetch();
                }
            },
            setDataSource: function(dataSource) {
                if (this.dataSource) {
                    this.dataSource.unbind(CHANGE, this._onChangeDataSource);
                }
                this.dataSource = dataSource;
                this.dataSource.bind(CHANGE, this._onChangeDataSource);
                if (this.options.autoBind) {
                    this.dataSource.fetch();
                }
            },
            _onChangeDataSource: function(e) {
                if (!e.action) {
                    this.refreshItems(e);
                }
            },
            items: function() {
                return this.element.children();
            },
            refreshItems: function(e) {
                var that = this, view = that.dataSource.view(), items, html = "", idx, length, template = that.options.itemTemplate;
                e = e || {};
                if (that.trigger(DATABINDING, {
                    action: e.action || "rebind",
                    items: e.items,
                    index: e.index
                })) {
                    return;
                }
                for (idx = 0, length = view.length; idx < length; idx++) {
                    html += template(view[idx]);
                }
                that.element.html(html);
                items = that.items();
                for (idx = 0, length = view.length; idx < length; idx++) {
                    items.eq(idx).attr(kendo.attr("uid"), view[idx].uid);
                }
                that.trigger(DATABOUND, {
                    action: e.action || "rebind",
                    items: e.items,
                    index: e.index
                });
                this._updateClasses();
            },
            _onOpen: function(e) {
                this._addCss(e.target);
            },
            _onClose: function(e) {
                this._removeCss(e.target);
            },
            _addCss: function(element) {
                if (element && this.options.cssOpenTarget) {
                    $(element).addClass(this.options.cssOpenTarget);
                }
            },
            _popupTarget: function() {
                return this.popup.options.anchor;
            },
            _removeCss: function(element) {
                if (element && this.options.cssOpenTarget) {
                    $(element).removeClass(this.options.cssOpenTarget);
                }
            },
            _wire: function() {
                ui.ContextMenu.fn._wire.call(this);
                var opt = this.options;
                if (opt.filter && this.target[0] && opt.withTarget) {
                    this.target.on(opt.showOn + NS + this._marker, this._showProxy);
                }
                if (this.target[0] && opt.ignore) {
                    this.target.on(opt.showOn + NS + this._marker, opt.ignore, proxy(this._ignoreHandler, this));
                }
            },
            _ignoreHandler: function(e) {
                if (this.options.openIgnore === PREVENT) {
                    e.preventDefault();
                }
                e.stopImmediatePropagation();
            },
            _showHandler: function(e) {
                var opt = this.options, filter = opt.filter, isBaseTarget = e.currentTarget === this.target[0], openOnTarget = opt.withTarget && filter && isBaseTarget, previosTarget = this._popupTarget(), targetChanged = e.currentTarget !== this._popupTarget();
                if (targetChanged) {
                    this._removeCss(previosTarget);
                }
                if (openOnTarget) {
                    opt.filter = null;
                }
                ui.ContextMenu.fn._showHandler.call(this, e);
                if (openOnTarget) {
                    opt.filter = filter;
                }
            }
        });
        kendo.ui.plugin(JunkyardContextMenu);
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.upload", [], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, proxy = $.proxy, FILELIST_CREATED = "fileListCreated", FILELIST_DESTROYED = "fileListDestroyed", DROP_ITEM = "dropItem", DROP_ZONE = "dropToZone", CLICK_INPUT = "clickInput", RETRY_UPLOAD = "retryUpload", NS = ".kendoUpload";
        var JunkyardUpload = ui.Upload.extend({
            init: function(element, options) {
                ui.Upload.fn.init.call(this, element, options);
                this._collapseButton();
            },
            options: {
                name: "JunkyardUpload",
                cancelOnDestroy: true,
                dropZoneFilter: ""
            },
            events: (ui.Upload.fn.events || []).concat([ FILELIST_CREATED, FILELIST_DESTROYED, DROP_ITEM, DROP_ZONE, CLICK_INPUT, RETRY_UPLOAD ]),
            _activeInput: function(input) {
                ui.Upload.fn._activeInput.call(this, input);
                var that = this;
                input.on("click" + NS, function(e) {
                    var params = Array.prototype.slice.call(arguments, 1);
                    if (that.trigger(CLICK_INPUT, {
                        orig: e,
                        params: params
                    })) {
                        e.preventDefault();
                    }
                });
            },
            _collapseButton: function() {
                var that = this, button = $("<div class='k-upload-close'></div>").appendTo(this.wrapper.find(".k-dropzone"));
                button.click(function() {
                    that.wrapper.find(".k-upload-files").toggleClass("k-upload-files--collapsed");
                    $(this).toggleClass("k-upload-close--collapsed");
                });
                this._collapseBtn = button;
            },
            expandFileList: function() {
                this.wrapper.find(".k-upload-files").removeClass("k-upload-files--collapsed");
                this._collapseBtn.removeClass("k-upload-close--collapsed");
            },
            collapseFileList: function() {
                this.wrapper.find(".k-upload-files").addClass("k-upload-files--collapsed");
                this._collapseBtn.addClass("k-upload-close--collapsed");
            },
            fileListScrollTop: function() {
                this.wrapper.find(".k-upload-files").scrollTop(0);
            },
            uploadFileByUid: function(uid) {
                var fileEntry = this.findFileByUid(uid);
                if (fileEntry) {
                    var started = this.isFileUploadStarted(fileEntry);
                    var hasValidationErrors = this._filesContainValidationErrors(fileEntry.data("fileNames"));
                    if (!started && !hasValidationErrors) {
                        this._module.performUpload(fileEntry);
                    }
                }
            },
            changeFileNameByUid: function(uid, newName) {
                var fileEntry = this.findFileByUid(uid);
                if (fileEntry) {
                    var files = fileEntry.data("fileNames");
                    var file = files && files[0] ? files[0] : null;
                    if (file && file.name !== newName) {
                        file.name = newName;
                        file.newName = newName;
                        file.origName = file.name;
                        fileEntry.find(".k-file-name").text(newName);
                    }
                }
            },
            changeFileBlobByUid: function(uid, newBlob) {
                var fileEntry = this.findFileByUid(uid);
                if (fileEntry) {
                    var files = fileEntry.data("fileNames");
                    var file = files && files[0] ? files[0] : null;
                    if (file) {
                        file.newBlob = newBlob;
                    }
                }
            },
            selectRawFile: function(rawFile) {
                this._proceedDroppedItems([ rawFile ]);
            },
            hasFileByUid: function(uid) {
                return !!this.findFileByUid(uid);
            },
            findFileByUid: function(uid) {
                var fileEntry = $(".k-file[" + kendo.attr("uid") + '="' + uid + '"]', this.wrapper);
                return fileEntry.length > 0 ? fileEntry : null;
            },
            findFileDataByUid: function(uid) {
                var fileEntry = this.findFileByUid(uid);
                return fileEntry.length > 0 ? (fileEntry.data("fileNames") || [])[0] : null;
            },
            clearUploadedFiles: function() {
                var that = this;
                var files = that.wrapper.find(".k-file.k-file-success");
                files.each(function(index, file) {
                    that._removeFileByDomElement(file, false);
                });
            },
            addUploadedFiles: function(files) {
                this._renderInitialFiles(files);
            },
            isFileUploadedByUid: function(uid) {
                var fileEntry = this.findFileByUid(uid);
                return fileEntry ? this.isFileUploaded(fileEntry) : false;
            },
            isFileUploaded: function(fileEntry) {
                return fileEntry.hasClass("k-file-success");
            },
            isFileUploadStarted: function(fileEntry) {
                return fileEntry.is(".k-file-progress, .k-file-success, .k-file-error");
            },
            fileInProgress: function(fileEntry) {
                return fileEntry.hasClass("k-file-progress");
            },
            fileListProgress: function(flag) {
                var fileList = $(".k-upload-files", this.wrapper);
                if (flag) {
                    fileList.addClass("k-upload-progress");
                } else {
                    fileList.removeClass("k-upload-progress");
                }
            },
            isFileList: function() {
                var fileList = $(".k-upload-files", this.wrapper);
                return fileList.length > 0;
            },
            cancelUploadByUid: function(uid, force) {
                var that = this;
                var file = that.wrapper.find('.k-file[data-uid="' + uid + '"]');
                if (file.length > 0) {
                    if (this.fileInProgress(file)) {
                        this.cancelUpload(file, force);
                    }
                }
            },
            retryUploadByUid: function(uid, force) {
                var that = this;
                var file = that.wrapper.find('.k-file[data-uid="' + uid + '"]');
                if (file.length > 0) {
                    this.retryUpload(file, force);
                }
            },
            cancelAllUpload: function(force) {
                var that = this;
                var files = that.wrapper.find(".k-file");
                files.each(function(index, file) {
                    file = $(file);
                    if (that.fileInProgress(file)) {
                        that.cancelUpload(file, force);
                    }
                });
            },
            cancelUpload: function(fileEntry, force) {
                if (force) {
                    this._module.onCancel({
                        target: $(fileEntry, this.wrapper)
                    });
                } else {
                    var button = fileEntry.find(".k-upload-action .k-i-cancel").parent(".k-upload-action");
                    if (button.length) {
                        this._onFileAction({
                            target: button
                        });
                    }
                }
            },
            retryUpload: function(fileEntry, force) {
                if (force) {
                    this._module.onRetry({
                        target: $(fileEntry, this.wrapper)
                    });
                } else {
                    var button = fileEntry.find(".k-upload-action .k-i-retry").parent(".k-upload-action");
                    if (button.length) {
                        this._onFileAction({
                            target: button
                        });
                    }
                }
            },
            _onFileAction: function(e) {
                if (!this.wrapper.hasClass("k-state-disabled")) {
                    var button = $(e.target).closest(".k-upload-action");
                    var icon = button.find(".k-icon");
                    var fileEntry = button.closest(".k-file");
                    var files = fileEntry.data("fileNames");
                    if (icon.hasClass("k-i-retry")) {
                        if (!this.trigger(RETRY_UPLOAD, {
                            files: files
                        })) {
                            ui.Upload.fn._onFileAction.call(this, e);
                        }
                    } else {
                        ui.Upload.fn._onFileAction.call(this, e);
                    }
                }
                return false;
            },
            _setupCustomDropZone: function() {
                if (this.options.dropZoneFilter) {
                    this._setupDropZoneFilter();
                } else {
                    ui.Upload.fn._setupCustomDropZone.call(this);
                }
            },
            _setupDropZoneFilter: function() {
                var that = this, dropZone = $(that.options.dropZone), filter = that.options.dropZoneFilter, dropHandler = proxy(that._onDrop, that);
                $(".k-upload-button", that.wrapper).wrap("<div class='k-dropzone'></div>");
                var stopEvent = function(e) {
                    e.stopPropagation();
                    e.preventDefault();
                };
                var preventEvent = function(e) {
                    e.preventDefault();
                };
                this._initDropZoneEvents(dropZone, stopEvent, preventEvent, dropHandler);
                this._initDropZoneFilterEvents(dropZone, filter, stopEvent, preventEvent, dropHandler);
            },
            _initDropZoneEvents: function(dropZone, stopEvent, preventEvent, dropHandler) {
                var that = this, ns = that._ns;
                dropZone.on("dragenter" + ns, stopEvent).on("dragover" + ns, preventEvent).on("drop" + ns, function(e) {
                    that.trigger(DROP_ZONE, {
                        item: $(e.currentTarget),
                        orig: e
                    });
                    dropHandler(e);
                });
                bindDragEventWrappers(dropZone, ns, undefined, function() {
                    if (!that.wrapper.hasClass("k-state-disabled")) {
                        dropZone.addClass("k-dropzone-hovered");
                    }
                }, function() {
                    dropZone.removeClass("k-dropzone-hovered");
                });
            },
            _initDropZoneFilterEvents: function(dropZone, filter, stopEvent, preventEvent, dropHandler) {
                var that = this, ns = that._ns;
                dropZone.on("dragenter" + ns, filter, stopEvent).on("dragover" + ns, filter, preventEvent).on("drop" + ns, filter, function(e) {
                    that.trigger(DROP_ITEM, {
                        item: $(e.currentTarget),
                        orig: e
                    });
                    dropHandler(e);
                });
                bindDragEventWrappers(dropZone, ns, filter, function(e) {
                    if (!that.wrapper.hasClass("k-state-disabled")) {
                        $(e.currentTarget).addClass("k-dropzone-hovered");
                    }
                }, function(e) {
                    $(e.currentTarget).removeClass("k-dropzone-hovered");
                });
            },
            _enqueueFile: function(name, data) {
                var fileEntry = ui.Upload.fn._enqueueFile.call(this, name, data);
                if (this.isFileList()) {
                    this.trigger(FILELIST_CREATED);
                }
                return fileEntry;
            },
            _removeFileEntry: function(fileEntry) {
                ui.Upload.fn._removeFileEntry.call(this, fileEntry);
                if (!this.isFileList()) {
                    this.trigger(FILELIST_DESTROYED);
                }
            },
            _onParentFormReset: function() {
                ui.Upload.fn._onParentFormReset.call(this);
                this.trigger(FILELIST_DESTROYED);
            },
            _onFileProgress: function(e, percentComplete) {
                ui.Upload.fn._onFileProgress.call(this, e, percentComplete);
            },
            destroy: function() {
                if (this.options.cancelOnDestroy) {
                    this.cancelAllUpload(true);
                }
                ui.Upload.fn.destroy.call(this);
            }
        });
        function bindDragEventWrappers(element, namespace, filter, onDragEnter, onDragLeave) {
            var hideInterval, lastDrag;
            var processDragLeave = function(e) {
                lastDrag = new Date();
                if (!hideInterval) {
                    hideInterval = setInterval(function() {
                        var sinceLastDrag = new Date() - lastDrag;
                        if (sinceLastDrag > 100) {
                            onDragLeave(e);
                            clearInterval(hideInterval);
                            hideInterval = null;
                        }
                    }, 100);
                }
            };
            var processDragLeaveForFilter = function(e) {
                var currentTarget = $(e.currentTarget);
                currentTarget.data("lastDrag", new Date());
                if (!currentTarget.data("hideInterval")) {
                    currentTarget.data("hideInterval", setInterval(function() {
                        var sinceLastDrag = new Date() - currentTarget.data("lastDrag");
                        if (sinceLastDrag > 100) {
                            onDragLeave(e);
                            clearInterval(currentTarget.data("hideInterval"));
                            currentTarget.data("hideInterval", null);
                        }
                    }, 100));
                }
            };
            element.on("dragenter" + namespace, filter, function(e) {
                onDragEnter(e);
                if (filter) {
                    processDragLeaveForFilter(e);
                } else {
                    processDragLeave(e);
                }
            }).on("dragover" + namespace, filter, function(e) {
                if (filter) {
                    $(e.currentTarget).data("lastDrag", new Date());
                } else {
                    lastDrag = new Date();
                }
            });
        }
        kendo.ui.plugin(JunkyardUpload);
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.command.base", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.constants" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, ObservableObject = kendo.data.ObservableObject, jyNS = ui.junkyard, CommandState = jyNS.CommandState, extend = $.extend, proxy = $.proxy, CHANGE = "change";
        var Command = ObservableObject.extend({
            init: function(options) {
                ObservableObject.fn.init.call(this);
                this.root = options.root;
                this.args = options.args || {};
                this.type = options.type || "Unknown";
                this.foreground = !!options.foreground;
                this.createdAt = new Date();
                this.set("state", CommandState.Created);
                this.set("lastError", null);
                this.set("canExec", true);
                this.execDeferred = null;
                this._created = proxy(this._created, this);
                this._running = proxy(this._running, this);
                this._done = proxy(this._done, this);
                this._fail = proxy(this._fail, this);
            },
            changeCanExec: function(value) {
                this.set("canExec", !!value);
            },
            _changeState: function(state) {
                this.set("state", state);
            },
            notifyStateChanged: function() {
                this.trigger(CHANGE, {
                    field: "state"
                });
            },
            isCreated: function() {
                return this.get("state") === CommandState.Created;
            },
            isRunning: function() {
                return this.get("state") === CommandState.Running;
            },
            isCompleted: function() {
                var state = this.get("state");
                return state === CommandState.Done || state === CommandState.Failed;
            },
            isDone: function() {
                return this.get("state") === CommandState.Done;
            },
            isFailed: function() {
                return this.get("state") === CommandState.Failed;
            },
            _created: function() {
                this._changeState(CommandState.Created);
            },
            _running: function() {
                this._changeState(CommandState.Running);
            },
            _done: function() {
                this._changeState(CommandState.Done);
                if (this.execDeferred) {
                    this.execDeferred.resolve();
                }
            },
            _fail: function(error) {
                this.set("lastError", error);
                this._changeState(CommandState.Failed);
                if (this.execDeferred) {
                    this.execDeferred.reject(error);
                }
            },
            _deferred: function(isNew) {
                if (!this.execDeferred || isNew) {
                    this.execDeferred = $.Deferred();
                }
                return this.execDeferred;
            },
            exec: function() {
                this._deferred(true);
                this._running();
                this._exec();
                return this._deferred();
            },
            _exec: function() {
                throw new Error("Not implemented.");
            }
        });
        extend(jyNS, {
            Command: Command
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.command.show-items", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.constants", "kendo.junkyard.commandutil", "kendo.junkyard.command.base" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, Command = jyNS.Command, extend = $.extend;
        var ShowItemsCommand = Command.extend({
            init: function(options) {
                Command.fn.init.call(this, options);
            },
            _exec: function() {
                var args = this.args, driveId = args.driveId, itemId = args.itemId, itemsVm = this.root.items, drivesVm = this.root.drives, toolbarVm = this.root.toolbar, searchVm = this.root.searchBar;
                if (!driveId) {
                    this._fail(new Error("driveId param is required."));
                    return;
                }
                toolbarVm.setCanChangeView(true);
                searchVm.close();
                drivesVm.setVisible(false);
                itemsVm.setVisible(true);
                itemsVm.onUpdateViewType();
                itemsVm.empty().load(driveId, itemId).done(this._done).fail(this._fail);
            }
        });
        extend(jyNS, {
            ShowItemsCommand: ShowItemsCommand
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.command.show-drives", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.constants", "kendo.junkyard.commandutil", "kendo.junkyard.command.base" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, Command = jyNS.Command, extend = $.extend;
        var ShowDrivesCommand = Command.extend({
            init: function(options) {
                Command.fn.init.call(this, options);
            },
            _exec: function() {
                var args = this.args, isShared = !!args.isShared, itemsVm = this.root.items, drivesVm = this.root.drives, toolbarVm = this.root.toolbar, searchVm = this.root.searchBar;
                toolbarVm.setCanChangeView(true);
                searchVm.close();
                itemsVm.setVisible(false);
                drivesVm.setVisible(true);
                drivesVm.onUpdateViewType();
                drivesVm.empty().load(isShared).done(this._done).fail(this._fail);
            }
        });
        extend(jyNS, {
            ShowDrivesCommand: ShowDrivesCommand
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.command.startup", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.constants", "kendo.junkyard.commandutil", "kendo.junkyard.command.base" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, Command = jyNS.Command, extend = $.extend;
        var StartupCommand = Command.extend({
            init: function(options) {
                Command.fn.init.call(this, options);
            },
            _exec: function() {
                var that = this;
                this.root.auth().done(function() {
                    that._startup();
                }).fail(that._fail);
            },
            _startup: function() {
                var that = this, menuTree = this.root.menuTree, router = this.root.router;
                menuTree.load().done(function() {
                    router.startAsync();
                    that._done();
                }).fail(this._fail);
            }
        });
        extend(jyNS, {
            StartupCommand: StartupCommand
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.command.change-view", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.constants", "kendo.junkyard.commandutil", "kendo.junkyard.command.base" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, Command = jyNS.Command, extend = $.extend;
        var ChangeViewCommand = Command.extend({
            init: function(options) {
                Command.fn.init.call(this, options);
            },
            _exec: function() {
                var args = this.args, viewType = args.viewType, itemsVm = this.root.items, drivesVm = this.root.drives;
                if (viewType == null) {
                    this._fail(new Error("viewType param is required."));
                    return;
                }
                itemsVm.switchViewType(viewType);
                drivesVm.switchViewType(viewType);
                this._done();
            }
        });
        extend(jyNS, {
            ChangeViewCommand: ChangeViewCommand
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.command.open-drive", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.constants", "kendo.junkyard.commandutil", "kendo.junkyard.command.base", "kendo.junkyard.models" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, Command = jyNS.Command, extend = $.extend;
        var OpenDriveCommand = Command.extend({
            init: function(options) {
                Command.fn.init.call(this, options);
            },
            _exec: function() {
                var args = this.args, driveModel = args.item, path = this.root.path, router = this.root.router;
                if (!driveModel) {
                    this._fail(new Error("item param is required."));
                    return;
                }
                if (path.currentBase) {
                    router.goToDrive(path.currentBase.id, driveModel.id);
                }
                this._done();
            }
        });
        extend(jyNS, {
            OpenDriveCommand: OpenDriveCommand
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.command.open-folder", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.constants", "kendo.junkyard.commandutil", "kendo.junkyard.command.base" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, Command = jyNS.Command, extend = $.extend;
        var OpenFolderCommand = Command.extend({
            init: function(options) {
                Command.fn.init.call(this, options);
            },
            _exec: function() {
                var args = this.args, itemModel = args.item, path = this.root.path, router = this.root.router;
                if (!itemModel) {
                    this._fail(new Error("item param is required."));
                    return;
                }
                if (path.currentBase && path.currentDrive) {
                    router.goToItem(path.currentBase.id, path.currentDrive.id, itemModel.id);
                }
                this._done();
            }
        });
        extend(jyNS, {
            OpenFolderCommand: OpenFolderCommand
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.command.dialog", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.constants", "kendo.junkyard.commandutil", "kendo.junkyard.command.base" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, Command = jyNS.Command, extend = $.extend;
        var DialogCommand = Command.extend({
            init: function(options) {
                Command.fn.init.call(this, options);
            },
            _exec: function() {
                var args = this.args, viewModel = args.viewModel, dialog = this.getDialogWidget();
                if (!viewModel) {
                    this._fail(new Error("viewModel param is required."));
                    return;
                }
                if (!dialog) {
                    this._fail(new Error("dialog not found."));
                    return;
                }
                dialog.open(viewModel);
                this._done();
            },
            getDialogWidget: function() {}
        });
        extend(jyNS, {
            DialogCommand: DialogCommand
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.command.add-drive-dialog", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.constants", "kendo.junkyard.commandutil", "kendo.junkyard.command.dialog" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, DialogCommand = jyNS.DialogCommand, extend = $.extend;
        var AddDriveDialogCommand = DialogCommand.extend({
            getDialogWidget: function() {
                return $("#jy-new-drive-dialog-" + this.root.uid).data("kendoJunkyardDialog");
            }
        });
        extend(jyNS, {
            AddDriveDialogCommand: AddDriveDialogCommand
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.command.ui", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.constants", "kendo.junkyard.commandutil", "kendo.junkyard.command.base", "kendo.junkyard.models" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, Command = jyNS.Command, extend = $.extend, proxy = $.proxy, when = $.when;
        var UICommand = Command.extend({
            init: function(options) {
                Command.fn.init.call(this, options);
                this._updateUI = proxy(this._updateUI, this);
            },
            _updateUI: function() {
                var args = this.args, isUpdateUI = args.updateUI === undefined ? true : args.updateUI;
                if (isUpdateUI) {
                    this._doUpdateUI.apply(this, arguments);
                }
            },
            _doUpdateUI: function() {},
            _makeNotifySuccess: function() {
                var that = this, args = arguments;
                return function() {
                    var message = that._successMessage.apply(that, args);
                    if (message) {
                        that.root.errorBar.showSuccess(message);
                    }
                };
            },
            _successMessage: function() {},
            reloadMenuNodeAndDrives: function(menuId, menuType, toSelectDriveId) {
                return when(this.reloadMenuNode(menuId, menuType), this.reloadDrives(false, toSelectDriveId));
            },
            reloadMenuNodeAndItems: function(menuId, menuType, toSelectItemId) {
                return when(this.reloadMenuNode(menuId, menuType), this.reloadItems(false, toSelectItemId));
            },
            reloadMenuNode: function(menuItemId, menuItemType) {
                var menuTreeVm = this.root.menuTree;
                return menuTreeVm.reloadNode(menuItemId, menuItemType, true, true);
            },
            reloadPath: function() {
                return this.root.path.reload();
            },
            reloadDrives: function(force, toSelectDriveId) {
                var drivesVm = this.root.drives;
                if (force || drivesVm.visible) {
                    return drivesVm.reload(true).done(function() {
                        if (toSelectDriveId) {
                            drivesVm.selectById(toSelectDriveId);
                        }
                    });
                }
                return false;
            },
            reloadItems: function(force, toSelectItemId) {
                var itemsVm = this.root.items;
                if (force || itemsVm.visible) {
                    return itemsVm.reload(true).done(function() {
                        if (toSelectItemId) {
                            itemsVm.selectById(toSelectItemId);
                        }
                    });
                }
                return false;
            },
            wait: function() {
                return when.apply(null, arguments);
            }
        });
        extend(jyNS, {
            UICommand: UICommand
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.command.save-drive", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.constants", "kendo.junkyard.commandutil", "kendo.junkyard.command.ui", "kendo.junkyard.models" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, UICommand = jyNS.UICommand, extend = $.extend, MenuIds = jyNS.MenuIds, MenuItemType = jyNS.MenuItemType, models = jyNS.models;
        var SaveDriveCommand = UICommand.extend({
            init: function(options) {
                UICommand.fn.init.call(this, options);
            },
            _exec: function() {
                var args = this.args, driveId = args.driveId, title = args.title, flags = args.flags, accessItems = args.accessItems, api = this.root.service.api;
                api.saveDrive(driveId, title, accessItems, flags).done(this._updateUI).fail(this._fail);
            },
            _doUpdateUI: function(resp) {
                var model = new models.DriveDetailsModel(resp.response || {}), selectAfterSave = this.args.selectAfterSave;
                this.reloadMenuNodeAndDrives(MenuIds.My, MenuItemType.Menu, selectAfterSave ? model.id : null).done(this._makeNotifySuccess(model)).done(this._done).fail(this._fail);
            },
            _successMessage: function(model) {
                if (!this.args.driveId) {
                    var localization = this.root.widgetOpt.localization;
                    return kendo.format(localization.addDriveSuccess, model[model.fields.title.field]);
                }
            }
        });
        extend(jyNS, {
            SaveDriveCommand: SaveDriveCommand
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.command.show-details", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.constants", "kendo.junkyard.commandutil", "kendo.junkyard.command.base" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, Command = jyNS.Command, extend = $.extend;
        var ShowDetailsCommand = Command.extend({
            init: function(options) {
                Command.fn.init.call(this, options);
            },
            _exec: function() {
                var args = this.args, driveId = args.driveId, itemId = args.itemId, itemType = args.itemType || null, title = args.title || null, detailsVm = this.root.details;
                if (!driveId) {
                    this._fail(new Error("driveId param is required."));
                    return;
                }
                if (itemId) {
                    detailsVm.showItem(driveId, itemId, title, itemType).done(this._done).fail(this._fail);
                } else {
                    detailsVm.showDrive(driveId, title).done(this._done).fail(this._fail);
                }
            }
        });
        extend(jyNS, {
            ShowDetailsCommand: ShowDetailsCommand
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.command.close-details", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.constants", "kendo.junkyard.commandutil", "kendo.junkyard.command.base" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, Command = jyNS.Command, extend = $.extend;
        var CloseDetailsCommand = Command.extend({
            init: function(options) {
                Command.fn.init.call(this, options);
            },
            _exec: function() {
                var detailsVm = this.root.details;
                detailsVm.close();
                this._done();
            }
        });
        extend(jyNS, {
            CloseDetailsCommand: CloseDetailsCommand
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.command.add-folder-dialog", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.constants", "kendo.junkyard.commandutil", "kendo.junkyard.command.dialog" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, DialogCommand = jyNS.DialogCommand, extend = $.extend;
        var AddFolderDialogCommand = DialogCommand.extend({
            getDialogWidget: function() {
                return $("#jy-new-folder-dialog-" + this.root.uid).data("kendoJunkyardDialog");
            }
        });
        extend(jyNS, {
            AddFolderDialogCommand: AddFolderDialogCommand
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.command.share-drive-dialog", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.constants", "kendo.junkyard.commandutil", "kendo.junkyard.command.base" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, Command = jyNS.Command, extend = $.extend;
        var ShareDriveDialogCommand = Command.extend({
            init: function(options) {
                Command.fn.init.call(this, options);
            },
            _exec: function() {
                var args = this.args, viewModel = args.viewModel, dialog = $("#jy-share-drive-dialog-" + this.root.uid).data("kendoJunkyardDialog");
                if (!viewModel) {
                    this._fail(new Error("viewModel param is required."));
                    return;
                }
                if (!dialog) {
                    this._fail(new Error("dialog not found."));
                    return;
                }
                dialog.open(viewModel);
                viewModel.load().done(this._done).fail(this._fail);
            }
        });
        extend(jyNS, {
            ShareDriveDialogCommand: ShareDriveDialogCommand
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.command.create-folder", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.constants", "kendo.junkyard.commandutil", "kendo.junkyard.command.ui", "kendo.junkyard.models" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, UICommand = jyNS.UICommand, extend = $.extend, MenuItemType = jyNS.MenuItemType, models = jyNS.models;
        var CreateFolderCommand = UICommand.extend({
            init: function(options) {
                UICommand.fn.init.call(this, options);
            },
            _exec: function() {
                var args = this.args, driveId = args.driveId, parentId = args.parentId, title = args.title, api = this.root.service.api;
                if (!driveId || !title) {
                    this._fail(new Error("driveId and title param is required."));
                    return;
                }
                api.createFolder(driveId, parentId, title).done(this._updateUI).fail(this._fail);
            },
            _doUpdateUI: function(resp) {
                var args = this.args, model = new models.ItemModel(resp.response || {}), menuId = args.parentId ? args.parentId : args.driveId, menuType = args.parentId ? MenuItemType.Item : MenuItemType.Drive;
                this.reloadMenuNodeAndItems(menuId, menuType, model.id).done(this._makeNotifySuccess(model)).done(this._done).fail(this._fail);
            },
            _successMessage: function(model) {
                var localization = this.root.widgetOpt.localization;
                return kendo.format(localization.addFolderSuccess, model[model.fields.title.field]);
            }
        });
        extend(jyNS, {
            CreateFolderCommand: CreateFolderCommand
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.command.upload", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.constants", "kendo.junkyard.commandutil", "kendo.junkyard.command.base" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, Command = jyNS.Command, extend = $.extend;
        var UploadCommand = Command.extend({
            init: function(options) {
                Command.fn.init.call(this, options);
            },
            _exec: function() {
                var args = this.args, driveId = args.driveId, itemId = args.itemId;
                this.root.upload.clickInput(driveId, itemId);
                this._done();
            }
        });
        extend(jyNS, {
            UploadCommand: UploadCommand
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.command.reload-ui", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.constants", "kendo.junkyard.commandutil", "kendo.junkyard.command.ui", "kendo.junkyard.models" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, UICommand = jyNS.UICommand, extend = $.extend, when = $.when, MenuItemType = jyNS.MenuItemType;
        var ReloadUICommand = UICommand.extend({
            init: function(options) {
                UICommand.fn.init.call(this, options);
            },
            _exec: function() {
                var args = this.args, driveId = args.driveId, itemId = args.itemId;
                if (!driveId) {
                    this._fail(new Error("driveId param is required."));
                    return;
                }
                var menuId = itemId ? itemId : driveId;
                var menuType = itemId ? MenuItemType.Item : MenuItemType.Drive;
                when(this.reloadMenuNode(menuId, menuType), this.reloadDrives(false), this.reloadItems(false)).done(this._done).fail(this._fail);
            }
        });
        extend(jyNS, {
            ReloadUICommand: ReloadUICommand
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.command.rename-dialog", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.constants", "kendo.junkyard.commandutil", "kendo.junkyard.command.dialog" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, DialogCommand = jyNS.DialogCommand, extend = $.extend;
        var RenameDialogCommand = DialogCommand.extend({
            getDialogWidget: function() {
                return $("#jy-rename-dialog-" + this.root.uid).data("kendoJunkyardDialog");
            }
        });
        extend(jyNS, {
            RenameDialogCommand: RenameDialogCommand
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.command.rename-drive", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.constants", "kendo.junkyard.commandutil", "kendo.junkyard.command.ui", "kendo.junkyard.models" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, UICommand = jyNS.UICommand, MenuItemType = jyNS.MenuItemType, extend = $.extend;
        var RenameDriveCommand = UICommand.extend({
            init: function(options) {
                UICommand.fn.init.call(this, options);
            },
            _exec: function() {
                var args = this.args, driveId = args.driveId, title = args.title, api = this.root.service.api;
                if (!driveId || !title) {
                    this._fail(new Error("driveId and title params is required."));
                    return;
                }
                api.renameDrive(driveId, title).done(this._updateUI).fail(this._fail);
            },
            _doUpdateUI: function() {
                var args = this.args, driveId = args.driveId, menuTree = this.root.menuTree, parent = menuTree.findParentNode(driveId, MenuItemType.Drive);
                if (parent) {
                    this.wait(this.reloadMenuNodeAndDrives(parent.id, parent.menuType), this.reloadPath()).done(this._done).fail(this._fail);
                } else {
                    this.wait(this.reloadDrives(), this.reloadPath()).done(this._done).fail(this._fail);
                }
            }
        });
        extend(jyNS, {
            RenameDriveCommand: RenameDriveCommand
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.command.rename-item", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.constants", "kendo.junkyard.commandutil", "kendo.junkyard.command.ui", "kendo.junkyard.models" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, UICommand = jyNS.UICommand, extend = $.extend, MenuItemType = jyNS.MenuItemType;
        var RenameItemCommand = UICommand.extend({
            init: function(options) {
                UICommand.fn.init.call(this, options);
            },
            _exec: function() {
                var args = this.args, driveId = args.driveId, itemId = args.itemId, title = args.title, api = this.root.service.api;
                if (!driveId || !title || !itemId) {
                    this._fail(new Error("driveId, itemId and title params is required."));
                    return;
                }
                api.renameItem(driveId, itemId, title).done(this._updateUI).fail(this._fail);
            },
            _doUpdateUI: function() {
                var args = this.args, itemId = args.itemId, menuTree = this.root.menuTree, parent = menuTree.findParentNode(itemId, MenuItemType.Item);
                if (parent) {
                    this.wait(this.reloadMenuNodeAndItems(parent.id, parent.menuType), this.reloadPath()).done(this._done).fail(this._fail);
                } else {
                    this.wait(this.reloadItems(), this.reloadPath()).done(this._done).fail(this._fail);
                }
            }
        });
        extend(jyNS, {
            RenameItemCommand: RenameItemCommand
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.command.move-dialog", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.constants", "kendo.junkyard.commandutil", "kendo.junkyard.command.dialog" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, DialogCommand = jyNS.DialogCommand, extend = $.extend;
        var MoveDialogCommand = DialogCommand.extend({
            getDialogWidget: function() {
                return $("#jy-move-item-dialog-" + this.root.uid).data("kendoJunkyardDialog");
            }
        });
        extend(jyNS, {
            MoveDialogCommand: MoveDialogCommand
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.command.restore-dialog", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.constants", "kendo.junkyard.commandutil", "kendo.junkyard.command.dialog" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, DialogCommand = jyNS.DialogCommand, extend = $.extend;
        var RestoreDialogCommand = DialogCommand.extend({
            getDialogWidget: function() {
                return $("#jy-restore-item-dialog-" + this.root.uid).data("kendoJunkyardDialog");
            }
        });
        extend(jyNS, {
            RestoreDialogCommand: RestoreDialogCommand
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.command.copy-dialog", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.constants", "kendo.junkyard.commandutil", "kendo.junkyard.command.dialog" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, DialogCommand = jyNS.DialogCommand, extend = $.extend;
        var CopyDialogCommand = DialogCommand.extend({
            getDialogWidget: function() {
                return $("#jy-copy-item-dialog-" + this.root.uid).data("kendoJunkyardDialog");
            }
        });
        extend(jyNS, {
            CopyDialogCommand: CopyDialogCommand
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.command.move-item", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.constants", "kendo.junkyard.commandutil", "kendo.junkyard.command.ui", "kendo.junkyard.models" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, UICommand = jyNS.UICommand, extend = $.extend, when = $.when, MenuItemType = jyNS.MenuItemType;
        var MoveItemCommand = UICommand.extend({
            init: function(options) {
                UICommand.fn.init.call(this, options);
            },
            _exec: function() {
                var args = this.args, driveId = args.driveId, folderId = args.folderId, itemIds = args.itemIds, api = this.root.service.api;
                if (!driveId) {
                    this._fail(new Error("driveId param is required."));
                    return;
                }
                if (!Array.isArray(itemIds) || itemIds.length === 0) {
                    this._fail(new Error("itemIds param is required."));
                    return;
                }
                api.moveItems(driveId, folderId, itemIds).done(this._updateUI).fail(this._fail);
            },
            _doUpdateUI: function() {
                var defers = [], args = this.args, driveId = args.driveId;
                defers.push(this.reloadMenuNode(driveId, MenuItemType.Drive));
                defers.push(this.reloadPath());
                defers.push(this.reloadItems());
                when.apply(null, defers).done(this._done).fail(this._fail);
            }
        });
        extend(jyNS, {
            MoveItemCommand: MoveItemCommand
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.command.restore-item", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.constants", "kendo.junkyard.commandutil", "kendo.junkyard.command.ui", "kendo.junkyard.models" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, UICommand = jyNS.UICommand, extend = $.extend, when = $.when, MenuItemType = jyNS.MenuItemType;
        var RestoreItemCommand = UICommand.extend({
            init: function(options) {
                UICommand.fn.init.call(this, options);
            },
            _exec: function() {
                var args = this.args, driveId = args.driveId, folderId = args.folderId, itemId = args.itemId, newName = args.newName, api = this.root.service.api;
                if (!driveId) {
                    this._fail(new Error("driveId param is required."));
                    return;
                }
                api.restoreItem(itemId, driveId, folderId, newName).done(this._updateUI).fail(this._fail);
            },
            _doUpdateUI: function() {
                var defers = [], args = this.args, driveId = args.driveId;
                defers.push(this.reloadMenuNode(driveId, MenuItemType.Drive));
                defers.push(this.reloadPath());
                defers.push(this.reloadItems());
                when.apply(null, defers).done(this._done).fail(this._fail);
            }
        });
        extend(jyNS, {
            RestoreItemCommand: RestoreItemCommand
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.command.copy-item", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.constants", "kendo.junkyard.commandutil", "kendo.junkyard.command.ui", "kendo.junkyard.models" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, UICommand = jyNS.UICommand, extend = $.extend, when = $.when, MenuItemType = jyNS.MenuItemType;
        var CopyItemCommand = UICommand.extend({
            init: function(options) {
                UICommand.fn.init.call(this, options);
            },
            _exec: function() {
                var args = this.args, driveId = args.driveId, folderId = args.folderId, itemIds = args.itemIds, api = this.root.service.api;
                if (!driveId) {
                    this._fail(new Error("driveId param is required."));
                    return;
                }
                if (!Array.isArray(itemIds) || itemIds.length === 0) {
                    this._fail(new Error("itemIds param is required."));
                    return;
                }
                api.copyItems(driveId, folderId, itemIds).done(this._updateUI).fail(this._fail);
            },
            _doUpdateUI: function() {
                var defers = [], args = this.args, driveId = args.driveId;
                defers.push(this.reloadMenuNode(driveId, MenuItemType.Drive));
                defers.push(this.reloadPath());
                defers.push(this.reloadItems());
                when.apply(null, defers).done(this._done).fail(this._fail);
            }
        });
        extend(jyNS, {
            CopyItemCommand: CopyItemCommand
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.command.download-item", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.constants", "kendo.junkyard.commandutil", "kendo.junkyard.command.ui" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, UICommand = jyNS.UICommand, extend = $.extend;
        var DownloadItemCommand = UICommand.extend({
            init: function(options) {
                UICommand.fn.init.call(this, options);
            },
            _exec: function() {
                var that = this, args = this.args, driveId = args.driveId, itemIds = args.itemIds, version = args.version, service = this.root.service, auth = service.auth, widgetOpt = this.root.widgetOpt, localization = widgetOpt.localization, doneDelay = 1500;
                if (!driveId) {
                    this._fail(new Error("driveId param is required."));
                    return;
                }
                if (!Array.isArray(itemIds) || itemIds.length === 0) {
                    this._fail(new Error("itemIds param is required."));
                    return;
                }
                auth.validateOrRefreshToken().done(function() {
                    that._doneDelay(doneDelay);
                    that._downloadItem(driveId, itemIds, version);
                }).fail(function() {
                    that._fail(new Error(localization.InvalidAuthToken));
                });
            },
            _doneDelay: function(delay) {
                var that = this;
                var timeoutResource = setTimeout(function() {
                    that._done();
                    clearTimeout(timeoutResource);
                }, delay);
            },
            _downloadItem: function(driveId, itemIds, version) {
                var api = this.root.service.api;
                var url = version ? api.makeDownloadVersionUrl(driveId, itemIds[0], version) : api.makeDownloadUrl(driveId, itemIds);
                $("<iframe>").hide().prop("src", url).appendTo($("#jy-download-iframes-" + this.root.uid));
            }
        });
        extend(jyNS, {
            DownloadItemCommand: DownloadItemCommand
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.command.open-file", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.constants", "kendo.junkyard.commandutil", "kendo.junkyard.command.base" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, Command = jyNS.Command, extend = $.extend, FileHandlerActionTypes = jyNS.FileHandlerActionTypes;
        var OpenFileCommand = Command.extend({
            init: function(options) {
                Command.fn.init.call(this, options);
            },
            _exec: function() {
                var args = this.args, item = args.item, version = args.version, actionType = args.actionType || FileHandlerActionTypes.Open, fileHandlerService = this.root.fileHandlerService;
                if (!item) {
                    this._fail(new Error("item param is required."));
                    return;
                }
                var fileHandler = fileHandlerService.findFileHandlerByExt(item.extension);
                var action = fileHandler ? fileHandler.resolveActionRef(fileHandler.findActionByType(actionType)) : null;
                if (action) {
                    this._open(item, action, version);
                    this._done();
                } else {
                    this._fail(new Error("Open action not registered."));
                }
            },
            _open: function(item, action, version) {
                var url = action.makeUrl(item, this.root, {
                    version: version
                });
                if (url) {
                    var win = window.open(url, "_blank");
                    if (win) {
                        win.focus();
                    }
                }
            }
        });
        extend(jyNS, {
            OpenFileCommand: OpenFileCommand
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.command.open-preview", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.constants", "kendo.junkyard.commandutil", "kendo.junkyard.command.base" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, Command = jyNS.Command, extend = $.extend;
        var OpenPreviewCommand = Command.extend({
            init: function(options) {
                Command.fn.init.call(this, options);
            },
            _exec: function() {
                var args = this.args, item = args.item, version = args.version, fileHandlerService = this.root.fileHandlerService, commandService = this.root.commandService;
                if (!item) {
                    this._fail(new Error("item param is required."));
                    return;
                }
                var fileHandler = fileHandlerService.findFileHandlerByExt(item.extension);
                var actions = fileHandler ? fileHandler.getActions() : [];
                commandService.previewDialog(item, actions, version).done(this._done).fail(this._fail);
            }
        });
        extend(jyNS, {
            OpenPreviewCommand: OpenPreviewCommand
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.command.preview-dialog", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.constants", "kendo.junkyard.commandutil", "kendo.junkyard.command.dialog" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, DialogCommand = jyNS.DialogCommand, extend = $.extend;
        var PreviewDialogCommand = DialogCommand.extend({
            getDialogWidget: function() {
                return $("#jy-preview-dialog-" + this.root.uid).data("kendoJunkyardDialog");
            }
        });
        extend(jyNS, {
            PreviewDialogCommand: PreviewDialogCommand
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.command.open-file-dialog", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.constants", "kendo.junkyard.commandutil", "kendo.junkyard.command.dialog" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, DialogCommand = jyNS.DialogCommand, extend = $.extend;
        var OpenFileDialogCommand = DialogCommand.extend({
            getDialogWidget: function() {
                return $("#jy-open-file-dialog-" + this.root.uid).data("kendoJunkyardDialog");
            }
        });
        extend(jyNS, {
            OpenFileDialogCommand: OpenFileDialogCommand
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.command.delete-item", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.constants", "kendo.junkyard.commandutil", "kendo.junkyard.command.ui", "kendo.junkyard.models" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, UICommand = jyNS.UICommand, extend = $.extend, when = $.when, MenuItemType = jyNS.MenuItemType;
        var DeleteItemCommand = UICommand.extend({
            init: function(options) {
                UICommand.fn.init.call(this, options);
            },
            _exec: function() {
                var args = this.args, driveId = args.driveId, itemIds = args.itemIds, api = this.root.service.api;
                if (!driveId) {
                    this._fail(new Error("driveId param is required."));
                    return;
                }
                if (!Array.isArray(itemIds) || itemIds.length === 0) {
                    this._fail(new Error("itemIds param is required."));
                    return;
                }
                api.deleteItems(driveId, itemIds).done(this._updateUI).fail(this._fail);
            },
            _doUpdateUI: function() {
                var defers = [], args = this.args, path = this.root.path, driveId = args.driveId, parentFolderId = args.folderId, itemIds = args.itemIds, itemIdToDelete = args.itemIds[0], pathInludedDeleteItem = path.includePath(itemIdToDelete, MenuItemType.Item), details = this.root.details;
                if (parentFolderId) {
                    defers.push(this.reloadMenuNode(parentFolderId, MenuItemType.Item));
                } else {
                    defers.push(this.reloadMenuNode(driveId, MenuItemType.Drive));
                }
                if (details.isOpenedForItems(itemIds)) {
                    this._closeDetails();
                }
                if (!pathInludedDeleteItem) {
                    defers.push(this.reloadItems());
                }
                when.apply(null, defers).done(this._done).fail(this._fail);
                if (pathInludedDeleteItem) {
                    this._closeDetails();
                    this._redirect(driveId, parentFolderId);
                }
            },
            _redirect: function(driveId, folderId) {
                var router = this.root.router;
                var path = this.root.path;
                var currentBase = path.currentBase;
                if (currentBase) {
                    if (folderId) {
                        router.goToItem(currentBase.id, driveId, folderId);
                    } else {
                        router.goToDrive(currentBase.id, driveId);
                    }
                }
            },
            _closeDetails: function() {
                this.root.commandService.closeDetails();
            }
        });
        extend(jyNS, {
            DeleteItemCommand: DeleteItemCommand
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.command.delete-item-with-confirm", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.constants", "kendo.junkyard.commandutil", "kendo.junkyard.command.ui", "kendo.junkyard.models" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, UICommand = jyNS.UICommand, extend = $.extend, utils = jyNS.utils, ItemType = jyNS.ItemType;
        var DeleteItemWithConfirmCommand = UICommand.extend({
            init: function(options) {
                UICommand.fn.init.call(this, options);
            },
            _exec: function() {
                var args = this.args, driveId = args.driveId, itemIds = args.itemIds || [], itemType = args.itemType, folderId = args.folderId, widgetOpt = this.root.widgetOpt, localization = widgetOpt.localization, confirmOpt = localization.confirm, hasMany = itemIds.length > 1, isFile = itemType === ItemType.File, isFolder = itemType === ItemType.Folder, commandService = this.root.commandService, message, title;
                if (hasMany) {
                    message = kendo.format(localization.deleteMultiple, itemIds.length);
                    title = localization.deleteMultipleTitle;
                } else if (isFile) {
                    message = localization.deleteFile;
                    title = localization.deleteFileTitle;
                } else if (isFolder) {
                    message = localization.deleteFolder;
                    title = localization.deleteFolderTitle;
                }
                utils.confirm(message, title, confirmOpt).done(function() {
                    commandService.deleteItems(driveId, folderId, itemIds);
                });
                this._done();
            }
        });
        extend(jyNS, {
            DeleteItemWithConfirmCommand: DeleteItemWithConfirmCommand
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.command.open-object", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.constants", "kendo.junkyard.commandutil", "kendo.junkyard.command.base" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, Command = jyNS.Command, MenuIds = jyNS.MenuIds, MenuItemType = jyNS.MenuItemType, when = $.when, extend = $.extend;
        var OpenObjectCommand = Command.extend({
            init: function(options) {
                Command.fn.init.call(this, options);
            },
            _exec: function() {
                var args = this.args, base = args.base, driveId = args.driveId, folderId = args.folderId, pathVm = this.root.path, commandService = this.root.commandService, isShared = base === MenuIds.Shared, defers = [];
                defers.push(pathVm.load(base, driveId, folderId));
                if (base === MenuIds.Trash) {
                    defers.push(commandService.showDeletedItems());
                } else if (driveId) {
                    defers.push(commandService.showItems(driveId, folderId, isShared));
                } else {
                    defers.push(commandService.showDrives(isShared));
                }
                this.updateMenuTree(base, driveId, folderId);
                when.apply(null, defers).done(this._done).fail(this._fail);
            },
            updateMenuTree: function(base, driveId, folderId) {
                var menuTree = this.root.menuTree;
                if (folderId) {
                    menuTree.updatePreserveItem(folderId, MenuItemType.Item);
                } else if (driveId) {
                    menuTree.updatePreserveItem(driveId, MenuItemType.Drive);
                } else {
                    menuTree.updatePreserveItem(base, MenuItemType.Menu);
                }
                menuTree.updateUI();
            }
        });
        extend(jyNS, {
            OpenObjectCommand: OpenObjectCommand
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.command.delete-drive", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.constants", "kendo.junkyard.commandutil", "kendo.junkyard.command.ui", "kendo.junkyard.models" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, UICommand = jyNS.UICommand, extend = $.extend, when = $.when, MenuItemType = jyNS.MenuItemType, MenuIds = jyNS.MenuIds;
        var DeleteDriveCommand = UICommand.extend({
            init: function(options) {
                UICommand.fn.init.call(this, options);
            },
            _exec: function() {
                var args = this.args, driveIds = args.driveIds, api = this.root.service.api;
                if (!Array.isArray(driveIds) || driveIds.length === 0) {
                    this._fail(new Error("driveIds param is required."));
                    return;
                }
                api.deleteDrives(driveIds).done(this._updateUI).fail(this._fail);
            },
            _doUpdateUI: function() {
                var defers = [], args = this.args, path = this.root.path, driveIds = args.driveIds, driveIdToDelete = args.driveIds[0], pathInludedDeleteDrive = path.includePath(driveIdToDelete, MenuItemType.Drive), details = this.root.details, menuTree = this.root.menuTree, parentNode = menuTree.findParentNode(driveIdToDelete, MenuItemType.Drive), router = this.root.router;
                if (parentNode) {
                    defers.push(this.reloadMenuNode(parentNode, MenuItemType.Menu));
                }
                if (details.isOpenedForDrives(driveIds)) {
                    this.root.commandService.closeDetails();
                }
                if (!pathInludedDeleteDrive) {
                    defers.push(this.reloadDrives());
                }
                when.apply(null, defers).done(this._done).fail(this._fail);
                if (pathInludedDeleteDrive) {
                    this.root.commandService.closeDetails();
                    router.goToBase(parentNode ? parentNode.id : MenuIds.My);
                }
            }
        });
        extend(jyNS, {
            DeleteDriveCommand: DeleteDriveCommand
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.command.change-size-dialog", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.constants", "kendo.junkyard.commandutil", "kendo.junkyard.command.dialog" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, DialogCommand = jyNS.DialogCommand, extend = $.extend;
        var ChangeSizeDialogCommand = DialogCommand.extend({
            getDialogWidget: function() {
                return $("#jy-change-size-dialog-" + this.root.uid).data("kendoJunkyardDialog");
            }
        });
        extend(jyNS, {
            ChangeSizeDialogCommand: ChangeSizeDialogCommand
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.command.change-drive-size", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.constants", "kendo.junkyard.commandutil", "kendo.junkyard.command.ui", "kendo.junkyard.models" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, UICommand = jyNS.UICommand, MenuItemType = jyNS.MenuItemType, extend = $.extend;
        var ChangeDriveSizeCommand = UICommand.extend({
            init: function(options) {
                UICommand.fn.init.call(this, options);
            },
            _exec: function() {
                var args = this.args, driveId = args.driveId, size = args.size, api = this.root.service.api;
                if (!driveId || size <= 0) {
                    this._fail(new Error("driveId and size params is required."));
                    return;
                }
                api.changeDriveSize(driveId, size).done(this._makeNotifySuccess()).done(this._updateUI).fail(this._fail);
            },
            _successMessage: function() {
                return this.root.widgetOpt.localization.changeDriveSizeSuccess;
            },
            _doUpdateUI: function() {
                var args = this.args, driveId = args.driveId, menuTree = this.root.menuTree, parent = menuTree.findParentNode(driveId, MenuItemType.Drive);
                if (parent) {
                    this.wait(this.reloadMenuNodeAndDrives(parent.id, parent.menuType), this.reloadPath()).done(this._done).fail(this._fail);
                } else {
                    this.wait(this.reloadDrives(), this.reloadPath()).done(this._done).fail(this._fail);
                }
            }
        });
        extend(jyNS, {
            ChangeDriveSizeCommand: ChangeDriveSizeCommand
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.command.show-deleted-items", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.constants", "kendo.junkyard.commandutil", "kendo.junkyard.command.base" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, Command = jyNS.Command, extend = $.extend;
        var ShowDeletedItemsCommand = Command.extend({
            init: function(options) {
                Command.fn.init.call(this, options);
            },
            _exec: function() {
                var itemsVm = this.root.items, drivesVm = this.root.drives, toolbarVm = this.root.toolbar, searchVm = this.root.searchBar;
                toolbarVm.setCanChangeView(true);
                searchVm.close();
                drivesVm.setVisible(false);
                itemsVm.setVisible(true);
                itemsVm.onUpdateViewType();
                itemsVm.empty().load(null, null, true).done(this._done).fail(this._fail);
            }
        });
        extend(jyNS, {
            ShowDeletedItemsCommand: ShowDeletedItemsCommand
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.command.share-link-dialog", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.constants", "kendo.junkyard.commandutil", "kendo.junkyard.command.dialog" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, DialogCommand = jyNS.DialogCommand, extend = $.extend;
        var ShareLinkDialogCommand = DialogCommand.extend({
            getDialogWidget: function() {
                return $("#jy-share-link-dialog-" + this.root.uid).data("kendoJunkyardDialog");
            }
        });
        extend(jyNS, {
            ShareLinkDialogCommand: ShareLinkDialogCommand
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.command.crop-editor-dialog", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.constants", "kendo.junkyard.commandutil", "kendo.junkyard.command.dialog" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, DialogCommand = jyNS.DialogCommand, extend = $.extend;
        var CropEditorDialogCommand = DialogCommand.extend({
            getDialogWidget: function() {
                return $("#jy-crop-editor-dialog-" + this.root.uid).data("kendoJunkyardDialog");
            }
        });
        extend(jyNS, {
            CropEditorDialogCommand: CropEditorDialogCommand
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.command.create-file", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.constants", "kendo.junkyard.commandutil", "kendo.junkyard.command.ui", "kendo.junkyard.models" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, UICommand = jyNS.UICommand, extend = $.extend, when = $.when, MenuItemType = jyNS.MenuItemType;
        var CreateFileCommand = UICommand.extend({
            init: function(options) {
                UICommand.fn.init.call(this, options);
            },
            _exec: function() {
                var that = this, args = this.args, driveId = args.driveId, directoryId = args.directoryId, item = args.item, menuId = directoryId ? directoryId : driveId, menuType = directoryId ? MenuItemType.Item : MenuItemType.Drive;
                if (!driveId || !item) {
                    this._fail(new Error("driveId and item param is required."));
                    return;
                }
                item.action({
                    driveId: driveId,
                    directoryId: directoryId,
                    done: function() {
                        that._doUpdateUI(menuId, menuType);
                    }
                });
            },
            _doUpdateUI: function(menuId, menuType) {
                when(this.reloadMenuNode(menuId, menuType), this.reloadDrives(false), this.reloadItems(false)).done(this._done).fail(this._fail);
            }
        });
        extend(jyNS, {
            CreateFileCommand: CreateFileCommand
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.command.action-file", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.constants", "kendo.junkyard.commandutil", "kendo.junkyard.command.ui", "kendo.junkyard.models" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, UICommand = jyNS.UICommand, extend = $.extend, when = $.when, MenuItemType = jyNS.MenuItemType;
        var ActionFileCommand = UICommand.extend({
            init: function(options) {
                UICommand.fn.init.call(this, options);
            },
            _exec: function() {
                var that = this, args = this.args, driveId = args.driveId, id = args.id, title = args.title, item = args.item, version = args.version, menuId = id ? id : driveId, menuType = id ? MenuItemType.Item : MenuItemType.Drive;
                if (!driveId || !item) {
                    this._fail(new Error("driveId and item param is required."));
                    return;
                }
                item.action({
                    driveId: driveId,
                    id: id,
                    title: title,
                    version: version,
                    done: function() {
                        that._doUpdateUI(menuId, menuType);
                    },
                    cancel: function() {
                        that._done();
                    }
                });
            },
            _doUpdateUI: function(menuId, menuType) {
                when(this.reloadMenuNode(menuId, menuType), this.reloadDrives(false), this.reloadItems(false)).done(this._done).fail(this._fail);
            }
        });
        extend(jyNS, {
            ActionFileCommand: ActionFileCommand
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.command.clear-trash", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.constants", "kendo.junkyard.commandutil", "kendo.junkyard.command.dialog" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, UICommand = jyNS.UICommand, extend = $.extend, when = $.when, MenuItemType = jyNS.MenuItemType;
        var ClearTrashCommand = UICommand.extend({
            init: function(options) {
                UICommand.fn.init.call(this, options);
            },
            _exec: function() {
                var self = this, localization = this.root.widgetOpt.localization, message = localization.clearTrashMessage, title = localization.clearTrashTitle, confirmParams = localization.confirm, api = this.root.service.api;
                jyNS.utils.confirm(message, title, confirmParams).done(function() {
                    self._running();
                    api.clearTrash().done(self._updateUI).fail(self._fail);
                });
                this._done();
            },
            _doUpdateUI: function() {
                this.wait(this.reloadItems(), this.reloadPath()).done(this._done).fail(this._fail);
            }
        });
        extend(jyNS, {
            ClearTrashCommand: ClearTrashCommand
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.command.revoke-all-urls", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.constants", "kendo.junkyard.commandutil", "kendo.junkyard.command.dialog" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, UICommand = jyNS.UICommand, extend = $.extend, when = $.when, MenuItemType = jyNS.MenuItemType;
        var RevokeAllUrls = UICommand.extend({
            init: function(options) {
                UICommand.fn.init.call(this, options);
            },
            _exec: function() {
                var self = this, localization = this.root.widgetOpt.localization, message = localization.revokeAllUrlsMessage, title = localization.revokeAllUrlsTitle, confirmParams = localization.confirm, api = this.root.service.api;
                var args = this.args, driveId = args.driveId, itemId = args.itemId;
                jyNS.utils.confirm(message, title, confirmParams).done(function() {
                    self._running();
                    api.revokeAllUrls(driveId, itemId).done(self._updateUI).fail(self._fail);
                });
                this._done();
            },
            _doUpdateUI: function() {
                this.wait(this.reloadItems(), this.reloadPath()).done(this._done).fail(this._fail);
            }
        });
        extend(jyNS, {
            RevokeAllUrls: RevokeAllUrls
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.command.delete-drive-by-id", [ "kendo.junkyard.ns", "kendo.junkyard.utils", "kendo.junkyard.constants", "kendo.junkyard.commandutil", "kendo.junkyard.command.dialog" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, UICommand = jyNS.UICommand, extend = $.extend, when = $.when, MenuItemType = jyNS.MenuItemType, MenuIds = jyNS.MenuIds;
        var DeleteDriveById = UICommand.extend({
            init: function(options) {
                UICommand.fn.init.call(this, options);
            },
            _exec: function() {
                var self = this, localization = this.root.widgetOpt.localization, message = localization.deleteDriveByIdMessage, title = localization.deleteDriveByIdTitle, confirmParams = localization.confirm, api = this.root.service.api;
                var args = this.args, driveId = args.driveId;
                jyNS.utils.confirm(message, title, confirmParams).done(function() {
                    self._running();
                    api.deleteDriveById(driveId).done(self._updateUI).fail(self._fail);
                });
                this._done();
            },
            _doUpdateUI: function() {
                var defers = [], args = this.args, path = this.root.path, driveIds = args.driveIds, driveIdToDelete = args.driveId[0] || args.driveId, pathInludedDeleteDrive = path.includePath(driveIdToDelete, MenuItemType.Drive), details = this.root.details, menuTree = this.root.menuTree, parentNode = menuTree.findParentNode(driveIdToDelete, MenuItemType.Drive), router = this.root.router;
                if (parentNode) {
                    defers.push(this.reloadMenuNode(parentNode, MenuItemType.Menu));
                }
                if (details.isOpenedForDrives(driveIds)) {
                    this.root.commandService.closeDetails();
                }
                when.apply(null, defers).done(this._done).fail(this._fail);
                if (pathInludedDeleteDrive) {
                    this.root.commandService.closeDetails();
                    router.goToBase(parentNode ? parentNode.id : MenuIds.My);
                }
                if (parentNode) {
                    this.wait(this.reloadMenuNodeAndDrives(parentNode.id, parentNode.menuType), this.reloadPath()).done(this._done).fail(this._fail);
                } else {
                    this.wait(this.reloadDrives(), this.reloadPath()).done(this._done).fail(this._fail);
                }
            }
        });
        extend(jyNS, {
            DeleteDriveById: DeleteDriveById
        });
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.commands", [ "kendo.junkyard.ns", "kendo.junkyard.constants", "kendo.junkyard.commandutil", "kendo.junkyard.command.show-items", "kendo.junkyard.command.show-drives", "kendo.junkyard.command.startup", "kendo.junkyard.command.change-view", "kendo.junkyard.command.open-drive", "kendo.junkyard.command.open-folder", "kendo.junkyard.command.add-drive-dialog", "kendo.junkyard.command.save-drive", "kendo.junkyard.command.show-details", "kendo.junkyard.command.close-details", "kendo.junkyard.command.add-folder-dialog", "kendo.junkyard.command.share-drive-dialog", "kendo.junkyard.command.create-folder", "kendo.junkyard.command.upload", "kendo.junkyard.command.reload-ui", "kendo.junkyard.command.rename-dialog", "kendo.junkyard.command.rename-drive", "kendo.junkyard.command.rename-item", "kendo.junkyard.command.move-dialog", "kendo.junkyard.command.restore-dialog", "kendo.junkyard.command.copy-dialog", "kendo.junkyard.command.move-item", "kendo.junkyard.command.restore-item", "kendo.junkyard.command.copy-item", "kendo.junkyard.command.download-item", "kendo.junkyard.command.open-file", "kendo.junkyard.command.open-preview", "kendo.junkyard.command.preview-dialog", "kendo.junkyard.command.open-file-dialog", "kendo.junkyard.command.delete-item", "kendo.junkyard.command.delete-item-with-confirm", "kendo.junkyard.command.open-object", "kendo.junkyard.command.delete-drive", "kendo.junkyard.command.change-size-dialog", "kendo.junkyard.command.change-drive-size", "kendo.junkyard.command.show-deleted-items", "kendo.junkyard.command.share-link-dialog", "kendo.junkyard.command.crop-editor-dialog", "kendo.junkyard.command.create-file", "kendo.junkyard.command.action-file", "kendo.junkyard.command.clear-trash", "kendo.junkyard.command.revoke-all-urls", "kendo.junkyard.command.delete-drive-by-id" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, jyNS = ui.junkyard, CommandManager = jyNS.CommandManager, Commands = jyNS.Commands;
        CommandManager.register(Commands.ShowItems, jyNS.ShowItemsCommand);
        CommandManager.register(Commands.ShowDrives, jyNS.ShowDrivesCommand);
        CommandManager.register(Commands.Startup, jyNS.StartupCommand);
        CommandManager.register(Commands.ChangeView, jyNS.ChangeViewCommand);
        CommandManager.register(Commands.OpenDrive, jyNS.OpenDriveCommand);
        CommandManager.register(Commands.OpenFolder, jyNS.OpenFolderCommand);
        CommandManager.register(Commands.AddDriveDialog, jyNS.AddDriveDialogCommand);
        CommandManager.register(Commands.SaveDrive, jyNS.SaveDriveCommand);
        CommandManager.register(Commands.ShowDetails, jyNS.ShowDetailsCommand);
        CommandManager.register(Commands.CloseDetails, jyNS.CloseDetailsCommand);
        CommandManager.register(Commands.AddFolderDialog, jyNS.AddFolderDialogCommand);
        CommandManager.register(Commands.CreateFolder, jyNS.CreateFolderCommand);
        CommandManager.register(Commands.ShareDriveDialog, jyNS.ShareDriveDialogCommand);
        CommandManager.register(Commands.Upload, jyNS.UploadCommand);
        CommandManager.register(Commands.ReloadUI, jyNS.ReloadUICommand);
        CommandManager.register(Commands.RenameDialog, jyNS.RenameDialogCommand);
        CommandManager.register(Commands.RenameDrive, jyNS.RenameDriveCommand);
        CommandManager.register(Commands.RenameItem, jyNS.RenameItemCommand);
        CommandManager.register(Commands.MoveDialog, jyNS.MoveDialogCommand);
        CommandManager.register(Commands.RestoreDialog, jyNS.RestoreDialogCommand);
        CommandManager.register(Commands.CopyDialog, jyNS.CopyDialogCommand);
        CommandManager.register(Commands.MoveItem, jyNS.MoveItemCommand);
        CommandManager.register(Commands.RestoreItem, jyNS.RestoreItemCommand);
        CommandManager.register(Commands.CopyItem, jyNS.CopyItemCommand);
        CommandManager.register(Commands.DownloadItem, jyNS.DownloadItemCommand);
        CommandManager.register(Commands.OpenFile, jyNS.OpenFileCommand);
        CommandManager.register(Commands.OpenPreview, jyNS.OpenPreviewCommand);
        CommandManager.register(Commands.PreviewDialog, jyNS.PreviewDialogCommand);
        CommandManager.register(Commands.OpenFileDialog, jyNS.OpenFileDialogCommand);
        CommandManager.register(Commands.DeleteItem, jyNS.DeleteItemCommand);
        CommandManager.register(Commands.DeleteItemWithConfirm, jyNS.DeleteItemWithConfirmCommand);
        CommandManager.register(Commands.OpenObject, jyNS.OpenObjectCommand);
        CommandManager.register(Commands.DeleteDrive, jyNS.DeleteDriveCommand);
        CommandManager.register(Commands.ChangeSizeDialog, jyNS.ChangeSizeDialogCommand);
        CommandManager.register(Commands.ChangeDriveSize, jyNS.ChangeDriveSizeCommand);
        CommandManager.register(Commands.ShowDeletedItems, jyNS.ShowDeletedItemsCommand);
        CommandManager.register(Commands.ShareLinkDialog, jyNS.ShareLinkDialogCommand);
        CommandManager.register(Commands.CropEditorDialog, jyNS.CropEditorDialogCommand);
        CommandManager.register(Commands.CreateFile, jyNS.CreateFileCommand);
        CommandManager.register(Commands.ActionFile, jyNS.ActionFileCommand);
        CommandManager.register(Commands.ClearTrash, jyNS.ClearTrashCommand);
        CommandManager.register(Commands.RevokeAllUrls, jyNS.RevokeAllUrls);
        CommandManager.register(Commands.DeleteDriveById, jyNS.DeleteDriveById);
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.binders", [ "kendo.junkyard.ns", "kendo.junkyard.utils" ], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, Binder = kendo.data.Binder, binders = kendo.data.binders, jyNS = ui.junkyard, utils = jyNS.utils, proxy = $.proxy;
        binders.widget.junkyardselect = {};
        binders.widget.junkyardlink = {};
        binders.widget.junkyardcropeditor = {};
        binders.widget.junkyardtags = {};
        binders.widget.model = Binder.extend({
            refresh: function() {
                var value = this.bindings.model.get();
                if (value) {
                    if (kendo.isFunction(this.element.setViewModel)) {
                        this.element.setViewModel(value);
                    }
                } else {
                    if (kendo.isFunction(this.element.clear)) {
                        this.element.clear();
                    }
                }
            }
        });
        binders.focus = Binder.extend({
            refresh: function() {
                var value = this.bindings.focus.get();
                if (value) {
                    $(this.element).focus();
                } else {
                    $(this.element).blur();
                }
            }
        });
        binders.focusIn = Binder.extend({
            refresh: function() {
                var value = this.bindings.focusIn.get();
                if (value) {
                    $(this.element).focus();
                }
            }
        });
        binders.image = Binder.extend({
            refresh: function() {
                var url = this.bindings.image.get() || "";
                this.element.setAttribute("src", url);
            }
        });
        binders.imageAjax = Binder.extend({
            init: function(element, bindings, options) {
                Binder.fn.init.call(this, element, bindings, options);
                this._imageLoader = new ImageLoader(this.element);
            },
            refresh: function() {
                var url = this.bindings.imageAjax.get() || "";
                if (url) {
                    this._imageLoader.load(url);
                } else {
                    this.element.setAttribute("src", url);
                }
            },
            destroy: function() {
                if (this._imageLoader) {
                    this._imageLoader.destroy();
                    this._imageLoader = null;
                }
            }
        });
        binders.cssClass = Binder.extend({
            refresh: function() {
                var cssClass = this.bindings.cssClass.get(), isValid = typeof cssClass === "string" && cssClass !== "";
                if (!isValid && this._previousClass == null) {
                    return;
                } else if (!isValid && this._previousClass != null) {
                    $(this.element).removeClass(this._previousClass);
                    this._previousClass = null;
                } else if (isValid && this._previousClass != null) {
                    $(this.element).removeClass(this._previousClass).addClass(cssClass);
                    this._previousClass = cssClass;
                } else if (isValid && this._previousClass == null) {
                    $(this.element).addClass(cssClass);
                    this._previousClass = cssClass;
                }
            }
        });
        binders.lazyText = Binder.extend({
            refresh: function() {
                var that = this, value = this.bindings.lazyText.get(), dataFormat = this.element.getAttribute("data-format") || "", dataField = this.element.getAttribute("data-field") || "", defaultText = this.element.getAttribute("data-default-text") || "", progressText = this.element.getAttribute("data-progress-text") || "";
                if (typeof value === "string") {
                    this._updateText(value, dataFormat, dataField);
                } else if (value && kendo.isFunction(value.done)) {
                    if (progressText) {
                        that._updateText(progressText, dataFormat, dataField);
                    }
                    value.done(function(value) {
                        that._updateText(value, dataFormat, dataField);
                    }).fail(function() {
                        if (defaultText) {
                            that._updateText(defaultText, dataFormat, dataField);
                        }
                    });
                } else {
                    this._updateText("", "", "");
                }
            },
            _updateText: function(data, dataFormat, dataField) {
                var text = null;
                if (typeof data === "string") {
                    text = data;
                } else if (data && dataField && Object.prototype.toString.call(data) === "[object Object]") {
                    text = data[dataField];
                }
                if (text == null) {
                    text = "";
                }
                $(this.element).text(kendo.toString(text, dataFormat));
            }
        });
        binders.size = Binder.extend({
            refresh: function() {
                var size = this.bindings.size.get();
                var text = utils.formatSize(size);
                var dataFormat = this.element.getAttribute("data-format") || "";
                var decimalSeparator = this.element.getAttribute("data-decimal-separator") || "";
                if (text == null) {
                    text = "";
                }
                if (decimalSeparator) {
                    text = text.replace(".", decimalSeparator);
                }
                $(this.element).text(kendo.toString(text, dataFormat));
            }
        });
        binders.ellipsisText = Binder.extend({
            refresh: function() {
                var text = this.bindings.ellipsisText.get();
                var dataFormat = this.element.getAttribute("data-format") || "";
                var dataPlaceholder = this.element.getAttribute("data-placeholder") || "";
                var dataMaxLength = this.element.getAttribute("data-max-length") || 0;
                var dataAddTitle = this.element.getAttribute("data-add-title") || "false";
                if (text == null) {
                    text = "";
                }
                if (dataMaxLength > 0 && text.length > 0) {
                    if (text.length > dataMaxLength) {
                        var halfLenth = (dataMaxLength - dataPlaceholder.length) / 2;
                        if (dataAddTitle === "true") {
                            this.element.setAttribute("title", text);
                        }
                        text = text.substring(0, halfLenth) + dataPlaceholder + text.substr(-halfLenth);
                    }
                }
                $(this.element).text(kendo.toString(text, dataFormat));
            }
        });
        binders.svgIcon = Binder.extend({
            refresh: function() {
                var value = this.bindings.svgIcon.get();
                var dataIconClassFormat = this.element.getAttribute("data-css-icon-format") || "";
                var baseIconClass = this.element.getAttribute("data-css-icon") || "";
                var extensionSuffix = value ? kendo.ui.junkyard.fileTypeIcon(value) : null;
                if (extensionSuffix) {
                    var iconClass = kendo.format(dataIconClassFormat, extensionSuffix);
                    $(this.element).removeClass().addClass(baseIconClass).addClass(iconClass).html(kendo.format('<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#{0}"></use>', iconClass));
                } else {
                    $(this.element).removeClass().addClass(baseIconClass).html("");
                }
            }
        });
        binders.widget.junkyardselect.value = Binder.extend({
            init: function(element, bindings, options) {
                Binder.fn.init.call(this, element, bindings, options);
                this._change = proxy(this.change, this);
                this._initWidget = proxy(this.initWidget, this);
                this.element.bind("change", this._change).bind("init", this._initWidget);
                this._initChange = false;
                this._initRefresh = false;
            },
            refresh: function() {
                if (!this._initRefresh) {
                    this._initChange = true;
                    this.element.setValue(this.bindings.value.get(), true);
                    this._initChange = false;
                }
                this._initRefresh = false;
            },
            change: function() {
                if (!this._initChange) {
                    this._initRefresh = true;
                    this.bindings.value.set(this.element.getValue());
                    this._initRefresh = false;
                }
                this._initChange = false;
            },
            initWidget: function() {
                this.refresh();
            },
            destroy: function() {
                this.element.unbind("change", this._change).unbind("init", this._initWidget);
            }
        });
        binders.widget.junkyardlink.value = Binder.extend({
            init: function(element, bindings, options) {
                Binder.fn.init.call(this, element, bindings, options);
                this._initWidget = proxy(this.initWidget, this);
                this.element.bind("init", this._initWidget);
            },
            refresh: function() {
                if (kendo.isFunction(this.element.setValue)) {
                    this.element.setValue(this.bindings.value.get());
                }
            },
            initWidget: function() {
                this.refresh();
            },
            destroy: function() {
                this.element.unbind("init", this._initWidget);
            }
        });
        binders.widget.junkyardcropeditor.imageUrl = Binder.extend({
            init: function(element, bindings, options) {
                Binder.fn.init.call(this, element, bindings, options);
                this._initWidget = proxy(this.initWidget, this);
                this.element.bind("init", this._initWidget);
            },
            refresh: function() {
                if (kendo.isFunction(this.element.setImageUrl)) {
                    this.element.setImageUrl(this.bindings.imageUrl.get());
                }
            },
            initWidget: function() {
                this.refresh();
            },
            destroy: function() {
                this.element.unbind("init", this._initWidget);
            }
        });
        binders.widget.junkyardtags.value = Binder.extend({
            init: function(element, bindings, options) {
                Binder.fn.init.call(this, element, bindings, options);
                this._change = proxy(this.change, this);
                this.element.bind("change", this._change);
                this._initChange = false;
                this._initRefresh = false;
                this.initWidget();
            },
            refresh: function() {
                if (!this._initRefresh) {
                    this._initChange = true;
                    this.element.setValue(this.bindings.value.get(), true);
                    this._initChange = false;
                }
                this._initRefresh = false;
            },
            change: function() {
                if (!this._initChange) {
                    this._initRefresh = true;
                    this.bindings.value.set(this.element.getValue());
                    this._initRefresh = false;
                }
                this._initChange = false;
            },
            initWidget: function() {
                this.refresh();
            },
            destroy: function() {
                this.element.unbind("change", this._change);
            }
        });
        function ImageLoader(element) {
            this.element = element;
            this.retryTimes = [ 2, 4, 8, 12, 18 ];
            this.allRetryAttempts = this.retryTimes.length;
            this.currentRetryAttempt = 0;
            this.xhr = null;
            this.timer = null;
        }
        ImageLoader.prototype.load = function(url) {
            this.abort();
            clearTimeout(this.timer);
            this.loadImage(url);
        };
        ImageLoader.prototype.loadImage = function(url) {
            var that = this;
            var xhr = new XMLHttpRequest();
            xhr.open("GET", url);
            xhr.responseType = "arraybuffer";
            xhr.onload = function(e) {
                if (this.status === 200) {
                    var arrayBuffer = this.response;
                    if (arrayBuffer && arrayBuffer.byteLength > 0) {
                        var contentType = "image/png";
                        that.setSrc(that.toDataUrl(contentType, that.toBase64(arrayBuffer)));
                    } else {
                        if (!that.tryRetry(url)) {
                            that.emptySrc();
                        }
                    }
                } else if (this.status === 202) {
                    if (!that.tryRetry(url)) {
                        that.emptySrc();
                    }
                } else {
                    that.emptySrc();
                }
            };
            xhr.send();
            this.xhr = xhr;
        };
        ImageLoader.prototype.toBase64 = function(arrayBuffer) {
            return btoa(new Uint8Array(arrayBuffer).reduce(function(data, byte) {
                return data + String.fromCharCode(byte);
            }, ""));
        };
        ImageLoader.prototype.toDataUrl = function(contentType, base64) {
            return "data:" + contentType.toLowerCase() + ";base64," + base64;
        };
        ImageLoader.prototype.tryRetry = function(url) {
            if (this.currentRetryAttempt >= this.allRetryAttempts) {
                return false;
            }
            clearTimeout(this.timer);
            var that = this;
            var time = this.retryTimes[this.currentRetryAttempt] || 0;
            this.timer = setTimeout(function() {
                that.currentRetryAttempt++;
                that.loadImage(url);
            }, time * 1e3);
            return true;
        };
        ImageLoader.prototype.setSrc = function(src) {
            if (this.element) {
                this.element.setAttribute("src", src);
            }
        };
        ImageLoader.prototype.emptySrc = function() {
            this.setSrc("");
        };
        ImageLoader.prototype.abort = function() {
            if (this.xhr) {
                this.xhr.abort();
            }
        };
        ImageLoader.prototype.destroy = function() {
            this.abort();
            clearTimeout(this.timer);
            this.element = null;
            this.xhr = null;
        };
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.dialog", [], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, proxy = $.proxy, CLOSE = "close", CLOSED = "closed", DEACTIVATE = "deactivate", ACTIVATE = "activate", RESIZE = "resize", DIALOG_RESULT = "dialogResult", KENDO_WINDOW = "kendoWindow", CREATE_VIEW = "createView", CLOSE_VIEW = "closeView";
        var JunkyardDialog = ui.Widget.extend({
            init: function(element, options) {
                ui.Widget.fn.init.call(this, element, options);
                this.view = null;
                this.window = null;
                this.viewModel = null;
                this.close = proxy(this.close, this);
                this._onCloseWindow = proxy(this._onCloseWindow, this);
            },
            options: {
                name: "JunkyardDialog",
                templateId: "",
                isMaximize: false,
                center: true,
                topContainer: null,
                topOverlay: false,
                topOverlayCss: "jy-top-overlay-dialog"
            },
            events: [ CLOSE, CLOSED, CREATE_VIEW ],
            open: function(viewModel) {
                if (this.view) {
                    return;
                }
                this.viewModel = viewModel;
                this._renderView(viewModel);
                this._setupWindow(viewModel.uid);
                this._bindWindowEvents(viewModel);
                this._openWindow();
            },
            close: function() {
                if (this.window) {
                    this.window.close();
                } else {
                    this._close();
                }
            },
            _renderView: function(viewModel) {
                this.view = new kendo.View(this.options.templateId, {
                    model: viewModel,
                    evalTemplate: true,
                    wrap: true
                });
                viewModel.bind(CLOSE, this.close);
                this.view.render(this.element);
                if (this.options.topOverlay) {
                    this._topOverlay();
                }
                this._triggerCreateView();
            },
            _topOverlay: function() {
                var topContainer = this.options.topContainer || document.body;
                if (topContainer) {
                    this.overlay = $("<div/>").appendTo($(topContainer)).addClass(this.element.attr("class")).addClass(this.options.topOverlayCss).append(this.element.contents());
                }
            },
            _findWindow: function(uid) {
                var elementId = kendo.format("#jy-window-{0}", uid);
                return $(elementId).data(KENDO_WINDOW);
            },
            _setupWindow: function(uid) {
                this.window = this._findWindow(uid);
                if (this.window) {
                    this.window.bind(DEACTIVATE, this._onCloseWindow);
                }
            },
            _openWindow: function() {
                if (this.window) {
                    if (this.viewModel) {
                        if (this.viewModel.trigger("beforeOpenDialog", {
                            dialog: this
                        })) {
                            return;
                        }
                    }
                    if (this.options.center) {
                        this.window.center();
                    }
                    if (this.options.isMaximize) {
                        this.window.maximize();
                    }
                    this.window.open();
                }
            },
            _bindWindowEvents: function(viewModel) {
                if (this.window) {
                    var proxy = function(eventName) {
                        return function(e) {
                            return viewModel.trigger(eventName, {
                                orig: e
                            });
                        };
                    };
                    this.window.bind(DEACTIVATE, proxy("afterCloseDialog")).bind(CLOSE, proxy("beforeCloseDialog")).bind(ACTIVATE, proxy("afterOpenDialog")).bind(RESIZE, proxy("resizeDialog"));
                }
            },
            _onCloseWindow: function() {
                this._close();
            },
            _close: function() {
                if (!this.view) {
                    return;
                }
                this._triggerClose(this.viewModel);
                if (this.window) {
                    this.window.unbind();
                    this.window.destroy();
                    this.window = null;
                }
                if (this.view) {
                    this.view.destroy();
                    this.view = null;
                }
                if (this.overlay) {
                    kendo.unbind(this.overlay);
                    kendo.destroy(this.overlay);
                    this.overlay.remove();
                }
                this.window = this.view = this.viewModel = this.overlay = null;
                this.trigger(CLOSED);
            },
            _triggerClose: function(vm) {
                var dialogResult = vm ? vm.get(DIALOG_RESULT) : undefined;
                this.trigger(CLOSE, {
                    result: dialogResult
                });
                if (vm) {
                    vm.trigger(CLOSE_VIEW);
                }
            },
            _triggerCreateView: function() {
                if (this.viewModel) {
                    this.viewModel.trigger(CREATE_VIEW);
                }
                this.trigger(CREATE_VIEW);
            },
            destroy: function() {
                this._close();
                ui.Widget.fn.destroy.call(this);
                this.element = null;
            }
        });
        kendo.ui.plugin(JunkyardDialog);
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.fragment", [], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, CREATE_VIEW = "createView", DESTROY_VIEW = "destroyView";
        var JunkyardFragment = ui.Widget.extend({
            init: function(element, options) {
                ui.Widget.fn.init.call(this, element, options);
                this.view = null;
                this.viewModel = null;
            },
            options: {
                name: "JunkyardFragment",
                templateId: "",
                deferredRendering: true
            },
            events: [],
            setViewModel: function(viewModel) {
                this.clear();
                this.viewModel = viewModel;
                if (this.options.deferredRendering) {
                    this.deferredRenderView(viewModel);
                } else {
                    this.renderView(viewModel);
                }
            },
            deferredRenderView: function(viewModel) {
                var that = this;
                setTimeout(function() {
                    that.renderView(viewModel);
                }, 0);
            },
            renderView: function(viewModel) {
                this.view = new kendo.View(this.options.templateId, {
                    model: viewModel,
                    evalTemplate: true,
                    wrap: false
                });
                this.view.render(this.element);
                kendo.resize(this.element);
                this._triggerCreateView();
            },
            clear: function() {
                if (this.view) {
                    this._triggerDestroyView();
                    this.view.destroy();
                    this.view = this.viewModel = null;
                }
            },
            _triggerCreateView: function() {
                if (this.viewModel) {
                    this.viewModel.trigger(CREATE_VIEW);
                }
                this.trigger(CREATE_VIEW);
            },
            _triggerDestroyView: function() {
                if (this.viewModel) {
                    this.viewModel.trigger(DESTROY_VIEW);
                }
                this.trigger(DESTROY_VIEW);
            },
            destroy: function() {
                this.clear();
                ui.Widget.fn.destroy.call(this);
                this.element = null;
            }
        });
        kendo.ui.plugin(JunkyardFragment);
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.selectable", [], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, CHANGE = "change", NS = ".kendoJunkyardSelectable", proxy = $.proxy;
        var JunkyardSelectable = ui.Widget.extend({
            init: function(element, options) {
                ui.Widget.fn.init.call(this, element, options);
                this._onReset = proxy(this._onReset, this);
                this._selectable();
                if (this.options.multiple) {
                    this._multipleSelectable();
                }
            },
            options: {
                name: "JunkyardSelectable",
                multiple: false,
                filter: ">*",
                target: "",
                aria: true,
                reset: false,
                cssMarquee: "",
                denyFilter: null,
                autoScroll: false,
                autoScrollOffset: 20,
                autoScrollTimeout: 50
            },
            events: [ CHANGE ],
            _selectable: function() {
                var that = this, opt = this.options;
                if (!opt.target) {
                    return;
                }
                this.target = $(opt.target);
                this.selectableWidget = new kendo.ui.Selectable(this.target, {
                    aria: opt.aria,
                    multiple: opt.multiple,
                    filter: opt.filter,
                    change: function() {
                        that.trigger(CHANGE);
                    }
                });
                if (opt.cssMarquee) {
                    this.selectableWidget._marquee.addClass(opt.cssMarquee);
                }
                this._addResetEvent();
            },
            _multipleSelectable: function() {
                var that = this;
                this.selectableWidget.userEvents.unbind("start").unbind("move").unbind("end").unbind("select");
                this.multipleUserEvents = new kendo.UserEvents(this.target, {
                    global: true,
                    allowSelection: true,
                    threshold: .01
                });
                var pressTarget = null;
                var press = function(e) {
                    pressTarget = e.event.target;
                };
                var start = function(e) {
                    if (that._denyFilter(pressTarget || e.event.target)) {
                        that.selectableWidget.userEvents.cancel();
                        that.multipleUserEvents.cancel();
                        that.selectableWidget._downTarget = null;
                        return;
                    }
                    that.selectableWidget._start(e);
                    if (that.options.autoScroll && that._targetCanScrolling()) {
                        that._startScrolling();
                    }
                    that._remResetEvent();
                };
                var move = function(e) {
                    if (that.options.autoScroll && that._targetCanScrolling()) {
                        that._moveScrolling(e);
                    } else {
                        that.selectableWidget._move(e);
                    }
                };
                var end = function(e) {
                    that.selectableWidget._end(e);
                    that._clearScrolling();
                    that._addResetEventWithDelay(50);
                };
                this.multipleUserEvents.bind("start", start).bind("move", move).bind("end", end).bind("select", proxy(this.selectableWidget._select, this.selectableWidget)).bind("press", press);
            },
            _denyFilter: function(target) {
                if (this.options.denyFilter) {
                    return kendo.support.matchesSelector.call(target, this.options.denyFilter);
                }
                return false;
            },
            _targetCanScrolling: function() {
                return this.target[0] && this.target[0].scrollHeight > this.target[0].clientHeight;
            },
            _startScrolling: function() {
                this.selectableWidget._marquee.appendTo(this.target);
                this._startScrollTop = this.target[0].scrollTop;
                this._startScrollLeft = this.target[0].scrollLeft;
            },
            _moveScrolling: function(e) {
                e.preventDefault();
                this._lastEvent = e;
                this._processMovement(e.x, e.y, e.event.ctrlKey, e.event.metaKey);
                this._processAutoScroll(e);
            },
            _clearScrolling: function() {
                this._lastEvent = null;
                this._startScrollTop = null;
                this._startScrollLeft = null;
                this._stopAutoScroll();
            },
            _processMovement: function(xPos, yPos, ctrlKey, metaKey) {
                var containerBounds = this.target[0].getBoundingClientRect();
                var scrollTop = this.target[0].scrollTop;
                var scrollLeft = this.target[0].scrollLeft;
                var startLocalX = xPos.startLocation - containerBounds.left + this._startScrollLeft;
                var startLocalY = yPos.startLocation - containerBounds.top + this._startScrollTop;
                var localX = xPos.location - containerBounds.left + scrollLeft;
                var localY = yPos.location - containerBounds.top + scrollTop;
                if (startLocalX < 0) {
                    startLocalX = 0;
                }
                if (startLocalY < 0) {
                    startLocalY = 0;
                }
                if (localX < 0) {
                    localX = 0;
                }
                if (localY < 0) {
                    localY = 0;
                }
                var deltaX = localX - startLocalX;
                var deltaY = localY - startLocalY;
                var position = {
                    left: startLocalX > localX ? localX : startLocalX,
                    top: startLocalY > localY ? localY : startLocalY,
                    width: Math.abs(deltaX),
                    height: Math.abs(deltaY)
                };
                var constraintPos = this._constraintByContainer(this.target, position);
                this.selectableWidget._marquee.css(constraintPos);
                var globalPosition = this._toGlobalContainerPosition(this.target, containerBounds, position);
                this.selectableWidget._invalidateSelectables(globalPosition, ctrlKey || metaKey);
            },
            _constraintByContainer: function(container, position) {
                var scrollWidth = container[0].scrollWidth;
                var scrollHeight = container[0].scrollHeight;
                var left = position.left;
                var top = position.top;
                var w = position.width;
                var h = position.height;
                if (left < 0) {
                    left = 0;
                }
                if (top < 0) {
                    top = 0;
                }
                if (left + w > scrollWidth) {
                    w = w - (left + w - scrollWidth);
                }
                if (top + h > scrollHeight) {
                    h = h - (top + h - scrollHeight);
                }
                return {
                    left: left,
                    top: top,
                    width: w,
                    height: h
                };
            },
            _toGlobalContainerPosition: function(container, containerBounds, position) {
                var scrollLeft = container[0].scrollLeft;
                var scrollTop = container[0].scrollTop;
                var containerLeft = containerBounds.left;
                var containerTop = containerBounds.top;
                var left = position.left;
                var top = position.top;
                var w = position.width;
                var h = position.height;
                var globalLeft = left + containerLeft - scrollLeft;
                var globalTop = top + containerTop - scrollTop;
                return {
                    left: globalLeft,
                    top: globalTop,
                    width: w,
                    height: h
                };
            },
            _processAutoScroll: function(e) {
                if (this.target[0]) {
                    var targetBounds = this.target[0].getBoundingClientRect();
                    this._scrollDirection = null;
                    if (e.y.location <= targetBounds.top) {
                        this._scrollDirection = -1;
                    } else if (e.y.location >= targetBounds.bottom) {
                        this._scrollDirection = 1;
                    } else {
                        this._stopAutoScroll();
                    }
                    if (this._scrollDirection !== null && !this._scrollInterval) {
                        this._scrollInterval = setInterval($.proxy(this, "_autoScroll"), this.options.autoScrollTimeout);
                    }
                }
            },
            _autoScroll: function() {
                if (this.target[0]) {
                    var scrollHeight = this.target[0].scrollHeight;
                    var clientHeight = this.target[0].clientHeight;
                    var scrollTop = this.target[0].scrollTop;
                    if (scrollHeight === clientHeight) {
                        return;
                    }
                    if (this._lastEvent) {
                        this._processMovement(this._lastEvent.x, this._lastEvent.y, this._lastEvent.event.ctrlKey, this._lastEvent.event.metaKey);
                    }
                    scrollTop += this.options.autoScrollOffset * this._scrollDirection;
                    if (scrollTop < 0) {
                        scrollTop = 0;
                    }
                    if (scrollTop > scrollHeight - clientHeight) {
                        scrollTop = scrollHeight - clientHeight;
                    }
                    this.target[0].scrollTop = scrollTop;
                }
            },
            _stopAutoScroll: function() {
                if (this._scrollInterval) {
                    clearInterval(this._scrollInterval);
                    this._scrollInterval = null;
                    this._scrollDirection = null;
                }
            },
            _addResetEventWithDelay: function(delay) {
                var that = this;
                var timeoutResource = setTimeout(function() {
                    that._addResetEvent();
                    clearTimeout(timeoutResource);
                }, delay);
            },
            _addResetEvent: function() {
                if (this.options.reset && this.target) {
                    this.target.on("click" + NS, this._onReset);
                }
            },
            _remResetEvent: function() {
                if (this.options.reset && this.target) {
                    this.target.off("click" + NS, this._onReset);
                }
            },
            _onReset: function(e) {
                if (!this.selectableWidget._items && !kendo.support.matchesSelector.call(e.target, this.options.filter + " *")) {
                    this.clear();
                }
            },
            clear: function() {
                this.selectableWidget.clear();
                this.selectableWidget._notify(CHANGE);
            },
            selectByUid: function(uid) {
                if (this.selectableWidget.element) {
                    var item = this.selectableWidget.element.find(this._selectorByUid(uid));
                    this.selectableWidget.clear();
                    this.selectableWidget.value(item);
                }
            },
            selectByUids: function(uids) {
                if (uids.length > 0 && this.selectableWidget.element) {
                    var items = this.selectableWidget.element.find(this._selectorByUids(uids));
                    this.selectableWidget.clear();
                    this.selectableWidget.value(items);
                }
            },
            setSelectedByUids: function(uids) {
                if (uids.length > 0 && this.selectableWidget.element) {
                    var that = this;
                    var items = this.selectableWidget.element.find(this._selectorByUids(uids));
                    items.each(function() {
                        that.selectableWidget._selectElement(this, true);
                    });
                }
            },
            _selectorByUid: function(uid) {
                return this.options.filter + "[" + kendo.attr("uid") + "=" + uid + "]";
            },
            _selectorByUids: function(uids) {
                var that = this;
                return uids.map(function(uid) {
                    return that._selectorByUid(uid);
                }).join(",");
            },
            destroy: function() {
                this._stopAutoScroll();
                if (this.selectableWidget && this.selectableWidget.element) {
                    this.selectableWidget.destroy();
                    this.selectableWidget = null;
                }
                if (this.multipleUserEvents) {
                    this.multipleUserEvents.destroy();
                    this.multipleUserEvents = null;
                }
                this.target.off("click" + NS);
                ui.Widget.fn.destroy.call(this);
                this.target = this.element = null;
            }
        });
        kendo.ui.plugin(JunkyardSelectable);
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.draggable", [], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, proxy = $.proxy, HINT = "hint", DRAG = "drag", DRAGSTART = "dragstart", DRAGEND = "dragend", DRAGCANCEL = "dragcancel", HOLD = "hold", KEYDOWN = "keydown", KEYUP = "keyup";
        var JunkyardDraggable = ui.Widget.extend({
            init: function(element, options) {
                ui.Widget.fn.init.call(this, element, options);
                this._templates();
                this._draggable();
                this._handleKeyUp = proxy(this._handleKeyUp, this);
                this._handleKeyDown = proxy(this._handleKeyDown, this);
            },
            options: {
                name: "JunkyardDraggable",
                element: null,
                hintTemplate: "",
                draggable: {}
            },
            events: [ HINT, DRAGSTART, DRAGEND, DRAGCANCEL, DRAG, HOLD, KEYUP, KEYDOWN ],
            _draggable: function() {
                if (this.options.element) {
                    var that = this;
                    var dragStartHandler = this._eventProxy(DRAGSTART);
                    var dragEndHandler = this._eventProxy(DRAGEND);
                    var dragCancelHandler = this._eventProxy(DRAGCANCEL);
                    var dragStart = function(e) {
                        that._start(e);
                        if (dragStartHandler(e)) {
                            that._afterEnd(e);
                        }
                    };
                    var dragEnd = function(e) {
                        dragEndHandler(e);
                        that._afterEnd(e);
                    };
                    var dragCancel = function(e) {
                        dragCancelHandler(e);
                        that._afterEnd(e);
                    };
                    this.draggable = new ui.Draggable($(this.options.element), $.extend({}, this.options.draggable, {
                        hint: proxy(this._handleHint, this),
                        drag: this._eventProxy(DRAG),
                        dragstart: dragStart,
                        dragend: dragEnd,
                        dragcancel: dragCancel,
                        hold: this._eventProxy(HOLD)
                    }));
                }
            },
            _templates: function() {
                this.hintTemplate = kendo.template(this.options.hintTemplate || "");
            },
            _eventProxy: function(eventName) {
                var that = this;
                return function(e) {
                    return that.trigger(eventName, e);
                };
            },
            _start: function() {
                $(document).one(KEYDOWN, this._handleKeyDown);
                $(document).on(KEYUP, this._handleKeyUp);
            },
            _afterEnd: function() {
                $(document).off(KEYDOWN, this._handleKeyDown);
                $(document).off(KEYUP, this._handleKeyUp);
            },
            _handleHint: function(element) {
                var e = {
                    hintData: {},
                    target: element
                };
                if (this.options.hintTemplate && !this.trigger(HINT, e)) {
                    return $(this.hintTemplate(e.hintData || {}));
                } else {
                    return element.clone();
                }
            },
            _handleKeyDown: function(e) {
                this.trigger(KEYDOWN, {
                    orig: e
                });
            },
            _handleKeyUp: function(e) {
                this.trigger(KEYUP, {
                    orig: e
                });
                $(document).one(KEYDOWN, this._handleKeyDown);
            },
            destroy: function() {
                if (this.draggable) {
                    this.draggable.destroy();
                    this.draggable = null;
                }
                this._afterEnd();
                ui.Widget.fn.destroy.call(this);
                this.element = null;
            }
        });
        kendo.ui.plugin(JunkyardDraggable);
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.tags", [], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, proxy = $.proxy, CHANGE = "change";
        var JunkyardTags = ui.Widget.extend({
            init: function(element, options) {
                ui.Widget.fn.init.call(this, element, options);
                this._changeHandler = proxy(this._onChange, this);
                this._tagify();
            },
            options: {
                name: "JunkyardTags"
            },
            events: [ CHANGE ],
            _tagify: function() {
                if (!window.Tagify) {
                    console.warn("Junkyard: Dependency Tagify not installed.");
                    return;
                }
                var element = this.element && this.element[0];
                if (!element) {
                    return;
                }
                var input = document.createElement("input");
                input.type = "text";
                this.input = input;
                element.classList.add("jy-tags-input");
                element.appendChild(input);
                this.tagify = new window.Tagify(this.input, {
                    placeholder: "Введите теги"
                });
                this.tagify.on(CHANGE, this._changeHandler);
            },
            setValue: function(tags, fromUser) {
                if (this.tagify) {
                    if (fromUser) {
                        this.tagify.off(CHANGE, this._changeHandler);
                        this.tagify.loadOriginalValues(tags);
                        this.tagify.on(CHANGE, this._changeHandler);
                    } else {
                        this.tagify.loadOriginalValues(tags);
                    }
                }
            },
            getValue: function() {
                if (!this.tagify || !Array.isArray(this.tagify.value)) return "";
                return this.tagify.value.map(function(tag) {
                    return tag.value;
                }).join(",");
            },
            _onChange: function(e) {
                this.trigger(CHANGE, {
                    value: e.detail.value
                });
            },
            destroy: function() {
                if (this.tagify) {
                    this.tagify.destroy();
                    this.tagify = null;
                }
                if (this.element && this.element[0] && this.input) {
                    this.element[0].removeChild(this.input);
                    this.input = null;
                }
                ui.Widget.fn.destroy.call(this);
                this.element = null;
            }
        });
        kendo.ui.plugin(JunkyardTags);
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.droptargetarea", [], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui, DROP = "drop", DRAGENTER = "dragenter", DRAGLEAVE = "dragleave";
        var JunkyardDropTargetArea = ui.Widget.extend({
            init: function(element, options) {
                ui.Widget.fn.init.call(this, element, options);
                this._dropTargetArea();
            },
            options: {
                name: "JunkyardDropTargetArea",
                element: null,
                droptargetarea: {}
            },
            events: [ DROP, DRAGENTER, DRAGLEAVE ],
            _dropTargetArea: function() {
                if (this.options.element) {
                    this.dropTargetArea = new ui.DropTargetArea($(this.options.element), $.extend({}, this.options.droptargetarea, {
                        dragenter: this._eventProxy(DRAGENTER),
                        dragleave: this._eventProxy(DRAGLEAVE),
                        drop: this._eventProxy(DROP)
                    }));
                }
            },
            _eventProxy: function(eventName) {
                var that = this;
                return function(e) {
                    return that.trigger(eventName, e);
                };
            },
            destroy: function() {
                ui.Widget.fn.destroy.call(this);
                this.dropTargetArea = null;
                this.element = null;
            }
        });
        kendo.ui.plugin(JunkyardDropTargetArea);
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.svg-progress", [], f);
})(function() {
    "use strict";
    (function($, undefined) {
        var kendo = window.kendo, ui = kendo.ui;
        var JunkyardSvgProgress = ui.Widget.extend({
            init: function(element, options) {
                ui.Widget.fn.init.call(this, element, options);
                this._render();
            },
            options: {
                name: "JunkyardSvgProgress"
            },
            events: [],
            _render: function() {
                var html = '<path class="jy-loading-hexes__outer" d="M48,7.854C49.238,7.14 50.763,7.14 52,7.854C58.502,11.608 78.998,23.441 85.501,27.195C86.738,27.909 87.5,29.23 87.5,30.659L87.5,69.342C87.5,70.771 86.738,72.091 85.501,72.806C78.999,76.56 58.503,88.393 52,92.148C50.763,92.862 49.238,92.862 48,92.148C41.498,88.393 21.003,76.56 14.5,72.806C13.263,72.092 12.501,70.771 12.501,69.342L12.501,30.659C12.501,29.23 13.263,27.91 14.5,27.195L48,7.854L48,7.854Z"/>';
                html += '<path class="jy-loading-hexes__middle" d="M48.5,19.112C49.428,18.576 50.572,18.576 51.5,19.112L76,33.257C76.928,33.793 77.5,34.784 77.5,35.855L77.5,64.146C77.5,65.218 76.928,66.208 76,66.744C71.207,69.512 56.293,78.122 51.5,80.889C50.572,81.425 49.428,81.425 48.5,80.889C43.706,78.122 28.793,69.512 24,66.744C23.071,66.208 22.5,65.218 22.5,64.146L22.5,35.855C22.5,34.784 23.071,33.793 24,33.257C28.793,30.49 43.706,21.879 48.5,19.112L48.5,19.112Z"/>';
                html += '<path class="jy-loading-hexes__core" d="M49,30.947C49.619,30.59 50.381,30.59 51,30.947C54.013,32.687 62.986,37.867 66,39.607C66.619,39.964 67,40.624 67,41.339L67,58.659C67,59.373 66.619,60.034 66,60.391C62.987,62.131 54.014,67.311 51,69.051C50.381,69.408 49.619,69.408 49,69.051C45.987,67.311 37.014,62.131 34,60.391C33.381,60.034 33,59.374 33,58.659L33,41.339C33,40.624 33.381,39.964 34,39.607C37.014,37.867 45.987,32.687 49,30.947L49,30.947Z"/>';
                this.element.html(html);
            }
        });
        kendo.ui.plugin(JunkyardSvgProgress);
    })(window.kendo.jQuery);
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});
(function(f, define) {
    "use strict";
    define("kendo.junkyard.core", [ "kendo.junkyard.ns", "kendo.junkyard", "kendo.junkyard.select", "kendo.junkyard.link", "kendo.junkyard.image-link", "kendo.junkyard.crop-editor", "kendo.junkyard.templates", "kendo.junkyard.constants", "kendo.junkyard.treeview", "kendo.junkyard.contextmenu", "kendo.junkyard.upload", "kendo.junkyard.vm.base", "kendo.junkyard.vm.root", "kendo.junkyard.vm.ui-events", "kendo.junkyard.models", "kendo.junkyard.data", "kendo.junkyard.data.base", "kendo.junkyard.utils", "kendo.junkyard.commands", "kendo.junkyard.binders", "kendo.junkyard.dialog", "kendo.junkyard.fragment", "kendo.junkyard.selectable", "kendo.junkyard.draggable", "kendo.junkyard.tags", "kendo.junkyard.droptargetarea", "kendo.junkyard.svg-progress" ], f);
})(function() {
    "use strict";
    return window.kendo;
}, typeof define == "function" && define.amd ? define : function(a1, a2, a3) {
    "use strict";
    (a3 || a2)();
});